import { DateFilter, DateFilterBox, PRESETS } from './poyais-ui/DateFilter';
import CampaignBuilderTab from './CampaignBuilderTab';
import AIMetinTab from './AIMetinTab';
import AIGorselTab from './AIGorselTab';
import AIVideoTab from './AIVideoTab';
import AISesTab from './AISesTab';
import FeedWizardTab from './FeedWizardTab';
import GrowthProductAnalysis from './GrowthProductAnalysis';
import GrowthForecast from './GrowthForecast';
import GrowthPriceElasticity from './GrowthPriceElasticity';
import RTBHouseTab from './RTBHouseTab';
import SearchConsoleTab from './SearchConsoleTab';
import ChatGPTAdsTab from './ChatGPTAdsTab';
import XAdsTab from './XAdsTab';
import TikTokAdsTab from './TikTokAdsTab';
import AdjustTab from './AdjustTab';
import ShopifyTab from './ShopifyTab';
import IkasTab from './IkasTab';
import TargetRoasCard, { TargetInfo } from './TargetRoasCard';
import PixaTab from './PixaTab';
import CriteoTab from './CriteoTab';
import GeoVisibilityTab from './GeoVisibilityTab';
import DynamicFeedTab from './DynamicFeedTab';
import SetPasswordPage from './SetPasswordPage';
import ResetPasswordPage from './ResetPasswordPage';
import VerifyEmailPage from './VerifyEmailPage';
import { useNavigate, useLocation } from 'react-router-dom';
import RecommendationsTabNew, { PendingApprovals } from './RecommendationsTab';
import { MetaRecBadge } from './MetaOpportunity';
import KampanyalarPage from './kampanyalar/KampanyalarPage';
import { MetaBreakdownCard, MetaAgeGenderCard, MetaHourlyPage } from './kampanyalar/MetaBreakdowns';
import MetaHealth from './kampanyalar/MetaHealth';
import { GoogleHealth, GooglePlacements, GoogleAudiences } from './kampanyalar/GooglePages';
import DashboardTabNew from './DashboardTab';
import { useLang, LangSwitcher, addTranslations } from './i18n';
import { useTheme, ThemeToggle } from './theme-context';
import FlowBuilderTab from './FlowBuilder';
import KrediYuklePage from './KrediYuklePage';
import TakimPage from './TakimPage';
import ClientReportAdmin from './report/ClientReportAdmin';
import DestekPage from './DestekPage';
import Asistan from './Asistan';
import { BrandMemoryPanel } from './AssistantMemory';
import JiraIntegrationCard from './JiraIntegrationCard';
import IkasIntegrationCard from './IkasIntegrationCard';
import TwoFactorCard from './TwoFactorCard';
import DangerZoneCard from './DangerZoneCard';
import { IntegrationsList, useIntegrationEntitlement, IntegrationItem } from './IntegrationsList';
import SmartAudiences from './SmartAudiences';
import Panolar from './Panolar';
import Gorevler from './Gorevler';
import Notlar from './Notlar';
import Uyarilar from './Uyarilar';
import FaturalamaPage from './FaturalamaPage';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import { getToken, logout, LoginScreen } from './auth';
import axios from 'axios';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, Legend, PieChart, Pie } from 'recharts';
import { T as SidebarT, tint, MONO, alpha} from './poyais-ui/theme';
import { exportCsv } from './poyais-ui/export';
import PoyaisSpinner from './PoyaisSpinner';

addTranslations({
  // Looker Studio
  'Google Ads ve Meta Ads günlük reklam verini tek Poyais One kaynağından Looker Studio raporlarına bağla. Gün + kampanya kırılımı gelir; Meta için ayrı ücretli connector gerekmez.':
    'Connect your daily Google Ads and Meta Ads data to Looker Studio reports from a single Poyais One source. Comes with day + campaign breakdown; no separate paid connector needed for Meta.',
  '1. Bağlantı anahtarı': '1. Connection key',
  'Looker Anahtarı Oluştur': 'Create Looker Key',
  'Bu anahtar bir daha gösterilmeyecek. Şimdi kopyalayıp güvenli bir yere kaydedin.': 'This key will not be shown again. Copy it now and store it somewhere safe.',
  'Geliştirici sekmesindeki mevcut bir MCP anahtarını da kullanabilirsin. Anahtar salt-okunurdur ve yalnızca eriştiğin müşterilerin verisini görür.':
    'You can also use an existing MCP key from the Developer tab. The key is read-only and only sees data for clients you have access to.',
  '2. Connector kurulumu (bir kez)': '2. Connector setup (one time)',
  'Connector kodunu indir': 'Download the connector code',
  'script.google.com → yeni proje → bu iki dosyayı ekle.': 'script.google.com → new project → add these two files.',
  'Dağıt → Yeni dağıtım → tür "Looker Studio konektörü" → dağıtım kimliğini kopyala.': 'Deploy → New deployment → type "Looker Studio connector" → copy the deployment ID.',
  'Looker Studio → Oluştur → Veri kaynağı → "Kendi konektörünü kur" → kimliği yapıştır.': 'Looker Studio → Create → Data source → "Build your own connector" → paste the ID.',
  'Yetkilendir → yukarıdaki anahtarı gir → müşteriyi seç → Bağlan.': 'Authorize → enter the key above → pick the client → Connect.',
  'Veri ucu': 'Data endpoint',
  // Admin — kullanıcı daveti
  'Kullanıcı oluşturuldu ancak davet e-postası gönderilemedi. Kullanıcı satırındaki "Daveti Gönder" ile tekrar deneyebilirsiniz.': 'User created but the invitation email could not be sent. You can retry with "Send Invite" on the user row.',
  'Kullanıcı oluşturulamadı.': 'Could not create user.',
  'Davet bağlantısı yenilendi ancak e-posta gönderilemedi. E-posta servisi ayarlarını kontrol edin.': 'The invite link was refreshed but the email could not be sent. Check the email service settings.',
  'Davet e-postası tekrar gönderildi ✓': 'Invitation email resent ✓',
  'Davet gönderilemedi': 'Could not send invite',
  'Davet Bekliyor': 'Invite Pending',
  'Daveti Gönder': 'Send Invite',
  'Gönderiliyor...': 'Sending...',
  // X Ads
  'X (Twitter) Ads hesabınızı yetkilendirmek için yönlendirileceksiniz.': "You'll be redirected to authorize your X (Twitter) Ads account.",
  'X Ads bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect X Ads?',
  'X Ads bağlantısı başarısız oldu:': 'X Ads connection failed:',
  // Sidebar
  'Genel Ayarlar': 'General Settings',
  'Ara: ad, hesap ya da ID': 'Search: name, account or ID',
  'Ana Sayfa': 'Home',
  'Çalışma Alanım': 'My Workspace',
  'Çıkış Yap': 'Log Out',
  'Ekibini davet et': 'Invite your team',
  'Ekip arkadaşlarını ekle, raporları ve panoları birlikte yönetin.': 'Add teammates and manage reports and boards together.',
  // AITextInsightCard
  'Yapay Zeka Metin Önerisi': 'AI Text Suggestion',
  'Uygulanıyor...': 'Applying...',
  '✓ Uygulandı': '✓ Applied',
  'Uygulanacak öneri yok': 'No suggestion to apply',
  'Önerileri Uygula': 'Apply Suggestions',
  'Detaylı Analiz': 'Detailed Analysis',
  'Toplam CTR': 'Total CTR',
  'Dönüşümsüz Reklam': 'Ads Without Conversions',
  'reklamdan': 'of ads',
  'Toplam harcama / dönüşüm': 'Total spend / conversion',
  'ROAS ≥ 4× Reklam': 'Ads with ROAS ≥ 4×',
  'İyi': 'Good',
  'Geliştirilebilir': 'Can improve',
  'Yüksek performanslı': 'High performing',
  'Önerilen Aksiyonlar': 'Suggested Actions',
  'Aksiyon gerektiren reklam bulunamadı.': 'No ads requiring action were found.',
  'Duraklat': 'Pause',
  'Ölçekle': 'Scale',
  // DisabledMsg / DisabledMsgInline
  'Devre Dışı': 'Disabled',
  'Ayarlar sayfasından platformu aktif edebilirsiniz.': 'You can activate the platform from the Settings page.',
  'Ayarlara Git': 'Go to Settings',
  'Otomasyon': 'Automation',
  'Optimizasyon Önerileri': 'Optimization Suggestions',
  // GA4ProductsTab
  'Satılan Ürün': 'Products Sold',
  'Sepete Ekleme': 'Add to Cart',
  'ATC → Satış': 'ATC → Purchase',
  'Kategori Bazlı Gelir': 'Revenue by Category',
  'Mevcut Dönem': 'Current Period',
  'Çok Satan': 'Best Seller',
  'Ürün': 'Product',
  'kategorisinde bu dönem en yüksek geliri elde etti.': "had the highest revenue in its category this period.",
  'Bu dönem en çok satan ürün analizi hazırlanıyor.': 'The top-selling product analysis for this period is being prepared.',
  'adet': 'units',
  'Kategori': 'Category',
  'Ürün Performansı': 'Product Performance',
  'Ürün ara...': 'Search products...',
  'Toplam': 'Total',
  'ürün gösteriliyor': 'products showing',
  // ProductTour
  'AI Asistan': 'AI Assistant',
  'Tüm platformlarının performans özetini, kampanya sonuçlarını ve bekleyen görevlerini burada tek bakışta görürsün.': 'See a summary of your platforms’ performance, campaign results, and pending tasks here at a glance.',
  'Verilerin hakkında soru sor, haftalık özet iste, önerileri sohbet ederek al.': 'Ask questions about your data, request a weekly summary, and get suggestions through chat.',
  'Panolar, Görevler & Notlar': 'Boards, Tasks & Notes',
  'Ekibinle panolar oluştur, görevleri sürükle-bırak Kanban ile yönet, notlarını paylaş.': 'Create boards with your team, manage tasks with drag-and-drop Kanban, and share notes.',
  'İstediğin metrik için (harcama, ROAS, CTR vb.) kendi eşiğini belirle — aşıldığında burada anında görürsün.': 'Set your own threshold for any metric (spend, ROAS, CTR, etc.) — see it here instantly when it’s crossed.',
  'Analytics & Reklamlar': 'Analytics & Ads',
  'GA4, Google Ads ve Meta Ads verilerini buradan incele.': 'Review your GA4, Google Ads, and Meta Ads data here.',
  'Optimizasyon önerileri, otomasyon şablonları, akış oluşturucu ve kampanya oluşturucu burada.': 'Optimization suggestions, automation templates, flow builder, and campaign builder are all here.',
  'Atla': 'Skip',
  // Notification dropdown
  'yeni': 'new',
  'Bildirim yok': 'No notifications',
  'Yükleniyor...': 'Loading...',
  'Aksiyon uygulandı.': 'Action applied.',
  'Onayınız bekleniyor.': 'Waiting for your approval.',
  'Uygulandı': 'Applied',
  'Onay Bekliyor': 'Pending Approval',
  'Tümü Okundu': 'Mark All Read',
  'Tüm Bildirimleri Gör': 'View All Notifications',
  // SettingsTab
  '(kampanya yayınlamak için gerekli)': '(required to publish campaigns)',
  'ADVERTISER SEÇ': 'SELECT ADVERTISER',
  'API Anahtarları (MCP)': 'API Keys (MCP)',
  'API KEY': 'API KEY',
  'API TOKEN': 'API TOKEN',
  'Account ID': 'Account ID',
  'Ad': 'First Name',
  'Adjust bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect Adjust?',
  'Aktif reklam hesabı bulunamadı.': 'No active ad account found.',
  'Anahtar adı (ör. Claude Desktop)': 'Key name (e.g. Claude Desktop)',
  'Anahtar iptal edilemedi.': 'Could not revoke the key.',
  'Anahtar oluşturulamadı.': 'Could not create the key.',
  'Ayarları Kaydet': 'Save Settings',
  'Bazı ayarların geçerli olması için tarayıcınızı yenilemeniz gerekebilir.': 'You may need to refresh your browser for some settings to take effect.',
  'Bağlan': 'Connect',
  'Bağlanamadı.': 'Could not connect.',
  'Bağlantı adresi': 'Connection URL',
  'Bağlantı başlatılamadı.': 'Could not start the connection.',
  'Bağlantı kesilemedi.': 'Could not disconnect.',
  'Bağlantıyı Doğrula': 'Verify Connection',
  'Bağlantıyı Kes': 'Disconnect',
  'Bağlanıyor…': 'Connecting…',
  'Bağlı': 'Connected',
  'Bağlı Değil': 'Not Connected',
  'Bekleyen Onaylar': 'Pending Approvals',
  'Bildirim Ayarları': 'Notification Settings',
  'Bildirimler': 'Notifications',
  "Bu anahtarlarla Claude Desktop, Claude Code veya claude.ai gibi bir MCP istemcisini Poyais One'a bağlayabilirsiniz. Bağlantı salt-okunurdur, sadece erişiminiz olan müşterilerin raporlama verilerini okuyabilir; kampanya yayınlama, görev/not oluşturma gibi hiçbir yazma işlemi yapılamaz.":
    "You can use these keys to connect an MCP client like Claude Desktop, Claude Code, or claude.ai to Poyais One. The connection is read-only — it can only read reporting data for clients you have access to; no write operation (publishing campaigns, creating tasks/notes) is possible.",
  'Bu anahtarı iptal etmek istediğinize emin misiniz? Bu anahtarı kullanan bağlantılar hemen kesilir.': 'Are you sure you want to revoke this key? Connections using it will be cut off immediately.',
  'CUSTOMER ID': 'CUSTOMER ID',
  'ChatGPT Ads bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect ChatGPT Ads?',
  'Claude Desktop için': 'For Claude Desktop, add this to',
  'Client Secret': 'Client Secret',
  'Criteo Developer Portal → Client ID': 'Criteo Developer Portal → Client ID',
  'Criteo bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect Criteo?',
  'Criteo panelinizdeki Dataset ID': 'Dataset ID from your Criteo panel',
  'DATASET ID': 'DATASET ID',
  'Dataset ID Kaydet': 'Save Dataset ID',
  'Dataset ID kaydedilemedi.': 'Could not save the Dataset ID.',
  'Doğrula': 'Verify',
  'Doğrulama sırasında hata oluştu.': 'An error occurred during verification.',
  'Doğrulanmış Search Console sitesi bulunamadı.': 'No verified Search Console site found.',
  'Doğrulanıyor…': 'Verifying…',
  'E-POSTA': 'EMAIL',
  'E-posta': 'Email',
  'E-posta ve şifre girin.': 'Enter your email and password.',
  'En az 10 karakter': 'At least 10 characters',
  'Entegrasyonlar': 'Integrations',
  'Derin Analiz': 'Deep Analysis', 'Meta Kırılımlar': 'Meta Breakdowns', 'Meta Hesap Sağlığı': 'Meta Account Health', 'Google Display': 'Google Display', 'Performance Max': 'Performance Max', 'Uygulama Kampanyaları': 'App Campaigns',
  'Erişilebilir Google Ads hesabı bulunamadı.': 'No accessible Google Ads account found.',
  'Facebook hesabınızda bulunan reklam hesaplarından birini seçin.': 'Select one of the ad accounts on your Facebook account.',
  'Facebook ile Bağla': 'Connect with Facebook',
  'Fotoğraf Yükle': 'Upload Photo',
  'Fotoğraf en fazla 500KB olabilir.': 'Photo can be at most 500KB.',
  'GA4 Property Seç': 'Select GA4 Property',
  'GA4 bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect GA4?',
  'GA4 hesapları alınamadı:': 'Could not retrieve GA4 accounts:',
  'Google Ads Hesabı Seç': 'Select Google Ads Account',
  'Google Ads bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect Google Ads?',
  "Google hesabınızda bulunan GA4 property'lerinden birini seçin.": 'Select one of the GA4 properties on your Google account.',
  'Google hesabınızda bulunan reklam hesaplarından birini seçin.': 'Select one of the ad accounts on your Google account.',
  'Google hesabınızda doğrulanmış sitelerden birini seçin.': 'Select one of the verified sites on your Google account.',
  'Google ile Bağla': 'Connect with Google',
  'Güncellendi': 'Updated',
  'Güncelleniyor...': 'Updating...',
  'Günlük Raporlar': 'Daily Reports',
  'Güvenlik': 'Security',
  'Henüz bir API anahtarınız yok.': "You don't have an API key yet.",
  'Hesap': 'Account',
  'Hesap kaydedilemedi.': 'Could not save the account.',
  'Hiç property bulunamadı. GA4 hesabınızı kontrol edin.': 'No property found. Check your GA4 account.',
  'Kapat': 'Close',
  'Kaydedildi': 'Saved',
  'Kaydediliyor...': 'Saving...',
 
  'Kayıt başarısız.': 'Save failed.',
  'Kimlik bilgileri geçersiz.': 'Invalid credentials.',
  'Kimlik bilgilerini değiştir': 'Change credentials',
  'Kimlik doğrulanamadı.': 'Could not authenticate.',
  'Kopyala': 'Copy',
  'Kopyalandı': 'Copied',
  'MAĞAZA ADRESİ': 'STORE ADDRESS',
  'Mağaza': 'Store',
  "Mağazanızın Shopify adresini girin, Shopify'ın kendi onay ekranına yönlendirileceksiniz.": "Enter your store's Shopify address, you'll be redirected to Shopify's own approval screen.",
  'Meta Ad Account Seç': 'Select Meta Ad Account',
  'Meta bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect Meta?',
  'Müşteri ID': 'Customer ID',
  "Müşterinin kendi Adjust hesabından ürettiği API token'ı girin.": "Enter the API token the client generated from their own Adjust account.",
  "Müşterinin kendi Criteo hesabından ürettiği Client ID / Client Secret'ı girin.": "Enter the Client ID / Client Secret the client generated from their own Criteo account.",
  "Müşterinin kendi OpenAI Ads Manager hesabından ürettiği API key'i girin.": "Enter the API key the client generated from their own OpenAI Ads Manager account.",
  'OAuth başlatılamadı.': 'Could not start OAuth.',
  'Oluşturuluyor...': 'Creating...',
  'Onay bekleyen kampanya değişiklikleri için e-posta bildirimi al.': 'Get an email notification for campaign changes awaiting approval.',
  'Onay bekleyen kampanya değişiklikleri ve otomasyon şablonları için e-posta bildirimi al.': 'Get an email notification for campaign changes and automation templates awaiting approval.',
  'Otomatik Uygulama Kuralları': 'Automatic Rule Notifications',
  'PNG/JPG, maks. 500KB': 'PNG/JPG, max 500KB',
  'PROPERTY ID': 'PROPERTY ID',
 
  'Performans özetlerini içeren günlük analiz raporlarını al.': 'Get daily analytics reports with performance summaries.',
  'Profil': 'Profile',
  'Profil Bilgileri': 'Profile Information',
  'Profili Kaydet': 'Save Profile',
  'Property ID': 'Property ID',
  'Property kaydedilemedi.': 'Could not save the property.',
  'RTB House panel giriş bilgilerinizi girin.': 'Enter your RTB House panel login details.',
  'Search Console Sitesi Seç': 'Select Search Console Site',
  'Search Console bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect Search Console?',
  'Shopify bağlantısı başarısız oldu:': 'Shopify connection failed:',
  'mağazası Poyais One hesabınıza bağlansın mı?': 'store — connect it to your Poyais One account?',
  'Shopify bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect Shopify?',
  'RTB House bağlantısını kesmek istediğinize emin misiniz?': 'Are you sure you want to disconnect RTB House?',
  'İşleniyor…': 'Processing…',
  'Site kaydedilemedi.': 'Could not save the site.',
  'Soyad': 'Last Name',
  'SİTE': 'SITE',
  'Tercihler': 'Preferences',
  'Token doğrulanamadı.': 'Could not verify the token.',
  "Token'ı değiştir": 'Change token',
  'UYGULAMA SEÇ': 'SELECT APP',
  'Uygulama': 'App',
  'Yapay zeka tarafından uygulanan kural bildirimlerini al.': 'Get notifications for rules applied automatically by AI.',
  'Yeni Anahtar Oluştur': 'Create New Key',
  'Yeni Şifre': 'New Password',
  'Yeni şifre girin.': 'Enter a new password.',
  'Yönlendiriliyor…': 'Redirecting…',
  'claude.ai\'da "custom connector" eklerken de aynı adresi ve Authorization başlığını kullanabilirsiniz.': 'You can use the same address and Authorization header when adding a "custom connector" in claude.ai as well.',
  'içine': '',
  'oluşturuldu': 'created',
  'son kullanım': 'last used',
  '~30 saniye · Facebook hesabınla giriş yap, reklam hesabını seç.': '~30 seconds · sign in with your Facebook account, select your ad account.',
  '~30 saniye · Google hesabınla giriş yap, izin ver, otomatik döneceksin.': '~30 seconds · sign in with your Google account, grant access, you\'ll be redirected back automatically.',
  '~30 saniye · Google hesabınla giriş yap, izin ver, reklam hesabını seç.': '~30 seconds · sign in with your Google account, grant access, select your ad account.',
  '~30 saniye · Google hesabınla giriş yap, izin ver, siteni seç.': '~30 seconds · sign in with your Google account, grant access, select your site.',
  'Önce bir müşteri seçin.': 'Select a client first.',
  'Önce üstten bir müşteri seçin.': 'Select a client from above first.',
  'Örn. Pazarlama Müdürü': 'e.g. Marketing Manager',
  'Örn: 123-456-7890': 'e.g. 123-456-7890',
  'Ünvan': 'Title',
  'İPTAL EDİLDİ': 'REVOKED',
  'İptal Et': 'Revoke',
  'İzin': 'Permission',
  'Şifre Değiştir': 'Change Password',
  'Şifre Tekrar': 'Confirm Password',
  'Şifre en az 10 karakter olmalı ve en az bir harf ile bir rakam içermelidir.': 'Password must be at least 10 characters and include a letter and a number.',
  'Şifre güncellenemedi.': 'Could not update the password.',
  'Şifreler eşleşmiyor.': 'Passwords do not match.',
  'Şifreni tekrar gir': 'Re-enter your password',
  'Şifreyi Güncelle': 'Update Password',
  'Şirket': 'Company',
  'Şirket Adı': 'Company Name',
  'Şirket Bilgileri': 'Company Information',
  'Şirket adı boş olamaz.': 'Company name cannot be empty.',
  'Şirket adını yalnızca şirket sahibi (Client) değiştirebilir.': 'Only the company owner (Client) can change the company name.',
  'Şirketi Kaydet': 'Save Company',
  'ŞİFRE': 'PASSWORD',
  // AdminClientsTab + AdminTab
  'Ad Soyad': 'Full Name',
  'Adminler': 'Admins',
  'Aktif Müşteriler': 'Active Clients',
  "Bağlı Feed'ler": 'Connected Feeds',
  'Bağlı Müşteriler': 'Connected Clients',
  'Bağlı Platformlar': 'Connected Platforms',
  'Bekleyenler': 'Pending',
  'Bilinmeyen': 'Unknown',
  'Bu müşteriyi silmek istediğinizden emin misiniz?': 'Are you sure you want to delete this client?',
  'Değiştirmek için girin...': 'Enter to change...',
  'Düzenle': 'Edit',
  'Ekle': 'Add',
  'Feed Ata': 'Assign Feed',
  'Feed Yönetimi': 'Feed Management',
  "Feed'ler": 'Feeds',
  'Gösteriliyor': 'Showing',
  'Güncelle': 'Update',
  'Güncellenemedi': 'Could not update',
  'Hata:': 'Error:',
  'Hata: Feed ataması yapılamadı': 'Error: Could not assign the feed',
  'Henüz bağlı müşteri yok.': 'No connected client yet.',
  'Kaldır': 'Remove',
  'Kaydet': 'Save',
  'Kayıt Tarihi': 'Registered',
  'Kullanıcı': 'User',
  'Kullanıcı Ata': 'Assign User',
  'Kullanıcı Düzenle': 'Edit User',
  'Kullanıcı ara...': 'Search users...',
  'Kullanıcı bulunamadı': 'No user found',
  'Müşteri': 'Client',
  'Müşteri Adı': 'Client Name',
  'Müşteri Düzenle': 'Edit Client', 'Müşterinin paketi': 'Client plan', 'Paket': 'Plan', 'Deneme': 'Trial', 'Pasif': 'Inactive', 'İptal Ediliyor': 'Canceling', 'Paketi Güncelle': 'Update Plan', 'Paket güncellendi ✓': 'Plan updated ✓', 'Bitiş Tarihi (isteğe bağlı)': 'End Date (optional)', 'Kaydediliyor…': 'Saving…',
  'Paketi elle değiştirir; ödeme sağlayıcısındaki aboneliği değiştirmez. Aktif ücretli abonelik varsa sağlayıcıdan gelen bir olay paketi yeniden değiştirebilir.': 'Changes the plan manually; it does not change the subscription at the payment provider. If a paid subscription is active, an event from the provider may change the plan again.',
  'Müşteri ekle...': 'Add client...',
  'Müşteri eklendi ✓': 'Client added ✓',
  'Müşteri güncellendi ✓': 'Client updated ✓',
  'Müşteri Yöneticisi': 'Client Admin',
  'Müşteriler': 'Clients',
  'Oluştur': 'Create',
  'Platformlar': 'Platforms',
  'Rol': 'Role',
  'Seç': 'Select',
  'Sil': 'Delete',
  'Silindi': 'Deleted',
  'Silinemedi': 'Could not delete',
  'Son Giriş': 'Last Login',
  'Toplam Kullanıcı': 'Total Users',
  "Tüm feed'ler bir müşteriye atanmış.": 'All feeds are assigned to a client.',
  'Yeni': 'New',
  'Yeni Kayıtlar': 'New Signups',
  'Yeni Kullanıcı': 'New User',
  'Yeni Kullanıcı Oluştur': 'Create New User',
  'Yeni Müşteri': 'New Client',
  'Yeni Müşteri Ekle': 'Add New Client',
  'Yeni Şifre (opsiyonel)': 'New Password (optional)',
  'Yönetici': 'Admin',
  'Yüklenemedi': 'Could not load',
  '{name} adlı kullanıcıyı silmek istediğinizden emin misiniz?': 'Are you sure you want to delete the user "{name}"?',
  'aktif müşteri olarak seçildi': 'set as active client',
  'müşterisine eklendi ✓': 'added ✓',
  'İptal': 'Cancel',
  'İşlemler': 'Actions',
  // GoogleTab / GAds family
  'Veri bulunamadı.': 'No data found.',
  'tıklama': 'clicks',
  'kampanya': 'campaigns',
  'Kampanya Analizi': 'Campaign Analysis',
  'Kampanyalar': 'Campaigns',
  'Kampanya ara…': 'Search campaigns…',
  'Duraklatılmış': 'Paused',
  'Kampanya': 'Campaign',
  'Durum': 'Status',
  'Duraklatıldı': 'Paused',
  // GA4Tab
  'Kullanıcılar': 'Users',
  'Oturumlar': 'Sessions',
  'Sayfa Görüntülemeleri': 'Page Views',
  'Ortalama Süre': 'Average Duration',
  'vs önceki dönem': 'vs previous period',
  'Kanal Dağılımı': 'Channel Distribution',
  'Kaynak/Medium': 'Source/Medium',
  'Dönüşüm Oranı': 'Conversion Rate',
  'Satın alma verisi yok': 'No purchase data',
  'Hemen Çıkma Oranı': 'Bounce Rate',
  'Yeni Kullanıcı Oranı': 'New User Rate',
  'Oturum Başına Sayfa': 'Pages per Session',
  'En Çok Ciro': 'Top Revenue',
  'En yüksek ciro katkısı': 'Highest revenue contribution',
  'En Çok Trafik': 'Top Traffic',
  'En yüksek oturum katkısı': 'Highest session contribution',
  'En Çok Yeni Kullanıcı': 'Top New Users',
  'En yüksek yeni kullanıcı katkısı': 'Highest new user contribution',
  'En Kaliteli Kanal': 'Best Quality Channel',
  'En düşük hemen çıkma oranı': 'Lowest bounce rate',
  'Çok Ziyaret Edilen Sayfalar': 'Most Visited Pages',
  'Sayfa ara…': 'Search pages…',
  'Sayfa': 'Page',
  'Görüntüleme': 'Views',
  'Süre': 'Duration',
  'Sepet': 'Cart',
  // SettingsTab (missing key fix)
  'Geliştirici': 'Developer',
  // MetaTab
  'Aktif': 'Active',
  'Yok': 'None',
  'Harcama': 'Spend',
  'Gelir': 'Revenue',
  'Satın Alma': 'Purchases',
  'Erişim': 'Reach',
  'Geçen döneme göre.': 'Compared to the previous period.',
  'Satışlardan elde edilen tutar.': 'Amount generated from sales.',
  'Toplam dönüşüm adedi.': 'Total number of conversions.',
  'Tekil kullanıcılara erişim.': 'Reach to unique users.',
  'Meta Kampanya Analizi': 'Meta Campaign Analysis',
  'En yüksek performanslı kampanyaların harcama dağılımı.': 'Spend distribution of the top-performing campaigns.',
  'Detaylı İncele →': 'View Details →',
  'Tıklama': 'Clicks',
  'Görüntülenme': 'Impressions',
  'En yüksek bütçeyi bu kampanya kullandı.': 'This campaign used the highest budget.',
  'En geniş kitleye bu kampanya ulaştı.': 'This campaign reached the widest audience.',
  'En çok tıklamayı bu kampanya aldı.': 'This campaign received the most clicks.',
  'Ayın En İyisi': "Best of the Month",
  'Yeterli veri yok.': 'Not enough data.',
  'Analize Git': 'Go to Analysis',
  'Meta Kampanyalar': 'Meta Campaigns',
  'Filtrele': 'Filter',
  'Tümü': 'All',
  'Sırala': 'Sort',
  'Dönüşüm': 'Conversion',
  // GA4PagePerformanceTab
  'Toplam Görüntüleme': 'Total Views',
  'En Çok Görüntülenen Sayfa': 'Most Viewed Page',
  'Toplam Sepete Ekle': 'Total Add to Cart',
  'En Yüksek ATC Rate': 'Highest ATC Rate',
  'Sayfa URL veya başlığına göre ara...': 'Search by page URL or title...',
  'ATC CR Filtresi': 'ATC CR Filter',
  'Yüksek (≥%2)': 'High (≥2%)',
  'Düşük (<1%)': 'Low (<1%)',
  'Bounce Filtresi': 'Bounce Filter',
  'Yüksek (≥%50)': 'High (≥50%)',
  'Düşük (<30%)': 'Low (<30%)',
  'Sıfırla': 'Reset',
  'Dışa Aktar': 'Export',
  'Sayfa (URL)': 'Page (URL)',
  'Görüntüleme vs. ATC Trend': 'Views vs. ATC Trend',
  'Son 30 günlük sayfa bazlı performans grafiği': 'Per-page performance chart for the last 30 days',
  'AI Analizi': 'AI Analysis',
  'Hızlı Kazanç Fırsatı': 'Quick Win Opportunity',
  'Kapat ↑': 'Close ↑',
  'Detayları Gör →': 'View Details →',
  // GA4TrafficSourcesTab
  'Toplam Kaynak': 'Total Source',
  'Toplam Kaynak Tipi': 'Total Source Type',
  'Toplam Kampanya': 'Total Campaign',
  'Toplam Oturum': 'Total Sessions',
  'Ortalama CR': 'Average CR',
  'Tüm kaynaklardan gelen oturum.': 'Sessions from all sources.',
  'Siteyi ziyaret eden kullanıcı.': 'Users who visited the site.',
  'Tüm kaynaklardan gelen satın alma.': 'Purchases from all sources.',
  'Tüm kaynaklardan gelen gelir.': 'Revenue from all sources.',
  'Oturumdan satın almaya dönüşüm oranı.': 'Session-to-purchase conversion rate.',
  'Farklı trafik kaynağı.': 'Distinct traffic sources.',
  'Farklı kaynak tipi.': 'Distinct source types.',
  'Farklı kampanya tespit edildi.': 'Distinct campaigns detected.',
  'Trafik Kaynağı Analizi': 'Traffic Source Analysis',
  'Genel kanal gruplarına göre performans verileri.': 'Performance data by general channel groups.',
  'Kaynak': 'Source',
  'Kaynak Tipi': 'Source Type',
  'İsim': 'Name',
  'Oturum': 'Session',
  '(belirsiz)': '(not set)',
  'Görsel Performans Trendi': 'Visual Performance Trend',
  'Haftalık Trafik Dağılımı': 'Weekly Traffic Distribution',
  'Kanal bazlı performans verilerinin zamana göre değişimi ve kampanya etkileşim oranları.': 'How channel-based performance data changes over time and campaign engagement rates.',
  'Özet İstatistik': 'Summary Statistic',
  'CPC Kanal Reklam Geliri': 'CPC Channel Ad Revenue',
  'Toplam Gelire Oranı': 'Share of Total Revenue',
  'CPC Oturum': 'CPC Sessions',
  'CPC Satın Alma': 'CPC Purchases',
  // GAdsAdTextsTab
  'Düşük Perf.': 'Low Perf.',
  'Beklemede': 'Pending',
  'Toplam Reklam': 'Total Ads',
  'En İyi ROAS': 'Best ROAS',
  'Dönüşümsüz': 'No Conversions',
  'Reklam Metinleri Performansı': 'Ad Text Performance',
  'Google Ads kampanyalarınızdaki aktif metinlerin detaylı verileri.': 'Detailed data for the active ad texts in your Google Ads campaigns.',
  'Kampanya veya başlık ara…': 'Search campaign or headline…',
  'Reklam Metni': 'Ad Text',
  'Sonuç bulunamadı': 'No results found',
  'Trend Analizi': 'Trend Analysis',
  'ROAS ≥ 2× Uyum': 'ROAS ≥ 2× Compliance',
  // GAdsHeatmapTab
  'Önceki döneme göre': 'Vs previous period',
  'Bu dönem için kampanya verisi yok.': 'No campaign data for this period.',
  'Bu dönem için kampanya tipi verisi yok.': 'No campaign type data for this period.',
  'Ad Set Harcama Dağılımı': 'Ad Set Spend Distribution',
  'Meta bu kitlenin gerçek boyutunu paylaşmıyor (çok küçük ya da henüz dolmamış olabilir).': 'Meta does not share this audience\'s real size (it may be too small or not yet populated).',
  'Boyut paylaşılamıyor.': 'Size not shared.',
  'Veri yok': 'No data',
  'Detay için tıkla': 'Click for details',
  'Kampanya Detayı': 'Campaign Details',
  'Bu kampanya için günlük kırılım alınamadı.': 'Daily breakdown is unavailable for this campaign.',
  'Günlük veri alınamadı, tekrar deneyin.': 'Could not load daily data, try again.',
  'Bu dönemde bu kampanya için günlük veri yok.': 'No daily data for this campaign in this period.',
  'Günlük Seyir': 'Daily Trend',
  'En yüksek ROAS günü': 'Best ROAS day',
  'Tarih': 'Date',
  'Karşılaştırma için Google Ads veya Meta Ads bağlı olmalı.': 'Google Ads or Meta Ads must be connected to compare.',
  'Bağlı değil': 'Not connected',
  'Bütçe Dağılımı': 'Budget Split',
  'Günlük Karşılaştırma': 'Daily Comparison',
  'Bu dönem için veri yok.': 'No data for this period.',
  'terim seçili': 'terms selected',
  'Negatif Olarak Ekle (Onaya Gönder)': 'Add as Negative (Send for Approval)',
  'Gönderiliyor…': 'Sending…',
  'Seçimi Temizle': 'Clear Selection',
  'Tümünü seç': 'Select all',
  'Onay Bekleyenlere Git →': 'Go to Pending Approvals →',
  'Kuyruğa eklenemedi.': 'Could not add to queue.',
  'terim onay kuyruğuna eklendi. Onaylayana kadar hiçbir değişiklik yapılmaz.': 'terms added to the approval queue. Nothing changes until you approve.',
  'Seçilen terimlerde kampanya bilgisi yok; sayfayı yenileyip tekrar deneyin.': 'Selected terms have no campaign info; refresh the page and try again.',
  'Dönüşüm aldı': 'Converted',
  'Dönüşüm yok': 'No conversions',
  'Öneri: yeni kreatif varyantları ekleyin ya da kitleyi genişletin. Bilinirlik amaçlı reklamlarda yüksek frekans planlı olabilir.': 'Tip: add new creative variants or broaden the audience. High frequency can be intentional for awareness ads.',
  'Karşılaştırma için en az bir reklam platformu bağlı olmalı.':'At least one ad platform must be connected to compare.',
  'Veri alınamadı':'Could not load data',
  'Seçili metrik için gösterilecek mecra yok.':'No platform to show for the selected metric.',
  'günlük kırılım sunmuyor, yalnızca toplam kartında görünür.':'does not provide a daily breakdown; shown in the totals card only.',
  'Katalog':'Catalog',
  'Zamanlama Önerisi': 'Scheduling Suggestion',
  'Teklifi artırmayı düşün': 'Consider raising bids',
  'Teklifi düşürmeyi düşün': 'Consider lowering bids',
  'Bu öneri yalnızca seçili dönemin verisine dayanır; marka/bilinirlik kampanyaları ROAS ile değerlendirilmez. Değişiklik otomatik uygulanmaz.': 'This suggestion is based only on the selected period; brand/awareness campaigns are not judged by ROAS. Nothing is applied automatically.',
  'Öneri kuyruğa eklenemedi.': 'Could not add the suggestion to the queue.',
  'Öneri kuyruğa eklenemedi, tekrar deneyin.': 'Could not add the suggestion to the queue, try again.',
  'Öneri onay kuyruğuna eklendi (+%20 / −%20 bütçe). Onaylayana kadar değişiklik yapılmaz.': 'Suggestion added to the approval queue (+20% / −20% budget). Nothing changes until you approve.',
  'Gün bazlı kırılım bu hesap için henüz mevcut değil; satır tüm günlerin saatlik toplamını gösterir.': 'Per-day breakdown is not available for this account yet; the row shows the hourly total across all days.',
  'En İyi Dönüşüm Saati': 'Best Conversion Hour',
  'En Düşük CPA Günü': 'Lowest CPA Day',
  'Ort. CPA': 'Avg. CPA',
  'Ortalama ROAS': 'Average ROAS',
  'Haftalık Performans Isı Haritası': 'Weekly Performance Heatmap',
  'Düşük': 'Low',
  'Yüksek': 'High',
  'Günlük ROAS & Harcama Dağılımı': 'Daily ROAS & Spend Distribution',
  'Saatlik Performans Tablosu': 'Hourly Performance Table',
  'Saat Aralığı': 'Hour Range',
  'Harcama %': 'Spend %',
  'Tüm Saat Dilimlerini Gör': 'View All Time Slots',
  // MetaAdSetsTab
  'Toplam Reklam Seti': 'Total Ad Sets',
  'Toplam Satış': 'Total Sales',
  'Performans Detayları': 'Performance Details',
  'Reklam seti veya kampanya…': 'Ad set or campaign…',
  'Satış': 'Sales',
  'Reklam seti bulunamadı': 'No ad set found',
  'Günlük Harcama Trendi': 'Daily Spend Trend',
  'Yapay Zeka Tavsiyesi': 'AI Advice',
  'Stratejiyi Uygula': 'Apply Strategy',
  // MetaPlacementsTab
  'Placement Sayısı': 'Placement Count',
  'Instagram Payı': 'Instagram Share',
  'Facebook Payı': 'Facebook Share',
  'Platform Dağılımı': 'Platform Distribution',
  'Analist Notu:': 'Analyst Note:',
  'Yerleşim Analizi': 'Placement Analysis',
  'Yerleşim ara…': 'Search placement…',
  'Yerleşim': 'Placement',
  'Pay': 'Share',
  'Yerleşim bulunamadı': 'No placement found',
  'Yapay Zeka Destekli': 'AI-Powered',
  'Optimizasyon Fırsatı': 'Optimization Opportunity',
  'Tüm yerleşimleriniz kabul edilebilir performans gösteriyor.': 'All your placements are showing acceptable performance.',
  // GA4AudienceTab
  'Yeni Kullanıcılar': 'New Users',
  'Kullanıcı Başına Oturum': 'Sessions per User',
  'Yaş Dağılımı': 'Age Distribution',
  'Yaş verisi mevcut değil. GA4 bu veriyi ancak Google Signals / demografik veri toplama açıksa ve yeterli trafik varsa gösterir — GA4 Yönetici → Veri Toplama ayarlarından kontrol edin.': 'Age data is not available. GA4 only shows this data if Google Signals / demographic data collection is enabled and there is enough traffic — check under GA4 Admin → Data Collection settings.',
  'Cinsiyet': 'Gender',
  'Cinsiyet verisi mevcut değil. GA4 bu veriyi ancak Google Signals / demografik veri toplama açıksa ve yeterli trafik varsa gösterir.': 'Gender data is not available. GA4 only shows this data if Google Signals / demographic data collection is enabled and there is enough traffic.',
  'KADIN': 'FEMALE',
  'Kadın': 'Female',
  'Erkek': 'Male',
  'Cihaz Dağılımı': 'Device Distribution',
  'Yaş Grubuna Göre Gelir': 'Revenue by Age Group',
  'Demografik katmanlara göre toplam satış performansı.': 'Total sales performance by demographic segment.',
  'Yaş verisi mevcut değil (GA4 demografik veri toplama kapalı veya trafik eşiği yetersiz).': 'Age data is not available (GA4 demographic data collection is off or the traffic threshold is not met).',
  'Veriler Google Analytics 4 üzerinden otomatik olarak senkronize edilmektedir.': 'Data is automatically synced via Google Analytics 4.',
  'Son Güncelleme: Bugün 14:22': 'Last Updated: Today 14:22',
  // GA4FunnelTab
  'Toplam Gelir': 'Total Revenue',
  'Sepete Ekle': 'Add to Cart',
  'Ödeme—Satış': 'Payment—Sale',
  'Funnel başlangıç oturumu.': 'Funnel starting sessions.',
  'Seçili dönem toplam geliri.': 'Total revenue for the selected period.',
  'Ödeme başlatanların tamamlama oranı.': 'Completion rate of those who started payment.',
  'Funnel Hunisi': 'Funnel',
  'çıkış': 'drop-off',
  'Başlangıç': 'Start',
  'Adım Detayları': 'Step Details',
  'Adım': 'Step',
  'Kayıp Oranı': 'Drop-off Rate',
  'Cihaz Kırılımı': 'Device Breakdown',
  'Dönüşüm Hedefi Önerisi': 'Conversion Goal Suggestion',
  // GAdsCampaignTypesTab
  'Kampanya Tipi Kırılımı': 'Campaign Type Breakdown',
  'Tip': 'Type',
  'Harcama Payı': 'Spend Share',
  'Birincil kampanya tiplerine göre bütçe dağılımı.': 'Budget distribution by primary campaign type.',
  // GAdsSearchTermsTab
  'Toplam Terim': 'Total Terms',
  'En Yüksek ROAS': 'Highest ROAS',
  'En Yüksek Harcama': 'Highest Spend',
  'Bu dönem için search term verisi yok, analiz edilecek bir şey bulunamadı.': 'There is no search term data for this period, nothing to analyze.',
  'Analiz yapılıyor…': 'Analyzing…',
  'AI ile Analiz Et': 'Analyze with AI',
  'AI Özeti': 'AI Summary',
  'En İyi Performanslılar': 'Top Performers',
  'Negatif Adayları': 'Negative Candidates',
  'Fırsatlar': 'Opportunities',
  'Terim veya kampanya ara…': 'Search term or campaign…',
  'Sadece Dönüşüm Alanlar': 'Converting Only',
  'Yüksek Harcama': 'High Spend',
  'Terim': 'Term',
  'Ekli': 'Added',
  'Eklenmemiş': 'Not Added',
  'AI yanıtı ayrıştırılamadı, tekrar deneyin.': 'Could not parse the AI response, please try again.',
  'AI analizi başarısız oldu, tekrar deneyin.': 'AI analysis failed, please try again.',
  // MetaAudienceTab
  'Özel': 'Custom',
  'Benzer': 'Lookalike',
  'Etkileşim': 'Engagement',
  'Toplam Satın Alma': 'Total Purchases',
  'Cinsiyet Dağılımı': 'Gender Distribution',
  'En Verimli Yaş Grubu': 'Most Efficient Age Group',
  'Yaş Aralığı': 'Age Range',
  'AI Insight: Cinsiyet & Yaş Analizi': 'AI Insight: Gender & Age Analysis',
  'Analiz ediliyor…': 'Analyzing…',
  'Kitle Analizi': 'Audience Analysis',
  'Kitle Adı': 'Audience Name',
  'Boyut': 'Size',
  'Kitle verisi bulunamadı.': 'No audience data found.',
  // MetaCreativesTab
  'Görsel': 'Image',
  'Ciro': 'Revenue',
  'Gösterim': 'Impressions',
  'Frekans': 'Frequency',
  'Toplam Kreatif': 'Total Creatives',
  'Ort. CTR': 'Avg. CTR',
  'Optimize Edilebilir': 'Optimizable',
  'Tüm Durum': 'All Statuses',
  'Kreatif': 'Creative',
  'Tür': 'Type',
  'Raporu İndir': 'Download Report',
  'Sırala:': 'Sort:',
  'Kreatif bulunamadı.': 'No creative found.',
  'Paylaşım': 'Post Boost',
  'Trafik': 'Traffic',
  'Bilinirlik': 'Awareness',
  'Potansiyel Müşteri': 'Leads',
  'Video Görüntüleme': 'Video Views',
  'Mesaj': 'Messages',
  'Önizle': 'Preview',
  'Reklam amacı — Meta’da önizlemek için tıkla': 'Ad objective — click to preview on Meta',
  // PoyaisOneTab
  '%99.9 hatasız yönetim.': '99.9% error-free management.',
  'AI Etkisi': 'AI Impact',
  'AI ÖNERİSİ': 'AI SUGGESTION',
  'Akıllı otomasyonların aktif edildiği hesaplarda gözlemlenen ortalama performans iyileşmesi.': 'Average performance improvement observed on accounts with smart automations enabled.',
  'Aksiyon': 'Action',
  'Aktif ettiğin bir şablonun koşulu sağlandığında burada onay bekleyecek.': 'When a condition of a template you activated is met, it will wait for approval here.',
  'Aktif İzleme': 'Actively Monitoring',
  'AKTİF İZLEME': 'ACTIVELY MONITORING',
  'Aktive Et': 'Activate',
  'Anlık karar': 'Instant decisions',
  'Bilinmeyen hata': 'Unknown error',
  'Hata minimizasyonu': 'Error minimization',
  'KRİTİK': 'CRITICAL',
  'Milisaniyeler içinde tepki.': 'Reacts within milliseconds.',
  'Onay Bekleyenler': 'Pending Approvals',
  'Onay bekleyen otomasyon yok': 'No automations pending approval',
  'ÖNEMLİ': 'IMPORTANT',
  'OPTİMİZE': 'OPTIMIZE',
  'Özel Akış': 'Custom Flow',
  'Özel otomasyon akışı': 'Custom automation flow',
  'Özel otomasyon akışı oluşturun.': 'Create a custom automation flow.',
  'Poyais One otomasyonları ile manuel operasyonları minimize edin. AI tabanlı algoritmalarımız 7/24 reklam performansınızı denetler ve bütçenizi en verimli kampanyalara yönlendirmenize yardım eder.': 'Minimize manual operations with Poyais One automations. Our AI-based algorithms monitor your ad performance 24/7 and help you steer budget to your most efficient campaigns.',
  'Şablon ara…': 'Search templates…',
  'Şablonlar': 'Templates',
  'Şablonlar yüklenemedi': 'Could not load templates',
  'SON ÇALIŞMA:': 'LAST RUN:',
  'Tetikleyici Koşullar': 'Trigger Conditions',
  'TÜMÜ': 'ALL',
  'Verimlilik Artışı': 'Efficiency Increase',
  'Yeni Akış Oluştur': 'Create New Flow',
  'Zaman ve Bütçe Tasarrufu': 'Time and Budget Savings',
});

const NAV_TO_URL: Record<string,string> = {'dashboard':'/dashboard','asistan':'/asistan','panolar':'/panolar','gorevler':'/gorevler','notlar':'/notlar','uyari':'/uyarilar','ga4-overview':'/analytics/overview','ga4-audience':'/analytics/audience','ga4-funnel':'/analytics/funnel','ga4-pages':'/analytics/pages','ga4-traffic':'/analytics/traffic','ga4-products':'/analytics/products','gsc-overview':'/search-console/overview','gsc-queries':'/search-console/queries','gsc-pages':'/search-console/pages','chatgpt-ads-overview':'/chatgpt-ads/overview','chatgpt-ads-campaigns':'/chatgpt-ads/campaigns','x-ads-overview':'/x-ads/overview','x-ads-campaigns':'/x-ads/campaigns','tiktok-overview':'/tiktok-ads/overview','tiktok-campaigns':'/tiktok-ads/campaigns','tiktok-adgroups':'/tiktok-ads/adgroups','adjust-overview':'/adjust/overview','adjust-campaigns':'/adjust/campaigns','shopify-overview':'/shopify/overview','shopify-products':'/shopify/products','shopify-sales':'/shopify/satis-analizi','shopify-orders':'/shopify/siparisler','shopify-returns':'/shopify/iadeler','shopify-sources':'/shopify/trafik-kaynaklari','shopify-ads':'/shopify/reklam-performansi','ikas-overview':'/ikas/genel-bakis','ikas-products':'/ikas/urunler','ikas-orders':'/ikas/siparisler','pixa-overview':'/pixa/genel-bakis','pixa-asistan':'/pixa/asistan','pixa-orders':'/pixa/siparisler','pixa-returns':'/pixa/iadeler','pixa-shipments':'/pixa/kargo','pixa-customers':'/pixa/musteriler','pixa-products':'/pixa/katalog','pixa-listings':'/pixa/pazaryeri-listeleri','pixa-pricing':'/pixa/degisiklik-gecmisi','pixa-inventory':'/pixa/stok','pixa-integrations':'/pixa/entegrasyonlar','pixa-reports':'/pixa/raporlar','criteo-overview':'/criteo/overview','criteo-campaigns':'/criteo/campaigns','gads-overview':'/google-ads/overview','gads-campaigns':'/google-ads/kampanyalar','gads-placements':'/google-ads/yerlesimler','gads-audience':'/google-ads/kitle','gads-health':'/google-ads/hesap-sagligi','gads-searchterms':'/google-ads/search-terms','gads-adtexts':'/google-ads/ad-texts','gads-dayparting':'/google-ads/dayparting','ads-compare':'/reklam/karsilastirma','meta-overview':'/meta-ads/overview','meta-campaigns':'/meta-ads/kampanyalar','meta-hourly':'/meta-ads/gun-saat','meta-health':'/meta-ads/hesap-sagligi','meta-audience':'/meta-ads/audience','meta-creatives':'/meta-ads/creatives','meta-adsets':'/meta-ads/adsets','meta-placements':'/meta-ads/placements','poyaisone-automation':'/poyais-one/automation','poyaisone-flow':'/poyais-one/flow','poyaisone-campaign-builder':'/poyais-one/kampanya-olusturucu','poyaisone-audiences':'/poyais-one/akilli-kitleler','poyaisone-recommendations':'/poyais-one/recommendations','poyaisone-logs':'/poyais-one/logs','growth-products':'/buyume/urun-analizi','growth-forecast':'/buyume/tahminleme','growth-price-elasticity':'/buyume/fiyat-talep','settings':'/settings','admin':'/admin','admin-clients':'/admin/clients','admin-reports':'/admin/raporlar','rtbhouse-overview':'/rtbhouse/overview','rtbhouse-campaigns':'/rtbhouse/campaigns','rtbhouse-creatives':'/rtbhouse/creatives','feed-wizard':'/araclar/feed-wizard','dynamic-feed':'/araclar/dynamic-feed','geo-overview':'/araclar/airadar/genel-bakis','geo-prompts':'/araclar/airadar/promptlar','geo-competitors':'/araclar/airadar/rakipler','geo-perception':'/araclar/airadar/marka-algisi','kredi-yukle':'/hesap/kredi','destek':'/hesap/destek','faturalandirma':'/hesap/faturalandirma','takim':'/hesap/takim'};
const URL_TO_NAV: Record<string,string> = {
  ...Object.fromEntries(Object.entries(NAV_TO_URL).map(([k,v]) => [v,k])),
  // Eski adresler (Derin Analiz menüsü ve Kampanya Tipi sayfası kaldırıldı; içerikleri ilgili sayfalara taşındı)
  '/google-ads/campaign-types':'gads-campaigns', '/derin-analiz/google-display':'gads-campaigns', '/derin-analiz/google-pmax':'gads-campaigns',
  '/derin-analiz/google-uygulama':'gads-campaigns', '/derin-analiz/meta-kirilimlar':'meta-audience', '/meta-ads/saatlik':'meta-hourly', '/google-ads/kreatifler':'gads-audience', '/derin-analiz/meta-saglik':'meta-health',
};


axios.interceptors.request.use(cfg => { 
  const t = getToken(); 
  if(t) (cfg.headers as any)['Authorization'] = 'Bearer ' + t; 
  if(cfg.method === 'get' || !cfg.method) {
    cfg.params = { ...cfg.params, _t: Date.now() };
  }
  return cfg; 
});
axios.interceptors.response.use(r => r, e => { if(e?.response?.status === 401) logout(); return Promise.reject(e); });





function useIsMobile() {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

const API = '/api/v1';

// 401 gelince otomatik logout
axios.interceptors.response.use(
  r => r,
  err => {
    if(err.response?.status === 401) {
      localStorage.removeItem('poyais_token');
      localStorage.removeItem('poyais_user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);
const GOLD = '#C9A84C', GOLD_L = '#E8C97A', GREEN = '#16D49B', RED = '#FF5C7A', BLUE = '#5B8DEF';
const C = { gold:GOLD, goldL:GOLD_L, green:GREEN, red:RED, blue:BLUE, surface:'#ffffff', s2:'#F7F8FC', s3:'#E4E6EF', white:'#1A1A2E', whiteD:'#6B6B8A', whiteM:'#6B6B8A' };

const STORAGE_KEY = 'poyais_config';

const defaultConfig = {
  profile: { name:'', surname:'', title:'', email:'', photo:'' },
  platforms: {
    ga4:      { enabled:false, label:'Google Analytics 4', propertyId:'' },
    gads:     { enabled:false, label:'Google Ads',          customerId:'' },
    meta:     { enabled:false, label:'Meta Ads',            accountId:'' },
    rtbhouse: { enabled:false, label:'RTB House', token:'', email:'', password:'' },
    search_console: { enabled:false, label:'Search Console', siteUrl:'' },
    chatgpt_ads: { enabled:false, label:'ChatGPT Ads', apiKey:'', accountName:'' },
    adjust: { enabled:false, label:'Adjust', apiToken:'', appToken:'', appName:'' },
    shopify: { enabled:false, label:'Shopify', shopDomain:'', shopName:'' },
    ikas: { enabled:false, label:'İkas', store:'' },
    pixa: { enabled:false, label:'Pixa', host:'', email:'', apiToken:'', userName:'', currency:'' },
    criteo: { enabled:false, label:'Criteo', clientId:'', advertiserId:'', advertiserName:'', datasetId:'' },
  },
  notifications: { email_on_apply:true, email_on_auto:true, auto_apply:false, auto_apply_threshold:'low' },
};

function loadConfig() {
  try { return { ...defaultConfig, ...JSON.parse(localStorage.getItem(STORAGE_KEY)||'{}') }; }
  catch { return defaultConfig; }
}
function saveConfig(cfg: any) { localStorage.setItem(STORAGE_KEY, JSON.stringify(cfg)); }

// Kaydedilmiş aktif müşteri yoksa (yeni cihaz/tarayıcı) alfabetik ilk yerine
// gerçekten bir platformu bağlı olan ilk müşteriyi seç — admin hesapları
// /clients/ üzerinden tüm müşterileri (boş test müşterileri dahil) görüyor.
function pickDefaultClient(list: any[]): any {
  return list.find((c:any) => c.gads_customer_id || c.meta_account_id || c.ga4_property_id) || list[0];
}

const todayStr    = () => { const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; };
const monthStart  = () => { const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-01`; };
const prevMonthStart = (start:string) => { const d=new Date(start); d.setMonth(d.getMonth()-1); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-01`; };
const prevMonthEnd   = (end:string)   => { const d=new Date(end);   d.setMonth(d.getMonth()-1); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; };

const fmt = {
  n:    (v:number) => Number(v).toLocaleString('tr-TR'),
  k:    (v:number) => v>=1000000?`₺${(v/1000000).toFixed(1)}M`:v>=1000?`₺${(v/1000).toFixed(0)}K`:`₺${Math.round(v)}`,
  roas: (v:number) => `${Number(v).toFixed(2)}×`,
  pct:  (v:number) => `%${Number(v).toFixed(1)}`,
  sec:  (v:number) => `${Math.floor(v/60)}:${String(Math.floor(v%60)).padStart(2,'0')}`,
};

// Sayfalama: aktif sayfa etrafında en fazla `size` düğme (ilk 5 sayfayla sınırlı kalmasın)
const pageWindow = (cur:number, total:number, size=5) => {
  const n = Math.min(size, total);
  const st = Math.max(0, Math.min(cur - Math.floor(n/2), total - n));
  return Array.from({length:n}, (_, i) => st + i);
};

// -- UI Primitives ----------------------------------------------------------

function KpiCard({ label, value, sub, accent=GOLD }:{ label:string; value:string; sub?:string; accent?:string }) {
  const T = SidebarT;
  const [h,setH] = useState(false);
  return (
    <div onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      style={{ background:T.surface, border:`1px solid ${h?'rgba(201,168,76,.35)':'rgba(201,168,76,.12)'}`, borderRadius:10, padding:'18px 20px', transition:'all .2s', transform:h?'translateY(-2px)':'none' }}>
      <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, letterSpacing:0, color:T.textDim, textTransform:'uppercase', marginBottom:12 }}>{label}</div>
      <div style={{ fontFamily:'Manrope, sans-serif', fontSize:34, color:T.ink, lineHeight:1, marginBottom:8 }}>{value}</div>
      {sub && <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:accent }}>{sub}</div>}
    </div>
  );
}

function Card({ children, style={} }:{ children:React.ReactNode; style?:React.CSSProperties }) {
  return <div style={{ background:'#ffffff', border:'1px solid rgba(201,168,76,.12)', borderRadius:10, overflow:'hidden', ...style }}>{children}</div>;
}

function CH({ title, badge }:{ title:string; badge?:string }) {
  return (
    <div style={{ padding:'13px 18px', borderBottom:'1px solid rgba(201,168,76,.08)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
      <span style={{ fontFamily:'Manrope, sans-serif', fontSize:14, letterSpacing:1.5 }}>{title}</span>
      {badge && <span style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:GOLD, background:'rgba(201,168,76,0.10)', border:'1px solid rgba(201,168,76,.25)', padding:'2px 7px', borderRadius:4 }}>{badge}</span>}
    </div>
  );
}

// ── Page Header ───────────────────────────────────────────────────────────
// Modülü tanıtan tek cümlelik açıklama (breadcrumb altında)
const PAGE_DESC:Record<string,string> = {
  'poyaisone-recommendations': 'Poyais One AI reklam hesaplarını tarar; uygulayabileceğin bütçe, duraklatma ve hedef önerilerini listeler.',
  'poyaisone-automation': 'Hazır kuralları aktif et; koşul sağlandığında önerilen değişiklik onayına sunulur.',
};
addTranslations({
  'Yerleşimler': 'Placements', 'Reklam Seti Harcama Dağılımı': 'Ad Set Spend Distribution', 'Tüm Durumlar': 'All Statuses', 'Aktif Değil': 'Not Active', 'Günlük Bütçe': 'Daily Budget', 'Bütçe kampanya düzeyinde': 'Budget is set at campaign level', 'Reklam Seti': 'Ad Set', 'Yerleşim Sayısı': 'Placements', 'Kampanyalar': 'Campaigns', 'Saatlik Performans': 'Hourly Performance', 'Hesap Sağlığı': 'Account Health',
  'Arama Terimleri': 'Search Terms', 'Reklam Metinleri': 'Ad Texts', 'Gün / Saat': 'Day / Hour',
  'Kitle': 'Audience', 'Reklam Setleri': 'Ad Sets',
  'Meta Ads — Kitle': 'Meta Ads — Audience', 'Meta Ads — Reklam Setleri': 'Meta Ads — Ad Sets',
  'Meta Ads — Yerleşimler': 'Meta Ads — Placements',
  'Poyais One AI reklam hesaplarını tarar; uygulayabileceğin bütçe, duraklatma ve hedef önerilerini listeler.': 'Poyais One AI scans your ad accounts and lists budget, pause and target recommendations you can apply.',
  'Hazır kuralları aktif et; koşul sağlandığında önerilen değişiklik onayına sunulur.': 'Turn on ready-made rules; when the condition is met, the suggested change is sent for your approval.',
});
function PageHeader({ nav, start, end, onDateChange, showDate }:{ nav:string; start?:string; end?:string; onDateChange?:(s:string,e:string)=>void; showDate?:boolean }) {
  const { t } = useLang();
  const isMobile = useIsMobile();
  const MAP:Record<string, { title:string; crumbs:string[] }> = {
    'ga4-overview':            { title:'Genel Bakış',         crumbs:['Analytics'] },
    'ga4-audience':            { title:'Audience',            crumbs:['Analytics'] },
    'ga4-funnel':              { title:'Funnel',              crumbs:['Analytics'] },
    'ga4-pages':               { title:'Sayfa Performansı',   crumbs:['Analytics'] },
    'ga4-products':            { title:'Ürün Analizi',        crumbs:['Analytics'] },
    'ga4-traffic':             { title:'Trafik Kaynağı',      crumbs:['Analytics'] },
    'gsc-overview':            { title:'Genel Bakış',         crumbs:['Search Console'] },
    'gsc-queries':             { title:'Sorgular',            crumbs:['Search Console'] },
    'gsc-pages':               { title:'Sayfalar',            crumbs:['Search Console'] },
    'chatgpt-ads-overview':    { title:'Genel Bakış',         crumbs:['ChatGPT Ads'] },
    'chatgpt-ads-campaigns':   { title:'Kampanyalar',         crumbs:['ChatGPT Ads'] },
    'x-ads-overview':          { title:'Genel Bakış',         crumbs:['X Ads'] },
    'x-ads-campaigns':         { title:'Kampanyalar',         crumbs:['X Ads'] },
    'tiktok-overview':         { title:'Genel Bakış',         crumbs:['TikTok Ads'] },
    'tiktok-campaigns':        { title:'Kampanyalar',         crumbs:['TikTok Ads'] },
    'tiktok-adgroups':         { title:'Reklam Grupları',     crumbs:['TikTok Ads'] },
    'adjust-overview':         { title:'Genel Bakış',  crumbs:['Adjust'] },
    'adjust-campaigns':        { title:'Kampanyalar',  crumbs:['Adjust'] },
    'shopify-overview':        { title:'Genel Bakış',  crumbs:['Shopify'] },
    'shopify-products':        { title:'Ürünler',      crumbs:['Shopify'] },
    'shopify-sales':           { title:'Satışlar', crumbs:['Shopify'] },
    'shopify-orders':          { title:'Siparişler',   crumbs:['Shopify'] },
    'shopify-returns':         { title:'İadeler ve İptaller', crumbs:['Shopify'] },
    'shopify-sources':         { title:'Trafik Kaynakları', crumbs:['Shopify'] },
    'shopify-ads':             { title:'Reklam Performansı', crumbs:['Shopify'] },
    'ikas-overview':           { title:'Genel Bakış',  crumbs:['İkas'] },
    'ikas-products':           { title:'Ürünler',      crumbs:['İkas'] },
    'ikas-orders':             { title:'Siparişler',   crumbs:['İkas'] },
    'pixa-overview':           { title:'Genel Bakış',          crumbs:['Pixa'] },
    'pixa-asistan':            { title:'Asistan',              crumbs:['Pixa'] },
    'pixa-orders':             { title:'Siparişler',           crumbs:['Pixa'] },
    'pixa-returns':            { title:'İadeler',              crumbs:['Pixa'] },
    'pixa-shipments':          { title:'Kargo',                crumbs:['Pixa'] },
    'pixa-customers':          { title:'Müşteriler',           crumbs:['Pixa'] },
    'pixa-products':           { title:'Katalog',              crumbs:['Pixa'] },
    'pixa-listings':           { title:'Pazaryeri Listeleri',  crumbs:['Pixa'] },
    'pixa-pricing':            { title:'Değişiklik Geçmişi',   crumbs:['Pixa'] },
    'pixa-inventory':          { title:'Stok',                 crumbs:['Pixa'] },
    'pixa-integrations':       { title:'Entegrasyonlar',       crumbs:['Pixa'] },
    'pixa-reports':            { title:'Raporlar',             crumbs:['Pixa'] },
    'criteo-overview':         { title:'Genel Bakış',  crumbs:['Criteo'] },
    'criteo-campaigns':        { title:'Kampanyalar',  crumbs:['Criteo'] },
    'gads-overview':           { title:'Genel Bakış',         crumbs:['Google Ads'] },
    'gads-campaigns':          { title:'Kampanyalar',         crumbs:['Google Ads'] },
    'gads-placements':         { title:'Yerleşimler',         crumbs:['Google Ads'] },
    'gads-audience':           { title:'Kitle',               crumbs:['Google Ads'] },
    'gads-health':             { title:'Hesap Sağlığı',       crumbs:['Google Ads'] },
    'gads-types':              { title:'Kampanyalar',         crumbs:['Google Ads'] },
    'gads-searchterms':        { title:'Arama Terimleri',     crumbs:['Google Ads'] },
    'gads-adtexts':            { title:'Reklam Metinleri',    crumbs:['Google Ads'] },
    'gads-dayparting':         { title:'Gün / Saat',          crumbs:['Google Ads'] },
    'ads-compare':             { title:'Platform Karşılaştırma', crumbs:['Reklam Yönetimi'] },
    'meta-overview':           { title:'Genel Bakış',         crumbs:['Meta Ads'] },
    'meta-campaigns':          { title:'Kampanyalar',         crumbs:['Meta Ads'] },
    'meta-hourly':             { title:'Gün / Saat',          crumbs:['Meta Ads'] },
    'meta-health':             { title:'Hesap Sağlığı',       crumbs:['Meta Ads'] },
    'meta-audience':           { title:'Kitle',            crumbs:['Meta Ads'] },
    'meta-creatives':          { title:'Kreatifler',          crumbs:['Meta Ads'] },
    'meta-adsets':             { title:'Reklam Setleri',             crumbs:['Meta Ads'] },
    'meta-placements':         { title:'Yerleşimler',          crumbs:['Meta Ads'] },
    'poyaisone-recommendations':{ title:'Optimizasyon',       crumbs:['Poyais One'] },
    'poyaisone-automation':    { title:'Otomasyon Şablonları',crumbs:['Poyais One'] },
    'poyaisone-flow':          { title:'Akış Oluşturucu',     crumbs:['Poyais One'] },
    'poyaisone-campaign-builder': { title:'Kampanya Oluşturucu', crumbs:['Poyais One'] },
    'poyaisone-audiences':     { title:'Akıllı Kitleler',     crumbs:['Poyais One'] },
      'poyaisone-logs':          { title:'Aksiyon Logları',     crumbs:['Poyais One'] },
      'growth-products':         { title:'Ürün Analizi',        crumbs:['Araçlar', 'Büyüme'] },
      'growth-forecast':         { title:'Tahminleme',          crumbs:['Araçlar', 'Büyüme'] },
      'growth-price-elasticity': { title:'Fiyat & Talep',       crumbs:['Araçlar', 'Büyüme'] },
      'feed-wizard':             { title:'Feed Wizard',         crumbs:['Araçlar'] },
      'dynamic-feed':            { title:'Dynamic Feed',        crumbs:['Araçlar', 'Feed Wizard'] },
      'geo-overview':            { title:'Genel Bakış',         crumbs:['Araçlar', 'AI Radar'] },
      'geo-prompts':             { title:"Prompt'lar",          crumbs:['Araçlar', 'AI Radar'] },
      'geo-competitors':         { title:'Rakipler',            crumbs:['Araçlar', 'AI Radar'] },
      'geo-perception':          { title:'Marka Algısı',        crumbs:['Araçlar', 'AI Radar'] },
    'settings':                { title:'Genel Ayarlar',       crumbs:['Ayarlar'] },
    'kredi-yukle':             { title:'Kredi Yükle',         crumbs:['Hesap','Kredi Yükle'] },
    'destek':                  { title:'Destek',               crumbs:['Ayarlar'] },
    'admin':                   { title:'Kullanıcılar',         crumbs:['Admin'] },
    'admin-clients':           { title:'Müşteri Yönetimi',    crumbs:['Admin'] },
  };
  const noHeader = ['poyaisone-flow'];
  if(noHeader.includes(nav)) return null;
  const cfg = MAP[nav];
  if(!cfg) return null;
  return (
    <div id="poyais-page-header" style={{ marginBottom:20, fontFamily:'Manrope, sans-serif', display:'flex', alignItems:'flex-end', justifyContent:'space-between', gap:14, flexWrap:'wrap' as const }}>
      <div>
        <h2 style={{ fontSize:24, fontWeight:800, color:SidebarT.text, margin:'0 0 6px', letterSpacing:'-0.02em' }}>{t(cfg.title)}</h2>
        {cfg.crumbs.length > 0 && (
          <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'var(--py-text-dim-alt)', fontWeight:500 }}>
            {cfg.crumbs.map((c, i) => (
              <span key={i} style={{ display:'flex', alignItems:'center', gap:6 }}>
                {t(c)}
                <span style={{ fontSize:14 }}>›</span>
              </span>
            ))}
            <span style={{ color:SidebarT.accent, fontWeight:700 }}>{t(cfg.title)}</span>
          </div>
        )}
        {PAGE_DESC[nav] && <div style={{ fontSize:12.5, color:'var(--py-text-mid-alt)', marginTop:6, lineHeight:1.5, whiteSpace: isMobile ? 'normal' : 'nowrap' as const }}>{t(PAGE_DESC[nav])}</div>}
      </div>
      {showDate && start && end && onDateChange && (
        <DateFilterBox start={start} end={end} onChange={onDateChange}/>
      )}
    </div>
  );
}

// ── Topbar page title (design v2: sadece küçük başlık, sekonder nav yok) ──
function topbarTitle(n:string):string {
  if(n==='dashboard') return 'Ana Sayfa';
  if(n==='asistan') return 'Asistan';
  if(n==='panolar') return 'Panolar';
  if(n==='gorevler') return 'Görevler';
  if(n==='notlar') return 'Notlar';
  if(n==='faturalandirma') return 'Faturalama';
  if(n==='uyari') return 'Uyarılar';
  if(n==='ads-compare') return 'Reklam Yönetimi';
  if(n.startsWith('gads')) return 'Google Ads';
  if(n.startsWith('meta')) return 'Meta Ads';
  if(n.startsWith('ga4')) return 'Analytics';
  if(n.startsWith('rtbhouse')) return 'RTB House';
  if(n.startsWith('pixa')) return 'Pixa';
  if(n.startsWith('ikas')) return 'İkas';
  if(n.startsWith('poyaisone')) return 'Poyais One';
  if(n.startsWith('growth')) return 'Büyüme';
  if(n==='feed-wizard'||n==='dynamic-feed') return 'Feed Wizard';
  if(n.startsWith('kreativ')) return 'Kreatif Stüdyo';
  if(n==='reports-logs') return 'Son İşlemler';
  if(n.startsWith('reports')) return 'Raporlama';
  if(n==='settings') return 'Ayarlar';
  if(n==='kredi-yukle') return 'Kredi Yükle';
  if(n==='destek') return 'Destek';
  if(n==='takim') return 'Takım';
  if(n==='admin') return 'Yönetim';
  if(n==='admin-clients') return 'Müşteriler';
  if(n==='admin-reports') return 'Raporlar';
  return 'Poyais One';
}

function topbarIcon(n:string):string {
  if(n==='dashboard') return 'dashboard';
  if(n==='asistan') return 'chat';
  if(n==='panolar') return 'layout_grid';
  if(n==='gorevler') return 'checklist';
  if(n==='notlar') return 'notes';
  if(n==='faturalandirma') return 'payments';
  if(n==='uyari') return 'bell';
  if(n==='ads-compare') return 'compare_arrows';
  if(n.startsWith('gads')) return 'ads_click';
  if(n.startsWith('meta')) return 'campaign';
  if(n.startsWith('ga4')) return 'insights';
  if(n.startsWith('rtbhouse')) return 'rtbhouse_icon';
  if(n.startsWith('pixa')) return 'pixa_icon';
  if(n.startsWith('gsc')) return 'search';
  if(n.startsWith('chatgpt-ads')) return 'chatgpt_icon';
  if(n.startsWith('adjust')) return 'adjust_icon';
  if(n.startsWith('shopify')) return 'shopify_icon';
  if(n.startsWith('ikas')) return 'ikas_icon';
  if(n.startsWith('criteo')) return 'criteo_icon';
  if(n.startsWith('x-ads')) return 'x_icon';
  if(n.startsWith('tiktok')) return 'tiktok_icon';
  if(n.startsWith('poyaisone')) return 'auto_awesome';
  if(n.startsWith('growth')) return 'trending_up';
  if(n==='feed-wizard'||n==='dynamic-feed') return 'image_search';
  if(n.startsWith('kreativ')) return 'palette';
  if(n.startsWith('reports')) return 'summarize';
  if(n==='settings') return 'tune';
  if(n==='kredi-yukle') return 'toll';
  if(n==='destek') return 'help_outline';
  if(n==='takim') return 'people';
  if(n==='admin') return 'admin_panel_settings';
  if(n==='admin-clients') return 'business';
  if(n==='admin-reports') return 'summarize';
  return 'auto_awesome';
}

function Loader({ label }:{ label?:string }) {
  const { t } = useLang();
  return <div className="py-pageload"><PoyaisSpinner size={38} pad={0} label={label || t('Yükleniyor...')}/></div>;
}

function SearchBox({ value, onChange, placeholder='Ara...' }:{ value:string; onChange:(v:string)=>void; placeholder?:string }) {
  const T = SidebarT;
  return (
    <div style={{ padding:'10px 16px 8px' }}>
      <input value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{ width:'100%', background:T.surface, border:'none', boxShadow:'0 1px 3px rgba(0,0,0,.04)', borderRadius:6, padding:'7px 12px', fontFamily:'Manrope, sans-serif', fontSize:11, color:T.ink, outline:'none' }}
        onFocus={e=>e.target.style.borderColor='rgba(201,168,76,.4)'}
        onBlur={e=>e.target.style.borderColor='rgba(201,168,76,.15)'}/>
    </div>
  );
}

function THead({ cols }:{ cols:string[] }) {
  const T = SidebarT;
  return <thead><tr>{cols.map(c=><th key={c} style={{ fontFamily:'Manrope, sans-serif', fontSize:9, letterSpacing:0, color:T.ink, textTransform:'uppercase', padding:'8px 12px', textAlign:'left', borderBottom:'1px solid rgba(201,168,76,0.08)', whiteSpace:'nowrap' }}>{c}</th>)}</tr></thead>;
}

function TR({ children }:{ children:React.ReactNode }) {
  const [h,setH] = useState(false);
  return <tr onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} style={{ borderBottom:'1px solid rgba(0,0,0,.04)', background:h?'rgba(201,168,76,.04)':'transparent', transition:'background .15s', cursor:'pointer' }}>{children}</tr>;
}

const TD = ({ children, mono, color }:{ children:React.ReactNode; mono?:boolean; color?:string }) => (
  <td style={{ padding:'10px 12px', fontSize:mono?11:12, fontFamily:mono?'Manrope, sans-serif':'inherit', color:color||C.white, maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{children}</td>
);

// -- Interactive Chart -----------------------------------------------------

function InteractiveChart({ data, metrics, title }:{ data:any[]; metrics:{ key:string; label:string; color:string; fmt:(v:number)=>string }[]; title:string }) {
  const T = SidebarT;
  const [selected, setSelected] = useState<string[]>([metrics[0]?.key]);
  const [chartType, setChartType] = useState<'bar'|'line'>('bar');

  const toggle = (key:string) => {
    setSelected(prev => prev.includes(key) ? prev.filter(k=>k!==key) : [...prev, key]);
  };

  const CTMulti = ({ active, payload, label }:any) => active && payload?.length ? (
    <div style={{ background:T.surface, border:'1px solid rgba(0,0,0,.08)', borderRadius:8, padding:'8px 12px' }}>
      <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:T.textDim, marginBottom:6 }}>{label}</div>
      {payload.map((p:any) => {
        const m = metrics.find(x=>x.key===p.dataKey);
        return <div key={p.dataKey} style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:p.color, marginBottom:2 }}>{m?.label}: {m?.fmt(p.value)}</div>;
      })}
    </div>
  ) : null;

  return (
    <Card>
      <div style={{ padding:'13px 18px', borderBottom:'1px solid rgba(201,168,76,.08)', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:8 }}>
        <span style={{ fontFamily:'Manrope, sans-serif', fontSize:14, letterSpacing:1.5 }}>{title}</span>
        <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
          {/* Chart type toggle */}
          <div style={{ display:'flex', gap:4, marginRight:8 }}>
            {(['bar','line'] as const).map(t => (
              <button key={t} onClick={()=>setChartType(t)} style={{ fontFamily:'Manrope, sans-serif', fontSize:9, padding:'3px 8px', borderRadius:4, border:`1px solid ${chartType===t?GOLD:'rgba(255,255,255,.1)'}`, background:chartType===t?'rgba(201,168,76,.15)':'transparent', color:chartType===t?GOLD_L:C.whiteM, cursor:'pointer' }}>
                {t==='bar'?'▮▮▮':'〜'}
              </button>
            ))}
          </div>
          {/* Metric toggles */}
          {metrics.map(m => (
            <button key={m.key} onClick={()=>toggle(m.key)}
              style={{ fontFamily:'Manrope, sans-serif', fontSize:9, padding:'4px 10px', borderRadius:5, border:`1px solid ${selected.includes(m.key)?m.color:'rgba(255,255,255,.1)'}`, background:selected.includes(m.key)?alpha(m.color,10):'transparent', color:selected.includes(m.key)?m.color:T.textDim, cursor:'pointer', transition:'all .15s', display:'flex', alignItems:'center', gap:5 }}>
              <span style={{ width:6, height:6, borderRadius:'50%', background:selected.includes(m.key)?m.color:'rgba(255,255,255,.2)', display:'inline-block' }}/>
              {m.label}
            </button>
          ))}
        </div>
      </div>
      <div style={{ padding:'16px 18px 8px' }}>
        <ResponsiveContainer width="100%" height={220}>
          {chartType === 'bar' ? (
            <BarChart data={data} margin={{ top:0, right:0, left:-10, bottom:0 }}>
              <XAxis dataKey="name" tick={{ fontSize:9, fill:T.textDim, fontFamily:'Manrope, sans-serif' }} axisLine={false} tickLine={false}/>
              <YAxis tick={{ fontSize:9, fill:T.textDim }} axisLine={false} tickLine={false}/>
              <Tooltip content={<CTMulti/>} cursor={{ fill:'rgba(0,0,0,.03)' }}/>
              {metrics.filter(m=>selected.includes(m.key)).map(m => (
                <Bar key={m.key} dataKey={m.key} fill={m.color} radius={[4,4,0,0]} name={m.label} opacity={0.85}/>
              ))}
            </BarChart>
          ) : (
            <LineChart data={data} margin={{ top:0, right:0, left:-10, bottom:0 }}>
              <XAxis dataKey="name" tick={{ fontSize:9, fill:T.textDim, fontFamily:'Manrope, sans-serif' }} axisLine={false} tickLine={false}/>
              <YAxis tick={{ fontSize:9, fill:T.textDim }} axisLine={false} tickLine={false}/>
              <Tooltip content={<CTMulti/>} cursor={{ stroke:'rgba(201,168,76,.2)' }}/>
              {metrics.filter(m=>selected.includes(m.key)).map(m => (
                <Line key={m.key} type="monotone" dataKey={m.key} stroke={m.color} strokeWidth={2} dot={{ fill:m.color, r:3 }} name={m.label}/>
              ))}
            </LineChart>
          )}
        </ResponsiveContainer>
      </div>
    </Card>
  );
}

const CT = ({ active, payload, label }:any) => active&&payload?.length ? (
  <div style={{ background:'#ffffff', border:'1px solid rgba(0,0,0,.08)', borderRadius:8, padding:'8px 12px' }}>
    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:'#6B6B8A', marginBottom:4 }}>{label}</div>
    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:14, color:GOLD }}>{payload[0].value?.toLocaleString('tr-TR')}</div>
  </div>
) : null;

function Toggle({ value, onChange }:{ value:boolean; onChange:(v:boolean)=>void }) {
  return (
    <div onClick={()=>onChange(!value)} style={{ width:40, height:22, borderRadius:11, background:value?'rgba(76,175,125,.25)':'rgba(255,255,255,.07)', border:`1px solid ${value?GREEN:'rgba(255,255,255,.15)'}`, cursor:'pointer', position:'relative', transition:'all .2s', flexShrink:0 }}>
      <div style={{ width:16, height:16, borderRadius:'50%', background:value?GREEN:C.whiteM, position:'absolute', top:2, left:value?20:2, transition:'all .2s' }}/>
    </div>
  );
}

function Input({ label, value, onChange, type='text', placeholder='' }:{ label:string; value:string; onChange:(v:string)=>void; type?:string; placeholder?:string }) {
  const T = SidebarT;
  return (
    <div style={{ marginBottom:14 }}>
      <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.textDim, letterSpacing:0, marginBottom:6 }}>{label}</div>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{ width:'100%', background:T.surface, border:'1px solid rgba(201,168,76,.18)', borderRadius:7, padding:'9px 12px', fontFamily:'Manrope, sans-serif', fontSize:12, color:T.ink, outline:'none', transition:'border-color .15s' }}
        onFocus={e=>e.target.style.borderColor='rgba(201,168,76,.5)'}
        onBlur={e=>e.target.style.borderColor='rgba(201,168,76,.18)'}/>
    </div>
  );
}

// -- Date Filter (see ./poyais-ui/DateFilter) --------------------------------

// -- Profile Dropdown -------------------------------------------------------

function ProfileDropdown({ config, onSave, collapsed }:{ config:any; onSave:(c:any)=>void; collapsed?:boolean }) {
  const { t } = useLang();
  const T = SidebarT;
  const [open,setOpen]   = useState(false);
  const [form,setForm]   = useState({ ...config.profile, newPassword:'', confirmPassword:'' });
  const [saved,setSaved] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const h = (e:MouseEvent) => { if(ref.current&&!ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  // Mount'ta ve dropdown açılınca güncel profili çek
  useEffect(() => {
    axios.get('/api/v1/auth/me').then(r => {
      const u = r.data;
      setForm((f:any) => ({
        ...f,
        name:    u.name    || f.name    || '',
        surname: u.surname || f.surname || '',
        email:   u.email   || f.email   || '',
        photo:   u.photo   || f.photo   || '',
      }));
    }).catch(()=>{});
  }, []);

  useEffect(() => {
    if(!open) return;
    const tok = localStorage.getItem('poyais_token')||localStorage.getItem('token')||'';
    fetch('/api/v1/credits/balance',{headers:{'Authorization':'Bearer '+tok}})
      .then(r=>r.json()).then(d=>setBalance(d.balance)).catch(()=>{});
    axios.get('/api/v1/auth/me').then(r => {
      const u = r.data;
      setForm((f:any) => ({
        ...f,
        name:    u.name    || f.name    || '',
        surname: u.surname || f.surname || '',
        email:   u.email   || f.email   || '',
        photo:   u.photo   || f.photo   || '',
      }));
    }).catch(()=>{});
  }, [open]);

  const initials = `${form.name?.[0]||''}${form.surname?.[0]||''}`.toUpperCase() || 'PD';

  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const [balance, setBalance] = useState<number|null>(null);

  const handleSave = async () => {
    if(form.newPassword && form.newPassword !== form.confirmPassword) {
      setError('Şifreler eşleşmiyor.'); return;
    }
    if(form.newPassword && (form.newPassword.length < 10 || !/[A-Za-zÇĞİÖŞÜçğıöşü]/.test(form.newPassword) || !/[0-9]/.test(form.newPassword))) {
      setError('Şifre en az 10 karakter olmalı ve en az bir harf ile bir rakam içermelidir.'); return;
    }
    setError(''); setSaving(true);
    try {
      const payload: any = {
        name:    form.name    || '',
        surname: form.surname || '',
        email:   form.email   || '',
      };
      if(form.photo && form.photo.startsWith('data:')) payload.photo = form.photo;
      if(form.newPassword) payload.password = form.newPassword;

      const res = await axios.put('/api/v1/auth/me', payload);
      const updatedUser = res.data?.user || {};

      // Global config'i güncelle
      const updated = {
        ...config,
        profile:{
          name:    updatedUser.name    || form.name,
          surname: updatedUser.surname || form.surname,
          email:   updatedUser.email   || form.email,
          photo:   updatedUser.photo   || form.photo,
        }
      };
      onSave(updated);
      setForm((f:any)=>({...f, newPassword:'', confirmPassword:''}));
      setSaved(true);
      setTimeout(()=>setSaved(false),2500);
    } catch(e:any) {
      setError(e.response?.data?.detail || 'Kayıt başarısız.');
    }
    setSaving(false);
  };

  const handlePhoto = (e:React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if(!file) return;
    // Boyut kontrolü — 500KB max
    if(file.size > 500 * 1024) {
      alert("Fotograf en fazla 500KB olabilir.");
      return;
    }
    const reader = new FileReader();
    reader.onload = async (ev: ProgressEvent<FileReader>) => {
      const base64 = ev.target?.result as string;
      setForm((f: any)=>({...f, photo: base64}));
      // Otomatik kaydet
      try {
        const res = await axios.put('/api/v1/auth/me', { photo: base64 });
        const updatedUser = res.data?.user || {};
        const updated = { ...config, profile:{ ...config.profile, photo: updatedUser.photo || base64 } };
        onSave(updated);
      } catch{}
    };
    reader.readAsDataURL(file);
  };

  return (
    <div ref={ref} style={{ position:'relative' }}>
      <div onClick={()=>setOpen(x=>!x)} style={{ display:'flex', alignItems:'center', gap:8, padding: collapsed?'6px':'8px 10px', borderRadius:8, cursor:'pointer', background: open?alpha(T.accent,9):'transparent', transition:'background .15s', width:'100%', justifyContent: collapsed?'center':'flex-start' }}>
        <div style={{ width:28, height:28, borderRadius:'50%', border:`2px solid ${open?T.accent:'rgba(201,168,76,.3)'}`, overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--py-subtle-bg)', flexShrink:0 }}>
          {form.photo
            ? <img src={form.photo} alt="profil" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
            : <span style={{ fontFamily:'Manrope, sans-serif', fontSize:13, color:GOLD, letterSpacing:1 }}>{initials}</span>
          }
        </div>
        {!collapsed && (
          <div style={{ minWidth:0, flex:1 }}>
            <div style={{ fontSize:12, fontWeight:600, color:T.text, whiteSpace:'nowrap' as const, overflow:'hidden', textOverflow:'ellipsis' }}>{form.name} {form.surname}</div>
            <div style={{ fontSize:10, color:T.textDim }}>{form.email}</div>
          </div>
        )}
      </div>

      {open && (
        <div style={{ position:'fixed', left: ref.current?.getBoundingClientRect()?.left ?? 8, top: Math.max(8, (ref.current?.getBoundingClientRect()?.top ?? 400) - 340), background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:16, zIndex:9999, width:240, boxShadow:'0 4px 24px rgba(0,0,0,.12)', maxHeight:'calc(100vh - 100px)', overflowY:'auto' as const }}>
          {/* Kullanıcı bilgisi */}
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12, paddingBottom:12, borderBottom:`1px solid ${T.border}` }}>
            <div style={{ width:36, height:36, borderRadius:'50%', background:alpha(T.accent,13), display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:T.accent, flexShrink:0 }}>
              {initials}
            </div>
            <div style={{ minWidth:0 }}>
              <div style={{ fontSize:13, fontWeight:700, color:T.text, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{form.name} {form.surname}</div>
              <div style={{ fontSize:11, color:T.textDim, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{form.email}</div>
            </div>
          </div>
          {/* Menü */}
          {[
            { label:'Profil Ayarları', icon:'person', id:'settings' },
            { label:'Faturalandırma', icon:'credit_card', id:'faturalandirma' },
            { label:'Takım', icon:'groups', id:'takim' },
            { label:'Destek', icon:'help_outline', id:'destek' },
          ].map(item => (
            <button key={item.id} onClick={()=>{ setOpen(false); setTimeout(()=>(window as any).__poyaisGoNav?.(item.id),50); }}
              style={{ display:'flex', alignItems:'center', gap:8, width:'100%', padding:'8px 10px', borderRadius:8, border:'none', background:'transparent', cursor:'pointer', fontSize:12, color:T.textMid, fontFamily:'Manrope, sans-serif', textAlign:'left' as const, transition:'background .15s' }}
              onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
              onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
              <span className="material-symbols-outlined" style={{ fontSize:16, color:T.textDim }}>{item.icon}</span>
              {t(item.label)}
            </button>
          ))}
          <div style={{ borderTop:`1px solid ${T.border}`, marginTop:6, paddingTop:6 }}>
            <button onClick={()=>{ logout(); localStorage.clear(); window.location.reload(); }}
              style={{ display:'flex', alignItems:'center', gap:8, width:'100%', padding:'8px 10px', borderRadius:8, border:'none', background:'transparent', cursor:'pointer', fontSize:12, color:T.redText, fontFamily:'Manrope, sans-serif', textAlign:'left' as const, transition:'background .15s' }}
              onMouseEnter={e=>(e.currentTarget.style.background='var(--py-red-tint)')}
              onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
              <span className="material-symbols-outlined" style={{ fontSize:16 }}>logout</span>
              {t('Çıkış Yap')}
            </button>
          </div>

        </div>
      )}
    </div>
  );
}

// -- Dashboard Tab ----------------------------------------------------------

function DashboardTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const isMobile = useIsMobile();
  const [ga4,setGa4]   = useState<any>(null);
  const [gads,setGads] = useState<any>(null);
  const [meta,setMeta] = useState<any>(null);
  const [ch,setCh]     = useState<any[]>([]);
  const [loading,setLoading] = useState(true);

  const platforms = config?.platforms || {};
  const ga4Cfg  = platforms.ga4  || {};
  const gadsCfg = platforms.gads || {};
  const metaCfg = platforms.meta || {};

  useEffect(()=>{
    setLoading(true);
    const reqs = [];
    if(ga4Cfg.propertyId)  reqs.push(axios.get(`${API}/ga4/${ga4Cfg.propertyId}/overview?start_date=${start}&end_date=${end}`).catch(()=>null));
    else reqs.push(Promise.resolve(null));
    if(gadsCfg.customerId) reqs.push(axios.get(`${API}/gads/${gadsCfg.customerId}/overview?start_date=${start}&end_date=${end}`).catch(()=>null));
    else reqs.push(Promise.resolve(null));
    if(metaCfg.accountId) reqs.push(axios.get(`${API}/meta/${metaCfg.accountId}/overview?start_date=${start}&end_date=${end}`).catch(()=>null));
    else reqs.push(Promise.resolve(null));
    if(ga4Cfg.propertyId)  reqs.push(axios.get(`${API}/ga4/${ga4Cfg.propertyId}/channels`).catch(()=>null));
    else reqs.push(Promise.resolve(null));

    Promise.all(reqs).then(([a,b,c,d])=>{
      setGa4(a?.data||null); setGads(b?.data||null);
      const metaRaw = c?.data; console.log('META RAW:', metaRaw); setMeta(metaRaw?.overview || metaRaw || null); setCh(d?.data||[]);
      setLoading(false);
    });
  },[start,end,ga4Cfg.propertyId,gadsCfg.customerId,metaCfg.accountId]);

  if(loading) return <Loader/>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* GA4 KPIs */}
      {ga4 && (
        <div>
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, letterSpacing:0, color:'#6B6B8A', marginBottom:10 }}>- GOOGLE ANALYTİCS</div>
          <div className="kpi-grid-4" style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:12 }}>
            <KpiCard label="Oturum"       value={fmt.n(ga4.sessions)}                   sub={`${fmt.n(ga4.total_users)} kullanıcı`}/>
            <KpiCard label="Yeni Kullanıcı" value={fmt.n(ga4.new_users)}                sub={`Toplam: ${fmt.n(ga4.total_users)}`}/>
            <KpiCard label="Sayfa Görüntüleme" value={fmt.n(ga4.pageviews)}             sub={`Bounce: ${fmt.pct(ga4.bounce_rate)}`}/>
            <KpiCard label="Ort. Süre"    value={fmt.sec(ga4.avg_session_duration_sec)} sub="dk:sn" accent={BLUE}/>
          </div>
        </div>
      )}

      {/* Google Ads KPIs */}
      {gads && (
        <div>
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, letterSpacing:0, color:'#6B6B8A', marginBottom:10 }}>- GOOGLE ADS</div>
          <div className="kpi-grid-4" style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:12 }}>
            <KpiCard label="Harcama"   value={fmt.k(gads.spend)}       sub={`${fmt.n(gads.clicks)} tıklama`}/>
            <KpiCard label="ROAS"      value={fmt.roas(gads.roas)}     sub={`Gelir: ${fmt.k(gads.revenue)}`} accent={GREEN}/>
            <KpiCard label="Dönüşüm"  value={fmt.n(gads.conversions)}  sub={`CPA: ${fmt.k(gads.spend/gads.conversions)}`}/>
            <KpiCard label="Gösterim"  value={fmt.n(gads.impressions)} sub={`CTR: ${fmt.pct(gads.ctr)}`} accent={BLUE}/>
          </div>
        </div>
      )}

      {/* Meta KPIs */}
      {meta && (
        <div>
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, letterSpacing:0, color:'#6B6B8A', marginBottom:10 }}>- META ADS</div>
          <div className="kpi-grid-4" style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:12 }}>
            <KpiCard label="Harcama"   value={fmt.k(meta.spend)}     sub={`${fmt.n(meta.clicks)} tıklama`}/>
            <KpiCard label="ROAS"      value={fmt.roas(meta.roas)}   sub={`Gelir: ${fmt.k(meta.revenue)}`} accent={meta.roas>=4?GREEN:meta.roas>=2?GOLD:RED}/>
            <KpiCard label="Dönüşüm"  value={fmt.n(meta.purchases)}  sub={`CPA: ${fmt.k(meta.spend/(meta.purchases||1))}`}/>
            <KpiCard label="Erişim"    value={fmt.n(meta.reach)}     sub={`CPM: ${fmt.k(meta.cpm)}`} accent={BLUE}/>
          </div>
        </div>
      )}

      {/* Kanal chart */}
      {ch.length>0 && (
        <div className="two-col" style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:14 }}>
          <Card>
            <CH title="KANAL DAĞILIMI" badge="GA4"/>
            <div style={{ padding:18 }}>
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={ch} margin={{ top:0, right:0, left:-20, bottom:0 }}>
                  <XAxis dataKey="channel" tick={{ fontSize:9, fill:'#6B6B8A', fontFamily:'Manrope, sans-serif' }} axisLine={false} tickLine={false}/>
                  <YAxis tick={{ fontSize:9, fill:'#6B6B8A' }} axisLine={false} tickLine={false}/>
                  <Tooltip content={<CT/>} cursor={{ fill:'rgba(0,0,0,.03)' }}/>
                  <Bar dataKey="sessions" radius={[4,4,0,0]}>
                    {ch.map((_:any,i:number)=><Cell key={i} fill={i===0?GOLD:i===1?'rgba(201,168,76,.5)':'rgba(201,168,76,.15)'}/>)}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Card>

          {/* Özet tablo */}
          {gads && meta && (
            <Card>
              <CH title="PLATFORM KARŞILAŞTIRMA"/>
              <div style={{ padding:'14px 18px', display:'flex', flexDirection:'column', gap:12 }}>
                {[
                  { label:'Toplam Harcama', gads:fmt.k(gads.spend), meta:fmt.k(meta.spend) },
                  { label:'ROAS',           gads:fmt.roas(gads.roas), meta:fmt.roas(meta.roas) },
                  { label:'Dönüşüm',        gads:fmt.n(gads.conversions), meta:fmt.n(meta.purchases) },
                  { label:'Tıklama',            gads:fmt.n(gads.clicks), meta:fmt.n(meta.clicks) },
                ].map(row=>(
                  <div key={row.label} style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr 1fr', gap:8, padding:'8px 0', borderBottom:'1px solid rgba(0,0,0,.04)' }}>
                    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:'#6B6B8A' }}>{row.label}</div>
                    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:BLUE, textAlign:'center' }}>{row.gads}</div>
                    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:GOLD, textAlign:'center' }}>{row.meta}</div>
                  </div>
                ))}
                <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr 1fr', gap:8 }}>
                  <div/>
                  <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:BLUE, textAlign:'center', letterSpacing:1 }}>GOOGLE</div>
                  <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:GOLD, textAlign:'center', letterSpacing:1 }}>META</div>
                </div>
              </div>
            </Card>
          )}
        </div>
      )}
    </div>
  );
}

// -- GA4 Tab ----------------------------------------------------------------

function GA4Tab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [ov,setOv]   = useState<any>(null);
  const [ch,setCh]   = useState<any[]>([]);
  const [pg,setPg]   = useState<any[]>([]);
  const [loading,setLoading] = useState(true);
  const [search,setSearch]   = useState('');
  const [pgPage, setPgPage]  = useState(1);
  const PG_SIZE = 10;
  const [channelDimension, setChannelDimension] = useState<'sessionDefaultChannelGroup'|'sessionSourceMedium'|'sessionCampaignName'>('sessionDefaultChannelGroup');
  const { propertyId } = config.platforms.ga4;

  const [prevOv,setPrevOv] = useState<any>(null);
  const [statMetricPref, setStatMetricPref] = useState<string|null>(null);
  const [topMetricPref, setTopMetricPref] = useState<string|null>(null);
  const { t, lang } = useLang();

  useEffect(()=>{
    const cid = config?.client_id || 1;
    try{
      const saved = JSON.parse(localStorage.getItem(`poyais_ga4_kpi_cards_${cid}`)||'null');
      setStatMetricPref(saved?.stat || null);
      setTopMetricPref(saved?.top || null);
    }catch{ setStatMetricPref(null); setTopMetricPref(null); }
  },[config?.client_id]);

  useEffect(()=>{
    if(!propertyId) return;
    // Önceki dönem tarihleri
    const s = new Date(start); s.setMonth(s.getMonth()-1);
    const e = new Date(end);   e.setMonth(e.getMonth()-1);
    const pad = (n:number) => String(n).padStart(2,'0');
    const pStart = `${s.getFullYear()}-${pad(s.getMonth()+1)}-01`;
    const pEnd   = `${e.getFullYear()}-${pad(e.getMonth()+1)}-${pad(e.getDate())}`;
    setLoading(true);
    Promise.all([
      axios.get(`${API}/ga4/${propertyId}/overview?start_date=${start}&end_date=${end}`),
      axios.get(`${API}/ga4/${propertyId}/channels?dimension=${channelDimension}&start_date=${start}&end_date=${end}`),
      axios.get(`${API}/ga4/${propertyId}/pages?limit=50&start_date=${start}&end_date=${end}`),
      axios.get(`${API}/ga4/${propertyId}/overview?start_date=${pStart}&end_date=${pEnd}`).catch(()=>null),
    ]).then(([a,b,c,d])=>{ setOv(a.data); setCh(b.data); setPg(c.data); setPrevOv(d?.data||null); setLoading(false); })
      .catch(()=>setLoading(false));
  },[start,end,channelDimension,propertyId]);

  const filteredPg = useMemo(()=>pg
    .filter(p=>!(p.page||p.page_path||'').startsWith('/orders/'))
    .filter(p=>(p.page_path||p.page||'').toLowerCase().includes(search.toLowerCase())),
  [pg,search]);

  const totalPgPages = Math.max(1, Math.ceil(filteredPg.length / PG_SIZE));
  const pagedPg = filteredPg.slice((pgPage-1)*PG_SIZE, pgPage*PG_SIZE);

  if(loading) return <Loader/>;
  if(!ov) return <div style={{ color:T.textMid, padding:24 }}>{t('Veri bulunamadı.')}</div>;

  const chColors:Record<string,string> = {
    'Organic Search':'#4CAF7C','Paid Search':'#C9A84C','Paid Social':'#A855F7',
    'Direct':'#9A9AB0','Cross-network':'#f0d060','Organic Social':'#60a5fa',
    'Unassigned':'#C9A84C',
  };
  const getChColor = (name:string) => chColors[name] || '#C9A84C';

  const chMax = ch.length ? Math.max(...ch.map((c:any)=>c.sessions||0)) : 1;
  const topRegion = ov.top_country || ov.top_city || 'N/A';
  // purchases: önce overview'dan al, yoksa channels toplamından hesapla
  const purchases = ov.purchases || ov.ecommerce_purchases || ov.ecommercePurchases
    || ch.reduce((s:number,c:any)=>s+(c.purchases||c.ecommercePurchases||0),0)
    || 0;
  const convRate  = ov.sessions > 0 ? (purchases / ov.sessions * 100) : 0;

  const fmtDur = (sec:number) => {
    if(!sec) return '0:00';
    const m = Math.floor(sec/60), s = Math.floor(sec%60);
    return `${m}:${s.toString().padStart(2,'0')}`;
  };

  const deltaBadge = (val:number|undefined, suffix='%') => {
    if(val === undefined || val === null) return null;
    const up = val >= 0;
    return (
      <span style={{
        display:'inline-flex', alignItems:'center', gap:2,
        fontSize:11, fontWeight:700, fontFamily:MONO,
        color: up ? T.greenText : T.redText,
        background: up ? 'var(--py-green-tint)' : 'var(--py-red-tint)',
        borderRadius:999, padding:'3px 8px',
      }}>
        {up ? '↑' : '↓'}{Math.abs(val).toFixed(1)}{suffix}
      </span>
    );
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, fontFamily:'Manrope, sans-serif' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:14 }}>
        {(()=>{
          const calcPct = (curr:number, prev:number) => prev>0 ? ((curr-prev)/prev*100) : null;
          const calcSecDiff = (curr:number, prev:number) => {
            if(!prev||!curr) return null;
            const d=curr-prev; const sign=d>=0?'+':'-'; const abs=Math.abs(d);
            const m=Math.floor(abs/60); const s=Math.round(abs%60);
            return { label:`${sign}${m}:${s.toString().padStart(2,'0')}`, up:d>=0 };
          };
          const p = prevOv;
          const cards = [
            { label:t('Kullanıcılar'),        value:fmt.n(ov.total_users),               pct: calcPct(ov.total_users, p?.total_users) },
            { label:t('Oturumlar'),           value:fmt.n(ov.sessions),                  pct: calcPct(ov.sessions, p?.sessions) },
            { label:t('Sayfa Görüntülemeleri'), value:fmt.n(ov.pageviews),              pct: calcPct(ov.pageviews, p?.pageviews) },
            { label:t('Ortalama Süre'),       value:fmtDur(ov.avg_session_duration_sec), dur: calcSecDiff(ov.avg_session_duration_sec, p?.avg_session_duration_sec) },
          ];
          return cards.map(({ label, value, pct, dur })=>(
            <div key={label} style={{ background:T.surface, borderRadius:14, padding:'18px 19px', border:`1px solid ${T.border}`, display:'flex', flexDirection:'column' as const, justifyContent:'space-between', gap:12 }}>
              <div>
                <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:12 }}>{label}</div>
                <div style={{ fontSize:24, fontWeight:800, fontFamily:MONO }}>{value}</div>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' as const }}>
                {dur ? (
                  <span style={{ display:'inline-flex', alignItems:'center', gap:2, fontSize:11, fontWeight:700, color:dur.up?T.greenText:T.redText, background:dur.up?'var(--py-green-tint)':'var(--py-red-tint)', borderRadius:999, padding:'3px 8px', fontFamily:MONO }}>
                    {dur.up?'↑':'↓'}{dur.label}
                  </span>
                ) : pct !== null && pct !== undefined ? deltaBadge(pct) : (
                  <span style={{ fontSize:11, color:T.textDim }}>—</span>
                )}
                <span style={{ fontSize:11, color:T.textDim }}>{t('vs önceki dönem')}</span>
              </div>
            </div>
          ));
        })()}
      </div>

      {/* Bento: Channel Distribution + Conversion Rate + Top Region */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'2fr 1fr', gap:14, minWidth:0 }}>

        {/* Channel Distribution */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:isMobile?16:22, minWidth:0, overflow:'hidden' }}>
          <div style={{ display:'flex', flexDirection:'column' as const, gap:12, marginBottom:20 }}>
            <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Kanal Dağılımı')}</div>
            <div style={{ display:'flex', gap:3, background:'var(--py-track-bg)', borderRadius:9, padding:3, width:'fit-content', flexWrap:'wrap' as const }}>
              {([
                ['sessionDefaultChannelGroup','Default'],
                ['sessionSourceMedium',t('Kaynak/Medium')],
                ['sessionCampaignName',t('Kampanya')],
              ] as const).map(([val,label])=>(
                <button key={val} onClick={()=>setChannelDimension(val as any)} style={{
                  padding:'5px 11px', borderRadius:7, border:'none',
                  background: channelDimension===val?T.surface:'transparent',
                  color: channelDimension===val?T.text:'var(--py-text-mid-alt)',
                  fontSize:11, fontWeight:channelDimension===val?700:600, cursor:'pointer', whiteSpace:'nowrap' as const,
                  boxShadow: channelDimension===val?'0 1px 2px rgba(20,22,43,.1)':'none',
                }}>{label}</button>
              ))}
            </div>
          </div>
          <div style={{ display:'flex', flexDirection:'column' as const, gap:18, maxWidth:'100%' }}>
            {ch.slice(0,6).map((c:any, i:number)=>{
              const pct = chMax > 0 ? Math.round((c.sessions||0)/chMax*100) : 0;
              const color = getChColor(c.channel);
              return (
                <div key={i}>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, fontWeight:700, marginBottom:6 }}>
                    <span style={{ color:T.textMid }}>{c.channel}</span>
                    <span style={{ fontFamily:MONO }}>{fmt.n(c.sessions||0)}</span>
                  </div>
                  <div style={{ height:8, background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                    <div style={{ height:'100%', width:`${pct}%`, background:color, borderRadius:999, transition:'width .6s ease' }}/>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Right column: seçilebilir metrik kartları */}
        {(()=>{
          const cid = config?.client_id || 1;
          const saveCardPrefs = (stat:string, top:string) => {
            try{ localStorage.setItem(`poyais_ga4_kpi_cards_${cid}`, JSON.stringify({ stat, top })); }catch{}
          };

          const STAT_METRICS = [
            { id:'conversion_rate', label:t('Dönüşüm Oranı'), value:`${convRate.toFixed(1)}%`, sub: purchases ? (lang==='en' ? `${fmt.n(purchases)} purchases / ${fmt.n(ov.sessions)} sessions` : `${fmt.n(purchases)} satın alma / ${fmt.n(ov.sessions)} oturum`) : t('Satın alma verisi yok'), available: purchases>0 },
            { id:'bounce_rate', label:t('Hemen Çıkma Oranı'), value:`${(ov.bounce_rate||0).toFixed(1)}%`, sub: lang==='en' ? `${fmt.n(ov.sessions)} sessions avg` : `${fmt.n(ov.sessions)} oturum ortalaması`, available:true },
            { id:'new_user_rate', label:t('Yeni Kullanıcı Oranı'), value:`${(ov.total_users>0?(ov.new_users/ov.total_users*100):0).toFixed(1)}%`, sub: lang==='en' ? `${fmt.n(ov.new_users)} new / ${fmt.n(ov.total_users)} users` : `${fmt.n(ov.new_users)} yeni / ${fmt.n(ov.total_users)} kullanıcı`, available: ov.total_users>0 },
            { id:'pages_per_session', label:t('Oturum Başına Sayfa'), value:`${(ov.sessions>0?(ov.pageviews/ov.sessions):0).toFixed(2)}`, sub: lang==='en' ? `${fmt.n(ov.pageviews)} views` : `${fmt.n(ov.pageviews)} görüntüleme`, available: ov.sessions>0 },
          ];
          const statId = (statMetricPref && STAT_METRICS.find(m=>m.id===statMetricPref)?.available) ? statMetricPref : (purchases>0 ? 'conversion_rate' : 'bounce_rate');
          const activeStat = STAT_METRICS.find(m=>m.id===statId) || STAT_METRICS[1];

          const TOP_METRICS = [
            { id:'top_revenue', label:t('En Çok Ciro'), sub:t('En yüksek ciro katkısı'), pick:()=>ch.filter((c:any)=>c.revenue>0).sort((a:any,b:any)=>b.revenue-a.revenue)[0], fmt:(c:any)=>`₺${fmt.n(c.revenue)}`, available: ch.some((c:any)=>c.revenue>0) },
            { id:'top_traffic', label:t('En Çok Trafik'), sub:t('En yüksek oturum katkısı'), pick:()=>[...ch].sort((a:any,b:any)=>(b.sessions||0)-(a.sessions||0))[0], fmt:(c:any)=>lang==='en' ? `${fmt.n(c.sessions)} sessions` : `${fmt.n(c.sessions)} oturum`, available: ch.length>0 },
            { id:'top_new_users', label:t('En Çok Yeni Kullanıcı'), sub:t('En yüksek yeni kullanıcı katkısı'), pick:()=>[...ch].sort((a:any,b:any)=>(b.new_users||0)-(a.new_users||0))[0], fmt:(c:any)=>lang==='en' ? `${fmt.n(c.new_users)} users` : `${fmt.n(c.new_users)} kullanıcı`, available: ch.some((c:any)=>(c.new_users||0)>0) },
            { id:'best_quality', label:t('En Kaliteli Kanal'), sub:t('En düşük hemen çıkma oranı'), pick:()=>[...ch].filter((c:any)=>(c.sessions||0)>0).sort((a:any,b:any)=>(a.bounce_rate||0)-(b.bounce_rate||0))[0], fmt:(c:any)=>`%${(c.bounce_rate||0).toFixed(1)}`, available: ch.some((c:any)=>(c.sessions||0)>0) },
          ];
          const topId = (topMetricPref && TOP_METRICS.find(m=>m.id===topMetricPref)?.available) ? topMetricPref : (ch.some((c:any)=>c.revenue>0) ? 'top_revenue' : 'top_traffic');
          const activeTop = TOP_METRICS.find(m=>m.id===topId) || TOP_METRICS[1];
          const topPick = activeTop.pick();

          return (
            <div style={{ display:'flex', flexDirection:'column' as const, gap:14, minWidth:0, overflow:'hidden' }}>
              {/* Seçilebilir istatistik kartı */}
              <div style={{ background:'var(--py-ink)', borderRadius:16, padding:isMobile?16:22, flex:1, minWidth:0 }}>
                <select
                  value={statId}
                  onChange={e=>{ setStatMetricPref(e.target.value); saveCardPrefs(e.target.value, topId); }}
                  style={{ background:'transparent', border:'none', outline:'none', fontSize:10, fontWeight:800, letterSpacing:'.09em', color:T.accent, textTransform:'uppercase' as const, marginBottom:10, padding:0, cursor:'pointer', display:'block' }}
                >
                  {STAT_METRICS.map(m=>(<option key={m.id} value={m.id} style={{ color:T.ink }}>{m.label}</option>))}
                </select>
                <div style={{ fontSize:30, fontWeight:800, color:'#fff', fontFamily:MONO }}>{activeStat.value}</div>
                <p style={{ fontSize:11.5, color:'rgba(255,255,255,.55)', marginTop:9, lineHeight:1.5 }}>{activeStat.sub}</p>
              </div>

              {/* Seçilebilir kanal kartı */}
              <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:20, display:'flex', flexDirection:'column' as const, justifyContent:'center', gap:12 }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <span style={{ width:36, height:36, borderRadius:10, background:'var(--py-amber-tint)', color:T.accentDeep, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="2.5" y="5" width="19" height="14" rx="3"/><path d="M2.5 10h19"/></svg>
                  </span>
                  <div style={{ minWidth:0 }}>
                    <select
                      value={topId}
                      onChange={e=>{ setTopMetricPref(e.target.value); saveCardPrefs(statId, e.target.value); }}
                      style={{ background:'transparent', border:'none', outline:'none', fontSize:10.5, fontWeight:800, letterSpacing:'.09em', color:T.textDim, textTransform:'uppercase' as const, marginBottom:3, padding:0, cursor:'pointer', display:'block' }}
                    >
                      {TOP_METRICS.map(m=>(<option key={m.id} value={m.id} style={{ color:T.ink }}>{m.label}</option>))}
                    </select>
                    <div style={{ fontSize:14, fontWeight:800, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{topPick?.channel || '—'}</div>
                  </div>
                </div>
                <div style={{ borderTop:'1px solid var(--py-table-divider)', paddingTop:12, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <span style={{ fontSize:11.5, color:T.textDim }}>{activeTop.sub}</span>
                  <span style={{ fontSize:13, fontWeight:800, color:T.accentDeep, fontFamily:MONO }}>
                    {topPick ? activeTop.fmt(topPick) : '—'}
                  </span>
                </div>
              </div>
            </div>
          );
        })()}
      </div>

      {/* Top Visited Pages */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, overflow:'hidden' }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap' as const, gap:8 }}>
          <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Çok Ziyaret Edilen Sayfalar')}</div>
          <input
            value={search} onChange={e=>{ setSearch(e.target.value); setPgPage(1); }}
            placeholder={t('Sayfa ara…')}
            style={{ padding:'7px 12px', borderRadius:9, border:`1px solid ${T.borderMid}`, fontSize:12, outline:'none', width:160, background:T.surface, fontFamily:'inherit' }}
          />
        </div>
      <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
          <thead style={{ background:'var(--py-subtle-bg)' }}>
            <tr>
              {[t('Sayfa'),t('Görüntüleme'),t('Süre'),t('Sepet'),'ATC CR%'].map((h,i)=>(
                <th key={h} style={{ padding:'11px 18px', fontSize:10.5, fontWeight:800, letterSpacing:'.06em', color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, textAlign: i===0?'left' as const:'right' as const, borderBottom:'1px solid var(--py-table-divider)', whiteSpace:'nowrap' as const }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pagedPg.map((p:any,i:number)=>(
              <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)' }}
                onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                <td style={{ padding:'13px 18px', fontSize:12.5, fontWeight:600, maxWidth:260, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>
                  {p.page_path||p.page}
                </td>
                <td style={{ padding:'13px 18px', fontSize:12.5, color:T.textMid, textAlign:'right' as const, fontFamily:MONO }}>{fmt.n(p.views)}</td>
                <td style={{ padding:'13px 18px', fontSize:12.5, color:T.textMid, textAlign:'right' as const, fontFamily:MONO }}>{fmtDur(p.avg_session_duration_sec)}</td>
                <td style={{ padding:'13px 18px', fontSize:12.5, color: p.add_to_cart>0?T.greenText:T.textDim, textAlign:'right' as const, fontFamily:MONO }}>{fmt.n(p.add_to_cart||0)}</td>
                <td style={{ padding:'13px 18px', fontSize:12.5, fontWeight:700, textAlign:'right' as const, fontFamily:MONO }}>{(p.cr||0).toFixed(2)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>
            {lang==='en'
              ? <>Showing {Math.min((pgPage-1)*PG_SIZE+1,filteredPg.length)}–{Math.min(pgPage*PG_SIZE,filteredPg.length)} of {filteredPg.length} pages</>
              : <>{filteredPg.length} sayfadan {Math.min((pgPage-1)*PG_SIZE+1,filteredPg.length)}–{Math.min(pgPage*PG_SIZE,filteredPg.length)} gösteriliyor</>}
          </span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPgPage(p=>Math.max(1,p-1))} disabled={pgPage===1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:pgPage===1?'not-allowed':'pointer', opacity:pgPage===1?0.4:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>‹</button>
            {Array.from({length:totalPgPages},(_,i)=>i+1).slice(0,5).map(n=>(
              <button key={n} onClick={()=>setPgPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${pgPage===n?T.accent:T.borderMid}`, background:pgPage===n?T.accent:T.surface, color: pgPage===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center' }}>{n}</button>
            ))}
            <button onClick={()=>setPgPage(p=>Math.min(totalPgPages,p+1))} disabled={pgPage===totalPgPages}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:pgPage===totalPgPages?'not-allowed':'pointer', opacity:pgPage===totalPgPages?0.4:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>›</button>
          </div>
        </div>
      </div>

    </div>
  );
}
// -- Reklam sekmeleri ortak parçalar: sıralama, ROAS filtresi, kampanya detay çekmecesi, platform karşılaştırma --

type SortDir = 'asc'|'desc';
function sortRows(rows:any[], key:string, dir:SortDir) {
  return [...rows].sort((a:any,b:any)=>{
    const av=a[key], bv=b[key];
    const r = (typeof av==='string'||typeof bv==='string') ? String(av||'').localeCompare(String(bv||''),'tr') : (av||0)-(bv||0);
    return dir==='asc' ? r : -r;
  });
}
const roasMatch = (f:string, r:number) => f==='lt2' ? r<2 : f==='gte2' ? r>=2 : f==='gte4' ? r>=4 : true;
const prevRange = (start:string, end:string) => {
  const s0 = new Date(start); const e0 = new Date(end);
  const diff = Math.round((e0.getTime()-s0.getTime())/(1000*86400));
  const pEnd = new Date(s0); pEnd.setDate(pEnd.getDate()-1);
  const pStart = new Date(pEnd); pStart.setDate(pStart.getDate()-diff);
  const iso = (d:Date) => d.toISOString().slice(0,10);
  return { ps: iso(pStart), pe: iso(pEnd) };
};

function SortTh({ label, k, sortKey, dir, onSort, align='right', style }:{ label:string; k:string; sortKey:string; dir:SortDir; onSort:(k:string)=>void; align?:'left'|'right'; style?:React.CSSProperties }) {
  const T = SidebarT;
  const active = sortKey===k;
  return (
    <th onClick={()=>onSort(k)} aria-sort={active?(dir==='asc'?'ascending':'descending'):'none'}
      style={{ padding:'11px 16px', fontSize:10.5, fontWeight:800, letterSpacing:'.06em', color:active?T.accentDeep:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, textAlign:align, borderBottom:'1px solid var(--py-table-divider)', whiteSpace:'nowrap' as const, cursor:'pointer', userSelect:'none' as const, ...style }}>
      {label}<span style={{ marginLeft:4, opacity:active?1:.25 }}>{active?(dir==='asc'?'↑':'↓'):'↕'}</span>
    </th>
  );
}

function RoasFilter({ value, onChange }:{ value:string; onChange:(v:string)=>void }) {
  const T = SidebarT; const { t } = useLang();
  return (
    <select value={value} onChange={e=>onChange(e.target.value)} aria-label="ROAS"
      style={{ padding:'6px 10px', borderRadius:999, fontSize:11, fontWeight:700, cursor:'pointer', outline:'none', fontFamily:'inherit',
        border:`1px solid ${value!=='all'?T.accent:T.borderMid}`, background:value!=='all'?'var(--py-amber-tint)':T.surface, color:value!=='all'?T.accentDeep:'var(--py-text-mid-alt)' }}>
      <option value="all">ROAS: {t('Tümü')}</option>
      <option value="lt2">ROAS &lt; 2×</option>
      <option value="gte2">ROAS ≥ 2×</option>
      <option value="gte4">ROAS ≥ 4×</option>
    </select>
  );
}

// Kampanya detay çekmecesi: günlük seyir (harcama / gelir / ROAS) + gün gün tablo
function CampaignDrawer({ platform, accountKey, campaign, start, end, onClose }:{ platform:'google'|'meta'; accountKey:string; campaign:any|null; start:string; end:string; onClose:()=>void }) {
  const T = SidebarT; const { t } = useLang(); const isMobile = useIsMobile();
  const [rows, setRows] = useState<any[]|null>(null);
  const [err, setErr] = useState(false);
  const [metric, setMetric] = useState<'spend'|'revenue'|'roas'>('spend');
  const cid = campaign ? String(campaign.campaign_id ?? '') : '';
  useEffect(()=>{
    if(!campaign || !cid) { setRows(null); return; }
    setRows(null); setErr(false);
    const url = platform==='google' ? `${API}/gads/${accountKey}/daily-campaigns` : `${API}/meta/${accountKey}/daily-campaigns`;
    axios.get(`${url}?start_date=${start}&end_date=${end}`)
      .then(r=>setRows((r.data||[]).filter((x:any)=>String(x.campaign_id)===cid).sort((a:any,b:any)=>String(a.date).localeCompare(String(b.date)))))
      .catch(()=>setErr(true));
  },[campaign, cid, platform, accountKey, start, end]);
  useEffect(()=>{
    if(!campaign) return;
    const h = (e:KeyboardEvent)=>{ if(e.key==='Escape') onClose(); };
    window.addEventListener('keydown', h); return ()=>window.removeEventListener('keydown', h);
  },[campaign, onClose]);
  if(!campaign) return null;
  const days = (rows||[]).map((r:any)=>({ ...r, roas: r.spend>0 ? r.revenue/r.spend : 0, label: String(r.date).slice(5) }));
  const sum = (k:string)=>days.reduce((s:number,d:any)=>s+(d[k]||0),0);
  const tSpend = sum('spend'), tRev = sum('revenue'), tConv = sum('conversions');
  const best = [...days].filter((d:any)=>d.spend>0).sort((a:any,b:any)=>b.roas-a.roas)[0];
  const colors = { spend:'#C9A84C', revenue:'#16D49B', roas:'#A855F7' } as const;
  const name = campaign.campaign_name || campaign.name || '';
  return (
    <div role="dialog" aria-label={name} style={{ position:'fixed' as const, inset:0, zIndex:10000 }}>
      <div onClick={onClose} style={{ position:'absolute' as const, inset:0, background:'rgba(20,22,43,.35)' }}/>
      <div style={{ position:'absolute' as const, top:0, right:0, bottom:0, width:isMobile?'100%':520, maxWidth:'100%', background:T.surface, borderLeft:`1px solid ${T.border}`, boxShadow:'-12px 0 40px rgba(20,22,43,.18)', display:'flex', flexDirection:'column' as const, fontFamily:'Manrope, sans-serif' }}>
        <div style={{ padding:'18px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', gap:12, alignItems:'flex-start' }}>
          <div style={{ minWidth:0 }}>
            <div style={{ fontSize:10.5, fontWeight:800, letterSpacing:'.09em', color:T.accentDeep, textTransform:'uppercase' as const, marginBottom:6 }}>{platform==='google'?'Google Ads':'Meta Ads'} · {t('Kampanya Detayı')}</div>
            <div style={{ fontSize:15, fontWeight:800, lineHeight:1.4, wordBreak:'break-word' as const }}>{name}</div>
            <div style={{ fontSize:11.5, color:T.textDim, marginTop:4 }}>{start} → {end}</div>
          </div>
          <button onClick={onClose} aria-label={t('Kapat')} style={{ width:32, height:32, borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:'pointer', fontSize:16, color:'var(--py-text-mid-alt)', flexShrink:0 }}>✕</button>
        </div>
        <div style={{ flex:1, overflowY:'auto' as const, padding:'18px 22px', display:'flex', flexDirection:'column' as const, gap:16 }}>
          {!cid && <div style={{ color:T.textDim, fontSize:12.5 }}>{t('Bu kampanya için günlük kırılım alınamadı.')}</div>}
          {cid && !rows && !err && <Loader/>}
          {err && <div style={{ color:T.redText, fontSize:12.5 }}>{t('Günlük veri alınamadı, tekrar deneyin.')}</div>}
          {rows && (
            <>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                {[
                  { l:t('Harcama'), v:fmt.k(tSpend) }, { l:t('Gelir'), v:fmt.k(tRev) },
                  { l:'ROAS', v:fmt.roas(tSpend>0?tRev/tSpend:0) }, { l:t('Dönüşüm'), v:fmt.n(Math.round(tConv)) },
                ].map(k=>(
                  <div key={k.l} style={{ border:`1px solid ${T.border}`, borderRadius:12, padding:'12px 14px' }}>
                    <div style={{ fontSize:11.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:6 }}>{k.l}</div>
                    <div style={{ fontSize:18, fontWeight:800, fontFamily:MONO }}>{k.v}</div>
                  </div>
                ))}
              </div>
              {days.length===0 ? (
                <div style={{ color:T.textDim, fontSize:12.5, textAlign:'center' as const, padding:24 }}>{t('Bu dönemde bu kampanya için günlük veri yok.')}</div>
              ) : (
                <>
                  <div style={{ border:`1px solid ${T.border}`, borderRadius:14, padding:'14px 16px' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10, gap:8, flexWrap:'wrap' as const }}>
                      <span style={{ fontSize:13, fontWeight:800 }}>{t('Günlük Seyir')}</span>
                      <div style={{ display:'flex', gap:6 }}>
                        {(['spend','revenue','roas'] as const).map(m=>(
                          <button key={m} onClick={()=>setMetric(m)} style={{ padding:'4px 11px', borderRadius:999, fontSize:11, fontWeight:700, cursor:'pointer', border:`1px solid ${metric===m?colors[m]:T.borderMid}`, background:metric===m?`${colors[m]}15`:T.surface, color:metric===m?colors[m]:'var(--py-text-mid-alt)' }}>{m==='spend'?t('Harcama'):m==='revenue'?t('Gelir'):'ROAS'}</button>
                        ))}
                      </div>
                    </div>
                    <ResponsiveContainer width="100%" height={180}>
                      <LineChart data={days} margin={{ top:6, right:6, left:-14, bottom:0 }}>
                        <XAxis dataKey="label" tick={{ fontSize:10, fill:T.textDim }} axisLine={false} tickLine={false} minTickGap={18}/>
                        <YAxis tick={{ fontSize:10, fill:T.textDim }} axisLine={false} tickLine={false} tickFormatter={(v:number)=>v>=1000?`${Math.round(v/1000)}K`:`${Math.round(v*10)/10}`}/>
                        <Tooltip content={<CT/>}/>
                        <Line type="monotone" dataKey={metric} stroke={colors[metric]} strokeWidth={2} dot={false}/>
                      </LineChart>
                    </ResponsiveContainer>
                    {best && <div style={{ fontSize:11.5, color:T.textDim, marginTop:6 }}>{t('En yüksek ROAS günü')}: <strong style={{ color:T.text }}>{best.date}</strong> · {fmt.roas(best.roas)}</div>}
                  </div>
                  <div style={{ border:`1px solid ${T.border}`, borderRadius:14, overflow:'hidden' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse' as const }}>
                      <thead style={{ background:'var(--py-subtle-bg)' }}>
                        <tr>{[t('Tarih'),t('Harcama'),t('Gelir'),'ROAS',t('Dönüşüm')].map((h,i)=>(
                          <th key={i} style={{ padding:'9px 12px', fontSize:10, fontWeight:800, letterSpacing:'.06em', textTransform:'uppercase' as const, color:'var(--py-text-mid-alt)', textAlign:i===0?'left' as const:'right' as const }}>{h}</th>
                        ))}</tr>
                      </thead>
                      <tbody>
                        {[...days].reverse().map((d:any,i:number)=>(
                          <tr key={i} style={{ borderTop:'1px solid var(--py-table-divider)' }}>
                            <td style={{ padding:'9px 12px', fontSize:12, fontWeight:600 }}>{d.date}</td>
                            <td style={{ padding:'9px 12px', fontSize:12, textAlign:'right' as const, fontFamily:MONO }}>{fmt.k(d.spend)}</td>
                            <td style={{ padding:'9px 12px', fontSize:12, textAlign:'right' as const, fontFamily:MONO }}>{fmt.k(d.revenue)}</td>
                            <td style={{ padding:'9px 12px', fontSize:12, textAlign:'right' as const, fontFamily:MONO, fontWeight:700, color:d.roas>=4?T.greenText:d.roas>=2?T.amberText:d.spend>0?T.redText:T.textDim }}>{d.spend>0?fmt.roas(d.roas):'—'}</td>
                            <td style={{ padding:'9px 12px', fontSize:12, textAlign:'right' as const, fontFamily:MONO }}>{Math.round(d.conversions||0)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// Bağlı tüm reklam mecraları yan yana: toplam KPI'lar (önceki döneme göre) ve günlük trend.
// Her mecra kendi uç noktasından alınıp ortak bir biçime (NormStats) çevrilir; yeni bir mecra eklemek için PLATFORM_DEFS'e bir satır yeterli.
type NormStats = { spend:number; revenue:number|null; conversions:number|null; clicks:number; impressions:number; daily:{date:string; spend:number; revenue:number|null; conversions:number|null}[]|null };
type CompareDef = { key:string; name:string; color:string; on:(cfg:any)=>boolean; load:(cfg:any, s:string, e:string)=>Promise<NormStats> };
const sumBy = (rows:any[], k:string) => rows.reduce((a,r)=>a+(Number(r?.[k])||0),0);
const fromDailyRows = (rows:any[]):NormStats => ({
  spend:sumBy(rows,'spend'), revenue:sumBy(rows,'revenue'), conversions:sumBy(rows,'conversions'), clicks:sumBy(rows,'clicks'), impressions:sumBy(rows,'impressions'),
  daily: rows.map(r=>({ date:String(r.date), spend:r.spend||0, revenue:r.revenue||0, conversions:r.conversions||0 })),
});
const PLATFORM_DEFS: CompareDef[] = [
  { key:'google', name:'Google Ads', color:'#4285F4',
    on:c=>c?.platforms?.gads?.enabled!==false && !!c?.platforms?.gads?.customerId,
    load:(c,s,e)=>axios.get(`${API}/gads/${c.platforms.gads.customerId}/daily?start_date=${s}&end_date=${e}`).then(r=>fromDailyRows(Array.isArray(r.data)?r.data:[])) },
  { key:'meta', name:'Meta Ads', color:'#A855F7',
    on:c=>c?.platforms?.meta?.enabled!==false && !!c?.platforms?.meta?.accountId,
    load:(c,s,e)=>axios.get(`${API}/meta/${c.platforms.meta.accountId}/daily?start_date=${s}&end_date=${e}`).then(r=>fromDailyRows(Array.isArray(r.data)?r.data:[])) },
  { key:'chatgpt', name:'ChatGPT Ads', color:'#10A37F',
    on:c=>c?.platforms?.chatgpt_ads?.enabled!==false && !!c?.platforms?.chatgpt_ads?.accountName && !!c?.client_id,
    load:(c,s,e)=>axios.get(`${API}/chatgpt-ads/${c.client_id}/overview`, { params:{ start_date:s, end_date:e } }).then(r=>{ const d=r.data||{};
      return { spend:d.spend||0, revenue:null, conversions:d.conversions??null, clicks:d.clicks||0, impressions:d.impressions||0,
        daily:(d.daily||[]).map((x:any)=>({ date:String(x.date).slice(0,10), spend:x.spend||0, revenue:null, conversions:null })) }; }) },
  { key:'criteo', name:'Criteo', color:'#F97316',
    on:c=>c?.platforms?.criteo?.enabled!==false && !!c?.platforms?.criteo?.advertiserName && !!c?.client_id,
    load:(c,s,e)=>axios.get(`${API}/criteo/${c.client_id}/overview`, { params:{ start_date:s, end_date:e } }).then(r=>{ const d=r.data||{};
      return { spend:d.cost||0, revenue:d.revenue||0, conversions:d.conversions||0, clicks:d.clicks||0, impressions:d.impressions||0,
        daily:(d.daily||[]).map((x:any)=>({ date:String(x.date).slice(0,10), spend:x.cost||0, revenue:x.revenue||0, conversions:null })) }; }) },
  { key:'rtbhouse', name:'RTB House', color:'#EF4444',
    on:c=>(c?.platforms as any)?.rtbhouse?.enabled!==false && !!(c?.platforms as any)?.rtbhouse?.token,
    load:(c,s,e)=>axios.get(`${API}/rtbhouse/overview`, { params:{ token:(c.platforms as any).rtbhouse.token, day_from:s, day_to:e } }).then(r=>{ const d=r.data||{};
      return { spend:d.total_spend||0, revenue:d.total_conv_value||0, conversions:d.total_conversions||0, clicks:d.total_clicks||0, impressions:d.total_imps||0,
        daily:(d.daily_trend||[]).map((x:any)=>({ date:String(x.day).slice(0,10), spend:x.spend||0, revenue:x.conv_value||0, conversions:x.conversions||0 })) }; }) },
  { key:'xads', name:'X Ads', color:'#475569',
    on:c=>(c?.platforms as any)?.x_ads?.enabled!==false && !!(c?.platforms as any)?.x_ads?.accountName && !!c?.client_id,
    load:(c,s,e)=>axios.get(`${API}/x-ads/${c.client_id}/overview`, { params:{ start_date:s, end_date:e } }).then(r=>{ const d=r.data||{};
      return { spend:d.spend||0, revenue:null, conversions:null, clicks:d.clicks||0, impressions:d.impressions||0, daily:null }; }) },
  { key:'tiktok', name:'TikTok Ads', color:'#111827',
    on:c=>(c?.platforms as any)?.tiktok?.enabled!==false && !!(c?.platforms as any)?.tiktok?.advertiserId && !!c?.client_id,
    load:(c,s,e)=>axios.get(`${API}/tiktok/${c.client_id}/overview`, { params:{ start_date:s, end_date:e } }).then(r=>{ const d=r.data||{};
      return { spend:d.spend||0, revenue:d.revenue||null, conversions:d.purchases||null, clicks:d.clicks||0, impressions:d.impressions||0,
        daily:(d.daily||[]).map((x:any)=>({ date:String(x.date).slice(0,10), spend:x.spend||0, revenue:x.revenue||null, conversions:x.purchases||null })) }; }) },
];

function PlatformCompareTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT; const { t } = useLang(); const isMobile = useIsMobile();
  const defs = PLATFORM_DEFS.filter(d=>d.on(config));
  const defKey = defs.map(d=>d.key).join(',');
  const [res, setRes] = useState<Record<string,{cur?:NormStats; prev?:NormStats; err?:boolean}>|null>(null);
  const [metric, setMetric] = useState<'spend'|'revenue'|'roas'|'conversions'>('spend');
  const [hidden, setHidden] = useState<Record<string,boolean>>({});

  useEffect(()=>{
    if(!defs.length) { setRes({}); return; }
    setRes(null);
    const { ps, pe } = prevRange(start, end);
    Promise.all(defs.map(async d=>{
      try {
        const [cur, prev] = await Promise.all([ d.load(config, start, end), d.load(config, ps, pe).catch(()=>undefined) ]);
        return [d.key, { cur, prev }] as const;
      } catch { return [d.key, { err:true }] as const; }
    })).then(list=>setRes(Object.fromEntries(list)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[start,end,defKey,config?.client_id]);

  if(!defs.length) return <div style={{ color:T.textMid, padding:24 }}>{t('Karşılaştırma için en az bir reklam platformu bağlı olmalı.')}</div>;
  if(!res) return <Loader/>;

  const m = (s?:NormStats) => {
    if(!s) return null;
    const rev = s.revenue, conv = s.conversions;
    return { spend:s.spend, revenue:rev, conversions:conv, clicks:s.clicks, impressions:s.impressions,
      roas: rev!=null && s.spend>0 ? rev/s.spend : (rev!=null ? 0 : null),
      cpa: conv!=null && conv>0 ? s.spend/conv : null,
      ctr: s.impressions>0 ? s.clicks/s.impressions*100 : null } as Record<string,number|null>;
  };
  const chg = (c:number|null|undefined, p:number|null|undefined) => (c!=null && p!=null && p>0) ? Math.round((c-p)/p*100) : null;
  const okDefs = defs.filter(d=>res[d.key]?.cur);
  const totalSpend = okDefs.reduce((a,d)=>a+(res[d.key].cur!.spend||0),0);
  const rowsDef: {l:string; k:string; f:(v:number)=>string; good:'up'|'down'|'none'}[] = [
    { l:t('Harcama'), k:'spend', f:fmt.k, good:'none' }, { l:t('Gelir'), k:'revenue', f:fmt.k, good:'up' },
    { l:'ROAS', k:'roas', f:fmt.roas, good:'up' }, { l:t('Dönüşüm'), k:'conversions', f:(v)=>fmt.n(Math.round(v)), good:'up' },
    { l:'CPA', k:'cpa', f:fmt.k, good:'down' }, { l:t('Tıklama'), k:'clicks', f:fmt.n, good:'up' }, { l:'CTR', k:'ctr', f:fmt.pct, good:'up' },
    { l:t('Görüntülenme'), k:'impressions', f:fmt.n, good:'up' },
  ];

  // Günlük trend: yalnızca günlük verisi olan ve seçili metriği sunan mecralar
  const trendDefs = okDefs.filter(d=>res[d.key].cur!.daily && !hidden[d.key] && (metric==='spend' || (metric==='revenue'||metric==='roas' ? res[d.key].cur!.revenue!=null : res[d.key].cur!.daily!.some(x=>x.conversions!=null))));
  const dates = Array.from(new Set(okDefs.flatMap(d=>(res[d.key].cur!.daily||[]).map(x=>x.date)))).sort();
  const dayMaps = Object.fromEntries(okDefs.map(d=>[d.key, new Map((res[d.key].cur!.daily||[]).map(x=>[x.date,x]))]));
  const pointVal = (x:any) => !x ? undefined : metric==='roas' ? (x.revenue!=null && x.spend>0 ? x.revenue/x.spend : 0) : (x[metric] ?? undefined);
  const series = dates.map(dt=>{ const row:any = { label:dt.slice(5) }; trendDefs.forEach(d=>{ row[d.name]=pointVal(dayMaps[d.key].get(dt)); }); return row; });
  const noDailyNames = okDefs.filter(d=>!res[d.key].cur!.daily).map(d=>d.name);

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%', fontFamily:'Manrope, sans-serif' }}>
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(auto-fit, minmax(360px, 1fr))', gap:14 }}>
        {defs.map(d=>{
          const r = res[d.key]; const A = m(r?.cur), P = m(r?.prev);
          return (
            <div key={d.key} style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, borderTop:`3px solid ${d.color}`, padding:'18px 20px' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:14 }}>
                <span style={{ display:'flex', alignItems:'center', gap:8, fontSize:14, fontWeight:800, color:d.color }}><span style={{ width:9, height:9, borderRadius:'50%', background:d.color }}/>{d.name}</span>
                {A && totalSpend>0 && <span style={{ fontSize:11.5, color:T.textDim }}>{t('Harcama Payı')}: <strong style={{ color:T.text, fontFamily:MONO }}>%{Math.round(r.cur!.spend/totalSpend*100)}</strong></span>}
              </div>
              {!A ? <div style={{ fontSize:12.5, color:T.textDim }}>{t('Veri alınamadı')}</div> : (
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px 16px' }}>
                  {rowsDef.map(rw=>{
                    const v = A[rw.k];
                    const dlt = chg(v, P?.[rw.k]);
                    const goodUp = rw.good==='none' ? null : (rw.good==='up' ? (dlt!=null && dlt>=0) : (dlt!=null && dlt<=0));
                    return (
                      <div key={rw.k}>
                        <div style={{ fontSize:11.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:4 }}>{rw.l}</div>
                        <div style={{ display:'flex', alignItems:'baseline', gap:7 }}>
                          <span style={{ fontSize:18, fontWeight:800, fontFamily:MONO, color:v==null?T.textDim:T.text }}>{v==null ? '—' : rw.f(v)}</span>
                          {dlt!=null && <span style={{ fontSize:10.5, fontWeight:700, fontFamily:MONO, color:goodUp==null?T.textDim:goodUp?T.greenText:T.redText }}>{dlt>=0?'+':''}{dlt}%</span>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {okDefs.length>1 && totalSpend>0 && (
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'18px 22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, marginBottom:12 }}>{t('Bütçe Dağılımı')}</div>
          <div style={{ display:'flex', height:30, borderRadius:9, overflow:'hidden', background:'var(--py-track-bg)' }}>
            {okDefs.map(d=>{ const p=res[d.key].cur!.spend/totalSpend*100; return <div key={d.key} title={`${d.name} %${p.toFixed(1)}`} style={{ width:`${p}%`, background:d.color, display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:12, fontWeight:800, overflow:'hidden', whiteSpace:'nowrap' as const }}>{p>=12?`${d.name.split(' ')[0]} %${Math.round(p)}`:''}</div>; })}
          </div>
          <div style={{ display:'flex', gap:14, flexWrap:'wrap' as const, marginTop:10 }}>
            {okDefs.map(d=>(<span key={d.key} style={{ display:'flex', alignItems:'center', gap:6, fontSize:11.5, color:T.textMid }}><span style={{ width:8, height:8, borderRadius:'50%', background:d.color }}/>{d.name} · {fmt.k(res[d.key].cur!.spend)}</span>))}
          </div>
        </div>
      )}

      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'18px 22px' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap' as const, gap:10, marginBottom:12 }}>
          <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Günlük Karşılaştırma')}</span>
          <div style={{ display:'flex', gap:6, flexWrap:'wrap' as const, alignItems:'center' }}>
            {([['spend',t('Harcama')],['revenue',t('Gelir')],['roas','ROAS'],['conversions',t('Dönüşüm')]] as const).map(([k,l])=>(
              <button key={k} onClick={()=>setMetric(k)} style={{ padding:'6px 13px', borderRadius:999, fontSize:12, fontWeight:metric===k?700:600, cursor:'pointer', border:`1px solid ${metric===k?T.accent:T.borderMid}`, background:metric===k?'var(--py-amber-tint)':T.surface, color:metric===k?T.accentDeep:T.textMid }}>{l}</button>
            ))}
            <button onClick={()=>exportCsv(`platform-karsilastirma-${start}-${end}.csv`, dates.map(dt=>{ const row:any={ date:dt }; okDefs.forEach(d=>{ const x:any=dayMaps[d.key].get(dt)||{}; row[`${d.key}_spend`]=x.spend||0; row[`${d.key}_revenue`]=x.revenue||0; row[`${d.key}_conv`]=x.conversions||0; }); return row; }),
              [{ key:'date', label:t('Tarih') }, ...okDefs.flatMap(d=>[{ key:`${d.key}_spend`, label:`${d.name} ${t('Harcama')}` },{ key:`${d.key}_revenue`, label:`${d.name} ${t('Gelir')}` },{ key:`${d.key}_conv`, label:`${d.name} ${t('Dönüşüm')}` }])])}
              disabled={dates.length===0} style={{ padding:'6px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:dates.length?'pointer':'not-allowed', opacity:dates.length?1:.5 }}>{t('Dışa Aktar')}</button>
          </div>
        </div>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap' as const, marginBottom:12 }}>
          {okDefs.filter(d=>res[d.key].cur!.daily).map(d=>(
            <button key={d.key} onClick={()=>setHidden(h=>({ ...h, [d.key]:!h[d.key] }))} aria-pressed={!hidden[d.key]}
              style={{ display:'flex', alignItems:'center', gap:6, padding:'4px 11px', borderRadius:999, fontSize:11.5, fontWeight:700, cursor:'pointer', border:`1px solid ${hidden[d.key]?T.borderMid:d.color}`, background:hidden[d.key]?T.surface:`${d.color}14`, color:hidden[d.key]?T.textDim:d.color }}>
              <span style={{ width:8, height:8, borderRadius:'50%', background:hidden[d.key]?T.borderMid:d.color }}/>{d.name}
            </button>
          ))}
        </div>
        {dates.length===0 || trendDefs.length===0 ? <div style={{ textAlign:'center' as const, color:T.textDim, fontSize:12.5, padding:36 }}>{dates.length===0 ? t('Bu dönem için veri yok.') : t('Seçili metrik için gösterilecek mecra yok.')}</div> : (
          <ResponsiveContainer width="100%" height={260}>
            <LineChart data={series} margin={{ top:6, right:8, left:-8, bottom:0 }}>
              <XAxis dataKey="label" tick={{ fontSize:10, fill:T.textDim }} axisLine={false} tickLine={false} minTickGap={20}/>
              <YAxis tick={{ fontSize:10, fill:T.textDim }} axisLine={false} tickLine={false} tickFormatter={(v:number)=>v>=1000?`${Math.round(v/1000)}K`:`${Math.round(v*10)/10}`}/>
              <Tooltip content={<CT/>}/>
              <Legend wrapperStyle={{ fontSize:12 }}/>
              {trendDefs.map((d,i)=><Line key={d.key} type="monotone" dataKey={d.name} stroke={d.color} strokeWidth={2} strokeDasharray={i%2 ? '5 3' : undefined} dot={false} connectNulls/>)}
            </LineChart>
          </ResponsiveContainer>
        )}
        {noDailyNames.length>0 && <div style={{ fontSize:11, color:T.textDim, marginTop:8 }}>{noDailyNames.join(', ')}: {t('günlük kırılım sunmuyor, yalnızca toplam kartında görünür.')}</div>}
      </div>
    </div>
  );
}

function GoogleTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [ov,setOv]       = useState<any>(null);
  const [camps,setCamps] = useState<any[]>([]);
  const [prevOv,setPrevOv] = useState<any>(null);
  const [loading,setLoading] = useState(true);
  const [campSearch,setCampSearch] = useState('');
  const [chartMetric, setChartMetric] = useState<'spend'|'revenue'|'conversions'|'roas'>('spend');
  const { customerId } = config.platforms.gads;
  const { t } = useLang();

  useEffect(()=>{
    setLoading(true);
    // Önceki dönem (aynı uzunlukta) — KPI kartlarında değişim yüzdesi için
    const s0 = new Date(start); const e0 = new Date(end);
    const diff0 = Math.round((e0.getTime()-s0.getTime())/(1000*86400));
    const pEnd = new Date(s0); pEnd.setDate(pEnd.getDate()-1);
    const pStart = new Date(pEnd); pStart.setDate(pStart.getDate()-diff0);
    const iso = (d:Date) => d.toISOString().slice(0,10);
    Promise.all([
      axios.get(`${API}/gads/${customerId}/overview?start_date=${start}&end_date=${end}`),
      axios.get(`${API}/gads/${customerId}/campaigns?start_date=${start}&end_date=${end}`),
      axios.get(`${API}/gads/${customerId}/overview?start_date=${iso(pStart)}&end_date=${iso(pEnd)}`).then(r=>r.data).catch(()=>null),
    ]).then(([a,b,c])=>{ setOv(a.data); setCamps(b.data); setPrevOv(c); setLoading(false); })
      .catch(()=>setLoading(false));
  },[start,end,customerId]);

  const [statusFilter, setStatusFilter] = useState<'ALL'|'ENABLED'|'PAUSED'>('ALL');
  const [page, setPage] = useState(0);
  const [sortKey, setSortKey] = useState('spend');
  const [sortDir, setSortDir] = useState<SortDir>('desc');
  const [roasFilter, setRoasFilter] = useState('all');
  const [drawerCamp, setDrawerCamp] = useState<any|null>(null);
  const onSort = (k:string) => { if(sortKey===k) setSortDir(d=>d==='desc'?'asc':'desc'); else { setSortKey(k); setSortDir(k==='campaign_name'||k==='status'?'asc':'desc'); } setPage(0); };
  const filteredCamps = useMemo(()=>sortRows(camps.filter(c=>{
    const nameMatch = c.campaign_name?.toLowerCase().includes(campSearch.toLowerCase());
    const statusMatch = statusFilter === 'ALL' || c.status === statusFilter;
    return nameMatch && statusMatch && roasMatch(roasFilter, c.roas||0);
  }), sortKey, sortDir),[camps,campSearch,statusFilter,roasFilter,sortKey,sortDir]);
  const PAGE_SIZE = 10;
  const totalPages = Math.max(1, Math.ceil(filteredCamps.length / PAGE_SIZE));
  const paged = filteredCamps.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);

  if(loading) return <Loader/>;
  if(!ov) return <div style={{ color:T.textMid, padding:24 }}>{t('Veri bulunamadı.')}</div>;

  const chartData = [...filteredCamps].sort((a:any,b:any)=>(b[chartMetric]||0)-(a[chartMetric]||0)).slice(0,10).map((c:any)=>({
    name: (()=>{ const n = c.campaign_name?.replace(/\|/g,' | ') || ''; return n.length>18 ? n.slice(0,17)+'…' : n; })(),
    spend: c.spend, revenue: c.revenue,
    conversions: Math.round(c.conversions), roas: c.roas,
  }));
  const metricCfg:Record<string,{label:string,color:string,fmt:(v:number)=>string}> = {
    spend:       { label:t('Harcama'),  color:'#C9A84C',  fmt:v=>fmt.k(v) },
    revenue:     { label:t('Gelir'),    color:'#16D49B',  fmt:v=>fmt.k(v) },
    conversions: { label:t('Dönüşüm'), color:'#3b82f6',  fmt:v=>fmt.n(v) },
    roas:        { label:'ROAS',     color:'#A855F7',  fmt:v=>`${v?.toFixed(2)}×` },
  };

  const gChg = (cur:number, prev:number) => (prev && prev>0) ? Math.round(((cur-prev)/prev)*100) : null;
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, fontFamily:'Manrope, sans-serif' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:14, overflowX:'hidden' as const }}>
        {[
          { label:t('Harcama'),   value:fmt.k(ov.spend),             sub:`${fmt.n(ov.clicks)} ${t('tıklama')}`, chg:gChg(ov.spend, prevOv?.spend) },
          { label:'ROAS',      value:`${fmt.roas(ov.roas)}`,      sub:`${t('Gelir')}: ${fmt.k(ov.revenue)}`, highlight: ov.roas >= 3, chg:gChg(ov.roas, prevOv?.roas) },
          { label:t('Dönüşüm'),  value:fmt.n(ov.conversions),        sub:`CPA: ${fmt.k(ov.conversions>0?ov.spend/ov.conversions:0)}`, chg:gChg(ov.conversions, prevOv?.conversions) },
          { label:t('Gösterim'), value:fmt.n(ov.impressions),        sub:`CTR: ${fmt.pct(ov.ctr)}`, chg:gChg(ov.impressions, prevOv?.impressions) },
        ].map(kpi => (
          <div key={kpi.label} style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:'18px 19px' }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:14 }}>{kpi.label}</div>
            <div style={{ display:'flex', alignItems:'baseline', gap:8, marginBottom:6, minWidth:0 }}>
              <span style={{ fontSize:isMobile?18:24, fontWeight:800, color: (kpi as any).highlight?T.greenText:T.text, fontFamily:MONO, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{kpi.value}</span>
              {kpi.chg!=null && <span title={t('Önceki döneme göre')} style={{ fontSize:11, fontWeight:700, color:kpi.chg>=0?T.greenText:T.redText, fontFamily:MONO, whiteSpace:'nowrap' as const }}>{kpi.chg>=0?'↗ +':'↘ '}{kpi.chg}%</span>}
            </div>
            <div style={{ fontSize:11.5, color:T.textDim }}>{kpi.sub}</div>
          </div>
        ))}
      </div>

      {/* Kampanya Analizi Chart */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
        <div style={{ display:'flex', flexDirection:isMobile?'column' as const:'row' as const, justifyContent:'space-between', alignItems:isMobile?'flex-start' as const:'center' as const, marginBottom:18, gap:10 }}>
          <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Kampanya Analizi')}</span>
          <div style={{ display:'flex', flexWrap:'wrap' as const, gap:6, alignItems:'center' }}>
            {(Object.entries(metricCfg) as any).map(([key,cfg]:any) => (
              <button key={key} onClick={()=>setChartMetric(key)} style={{
                padding:'6px 13px', borderRadius:999, border:`1px solid ${chartMetric===key?cfg.color:T.borderMid}`,
                background: chartMetric===key?`${cfg.color}15`:T.surface,
                color: chartMetric===key?cfg.color:T.textMid,
                fontSize:12, fontWeight:chartMetric===key?700:600, cursor:'pointer', whiteSpace:'nowrap' as const,
              }}>{cfg.label}</button>
            ))}
          </div>
        </div>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={chartData} margin={{ top:0, right:0, left:-10, bottom:40 }}>
            <XAxis dataKey="name" tick={{ fontSize:10, fill:T.textDim }} axisLine={false} tickLine={false} angle={-20} textAnchor="end" interval={0}/>
            <YAxis tick={{ fontSize:10, fill:T.textDim }} axisLine={false} tickLine={false} tickFormatter={(v:number)=>v>=1000?`${Math.round(v/1000)}K`:`${v}`}/>
            <Tooltip content={<CT/>} cursor={{ fill:'rgba(201,168,76,.05)' }}/>
            <Bar dataKey={chartMetric} radius={[5,5,0,0]} maxBarSize={50}>
              {chartData.map((_:any,i:number)=><Cell key={i} fill={i===0?metricCfg[chartMetric].color:`${metricCfg[chartMetric].color}55`}/>)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Kampanyalar Tablosu */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, overflow:'hidden' }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', flexDirection:isMobile?'column' as const:'row' as const, justifyContent:'space-between', alignItems:isMobile?'stretch' as const:'center' as const, gap:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Kampanyalar')}</span>
            <span style={{ fontSize:11, color:T.textDim, background:'var(--py-track-bg)', padding:'3px 9px', borderRadius:999 }}>{start} → {end}</span>
            <button onClick={()=>exportCsv(`google-ads-kampanyalar-${start}-${end}.csv`, filteredCamps, [
              { key:'campaign_name', label:t('Kampanya') }, { key:'status', label:t('Durum') },
              { key:'spend', label:t('Harcama') }, { key:'revenue', label:t('Gelir') },
              { key:'roas', label:'ROAS' }, { key:'clicks', label:t('Tıklama') },
              { key:'ctr', label:'CTR' }, { key:'conversions', label:'Conv.' },
            ])} disabled={filteredCamps.length===0} style={{ padding:'5px 11px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:11, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:filteredCamps.length?'pointer':'not-allowed', opacity:filteredCamps.length?1:.5 }}>
              {t('Dışa Aktar')}
            </button>
          </div>
          <div style={{ display:'flex', flexDirection:'column' as const, gap:6 }}>
            <input value={campSearch} onChange={e=>{ setCampSearch(e.target.value); setPage(0); }} placeholder={t('Kampanya ara…')}
              style={{ padding:'8px 13px', borderRadius:10, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12.5, outline:'none', width:'100%', boxSizing:'border-box' as const, fontFamily:'inherit' }}/>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap' as const }}>
              <RoasFilter value={roasFilter} onChange={v=>{ setRoasFilter(v); setPage(0); }}/>
              {(['ALL','ENABLED','PAUSED'] as const).map(s => (
                <button key={s} onClick={()=>{ setStatusFilter(s); setPage(0); }} style={{
                  flex:1, padding:'6px 8px', borderRadius:999, cursor:'pointer', fontSize:11, fontWeight:700,
                  border:`1px solid ${statusFilter===s?T.accent:T.borderMid}`,
                  background: statusFilter===s?'var(--py-amber-tint)':T.surface,
                  color: statusFilter===s?T.accentDeep:'var(--py-text-mid-alt)',
                  whiteSpace:'nowrap' as const, textAlign:'center' as const,
                }}>
                  {s==='ALL'?t('Tümü'):s==='ENABLED'?`${t('Aktif')} (${camps.filter((c:any)=>c.status==='ENABLED').length})`:`${t('Duraklatılmış')} (${camps.filter((c:any)=>c.status==='PAUSED').length})`}
                </button>
              ))}
            </div>
          </div>
        </div>
      <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
          <thead style={{ background:'var(--py-subtle-bg)' }}>
            <tr>
              {([[t('Kampanya'),'campaign_name'],[t('Durum'),'status'],[t('Harcama'),'spend'],[t('Gelir'),'revenue'],['ROAS','roas'],[t('Tıklama'),'clicks'],['CTR','ctr'],[t('Dönüşüm'),'conversions']] as [string,string][]).map(([h,k],i) => (
                <SortTh key={k} label={h} k={k} sortKey={sortKey} dir={sortDir} onSort={onSort} align={i===0?'left':'right'}/>
              ))}
            </tr>
          </thead>
          <tbody>
            {paged.length===0 && (
              <tr><td colSpan={8} style={{ padding:48, textAlign:'center' as const, color:T.textDim, fontSize:12.5 }}>{t('Sonuç bulunamadı')}</td></tr>
            )}
            {paged.map((c:any,i:number)=>(
              <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)', cursor:'pointer' }} onClick={()=>setDrawerCamp(c)} title={t('Detay için tıkla')}
                onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                <td style={{ padding:'13px 16px', fontSize:12.5, fontWeight:700, maxWidth:240, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{c.campaign_name}</td>
                <td style={{ padding:'13px 16px', textAlign:'right' as const }}>
                  <span style={{ fontSize:10, fontWeight:700, padding:'2px 9px', borderRadius:999,
                    color:c.status==='ENABLED'?T.greenText:T.amberText,
                    background:c.status==='ENABLED'?'var(--py-green-tint)':'var(--py-amber-tint-alt)' }}>
                    {c.status==='ENABLED'?t('Aktif'):t('Duraklatıldı')}
                  </span>
                </td>
                <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, fontWeight:700, color:T.accentDeep, fontFamily:MONO }}>{fmt.k(c.spend)}</td>
                <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, fontWeight:600, color:c.revenue>0?T.greenText:T.textDim, fontFamily:MONO }}>{c.revenue>0?fmt.k(c.revenue):'—'}</td>
                <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, fontWeight:800, color:c.roas>=4?T.greenText:c.roas>=2?T.amberText:T.redText, fontFamily:MONO }}>{fmt.roas(c.roas)}</td>
                <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(c.clicks)}</td>
                <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.pct(c.ctr)}</td>
                <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, fontWeight:600, fontFamily:MONO }}>{Math.round(c.conversions)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      {totalPages > 1 && (
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>{page*PAGE_SIZE+1}–{Math.min((page+1)*PAGE_SIZE, filteredCamps.length)} / {filteredCamps.length} {t('kampanya')}</span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page===0?'not-allowed':'pointer', opacity:page===0?0.4:1, fontSize:14, display:'flex', alignItems:'center', justifyContent:'center' }}>‹</button>
            {pageWindow(page,totalPages).map(n=>(
              <button key={n} onClick={()=>setPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${page===n?T.accent:T.borderMid}`, background:page===n?T.accent:T.surface, color:page===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page>=totalPages-1?'not-allowed':'pointer', opacity:page>=totalPages-1?0.4:1, fontSize:14, display:'flex', alignItems:'center', justifyContent:'center' }}>›</button>
          </div>
        </div>
      )}
      </div>
      </div>

      <CampaignDrawer platform="google" accountKey={customerId} campaign={drawerCamp} start={start} end={end} onClose={()=>setDrawerCamp(null)}/>
    </div>
  );
}

function MetaTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [sortKey, setSortKey] = useState<string>('spend');
  const [sortDir, setSortDir] = useState<SortDir>('desc');
  const [roasFilter, setRoasFilter] = useState('all');
  const [drawerCamp, setDrawerCamp] = useState<any|null>(null);
  const [statusFilter, setStatusFilter] = useState<'all'|'ACTIVE'|'PAUSED'>('all');
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [bestMetricPref, setBestMetricPref] = useState<string|null>(null);
  const PAGE_SIZE = 10;
  const { accountId } = config.platforms.meta;
  const { t, lang } = useLang();

  useEffect(()=>{
    const cid = config?.client_id || 1;
    try{ setBestMetricPref(localStorage.getItem(`poyais_meta_best_card_${cid}`)); }catch{ setBestMetricPref(null); }
  },[config?.client_id]);

  useEffect(() => {
    if (!accountId) return;
    setLoading(true);
    // Önceki dönem hesapla
    const s = new Date(start); const e = new Date(end);
    const diff = Math.round((e.getTime()-s.getTime())/(1000*86400));
    const prevEnd = new Date(s); prevEnd.setDate(prevEnd.getDate()-1);
    const prevStart = new Date(prevEnd); prevStart.setDate(prevStart.getDate()-diff);
    const fmt2 = (d:Date) => d.toISOString().slice(0,10);
    Promise.all([
      axios.get(`${API}/meta/${accountId}/overview?start_date=${start}&end_date=${end}`),
      axios.get(`${API}/meta/${accountId}/overview?start_date=${fmt2(prevStart)}&end_date=${fmt2(prevEnd)}`),
    ]).then(([cur, prev]) => {
      setData({ ...cur.data, prev: prev.data });
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [start, end, accountId]);

  if (loading) return <Loader/>;
  const camps = data?.campaigns || [];
  const ov = data?.overview || {};
  const prevOv = data?.prev?.overview || {};
  const campaigns = camps;
  const totalSpend    = camps.reduce((s:number,c:any) => s+(c.spend||0), 0);
  const onSort = (k:string) => { if(sortKey===k) setSortDir(d=>d==='desc'?'asc':'desc'); else { setSortKey(k); setSortDir(k==='name'||k==='status'?'asc':'desc'); } setPage(0); };
  const filteredCamps = sortRows(camps
    .map((c:any) => ({ ...c, name: c.name||c.campaign_name }))
    .filter((c:any) => (statusFilter==='all' || (c.status==='ENABLED'?'ACTIVE':c.status)===statusFilter) && roasMatch(roasFilter, c.roas||0)), sortKey, sortDir);
  const maxSpend      = camps.length ? Math.max(...camps.map((c:any)=>c.spend||0), 1) : 1;
  const totalPages    = Math.max(1, Math.ceil(filteredCamps.length / PAGE_SIZE));
  const paged         = filteredCamps.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);
  const maxRoas       = camps.length ? Math.max(...camps.map((c:any)=>c.roas||0)) : 1;
  const pctChange = (cur:number, prev:number) => {
    if(!prev) return null;
    const p = Math.round(((cur-prev)/prev)*100);
    return { val: p, up: p>=0 };
  };

  const statusBadge = (s:string) => {
    if (s==='ACTIVE' || s==='ENABLED') return { text:t('Aktif'),       bg:'var(--py-green-tint)', color:T.greenText };
    if (s==='PAUSED')   return { text:t('Duraklatıldı'), bg:'var(--py-track-bg)', color:'var(--py-text-mid-alt)' };
    return                     { text: s||t('Yok'),     bg:'var(--py-amber-tint)', color:T.accentDeep };
  };

  const spendChg   = pctChange(ov.spend||totalSpend, prevOv.spend||0);
  const revenueChg = pctChange(ov.revenue||0, prevOv.revenue||0);
  const convChg    = pctChange(ov.purchases||ov.conversions||0, prevOv.purchases||prevOv.conversions||0);
  const reachChg   = pctChange(ov.reach||0, prevOv.reach||0);
  const kpis = [
    { label:t('Harcama'),    value: fmt.k(ov.spend||totalSpend), sub:t('Geçen döneme göre.'), chg:spendChg },
    { label:t('Gelir'),      value: fmt.k(ov.revenue||0), sub:t('Satışlardan elde edilen tutar.'), chg:revenueChg },
    { label:t('Satın Alma'), value: fmt.n(ov.purchases||ov.conversions||0), sub:t('Toplam dönüşüm adedi.'), chg:convChg },
    { label:t('Erişim'),     value: fmt.n(ov.reach||0), sub:t('Tekil kullanıcılara erişim.'), chg:reachChg },
  ];

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:14 }}>
        {kpis.map((k,i) => (
          <div key={i} style={{ background:T.surface, padding:'18px 19px', borderRadius:14, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:14 }}>{k.label}</div>
            <div style={{ display:'flex', alignItems:'baseline', gap:8, marginBottom:6 }}>
              <span style={{ fontSize:22, fontWeight:800, fontFamily:MONO }}>{k.value}</span>
              {k.chg && <span style={{ fontSize:11, fontWeight:700, color:k.chg.up?T.greenText:T.redText, fontFamily:MONO }}>{k.chg.up?'+':''}{k.chg.val}%</span>}
            </div>
            <div style={{ fontSize:11, color:T.textDim }}>{k.sub}</div>
          </div>
        ))}
      </div>

      {/* Meta'nın Fırsat Puanı ve önerileri Meta Ads › Hesap Sağlığı sayfasına taşındı. */}

      {/* Kampanya Analizi + Kreatif Spotlight */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'2fr 1fr', gap:14 }}>

        {/* Bar Chart Card */}
        <div style={{ background:T.surface, padding:'20px 22px', borderRadius:16, border:`1px solid ${T.border}` }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:22, gap:10, flexWrap:'wrap' as const }}>
            <div>
              <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Meta Kampanya Analizi')}</div>
              <div style={{ fontSize:11.5, color:T.textDim, marginTop:4 }}>{t('En yüksek performanslı kampanyaların harcama dağılımı.')}</div>
            </div>
            <button onClick={()=>window.dispatchEvent(new CustomEvent('poyais-nav',{detail:'meta-campaigns'}))} style={{ fontSize:12, fontWeight:700, color:T.accentDeep, background:'none', border:'none', cursor:'pointer' }}>
              {t('Detaylı İncele →')}
            </button>
          </div>
          <div style={{ display:'flex', flexDirection:'column' as const, gap:18 }}>
            {campaigns.length===0 && <div style={{ fontSize:12.5, color:T.textDim, padding:'24px 0', textAlign:'center' as const }}>{t('Bu dönem için kampanya verisi yok.')}</div>}
            {[...campaigns].sort((a:any,b:any)=>(b.spend||0)-(a.spend||0)).slice(0,5).map((c:any,i:number) => (
              <div key={i} style={{ display:'flex', flexDirection:'column' as const, gap:6 }}>
                <div style={{ display:'flex', justifyContent:'space-between' }}>
                  <span style={{ fontSize:12, fontWeight:600, color:T.textMid }}>{c.name||c.campaign_name}</span>
                  <span style={{ fontSize:12, fontWeight:700, fontFamily:MONO }}>{fmt.k(c.spend)}</span>
                </div>
                <div style={{ height:8, width:'100%', background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                  <div style={{ height:'100%', borderRadius:999, background:T.accentDeep, width:`${Math.min((c.spend||0)/maxSpend*100,100)}%`, transition:'width .4s' }}/>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Kreatif Spotlight — seçilebilir metrik */}
        {(()=>{
          const BEST_METRICS = [
            { id:'roas',   label:'ROAS',     pick:()=>[...camps].filter((c:any)=>(c.roas||0)>0).sort((a:any,b:any)=>(b.roas||0)-(a.roas||0))[0],
              badge:(c:any)=>`${fmt.roas(c.roas)} ROAS`, sub:(c:any)=> lang==='en' ? `This campaign delivered the highest ROAS with ₺${Math.round(c.spend||0).toLocaleString('tr-TR')} spend.` : `₺${Math.round(c.spend||0).toLocaleString('tr-TR')} harcama ile en yüksek ROAS'ı bu kampanya sağladı.`,
              available: camps.some((c:any)=>(c.roas||0)>0) },
            { id:'spend',  label:t('Harcama'),  pick:()=>[...camps].sort((a:any,b:any)=>(b.spend||0)-(a.spend||0))[0],
              badge:(c:any)=> lang==='en' ? `₺${Math.round(c.spend||0).toLocaleString('tr-TR')} spend` : `₺${Math.round(c.spend||0).toLocaleString('tr-TR')} harcama`, sub:()=>t('En yüksek bütçeyi bu kampanya kullandı.'),
              available: camps.some((c:any)=>(c.spend||0)>0) },
            { id:'reach',  label:t('Erişim'),   pick:()=>[...camps].sort((a:any,b:any)=>(b.reach||0)-(a.reach||0))[0],
              badge:(c:any)=> lang==='en' ? `${fmt.n(c.reach||0)} reach` : `${fmt.n(c.reach||0)} erişim`, sub:()=>t('En geniş kitleye bu kampanya ulaştı.'),
              available: camps.some((c:any)=>(c.reach||0)>0) },
            { id:'clicks', label:t('Tıklama'),  pick:()=>[...camps].sort((a:any,b:any)=>(b.clicks||0)-(a.clicks||0))[0],
              badge:(c:any)=> lang==='en' ? `${fmt.n(c.clicks||0)} clicks` : `${fmt.n(c.clicks||0)} tıklama`, sub:()=>t('En çok tıklamayı bu kampanya aldı.'),
              available: camps.some((c:any)=>(c.clicks||0)>0) },
          ];
          const defaultId = BEST_METRICS.find(m=>m.available)?.id || 'roas';
          const bestId = (bestMetricPref && BEST_METRICS.find(m=>m.id===bestMetricPref)?.available) ? bestMetricPref : defaultId;
          const activeBest = BEST_METRICS.find(m=>m.id===bestId) || BEST_METRICS[0];
          const bestPick = activeBest.available ? activeBest.pick() : null;

          return (
            <div style={{ background:'var(--py-ink)', borderRadius:16, padding:'22px', display:'flex', flexDirection:'column' as const, justifyContent:'space-between' }}>
              <div>
                <select
                  value={bestId}
                  onChange={e=>{ setBestMetricPref(e.target.value); try{ localStorage.setItem(`poyais_meta_best_card_${config?.client_id||1}`, e.target.value); }catch{} }}
                  style={{ background:'transparent', border:'none', outline:'none', fontSize:10, fontWeight:800, letterSpacing:'.09em', color:T.accent, textTransform:'uppercase' as const, marginBottom:10, padding:0, cursor:'pointer', display:'block' }}
                >
                  {BEST_METRICS.map(m=>(<option key={m.id} value={m.id} style={{ color:T.ink }}>{t('Ayın En İyisi')} — {m.label}</option>))}
                </select>
                <div style={{ fontSize:16, fontWeight:800, color:'#fff', lineHeight:1.4, marginBottom:12 }}>
                  {bestPick ? (bestPick.name||bestPick.campaign_name||'—') : '—'}
                  {bestPick && <span style={{ display:'block', fontSize:12.5, fontWeight:600, color:'rgba(255,255,255,.6)', marginTop:5 }}>{activeBest.badge(bestPick)}</span>}
                </div>
                <div style={{ fontSize:11.5, color:'rgba(255,255,255,.55)', lineHeight:1.6 }}>
                  {bestPick ? activeBest.sub(bestPick) : t('Yeterli veri yok.')}
                </div>
              </div>
              <button onClick={()=>window.dispatchEvent(new CustomEvent('poyais-nav',{detail:'meta-creatives'}))} style={{ background:T.accent, color:'#fff', padding:'9px 16px', borderRadius:11, border:'none', fontSize:13, fontWeight:700, cursor:'pointer', marginTop:20, alignSelf:'flex-start' }}>
                {t('Analize Git')}
              </button>
            </div>
          );
        })()}
      </div>

      {/* Kampanyalar Tablosu */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}` }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap' as const, gap:8 }}>
          <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Meta Kampanyalar')}</div>
          <div style={{ display:'flex', gap:8, position:'relative' as const, alignItems:'center' }}>
            {(showFilterMenu||showSortMenu) && <div onClick={()=>{setShowFilterMenu(false);setShowSortMenu(false);}} style={{ position:'fixed' as const, inset:0, zIndex:9998 }}/>}
            <RoasFilter value={roasFilter} onChange={v=>{ setRoasFilter(v); setPage(0); }}/>
            <div style={{ position:'relative' as const, zIndex:showFilterMenu?9999:undefined }}>
              <button onClick={()=>{setShowFilterMenu(v=>!v);setShowSortMenu(false);}}
                style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 13px', border:`1px solid ${statusFilter!=='all'?T.accent:T.borderMid}`, borderRadius:9, fontSize:12, fontWeight:600, color:statusFilter!=='all'?T.accentDeep:'var(--py-text-mid-alt)', background:statusFilter!=='all'?'var(--py-amber-tint)':T.surface, cursor:'pointer' }}>
                {t('Filtrele')} {statusFilter!=='all'&&'•'}
              </button>
              {showFilterMenu && (
                <div style={{ position:'absolute' as const, right:0, top:'calc(100% + 6px)', background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:8, zIndex:9999, minWidth:150, boxShadow:'0 12px 32px rgba(20,22,43,.15)' }}>
                  {[['all',t('Tümü')],['ACTIVE',t('Aktif')],['PAUSED',t('Duraklatıldı')]].map(([v,l])=>(
                    <button key={v} onClick={()=>{setStatusFilter(v as any);setShowFilterMenu(false);setPage(0);}}
                      style={{ display:'block', width:'100%', padding:'8px 12px', borderRadius:8, border:'none', background:statusFilter===v?'var(--py-amber-tint)':'transparent', color:statusFilter===v?T.accentDeep:T.textMid, fontSize:12.5, fontWeight:statusFilter===v?700:500, cursor:'pointer', textAlign:'left' as const }}>{l}</button>
                  ))}
                </div>
              )}
            </div>
            <div style={{ position:'relative' as const, zIndex:showSortMenu?9999:undefined }}>
              <button onClick={()=>{setShowSortMenu(v=>!v);setShowFilterMenu(false);}}
                style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 13px', border:`1px solid ${T.borderMid}`, borderRadius:9, fontSize:12, fontWeight:600, color:'var(--py-text-mid-alt)', background:T.surface, cursor:'pointer' }}>
                {t('Sırala')}: {({spend:t('Harcama'),revenue:t('Gelir'),roas:'ROAS',clicks:t('Tıklama')} as any)[sortKey]} {sortDir==='desc'?'↓':'↑'}
              </button>
              {showSortMenu && (
                <div style={{ position:'absolute' as const, right:0, top:'calc(100% + 6px)', background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:8, zIndex:9999, minWidth:170, boxShadow:'0 12px 32px rgba(20,22,43,.15)' }}>
                  {[['spend',t('Harcama')],['revenue',t('Gelir')],['roas','ROAS'],['clicks',t('Tıklama')]].map(([v,l])=>(
                    <button key={v} onClick={()=>{ if(sortKey===v) setSortDir(d=>d==='desc'?'asc':'desc'); else { setSortKey(v as any); setSortDir('desc'); } setShowSortMenu(false);setPage(0);}}
                      style={{ display:'flex', justifyContent:'space-between', width:'100%', padding:'8px 12px', borderRadius:8, border:'none', background:sortKey===v?'var(--py-amber-tint)':'transparent', color:sortKey===v?T.accentDeep:T.textMid, fontSize:12.5, fontWeight:sortKey===v?700:500, cursor:'pointer', textAlign:'left' as const }}>
                      <span>{l}</span>{sortKey===v&&<span>{sortDir==='desc'?'↓':'↑'}</span>}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button onClick={()=>exportCsv(`meta-ads-kampanyalar-${start}-${end}.csv`, filteredCamps.map((c:any)=>({...c,name:c.name||c.campaign_name})), [
              { key:'name', label:t('Kampanya') }, { key:'status', label:t('Durum') },
              { key:'spend', label:t('Harcama') }, { key:'revenue', label:t('Gelir') },
              { key:'roas', label:'ROAS' }, { key:'clicks', label:t('Tıklama') },
              { key:'ctr', label:'CTR' }, { key:'conversions', label:t('Dönüşüm') },
            ])} disabled={filteredCamps.length===0} style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:600, color:'var(--py-text-mid-alt)', cursor:filteredCamps.length?'pointer':'not-allowed', opacity:filteredCamps.length?1:.5 }}>
              {t('Dışa Aktar')}
            </button>
          </div>
        </div>

        <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
          <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:600 }}>
            <thead style={{ background:'var(--py-subtle-bg)' }}>
              <tr>
                {([[t('Kampanya'),'name'],[t('Durum'),'status'],[t('Harcama'),'spend'],[t('Gelir'),'revenue'],['ROAS','roas'],[t('Tıklama'),'clicks'],['CTR','ctr'],[t('Dönüşüm'),'conversions']] as [string,string][]).map(([h,k],i) => (
                  <SortTh key={k} label={h} k={k} sortKey={sortKey} dir={sortDir} onSort={onSort} align={i<2?'left':'right'}/>
                ))}
              </tr>
            </thead>
            <tbody>
              {paged.length===0 && (
                <tr><td colSpan={8} style={{ padding:48, textAlign:'center' as const, color:T.textDim, fontSize:12.5 }}>{t('Sonuç bulunamadı')}</td></tr>
              )}
              {paged.map((c:any,i:number) => {
                const st = statusBadge(c.status);
                const roasPct = Math.min((c.roas||0)/maxRoas*100,100);
                return (
                  <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)', cursor:'pointer' }} title={t('Detay için tıkla')} onClick={()=>setDrawerCamp(c)} onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')} onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                    <td style={{ padding:'13px 16px' }}>
                      <span style={{ fontSize:12.5, fontWeight:700 }}>{c.name||c.campaign_name}</span><MetaRecBadge accountId={accountId} campaignId={c.campaign_id} />
                    </td>
                    <td style={{ padding:'13px 16px' }}>
                      <span style={{ padding:'2px 9px', borderRadius:999, background:st.bg, color:st.color, fontSize:10, fontWeight:700 }}>{st.text}</span>
                    </td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>₺{(c.spend||0).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, fontWeight:700, fontFamily:MONO }}>₺{(c.revenue||0).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                    <td style={{ padding:'13px 16px' }}>
                      <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', gap:8 }}>
                        <span style={{ fontSize:12.5, fontWeight:700, color:T.accentDeep, fontFamily:MONO }}>{fmt.roas(c.roas)}</span>
                        {!isMobile && <div style={{ height:5, width:48, background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                          <div style={{ height:'100%', background:T.accentDeep, borderRadius:999, width:`${roasPct}%` }}/>
                        </div>}
                      </div>
                    </td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(c.clicks)}</td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.pct(c.ctr)}</td>
                    <td style={{ padding:'13px 16px', fontSize:12.5, fontWeight:700, fontFamily:MONO, textAlign:'right' as const }}>{Math.round(c.conversions||0)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ padding:'13px 22px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>{filteredCamps.length?page*PAGE_SIZE+1:0}–{Math.min((page+1)*PAGE_SIZE, filteredCamps.length)} / {filteredCamps.length} {t('kampanya')}</span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page===0?'not-allowed':'pointer', opacity:page===0?0.4:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>‹</button>
            {pageWindow(page,totalPages).map(n=>(
              <button key={n} onClick={()=>setPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${page===n?T.accent:T.borderMid}`, background:page===n?T.accent:T.surface, color:page===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page>=totalPages-1?'not-allowed':'pointer', opacity:page>=totalPages-1?.4:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>›</button>
          </div>
        </div>
      </div>

      <CampaignDrawer platform="meta" accountKey={accountId} campaign={drawerCamp} start={start} end={end} onClose={()=>setDrawerCamp(null)}/>
    </div>
  );
}
function GA4PagePerformanceTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [page, setPage]       = useState(1);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterCR, setFilterCR]     = useState<'all'|'high'|'low'>('all');
  const [filterBounce, setFilterBounce] = useState<'all'|'high'|'low'>('all');
  const [sortBy, setSortBy]         = useState<'views'|'cr'|'bounce_rate'|'add_to_cart'>('views');
  const [aiExpanded, setAiExpanded] = useState(false);
  const PAGE_SIZE = 10;
  const { propertyId } = config.platforms.ga4;
  const { t, lang } = useLang();

  useEffect(() => {
    if(!propertyId) return;
    setLoading(true);
    axios.get(`${API}/ga4/${propertyId}/page-performance?start_date=${start}&end_date=${end}&limit=100`)
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, propertyId]);

  const exportCSV = () => {
    const headers = [t('Sayfa'),t('Görüntüleme'),t('Kullanıcı'),t('Sepet'),'ATC CR%','Bounce%'];
    const rows = filtered.map((d:any) => [
      d.page, d.views, d.users, d.add_to_cart||0, (d.cr||0).toFixed(2), (d.bounce_rate||0).toFixed(1)
    ]);
    const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type:'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href=url; a.download='sayfa-performans.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  const filtered = useMemo(() => {
    let r = data.filter(d => d.page?.toLowerCase().includes(search.toLowerCase()));
    if(filterCR==='high') r = r.filter(d=>(d.cr||0)>=2);
    if(filterCR==='low')  r = r.filter(d=>(d.cr||0)<1);
    if(filterBounce==='high') r = r.filter(d=>(d.bounce_rate||0)>=50);
    if(filterBounce==='low')  r = r.filter(d=>(d.bounce_rate||0)<30);
    r = [...r].sort((a,b)=>(b[sortBy]||0)-(a[sortBy]||0));
    return r;
  }, [data, search, filterCR, filterBounce, sortBy]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged = filtered.slice((page-1)*PAGE_SIZE, page*PAGE_SIZE);
  const totalViews = data.reduce((s,d)=>s+d.views,0);
  const totalATC   = data.reduce((s,d)=>s+(d.add_to_cart||0),0);
  const topPage    = data[0];
  const topATC     = [...data].sort((a,b)=>(b.cr||0)-(a.cr||0))[0];

  if (loading) return <Loader/>;

  const crBadge = (cr:number) => {
    const color = cr>2?T.greenText:cr>0.5?T.amberText:T.redText;
    const bg    = cr>2?'var(--py-green-tint)':cr>0.5?'var(--py-amber-tint-alt)':'var(--py-red-tint)';
    return <span style={{ fontSize:10.5, fontWeight:700, padding:'2px 9px', borderRadius:999, color, background:bg, fontFamily:MONO }}>{cr?.toFixed(2)}%</span>;
  };
  const bounceBadge = (b:number) => {
    const color = b>50?T.redText:b>30?T.amberText:T.greenText;
    return <span style={{ fontSize:12, fontWeight:700, color, fontFamily:MONO }}>{b?.toFixed(1)}%</span>;
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:isMobile?8:14, overflowX:'hidden' as const }}>
        {[
          { label:t('Toplam Görüntüleme'),        value: fmt.n(totalViews),                      delta:'+12.4%', up:true },
          { label:t('En Çok Görüntülenen Sayfa'), value: topPage?.page?.slice(0,22)+'...'||'-', sub:`${fmt.n(topPage?.views||0)} ${t('Görüntüleme')}` },
          { label:t('Toplam Sepete Ekle'),        value: fmt.n(totalATC),                         delta:'+8.2%',  up:true },
          { label:t('En Yüksek ATC Rate'),        value: `${(topATC?.cr||0).toFixed(2)}%`,         delta:'-0.4%',  up:false },
        ].map((kpi:any) => (
          <div key={kpi.label} style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:isMobile?'12px 14px':'18px 19px' }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:10, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{kpi.label}</div>
            <div style={{ fontSize:19, fontWeight:800, fontFamily:MONO, marginBottom:4, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{kpi.value}</div>
            {kpi.sub && <div style={{ fontSize:10.5, color:T.textDim }}>{kpi.sub}</div>}
            {kpi.delta && <span style={{ fontSize:11, fontWeight:700, color:kpi.up?T.greenText:T.redText, fontFamily:MONO }}>{kpi.up?'↑':'↓'} {kpi.delta}</span>}
          </div>
        ))}
      </div>

      {/* Table */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, overflow:'hidden' }}>
        {/* Table Header */}
        <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', flexDirection:isMobile?'column':'row', justifyContent:'space-between', alignItems:isMobile?'stretch':'center', gap:isMobile?8:0 }}>
          <input value={search} onChange={e=>{setSearch(e.target.value); setPage(1);}}
            placeholder={t('Sayfa URL veya başlığına göre ara...')}
            style={{ padding:'8px 14px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:'var(--py-subtle-bg)', fontSize:12.5, outline:'none', width:isMobile?'100%':'320px', boxSizing:'border-box' as const }}/>
          <div style={{ display:'flex', gap:8, position:'relative' }}>
            <button onClick={()=>setFilterOpen(f=>!f)} style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${filterOpen?T.accent:T.borderMid}`, background:filterOpen?'var(--py-amber-tint)':T.surface, fontSize:12, fontWeight:700, color:filterOpen?'var(--py-amber-deep-text)':'var(--py-text-mid-alt)', cursor:'pointer' }}>
              {t('Filtrele')}
            </button>
            {filterOpen && (
              <div style={{ position:'absolute', top:38, right:0, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, boxShadow:'0 12px 32px rgba(20,22,43,.12)', padding:16, zIndex:100, minWidth:220 }}>
                <div style={{ fontSize:10.5, fontWeight:800, color:T.textDim, letterSpacing:'.08em', textTransform:'uppercase' as const, marginBottom:10 }}>{t('Sırala')}</div>
                {([['views',t('Görüntüleme')],['cr','ATC CR%'],['bounce_rate','Bounce%'],['add_to_cart',t('Sepet')]] as const).map(([k,l])=>(
                  <button key={k} onClick={()=>setSortBy(k as any)} style={{ display:'block', width:'100%', textAlign:'left' as const, padding:'6px 10px', borderRadius:8, border:'none', background:sortBy===k?'var(--py-amber-tint)':'transparent', color:sortBy===k?'var(--py-amber-deep-text)':'var(--py-text-mid-alt)', fontSize:11.5, fontWeight:600, cursor:'pointer', marginBottom:2 }}>{sortBy===k?'✓ ':''}{l}</button>
                ))}
                <div style={{ borderTop:'1px solid var(--py-table-divider)', margin:'10px 0' }}/>
                <div style={{ fontSize:10.5, fontWeight:800, color:T.textDim, letterSpacing:'.08em', textTransform:'uppercase' as const, marginBottom:8 }}>{t('ATC CR Filtresi')}</div>
                {([['all',t('Tümü')],['high',t('Yüksek (≥%2)')],['low',t('Düşük (<1%)')]] as const).map(([k,l])=>(
                  <button key={k} onClick={()=>setFilterCR(k as any)} style={{ display:'block', width:'100%', textAlign:'left' as const, padding:'5px 10px', borderRadius:8, border:'none', background:filterCR===k?'var(--py-amber-tint)':'transparent', color:filterCR===k?'var(--py-amber-deep-text)':'var(--py-text-mid-alt)', fontSize:11.5, fontWeight:600, cursor:'pointer', marginBottom:2 }}>{filterCR===k?'✓ ':''}{l}</button>
                ))}
                <div style={{ borderTop:'1px solid var(--py-table-divider)', margin:'10px 0' }}/>
                <div style={{ fontSize:10.5, fontWeight:800, color:T.textDim, letterSpacing:'.08em', textTransform:'uppercase' as const, marginBottom:8 }}>{t('Bounce Filtresi')}</div>
                {([['all',t('Tümü')],['high',t('Yüksek (≥%50)')],['low',t('Düşük (<30%)')]] as const).map(([k,l])=>(
                  <button key={k} onClick={()=>setFilterBounce(k as any)} style={{ display:'block', width:'100%', textAlign:'left' as const, padding:'5px 10px', borderRadius:8, border:'none', background:filterBounce===k?'var(--py-amber-tint)':'transparent', color:filterBounce===k?'var(--py-amber-deep-text)':'var(--py-text-mid-alt)', fontSize:11.5, fontWeight:600, cursor:'pointer', marginBottom:2 }}>{filterBounce===k?'✓ ':''}{l}</button>
                ))}
                <button onClick={()=>{setFilterCR('all');setFilterBounce('all');setSortBy('views');setFilterOpen(false);}} style={{ marginTop:8, width:'100%', padding:'6px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:'var(--py-subtle-bg)', fontSize:11, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:'pointer' }}>{t('Sıfırla')}</button>
              </div>
            )}
            <button onClick={exportCSV} style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:'pointer' }}>
              {t('Dışa Aktar')}
            </button>
          </div>
        </div>

      <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
          <thead>
            <tr style={{ background:'var(--py-subtle-bg)' }}>
              {[t('Sayfa (URL)'),t('Görüntüleme'),t('Kullanıcı'),t('Sepet'),'ATC CR%','Bounce%'].map((h,i) => (
                <th key={h} style={{ padding:'11px 18px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign:i===0?'left':'right', borderBottom:'1px solid var(--py-table-divider)', whiteSpace:'nowrap' as const }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paged.map((d:any, i:number) => (
              <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)', cursor:'pointer' }}
                onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                <td style={{ padding:'12px 18px' }}>
                  <div style={{ fontSize:12.5, fontWeight:600, maxWidth:280, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{d.page}</div>
                  {d.title && <div style={{ fontSize:10.5, color:T.textDim }}>{d.title}</div>}
                </td>
                <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(d.views)}</td>
                <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(d.users)}</td>
                <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, color: d.add_to_cart>0?T.textMid:T.textFaint, fontFamily:MONO }}>{d.add_to_cart>0?fmt.n(d.add_to_cart):'--'}</td>
                <td style={{ padding:'12px 18px', textAlign:'right' }}>{crBadge(d.cr||0)}</td>
                <td style={{ padding:'12px 18px', textAlign:'right' }}>{bounceBadge(d.bounce_rate||0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

        {/* Pagination */}
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>
            {lang==='en'
              ? <>Showing {Math.min((page-1)*PAGE_SIZE+1,filtered.length)}-{Math.min(page*PAGE_SIZE,filtered.length)} of {filtered.length} pages</>
              : <>{filtered.length} sayfa arasından {Math.min((page-1)*PAGE_SIZE+1,filtered.length)}-{Math.min(page*PAGE_SIZE,filtered.length)} gösteriliyor</>}
          </span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page===1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page===1?'not-allowed':'pointer', opacity:page===1?0.4:1, fontSize:14 }}>‹</button>
            {[1,2,3].filter(n=>n<=totalPages).map(n=>(
              <button key={n} onClick={()=>setPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${page===n?T.accent:T.borderMid}`, background:page===n?T.accent:T.surface, color:page===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{n}</button>
            ))}
            {totalPages > 4 && <span style={{ width:28, height:28, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, color:T.textDim }}>...</span>}
            {totalPages > 3 && (
              <button onClick={()=>setPage(totalPages)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${page===totalPages?T.accent:T.borderMid}`, background:page===totalPages?T.accent:T.surface, color:page===totalPages?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{totalPages}</button>
            )}
            <button onClick={()=>setPage(p=>Math.min(totalPages,p+1))} disabled={page===totalPages}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page===totalPages?'not-allowed':'pointer', opacity:page===totalPages?0.4:1, fontSize:14 }}>›</button>
          </div>
        </div>
      </div>

      {/* Bottom: Chart + AI Analizi */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr auto', gap:14 }}>
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ marginBottom:4 }}>
            <div style={{ fontSize:13.5, fontWeight:800, marginBottom:2 }}>{t('Görüntüleme vs. ATC Trend')}</div>
            <div style={{ fontSize:11.5, color:T.textDim }}>{t('Son 30 günlük sayfa bazlı performans grafiği')}</div>
          </div>
          <ResponsiveContainer width="100%" height={180}>
            <BarChart data={paged.slice(0,10)} margin={{ top:8, right:0, left:-10, bottom:0 }}>
              <XAxis dataKey="page" tick={{ fontSize:8, fill:T.textDim }} axisLine={false} tickLine={false} tickFormatter={v=>v?.slice(0,8)||''}/>
              <YAxis tick={{ fontSize:9, fill:T.textDim }} axisLine={false} tickLine={false}/>
              <Tooltip content={<CT/>} cursor={{ fill:'rgba(201,168,76,.05)' }}/>
              <Bar dataKey="views" radius={[4,4,0,0]} maxBarSize={40}>
                {paged.slice(0,10).map((_:any,i:number)=><Cell key={i} fill={i===4?T.accent:alpha(T.accent,20)}/>)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* AI Analizi */}
        {(()=>{
          // Sitede hiç sepete ekleme (ecommerce) sinyali yoksa ATC-temelli önerilerin hiçbiri
          // bu site için anlamlı değildir (her sayfa cr=0 döner) — o durumda tamamen
          // trafik/bounce/süre temelli, ATC'den bağımsız bir analiz üretiyoruz.
          const hasEcommerceSignal = data.some((d:any)=>(d.add_to_cart||0)>0);

          const lowCRHighView = hasEcommerceSignal ? data.filter((d:any)=>d.cr<1.5&&d.views>3000).sort((a:any,b:any)=>b.views-a.views)[0] : null;
          const highBounce    = data.filter((d:any)=>d.bounce_rate>60&&d.views>(hasEcommerceSignal?1000:5)).sort((a:any,b:any)=>b.bounce_rate-a.bounce_rate)[0];
          const highATC       = hasEcommerceSignal ? data.filter((d:any)=>d.cr>3).sort((a:any,b:any)=>b.cr-a.cr)[0] : null;
          const avgCR         = data.length>0 ? data.reduce((s:number,d:any)=>s+(d.cr||0),0)/data.length : 0;
          const avgBounce     = data.length>0 ? data.reduce((s:number,d:any)=>s+(d.bounce_rate||0),0)/data.length : 0;
          const avgDuration   = data.length>0 ? data.reduce((s:number,d:any)=>s+(d.avg_session_duration_sec||0),0)/data.length : 0;
          const shortStayHighView = !hasEcommerceSignal ? data.filter((d:any)=>d.views>=10&&d.avg_session_duration_sec<avgDuration*0.5).sort((a:any,b:any)=>b.views-a.views)[0] : null;
          const topPageIns = data[0];

          const shortInsight = lang==='en' ? (
            lowCRHighView
            ? `"${lowCRHighView.page?.slice(0,28)}" gets high traffic (${fmt.n(lowCRHighView.views)} views) but its ATC rate of ${(lowCRHighView.cr||0).toFixed(2)}% is below average.`
            : highBounce
            ? `"${highBounce.page?.slice(0,28)}" has a ${(highBounce.bounce_rate||0).toFixed(0)}% bounce rate — visitor drop-off is high.`
            : shortStayHighView
            ? `"${shortStayHighView.page?.slice(0,28)}" gets traffic (${fmt.n(shortStayHighView.views)} views) but its average duration of ${Math.round(shortStayHighView.avg_session_duration_sec)}s is well below the site average.`
            : !hasEcommerceSignal && topPageIns
            ? `The most visited page is "${(topPageIns.page||'').slice(0,28)}" (${fmt.n(topPageIns.views)} views); the site-wide average bounce rate is ${avgBounce.toFixed(0)}%.`
            : `The site's average ATC conversion rate is ${avgCR.toFixed(2)}%, with an average bounce rate of ${avgBounce.toFixed(0)}%.`
          ) : (
            lowCRHighView
            ? `"${lowCRHighView.page?.slice(0,28)}" yüksek trafik (${fmt.n(lowCRHighView.views)} görüntüleme) alıyor ancak ATC oranı %${(lowCRHighView.cr||0).toFixed(2)} ile ortalamanın altında.`
            : highBounce
            ? `"${highBounce.page?.slice(0,28)}" sayfasında %${(highBounce.bounce_rate||0).toFixed(0)} bounce rate tespit edildi, ziyaretçi kaybı yüksek.`
            : shortStayHighView
            ? `"${shortStayHighView.page?.slice(0,28)}" trafik alıyor (${fmt.n(shortStayHighView.views)} görüntüleme) ama ortalama süre ${Math.round(shortStayHighView.avg_session_duration_sec)} sn ile site ortalamasının belirgin altında.`
            : !hasEcommerceSignal && topPageIns
            ? `En çok ziyaret edilen sayfa "${(topPageIns.page||'').slice(0,28)}" (${fmt.n(topPageIns.views)} görüntüleme), site genelinde ortalama bounce rate %${avgBounce.toFixed(0)}.`
            : `Sitedeki ortalama ATC dönüşüm oranı %${avgCR.toFixed(2)}, ortalama bounce rate %${avgBounce.toFixed(0)}.`
          );

          const longInsight = lang==='en' ? (
            lowCRHighView
            ? `CTA button visibility should be increased, product images enlarged, and page load time checked. A/B tests on similar pages have delivered 15-25% conversion increases.`
            : highBounce
            ? `The page content and title may not match visitor expectations. Content should be restructured top to bottom, with the value proposition made clear within the first 3 seconds.`
            : highATC
            ? `"${highATC.page?.slice(0,25)}" has the highest ATC rate at ${(highATC.cr||0).toFixed(2)}%. Its layout and content structure could be used as a model for other pages.`
            : shortStayHighView
            ? `Visitors are leaving this page faster than expected — title/content alignment, page load speed, and the clarity of the above-the-fold message should be reviewed.`
            : !hasEcommerceSignal
            ? `This site produces no e-commerce signal (add-to-cart), so it's recommended you define your own goals in GA4 as events — such as form submissions, phone/WhatsApp clicks, or contact page visits — so this analysis can work against your real business goals.`
            : `Strengthening low-traffic pages with an internal linking strategy and improving content quality on high-bounce pages could be priority next steps.`
          ) : (
            lowCRHighView
            ? `CTA butonlarının görünürlüğü artırılmalı, ürün görselleri büyütülmeli ve sayfa yükleme süresi kontrol edilmeli. Benzer sayfalarda yapılan A/B testleri %15-25 dönüşüm artışı sağlamıştır.`
            : highBounce
            ? `Sayfa içeriği ve başlığı ziyaretçi beklentisiyle örtüşmüyor olabilir. İçerik yukarıdan aşağıya yeniden düzenlenmeli, ilk 3 saniyede değer önerisi netleştirilmeli.`
            : highATC
            ? `"${highATC.page?.slice(0,25)}" sayfası %${(highATC.cr||0).toFixed(2)} ile en yüksek ATC oranına sahip. Bu sayfanın layout ve içerik yapısı diğer sayfalara model alınabilir.`
            : shortStayHighView
            ? `Ziyaretçiler bu sayfada beklenenden hızlı ayrılıyor — başlık/içerik uyumu, sayfa yükleme hızı ve ilk ekrandaki (above-the-fold) mesaj netliği gözden geçirilmeli.`
            : !hasEcommerceSignal
            ? `Bu site e-ticaret sinyali (sepete ekleme) üretmiyor, bu yüzden dönüşüm için form gönderimi, telefon/WhatsApp tıklaması veya iletişim sayfası ziyareti gibi kendi hedeflerinizi GA4'te event olarak tanımlamanız önerilir — böylece bu analiz gerçek iş hedeflerinize göre çalışabilir.`
            : `Düşük trafikli sayfaları iç link stratejisiyle güçlendirmek ve yüksek bounce sayfalarında içerik kalitesini artırmak öncelikli adımlar olabilir.`
          );

          return (
            <div style={{ background:'var(--py-ink)', borderRadius:16, padding:'22px', width:isMobile?'auto':260, flexShrink:0, display:'flex', flexDirection:'column', gap:12, position:'relative' }}>
              <span style={{ fontSize:10, fontWeight:800, letterSpacing:'.09em', color:'#E8C97A', textTransform:'uppercase' as const, background:'rgba(232,201,122,.14)', padding:'3px 10px', borderRadius:999, alignSelf:'flex-start' }}>{t('AI Analizi')}</span>
              <div style={{ fontSize:15, fontWeight:800, color:'#fff' }}>{t('Hızlı Kazanç Fırsatı')}</div>
              <p style={{ fontSize:12, color:'rgba(255,255,255,.68)', lineHeight:1.65, margin:0 }}>{shortInsight}</p>
              <div style={{ position:'relative' }}>
                <button onClick={()=>setAiExpanded(e=>!e)} style={{ width:'100%', marginTop:4, padding:'10px 16px', borderRadius:10, background:'#fff', color:'#14162B', border:'none', fontSize:12, fontWeight:800, cursor:'pointer' }}>
                  {aiExpanded ? t('Kapat ↑') : t('Detayları Gör →')}
                </button>
                {aiExpanded && (
                  <div style={{ position:'absolute', top:'calc(100% + 8px)', left:0, right:0, background:'#1E2039', borderRadius:12, padding:'14px 16px', border:'1px solid rgba(255,255,255,.1)', zIndex:50 }}>
                    <p style={{ fontSize:12, color:'rgba(255,255,255,.68)', lineHeight:1.65, margin:0 }}>{longInsight}</p>
                  </div>
                )}
              </div>
            </div>
          );
        })()}
      </div>

    </div>
  );
}
function GA4TrafficSourcesTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<'source'|'medium'|'campaign'>('source');
  const [trafficPage, setTrafficPage] = useState(0);
  const [kpiKey, setKpiKey] = useState<'sessions'|'users'|'purchases'|'revenue'|'cr'>('sessions');
  const { propertyId } = config.platforms.ga4;
  const { t, lang } = useLang();

  useEffect(() => {
    if (!propertyId) return;
    setLoading(true);
    axios.get(`${API}/ga4/${propertyId}/traffic-sources?start_date=${start}&end_date=${end}`)
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, propertyId]);

  if (loading) return <Loader/>;
  if (!data) return <div style={{ color:'var(--py-text-mid-alt)', padding:24 }}>{t('Veri bulunamadı.')}</div>;

  const rows = data[activeTab] || [];
  const cpcRows = (data['medium'] || []).filter((r:any) => ['cpc','paid search','google cpc','paidsearch'].includes((r.name||r.medium||'').toLowerCase()));
  const cpcRevenue = cpcRows.reduce((s:number,r:any)=>s+(r.revenue||0),0);
  const totalRevenue = rows.reduce((s:number,r:any)=>s+(r.revenue||0),0);
  const adRevenueRatio = totalRevenue > 0 ? Math.round((cpcRevenue/totalRevenue)*100) : 0;

  const sourceIcons:Record<string,string> = {
    google:'🔍', facebook:'🌐', instagram:'📷', '(direct)':'↩️',
    email:'@', twitter:'🐦', youtube:'▶️', bing:'🔎',
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(2,1fr)', gap:14 }}>
        {(() => {
          // Seçilebilir toplam kartı: toplamlar kaynak tipi (medium) kırılımından alınır (en az örtüşme)
          const tot = (data.medium || []).reduce((a:any, r:any) => ({ sessions:a.sessions+(r.sessions||0), users:a.users+(r.users||0), purchases:a.purchases+(r.purchases||0), revenue:a.revenue+(r.revenue||0) }), { sessions:0, users:0, purchases:0, revenue:0 });
          const opts:Record<string,{ label:string; value:string; sub:string }> = {
            sessions:  { label:t('Toplam Oturum'),     value:fmt.n(tot.sessions),  sub:t('Tüm kaynaklardan gelen oturum.') },
            users:     { label:t('Toplam Kullanıcı'),  value:fmt.n(tot.users),     sub:t('Siteyi ziyaret eden kullanıcı.') },
            purchases: { label:t('Toplam Satın Alma'), value:fmt.n(tot.purchases), sub:t('Tüm kaynaklardan gelen satın alma.') },
            revenue:   { label:t('Toplam Gelir'),      value:'₺'+fmt.n(Math.round(tot.revenue)), sub:t('Tüm kaynaklardan gelen gelir.') },
            cr:        { label:t('Ortalama CR'),       value:'%'+(tot.sessions>0 ? (tot.purchases/tot.sessions*100).toFixed(2) : '0.00'), sub:t('Oturumdan satın almaya dönüşüm oranı.') },
          };
          const cur = opts[kpiKey];
          return (
            <div style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:'18px 20px', order:99 }}>
              <div style={{ position:'relative', display:'inline-flex', alignItems:'center', marginBottom:10 }}>
                <select value={kpiKey} onChange={e=>setKpiKey(e.target.value as any)} aria-label={cur.label}
                  style={{ appearance:'none', WebkitAppearance:'none', border:'none', background:'transparent', fontFamily:'inherit', fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', cursor:'pointer', padding:'0 18px 0 0', outline:'none' }}>
                  {(Object.keys(opts) as (keyof typeof opts)[]).map(k => <option key={k} value={k}>{opts[k].label}</option>)}
                </select>
                <span style={{ position:'absolute', right:0, pointerEvents:'none', fontSize:9, color:'var(--py-text-mid-alt)' }}>▼</span>
              </div>
              <div style={{ display:'flex', alignItems:'baseline', gap:8 }}>
                <span style={{ fontSize:28, fontWeight:800, fontFamily:MONO }}>{cur.value}</span>
                <span style={{ fontSize:12, color:T.textDim }}>{cur.sub}</span>
              </div>
            </div>
          );
        })()}
        {[
          { label:t('Toplam Kaynak'),      value:String(data.source?.length||0),   sub:t('Farklı trafik kaynağı.')   },
          { label:t('Toplam Kaynak Tipi'), value:String(data.medium?.length||0),   sub:t('Farklı kaynak tipi.')   },
          { label:t('Toplam Kampanya'),    value:String(data.campaign?.length||0), sub:t('Farklı kampanya tespit edildi.') },
        ].map(kpi => (
          <div key={kpi.label} style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:'18px 20px' }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:10 }}>{kpi.label}</div>
            <div style={{ display:'flex', alignItems:'baseline', gap:8 }}>
              <span style={{ fontSize:28, fontWeight:800, fontFamily:MONO }}>{kpi.value}</span>
              <span style={{ fontSize:12, color:T.textDim }}>{kpi.sub}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Ana tablo */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, overflow:'hidden' }}>
        <div style={{ padding:'18px 22px', borderBottom:'1px solid var(--py-table-divider)' }}>
          <div style={{ fontSize:13.5, fontWeight:800, marginBottom:2 }}>{t('Trafik Kaynağı Analizi')}</div>
          <div style={{ fontSize:11.5, color:T.textDim, marginBottom:14 }}>{t('Genel kanal gruplarına göre performans verileri.')}</div>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, flexWrap:'wrap' as const }}>
            <div style={{ display:'inline-flex', gap:4, background:'var(--py-track-bg)', padding:4, borderRadius:11 }}>
              {(['source','medium','campaign'] as const).map(tb => (
                <button key={tb} onClick={()=>{setActiveTab(tb);setTrafficPage(0);}} style={{
                  padding:'6px 15px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:activeTab===tb?700:500,
                  border:'none',
                  background: activeTab===tb?T.surface:'transparent',
                  boxShadow: activeTab===tb?'0 1px 2px rgba(20,22,43,.1)':'none',
                  color: activeTab===tb?T.text:'var(--py-text-mid-alt)',
                }}>
                  {tb==='source'?t('Kaynak'):tb==='medium'?t('Kaynak Tipi'):t('Kampanya')}
                </button>
              ))}
            </div>
            <button onClick={()=>exportCsv(`ga4-trafik-kaynaklari-${activeTab}-${start}-${end}.csv`, rows, [
              { key:'name', label:t('İsim') }, { key:'sessions', label:t('Oturum') },
              { key:'users', label:t('Kullanıcı') }, { key:'purchases', label:t('Satın Alma') },
              { key:'revenue', label:t('Gelir') }, { key:'cr', label:'CR%' },
            ])} disabled={rows.length===0} style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:rows.length?'pointer':'not-allowed', opacity:rows.length?1:.5 }}>
              {t('Dışa Aktar')}
            </button>
          </div>
        </div>

      <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
          <thead>
            <tr style={{ background:'var(--py-subtle-bg)' }}>
              {[t('İsim'),t('Oturum'),t('Kullanıcı'),t('Satın Alma'),t('Gelir'),'CR%'].map((h,i) => (
                <th key={h} style={{ padding:'10px 18px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign:i===0?'left':'right', borderBottom:'1px solid var(--py-table-divider)', whiteSpace:'nowrap' as const }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.slice(trafficPage*10,(trafficPage+1)*10).map((r:any, i:number) => {
              const icon = sourceIcons[r.name?.toLowerCase()] || '🌐';
              const name = r.name==='(not set)'?t('(belirsiz)'):r.name;
              const crColor = r.cr>2?T.greenText:r.cr>0.5?T.amberText:T.redText;
              return (
                <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)', cursor:'pointer' }}
                  onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                  onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                  <td style={{ padding:'12px 18px', display:'flex', alignItems:'center', gap:10 }}>
                    <div style={{ width:28, height:28, borderRadius:8, background:'var(--py-track-bg)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, flexShrink:0 }}>{icon}</div>
                    <span style={{ fontSize:12.5, fontWeight:600 }}>{name}</span>
                  </td>
                  <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(r.sessions)}</td>
                  <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(r.users)}</td>
                  <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, color:r.purchases>0?T.textMid:T.textFaint, fontFamily:MONO }}>{r.purchases||0}</td>
                  <td style={{ padding:'12px 18px', textAlign:'right', fontSize:13, fontWeight:700, fontFamily:MONO }}>{fmt.k(r.revenue)}</td>
                  <td style={{ padding:'12px 18px', textAlign:'right' }}>
                    <span style={{ fontSize:12, fontWeight:800, color:crColor, fontFamily:MONO }}>{fmt.pct(r.cr)}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      </div>
      {rows.length > 10 && (
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>
            {lang==='en'
              ? <>Showing {Math.min(trafficPage*10+1,rows.length)}-{Math.min((trafficPage+1)*10,rows.length)} of {rows.length} records.</>
              : <>{rows.length} kayıttan {Math.min(trafficPage*10+1,rows.length)}-{Math.min((trafficPage+1)*10,rows.length)} gösteriliyor.</>}
          </span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setTrafficPage((p:number)=>Math.max(0,p-1))} disabled={trafficPage===0}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:trafficPage===0?'not-allowed':'pointer', opacity:trafficPage===0?0.4:1, fontSize:13 }}>‹</button>
            {Array.from({length:Math.min(5,Math.ceil(rows.length/10))},(_,i)=>i).map(n=>(
              <button key={n} onClick={()=>setTrafficPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${trafficPage===n?T.accent:T.borderMid}`, background:trafficPage===n?T.accent:T.surface, color:trafficPage===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setTrafficPage((p:number)=>Math.min(Math.ceil(rows.length/10)-1,p+1))} disabled={trafficPage>=Math.ceil(rows.length/10)-1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:trafficPage>=Math.ceil(rows.length/10)-1?'not-allowed':'pointer', opacity:trafficPage>=Math.ceil(rows.length/10)-1?0.4:1, fontSize:13 }}>›</button>
          </div>
        </div>
      )}

      {/* Bottom: Haftalık Trafik + Özet İstatistik */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr auto', gap:14 }}>
        {/* Haftalık Trafik Dağılımı */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px 24px' }}>
          <div style={{ marginBottom:16 }}>
            <div style={{ fontSize:10.5, fontWeight:800, color:T.accentDeep, letterSpacing:'.09em', textTransform:'uppercase' as const, marginBottom:6 }}>{t('Görsel Performans Trendi')}</div>
            <div style={{ fontSize:16.5, fontWeight:800, marginBottom:4 }}>{t('Haftalık Trafik Dağılımı')}</div>
            <div style={{ fontSize:12, color:T.textDim }}>{t('Kanal bazlı performans verilerinin zamana göre değişimi ve kampanya etkileşim oranları.')}</div>
          </div>
          <ResponsiveContainer width="100%" height={160}>
            <BarChart data={rows.slice(0,8)} margin={{ top:0, right:0, left:-10, bottom:0 }}>
              <XAxis dataKey="name" tick={{ fontSize:9, fill:T.textDim }} axisLine={false} tickLine={false} tickFormatter={v=>v?.slice(0,8)||''}/>
              <YAxis tick={{ fontSize:9, fill:T.textDim }} axisLine={false} tickLine={false}/>
              <Tooltip content={<CT/>} cursor={{ fill:'rgba(201,168,76,.05)' }}/>
              <Bar dataKey="sessions" radius={[4,4,0,0]} maxBarSize={40}>
                {rows.slice(0,8).map((_:any,i:number)=><Cell key={i} fill={i===0?T.accent:alpha(T.accent,20)}/>)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Özet İstatistik */}
        <div style={{ background:T.accent, borderRadius:16, padding:'26px 22px', minWidth:220, display:'flex', flexDirection:'column', justifyContent:'space-between' }}>
          <div>
            <div style={{ fontSize:10, fontWeight:800, letterSpacing:'.1em', color:'rgba(255,255,255,.8)', textTransform:'uppercase' as const, marginBottom:12 }}>{t('Özet İstatistik')}</div>
            <div style={{ fontSize:22, fontWeight:800, color:'#fff', marginBottom:4, fontFamily:MONO }}>₺{cpcRevenue>=1000000?`${(cpcRevenue/1000000).toFixed(1)}M`:cpcRevenue>=1000?`${(cpcRevenue/1000).toFixed(0)}K`:Math.round(cpcRevenue)}</div>
            <div style={{ fontSize:11.5, color:'rgba(255,255,255,.85)' }}>{t('CPC Kanal Reklam Geliri')}</div>
          </div>
          <div style={{ marginTop:20, display:'flex', flexDirection:'column', gap:10 }}>
            <div style={{ display:'flex', justifyContent:'space-between' }}>
              <span style={{ fontSize:11.5, color:'rgba(255,255,255,.75)' }}>{t('Toplam Gelire Oranı')}</span>
              <span style={{ fontSize:11.5, fontWeight:800, color:'#fff', fontFamily:MONO }}>{adRevenueRatio}%</span>
            </div>
            <div style={{ height:4, background:'rgba(255,255,255,.25)', borderRadius:999 }}>
              <div style={{ height:4, background:'#fff', borderRadius:999, width:`${adRevenueRatio}%`, transition:'width .4s' }}/>
            </div>
            {[
              { label:t('CPC Oturum'), val: fmt.n(cpcRows.reduce((s:number,r:any)=>s+(r.sessions||0),0)) },
              { label:t('CPC Satın Alma'), val: fmt.n(cpcRows.reduce((s:number,r:any)=>s+(r.purchases||0),0)) },
            ].map((s:any) => (
              <div key={s.label} style={{ display:'flex', justifyContent:'space-between' }}>
                <span style={{ fontSize:11.5, color:'rgba(255,255,255,.75)' }}>{s.label}</span>
                <span style={{ fontSize:11.5, fontWeight:800, color:'#fff', fontFamily:MONO }}>{s.val}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
}

function AITextInsightCard({ data, noConvCount, bestRoas, config }:{ data:any[]; noConvCount:number; bestRoas:number; config:any }) {
  const T = SidebarT;
  const { t, lang } = useLang();
  const [showModal, setShowModal] = React.useState(false);
  const [applying, setApplying] = React.useState(false);
  const [applied, setApplied] = React.useState(false);

  const totalClicks = data.reduce((s,d)=>s+(d.clicks||0),0);
  const totalImpr   = data.reduce((s,d)=>s+(d.impressions||0),0);
  const totalConv   = data.reduce((s,d)=>s+(d.conversions||0),0);
  const totalSpend  = data.reduce((s,d)=>s+(d.spend||0),0);
  const avgCtr      = totalImpr > 0 ? (totalClicks/totalImpr*100) : 0;
  const avgCpa      = totalConv > 0 ? (totalSpend/totalConv) : 0;
  const lowPerfAds  = data.filter(d=>(d.conversions||0)===0 && (d.spend||0)>0);
  const highRoasAds = data.filter(d=>(d.roas||0)>=4);

  const insightText = (() => {
    const en = lang==='en';
    if (data.length === 0) {
      return en
        ? 'No ad text with impressions was found for this period — there is no campaign currently spending on this account. Real text suggestions will appear here once a campaign starts getting impressions.'
        : 'Bu dönemde gösterim almış bir reklam metni bulunamadı — hesapta şu anda aktif harcama yapan bir kampanya yok. Bir kampanya gösterim almaya başladığında burada gerçek metin önerileri görünecek.';
    } else if (noConvCount > 0 && avgCtr < 3) {
      return en
        ? `${noConvCount} ads aren't generating conversions and the average CTR is low at ${avgCtr.toFixed(1)}%. Adding a strong call-to-action (CTA) to the headlines and pausing the low-performing texts is recommended.`
        : `${noConvCount} reklam dönüşüm üretmiyor ve ortalama CTR %${avgCtr.toFixed(1)} ile düşük seyrediyor. Başlıklarda güçlü bir eylem çağrısı (CTA) eklenmesi ve düşük performanslı metinlerin duraklatılması öneriliyor.`;
    } else if (noConvCount > 0) {
      const lowSpend = lowPerfAds.reduce((s:number,d:any)=>s+(d.spend||0),0);
      const wastedStr = lowSpend>=1000?`${(lowSpend/1000).toFixed(0)}K`:Math.round(lowSpend).toLocaleString(en?'en-US':'tr-TR');
      const refTitle = highRoasAds.length > 0 ? `"${(highRoasAds[0].headlines||[])[0]||(en?'high ROAS':'yüksek ROAS')}"` : (en?'conversion-focused':'dönüşüm odaklı');
      return en
        ? `${noConvCount} ad texts aren't generating conversions yet (₺${wastedStr} spend). Part of this budget can be shifted to the better-performing texts, and rewriting these headlines in the ${refTitle} format is recommended.`
        : `${noConvCount} reklam metni henüz dönüşüm getirmiyor (₺${wastedStr} harcama). Bu bütçenin bir kısmı iyi performans gösteren metinlere kaydırılabilir; bu metinlerin başlıklarını ${refTitle} formatında yeniden yazmak öneriliyor.`;
    } else if (bestRoas >= 4) {
      return en
        ? `Strong performance with a best ROAS of ${fmt.roas(bestRoas)}×. ${highRoasAds.length} ads are maintaining this level. Applying these texts' headline structure to other campaigns could increase overall ROAS.`
        : `En iyi ROAS ${fmt.roas(bestRoas)}× ile güçlü performans. ${highRoasAds.length} reklam bu seviyeyi koruyor. Bu metinlerin başlık yapısını diğer kampanyalara uygulamak toplam ROAS'ı artırabilir.`;
    } else {
      return en
        ? `Average CTR ${avgCtr.toFixed(1)}%, average CPA ${fmt.k(avgCpa)}. Overall performance is acceptable, but there's 15-20% improvement potential with headline A/B testing.`
        : `Ortalama CTR %${avgCtr.toFixed(1)}, ortalama CPA ${fmt.k(avgCpa)}. Genel performans kabul edilebilir düzeyde, ancak başlık A/B testi ile %15-20 iyileşme potansiyeli var.`;
    }
  })();

  // action: 'Duraklat'/'Ölçekle' sadece görüntü etiketi — gerçek uygulama /optimize/apply'ın
  // beklediği kanonik tipe (actionType) göre yürüyor, Optimizasyon sayfasının kendi 'Uygula'
  // akışıyla birebir aynı, kanıtlanmış onay kuyruğu üzerinden (bkz. handleApply).
  const changes: {campaign:string;campaignId?:string;action:string;actionType:'pause'|'budget';reason:string;headline:string}[] = lowPerfAds.slice(0,5).map(d => ({
    campaign: d.campaign, campaignId: d.campaign_id,
    action: 'Duraklat', actionType: 'pause',
    reason: lang==='en' ? `${fmt.k(d.spend||0)} spend, 0 conversions` : `${fmt.k(d.spend||0)} harcama, 0 dönüşüm`,
    headline: (d.headlines||[])[0]||'—',
  }));
  if (highRoasAds.length > 0) {
    changes.push({ campaign: highRoasAds[0].campaign, campaignId: highRoasAds[0].campaign_id,
      action: 'Ölçekle', actionType: 'budget',
      reason: `ROAS ${fmt.roas(highRoasAds[0].roas||0)}×`, headline: (highRoasAds[0].headlines||[])[0]||'—' });
  }

  const usableChanges = changes.filter(c => c.campaignId);

  const handleApply = () => {
    if (usableChanges.length === 0) return;
    setApplying(true);
    const clientId = config?.client_id || config?.platforms?.gads?.clientId || 1;
    const customerId = config?.platforms?.gads?.customerId || '';
    const usable = usableChanges;
    Promise.all(usable.map(c => axios.post(`${API}/optimize/apply`, {
      client_id: clientId,
      platform: 'google',
      campaign_id: c.campaignId,
      campaign_name: c.campaign,
      customer_id: customerId,
      title: `${c.headline} — ${c.action}`,
      impact_label: c.reason,
      action: c.actionType === 'budget'
        ? { type: 'budget', current: 100, suggested: 120 }
        : { type: 'pause' },
    })))
      .then(() => {
        setApplying(false);
        setApplied(true);
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('poyais-nav', { detail: 'poyaisone-recommendations' }));
        }, 800);
      })
      .catch((err) => {
        console.error('Optimizasyon apply hatası:', err?.response?.status, err?.response?.data);
        setApplying(false);
        setApplied(true);
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('poyais-nav', { detail: 'poyaisone-recommendations' }));
        }, 800);
      });
  };

  return (
    <>
      <div style={{ background:'linear-gradient(135deg,#1e293b 0%,#0f172a 100%)', borderRadius:16, padding:'28px 32px', position:'relative' as const, overflow:'hidden', boxShadow:'0 4px 24px rgba(0,0,0,.15)' }}>
        <div style={{ position:'relative' as const, zIndex:1 }}>
          <div style={{ fontSize:18, fontWeight:700, color:'#fff', fontFamily:'Manrope, sans-serif', marginBottom:8 }}>{t('Yapay Zeka Metin Önerisi')}</div>
          <div style={{ fontSize:12, color:T.textDimAlt, fontFamily:'Manrope, sans-serif', lineHeight:1.6, marginBottom:20, maxWidth:480 }}>
            {insightText}
          </div>
          <div style={{ display:'flex', gap:10 }}>
            <button onClick={handleApply} disabled={applying||applied||usableChanges.length===0}
              style={{ background: applied?T.green:usableChanges.length===0?'rgba(255,255,255,.12)':T.accent, color: usableChanges.length===0?T.textDimAlt:T.ink, padding:'9px 18px', borderRadius:8, border:'none', fontSize:12, fontWeight:800, cursor: applying||applied||usableChanges.length===0?'not-allowed':'pointer', fontFamily:'Manrope, sans-serif', opacity: applying?0.7:1, transition:'all .3s' }}>
              {applying ? t('Uygulanıyor...') : applied ? t('✓ Uygulandı') : usableChanges.length===0 ? t('Uygulanacak öneri yok') : t('Önerileri Uygula')}
            </button>
            <button onClick={()=>setShowModal(true)}
              style={{ background:'rgba(255,255,255,.1)', color:'#fff', padding:'9px 18px', borderRadius:8, border:'none', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>
              {t('Detaylı Analiz')}
            </button>
          </div>
        </div>
        <div style={{ position:'absolute' as const, right:-40, top:-40, width:200, height:200, background:'rgba(201,168,76,0.08)', borderRadius:'50%', filter:'blur(40px)' }}/>
        <div style={{ position:'absolute' as const, right:20, bottom:10, fontSize:80, opacity:.1 }}>📈</div>
      </div>

      {showModal && (
        <div style={{ position:'fixed' as const, inset:0, background:'rgba(0,0,0,.55)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}
          onClick={e=>{ if(e.target===e.currentTarget) setShowModal(false); }}>
          <div style={{ background:T.surface, borderRadius:16, padding:'28px 32px', maxWidth:600, width:'100%', maxHeight:'80vh', overflowY:'auto' as const, boxShadow:'0 20px 60px rgba(0,0,0,.3)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
              <div style={{ fontSize:17, fontWeight:700, color:T.text, fontFamily:'Manrope, sans-serif' }}>{t('Detaylı Analiz')}</div>
              <button onClick={()=>setShowModal(false)} style={{ background:'none', border:'none', fontSize:20, cursor:'pointer', color:T.textDim }}>×</button>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:20 }}>
              {[
                { label:t('Toplam CTR'), value:`%${avgCtr.toFixed(2)}`, note: avgCtr>3?t('İyi'):t('Geliştirilebilir') },
                { label:t('Dönüşümsüz Reklam'), value:`${noConvCount}`, note:`${data.length} ${t('reklamdan')}` },
                { label:t('Ort. CPA'), value: avgCpa>0?`₺${Math.round(avgCpa).toLocaleString(lang==='en'?'en-US':'tr-TR')}`:'—', note:t('Toplam harcama / dönüşüm') },
                { label:t('ROAS ≥ 4× Reklam'), value:`${highRoasAds.length}`, note:t('Yüksek performanslı') },
              ].map((s,i)=>(
                <div key={i} style={{ background:'var(--py-subtle-bg)', borderRadius:10, padding:'14px 16px' }}>
                  <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.06em', textTransform:'uppercase' as const, marginBottom:4, fontFamily:'Manrope, sans-serif' }}>{s.label}</div>
                  <div style={{ fontSize:20, fontWeight:800, color:T.text, fontFamily:'Manrope, sans-serif' }}>{s.value}</div>
                  <div style={{ fontSize:10, color:T.textDim, marginTop:2, fontFamily:'Manrope, sans-serif' }}>{s.note}</div>
                </div>
              ))}
            </div>

            <div style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:12, fontFamily:'Manrope, sans-serif' }}>{t('Önerilen Aksiyonlar')}</div>
            {changes.length === 0 && <div style={{ fontSize:12, color:T.textDim, fontFamily:'Manrope, sans-serif' }}>{t('Aksiyon gerektiren reklam bulunamadı.')}</div>}
            {changes.map((c,i)=>(
              <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderBottom:`1px solid ${T.borderAlt}` }}>
                <div>
                  <div style={{ fontSize:11, fontWeight:700, color:T.text, fontFamily:'Manrope, sans-serif' }}>{c.headline}</div>
                  <div style={{ fontSize:10, color:T.textDim, fontFamily:'Manrope, sans-serif', marginTop:2 }}>{c.campaign} · {c.reason}</div>
                </div>
                <span style={{ padding:'3px 10px', borderRadius:999, fontSize:10, fontWeight:700, fontFamily:'Manrope, sans-serif',
                  background: c.action==='Duraklat'?'var(--py-red-tint)':c.action==='Ölçekle'?'var(--py-green-tint)':alpha(T.accent,12),
                  color: c.action==='Duraklat'?T.red:c.action==='Ölçekle'?T.green:T.accent }}>
                  {t(c.action)}
                </span>
              </div>
            ))}

            <button onClick={()=>setShowModal(false)}
              style={{ marginTop:20, width:'100%', padding:'11px', borderRadius:8, background:T.ink, color:'#fff', border:'none', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>
              {t('Kapat')}
            </button>
          </div>
        </div>
      )}
    </>
  );
}

function GAdsAdTextsTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [overview, setOverview] = useState<any>({});
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const PAGE_SIZE = 10;
  const { customerId } = config.platforms.gads;
  const { t, lang } = useLang();

  useEffect(() => {
    if (!customerId) return;
    setLoading(true);
    axios.get(`${API}/gads/${customerId}/ad-texts?start_date=${start}&end_date=${end}`)
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, customerId]);

  const filtered = useMemo(() => data.filter(d =>
    d.campaign?.toLowerCase().includes(search.toLowerCase()) ||
    d.headlines?.join(' ').toLowerCase().includes(search.toLowerCase())
  ), [data, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged = filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
  const totalSpend  = data.reduce((s,d) => s + (d.spend||0), 0);
  const bestRoas    = data.length ? Math.max(...data.map(d => d.roas||0)) : 0;
  const noConvCount = data.filter(d => (d.conversions||0) === 0).length;

  const statusLabel = (d:any) => {
    if ((d.conversions||0) === 0 && (d.spend||0) > 500) return { text:t('Düşük Perf.'), bg:'var(--py-red-tint)', color:T.redText };
    if (d.status === 'PAUSED') return { text:t('Beklemede'), bg:'var(--py-track-bg)', color:'var(--py-text-mid-alt)' };
    return { text:t('Aktif'), bg:'var(--py-green-tint)', color:T.greenText };
  };
  const roasColor = (r:number) => r >= 4 ? T.greenText : r >= 2 ? T.amberText : T.redText;

  if (loading) return <Loader/>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:14 }}>
        {[
          { label:t('Toplam Reklam'),  value: fmt.n(data.length) },
          { label:t('En İyi ROAS'),    value: fmt.roas(bestRoas), gold:true },
          { label:t('Toplam Harcama'), value: fmt.k(totalSpend) },
          { label:t('Dönüşümsüz'),     value: fmt.n(noConvCount), labelColor:T.redText },
        ].map((k,i) => (
          <div key={i} style={{ background:T.surface, padding:'18px 19px', borderRadius:14, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:12.5, fontWeight:600, color: k.labelColor||'var(--py-text-mid-alt)', marginBottom:12 }}>{k.label}</div>
            <span style={{ fontSize:22, fontWeight:800, color: k.gold?T.greenText:T.text, fontFamily:MONO }}>{k.value}</span>
          </div>
        ))}
      </div>

      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}` }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', alignItems:'center', justifyContent:'space-between', gap:16, flexWrap:'wrap' as const }}>
          <div>
            <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Reklam Metinleri Performansı')}</div>
            <div style={{ fontSize:11.5, color:T.textDim, marginTop:3 }}>{t('Google Ads kampanyalarınızdaki aktif metinlerin detaylı verileri.')}</div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:9, flexWrap:'wrap' as const }}>
            <div style={{ display:'flex', alignItems:'center', gap:9, flexShrink:0, border:`1px solid ${T.borderMid}`, borderRadius:10, padding:'8px 12px' }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={T.textDim} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>
              <input value={search} onChange={e => { setSearch(e.target.value); setPage(0); }}
                placeholder={t('Kampanya veya başlık ara…')}
                style={{ border:'none', outline:'none', fontSize:12.5, color:T.text, width:220, fontFamily:'inherit', background:'transparent' }}/>
            </div>
            <button onClick={()=>exportCsv(`gads-reklam-metinleri-${start}-${end}.csv`, filtered.map((d:any)=>({
              ...d,
              headline_text: (d.headlines||[]).join(' | '),
              status_text: statusLabel(d).text,
              ctr_calc: d.ctr!=null && !isNaN(d.ctr) ? d.ctr : (d.clicks>0&&d.impressions>0 ? (d.clicks/d.impressions*100) : 0),
            })), [
              { key:'headline_text', label:t('Reklam Metni') }, { key:'campaign', label:t('Kampanya') },
              { key:'status_text', label:t('Durum') }, { key:'spend', label:t('Harcama') },
              { key:'clicks', label:t('Tıklama') }, { key:'ctr_calc', label:'CTR' },
              { key:'purchases', label:'Conv.' }, { key:'roas', label:'ROAS' },
            ])} disabled={filtered.length===0} style={{ padding:'8px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:filtered.length?'pointer':'not-allowed', opacity:filtered.length?1:.5 }}>
              {t('Dışa Aktar')}
            </button>
          </div>
        </div>

        <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
          <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:600 }}>
            <thead>
              <tr style={{ background:'var(--py-subtle-bg)' }}>
                {[t('Reklam Metni'),t('Kampanya'),t('Durum'),t('Harcama'),t('Tıklama'),'CTR',t('Dönüşüm'),'ROAS'].map((h,i) => (
                  <th key={i} style={{ padding:'11px 18px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign: i>2?'right' as const:'left' as const, whiteSpace:'nowrap' as const, borderBottom:'1px solid var(--py-table-divider)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paged.length === 0 && (
                <tr><td colSpan={8} style={{ padding:48, textAlign:'center' as const, color:T.textDim, fontSize:13 }}>{t('Sonuç bulunamadı')}</td></tr>
              )}
              {paged.map((d:any, i:number) => {
                const st = statusLabel(d);
                return (
                  <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)' }}>
                    <td style={{ padding:'13px 18px', maxWidth:300 }}>
                      <div style={{ display:'flex', flexWrap:'wrap' as const, gap:4, marginBottom:4 }}>
                        {(d.headlines||[]).slice(0,3).map((h:string,j:number) => (
                          <span key={j} style={{ fontSize:11, fontWeight:700 }}>
                            {j>0 && <span style={{ color:T.textDim, marginRight:2 }}>|</span>}{h}
                          </span>
                        ))}
                      </div>
                      {d.descriptions?.[0] && <div style={{ fontSize:11, color:T.textDim, lineHeight:1.5 }}>{d.descriptions[0]}</div>}
                    </td>
                    <td style={{ padding:'13px 18px', maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>
                      <span title={d.campaign} style={{ fontSize:11.5, fontWeight:600, color:'var(--py-text-mid-alt)' }}>{d.campaign}</span>
                    </td>
                    <td style={{ padding:'13px 18px', whiteSpace:'nowrap' as const }}>
                      <span style={{ padding:'2px 9px', borderRadius:999, background:st.bg, color:st.color, fontSize:10, fontWeight:700 }}>{st.text}</span>
                    </td>
                    <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, fontWeight:700, color:T.textMid, fontFamily:MONO }}>{fmt.k(d.spend)}</td>
                    <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(d.clicks)}</td>
                    <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{d.ctr!=null && !isNaN(d.ctr) ? fmt.pct(d.ctr) : (d.clicks>0&&d.impressions>0 ? fmt.pct(d.clicks/d.impressions*100) : '—')}</td>
                    <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, fontWeight:700, fontFamily:MONO }}>{Math.round(d.purchases||0)}</td>
                    <td style={{ padding:'13px 18px', textAlign:'right' as const }}>
                      <span style={{ fontSize:12.5, fontWeight:800, color:roasColor(d.roas), fontFamily:MONO }}>{fmt.roas(d.roas)}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>
            {lang==='en'
              ? <>Showing {Math.min(page*PAGE_SIZE+1,filtered.length)}-{Math.min((page+1)*PAGE_SIZE,filtered.length)} of {filtered.length} total records.</>
              : <>Toplam {filtered.length} kayıttan {Math.min(page*PAGE_SIZE+1,filtered.length)}-{Math.min((page+1)*PAGE_SIZE,filtered.length)} arası gösteriliyor.</>}
          </span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page===0?'not-allowed':'pointer', opacity:page===0?0.4:1, fontSize:14, display:'flex', alignItems:'center', justifyContent:'center' }}>{'<'}</button>
            {pageWindow(page,totalPages).map(n=>(
              <button key={n} onClick={()=>setPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${page===n?T.accent:T.borderMid}`, background:page===n?T.accent:T.surface, color:page===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page>=totalPages-1?'not-allowed':'pointer', opacity:page>=totalPages-1?.4:1, fontSize:14, display:'flex', alignItems:'center', justifyContent:'center' }}>{'>'}</button>
          </div>
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'2fr 1fr', gap:14 }}>
        <AITextInsightCard data={data} noConvCount={noConvCount} bestRoas={bestRoas} config={config}/>
        <div style={{ background:T.surface, borderRadius:16, padding:'20px 22px', border:`1px solid ${T.border}`, display:'flex', flexDirection:'column' as const, justifyContent:'space-between' }}>
          {(() => {
            const activeAds = data.filter((d:any) => d.status !== 'PAUSED');
            const totalClicks = data.reduce((s:any,d:any)=>s+(d.clicks||0),0);
            const totalImpr   = data.reduce((s:any,d:any)=>s+(d.impressions||0),0);
            const avgCtr      = totalImpr > 0 ? (totalClicks/totalImpr*100) : 0;
            const roasAbove2  = data.filter((d:any)=>(d.roas||0)>=2).length;
            const roasPct     = data.length > 0 ? Math.round((roasAbove2/data.length)*100) : 0;
            const highRoas    = data.filter((d:any)=>(d.roas||0)>=4).length;
            const trendText   = lang==='en' ? (
              data.length === 0
              ? "There's no trend data for this period — no ad in the account has received impressions. Once a campaign becomes active and data accumulates, a real trend analysis will appear here."
              : avgCtr > 5
              ? `Average CTR of ${avgCtr.toFixed(1)}% is above the industry average. ${highRoas} ads are showing high ROAS performance.`
              : avgCtr > 2
              ? `Average CTR of ${avgCtr.toFixed(1)}% is at a moderate level. Click-through rate can be improved by increasing headline relevance.`
              : `CTR of ${avgCtr.toFixed(1)}% is running low. Headline-to-search-query alignment should be reviewed for the ${activeAds.length} active ads.`
            ) : (
              data.length === 0
              ? 'Bu dönem için trend verisi yok — hesapta gösterim alan bir reklam bulunmuyor. Bir kampanya aktif hale gelip veri biriktikçe burada gerçek bir trend analizi görünecek.'
              : avgCtr > 5
              ? `Ortalama CTR %${avgCtr.toFixed(1)} ile sektör ortalamasının üzerinde. ${highRoas} reklam yüksek ROAS performansı gösteriyor.`
              : avgCtr > 2
              ? `Ortalama CTR %${avgCtr.toFixed(1)} düzeyde. Başlık relevansını artırarak tıklama oranı iyileştirilebilir.`
              : `CTR %${avgCtr.toFixed(1)} düşük seyrediyor. ${activeAds.length} aktif reklamın başlık-arama sorgusu uyumu gözden geçirilmeli.`
            );
            return (
              <>
                <div>
                  <div style={{ fontSize:13.5, fontWeight:800, marginBottom:8 }}>{t('Trend Analizi')}</div>
                  <div style={{ fontSize:11.5, color:'var(--py-text-mid-alt)', lineHeight:1.6 }}>{trendText}</div>
                </div>
                {data.length > 0 && (
                <div style={{ marginTop:16, paddingTop:16, borderTop:'1px solid var(--py-table-divider)' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:7 }}>
                    <span style={{ fontSize:10.5, fontWeight:800, color:T.textDim, textTransform:'uppercase' as const, letterSpacing:'.06em' }}>{t('ROAS ≥ 2× Uyum')}</span>
                    <span style={{ fontSize:11, fontWeight:700, color: roasPct>=50?T.greenText:T.redText }}>{roasPct}%</span>
                  </div>
                  <div style={{ width:'100%', background:'var(--py-track-bg)', borderRadius:999, height:6 }}>
                    <div style={{ height:6, borderRadius:999, background: roasPct>=50?T.greenText:T.redText, width:`${roasPct}%`, transition:'width .4s' }}/>
                  </div>
                  <div style={{ fontSize:11, color:T.textDim, marginTop:7 }}>
                    {lang==='en'
                      ? <>{roasAbove2} / {data.length} ads meet the ROAS ≥ 2× target.</>
                      : <>{roasAbove2} / {data.length} reklam ROAS ≥ 2× hedefini karşılıyor.</>}
                  </div>
                </div>
                )}
              </>
            );
          })()}
        </div>
      </div>
    </div>
  );
}
function GAdsHeatmapTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [showAllHours, setShowAllHours] = useState(false);
  const { customerId } = config.platforms.gads;
  const { t, lang } = useLang();

  useEffect(() => {
    if (!customerId) return;
    setLoading(true);
    axios.get(`${API}/gads/${customerId}/dayparting?start_date=${start}&end_date=${end}`)
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, customerId]);

  if (loading) return <Loader/>;
  if (!data) return <div style={{ color:'var(--py-text-mid-alt)', padding:24 }}>{t('Veri bulunamadı.')}</div>;

  const days  = data.days  || [];
  const hours = data.hours || [];

  const totalSpend = days.reduce((s:number,d:any) => s+(d.spend||0), 0);
  const totalRev    = days.reduce((s:number,d:any) => s+(d.revenue||0), 0);
  const avgRoas    = totalSpend>0 ? totalRev/totalSpend : 0; // harcama ağırlıklı
  const parseHour  = (h:any) => typeof h.hour==='string' ? parseInt(h.hour.split(':')[0]) : (h.hour||0);
  const bestHour   = [...hours].sort((a:any,b:any)=>(b.conversions||0)-(a.conversions||0))[0];
  const bestHourCvr = bestHour && (bestHour.clicks||0)>0 ? ((bestHour.conversions||0)/(bestHour.clicks||1)*100).toFixed(1) : '0';
  const lowestCpaDay = [...days].filter(d=>(d.conversions||0)>0).sort((a:any,b:any)=>((a.spend||0)/(a.conversions||1))-((b.spend||0)/(b.conversions||1)))[0];
  const DAY_NAMES: Record<string,string> = lang==='en'
    ? { MONDAY:'Monday',TUESDAY:'Tuesday',WEDNESDAY:'Wednesday',THURSDAY:'Thursday',FRIDAY:'Friday',SATURDAY:'Saturday',SUNDAY:'Sunday', Pzt:'Monday',Sal:'Tuesday',Car:'Wednesday',Per:'Thursday',Cum:'Friday',Cmt:'Saturday',Paz:'Sunday' }
    : { MONDAY:'Pazartesi',TUESDAY:'Salı',WEDNESDAY:'Çarşamba',THURSDAY:'Perşembe',FRIDAY:'Cuma',SATURDAY:'Cumartesi',SUNDAY:'Pazar', Pzt:'Pazartesi',Sal:'Salı',Car:'Çarşamba',Per:'Perşembe',Cum:'Cuma',Cmt:'Cumartesi',Paz:'Pazar' };
  const DAY_SHORT: Record<string,string> = lang==='en'
    ? { MONDAY:'Mon',TUESDAY:'Tue',WEDNESDAY:'Wed',THURSDAY:'Thu',FRIDAY:'Fri',SATURDAY:'Sat',SUNDAY:'Sun', Pzt:'Mon',Sal:'Tue',Car:'Wed',Per:'Thu',Cum:'Fri',Cmt:'Sat',Paz:'Sun' }
    : { MONDAY:'Pzt',TUESDAY:'Sal',WEDNESDAY:'Çar',THURSDAY:'Per',FRIDAY:'Cum',SATURDAY:'Cmt',SUNDAY:'Paz', Pzt:'Pzt',Sal:'Sal',Car:'Çar',Per:'Per',Cum:'Cum',Cmt:'Cmt',Paz:'Paz' };
  const lowestCpaDayName = lowestCpaDay ? (DAY_NAMES[lowestCpaDay.day]||lowestCpaDay.day) : t('Yok');
  const lowestCpa = lowestCpaDay && (lowestCpaDay.conversions||0)>0 ? ((lowestCpaDay.spend||0)/(lowestCpaDay.conversions||1)).toFixed(2) : 'YOK';
  const maxDayRoas  = days.length  ? Math.max(...days.map((d:any)=>d.roas||0),  1) : 1;
  const maxHourRoas = hours.length ? Math.max(...hours.map((h:any)=>h.roas||0), 1) : 1;
  const DAY_ORDER   = ['MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY','SUNDAY','Pzt','Sal','Car','Çar','Per','Cum','Cmt','Paz'];
  // Isı haritası YALNIZCA gerçek veriyle çizilir: backend gün x saat hücreleri (cells) döndürüyorsa
  // gün satırları, döndürmüyorsa tüm günlerin saatlik toplamı tek satır olarak gösterilir. Türetilmiş/uydurma hücre yok.
  const cells:any[] = data.cells || [];
  const hasMatrix = cells.length > 0;
  const HOURS24 = Array.from({length:24},(_,i)=>i);
  const hourLabelEvery = isMobile ? 6 : 3;
  const heatRows: {key:string; label:string}[] = hasMatrix
    ? DAY_ORDER.filter(day=>cells.some((c:any)=>c.day===day)).map(day=>({ key:day, label:DAY_SHORT[day]||day }))
    : [{ key:'ALL', label:t('Tümü') }];
  const cellOf = (rowKey:string, h:number) => hasMatrix
    ? cells.find((c:any)=>c.day===rowKey && c.hour===h)
    : hours.find((hr:any)=>parseHour(hr)===h);
  const cellVals = (hasMatrix ? cells : hours).filter((c:any)=>(c.spend||0)>0).map((c:any)=>c.roas||0);
  const minRoas = cellVals.length ? Math.min(...cellVals) : 0;
  const maxRoas = cellVals.length ? Math.max(...cellVals) : 1;
  const heatColor = (cell:any) => {
    if (!cell || !(cell.spend>0)) return 'var(--py-track-bg)';
    const range = maxRoas - minRoas || 1;
    const r = Math.min(Math.max(((cell.roas||0) - minRoas) / range, 0), 1);
    return `rgba(201,168,76,${(0.18 + r*0.82).toFixed(2)})`;
  };
  const hourSpendTotal = hours.reduce((s:number,h:any)=>s+(h.spend||0),0)||1;
  const sortedHours = showAllHours ? [...hours].sort((a:any,b:any)=>parseHour(a)-parseHour(b)) : [...hours].sort((a:any,b:any)=>(b.roas||0)-(a.roas||0)).slice(0,5);

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:14 }}>
        {[
          { label:t('Toplam Harcama'),           value: fmt.k(totalSpend) },
          { label:t('En İyi Dönüşüm Saati'),    value: bestHour ? `${parseHour(bestHour)}:00 - ${parseHour(bestHour)+1}:00` : t('Yok'), sub: bestHour ? `${t('Dönüşüm Oranı')}: %${bestHourCvr}` : '' },
          { label:t('En Düşük CPA Günü'),        value: lowestCpaDayName,    sub: lowestCpa!=='YOK' ? `${t('Ort. CPA')}: ₺${lowestCpa}` : '' },
          { label:t('Ortalama ROAS'),            value: fmt.roas(avgRoas), gold:true },
        ].map((k,i) => (
          <div key={i} style={{ background:T.surface, padding:'18px 19px', borderRadius:14, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:12 }}>{k.label}</div>
            <div style={{ fontSize:18, fontWeight:800, color: (k as any).gold?T.greenText:T.text, fontFamily:MONO }}>{k.value}</div>
            {k.sub && <div style={{ fontSize:11, color:T.textDim, marginTop:6 }}>{k.sub}</div>}
          </div>
        ))}
      </div>

      {/* Zamanlama önerisi: gerçek saatlik veriden, uygulanabilir reklam zamanlaması (ad schedule) ipuçları */}
      {(()=>{
        const act = hours.filter((h:any)=>(h.spend||0)>0);
        if(act.length<6) return null;
        const tot = act.reduce((s:number,h:any)=>s+(h.spend||0),0);
        const totRev = act.reduce((s:number,h:any)=>s+(h.revenue||0),0);
        const base = tot>0 ? totRev/tot : 0;
        const share = (h:any)=>(h.spend||0)/tot*100;
        const strong = [...act].filter((h:any)=>share(h)>=2 && (h.roas||0) > base*1.25).sort((a:any,b:any)=>(b.roas||0)-(a.roas||0)).slice(0,3);
        const weak = [...act].filter((h:any)=>share(h)>=2 && (h.roas||0) < base*0.6).sort((a:any,b:any)=>(b.spend||0)-(a.spend||0)).slice(0,3);
        if(!strong.length && !weak.length) return null;
        const lab = (h:any)=>`${String(parseHour(h)).padStart(2,'0')}:00–${String((parseHour(h)+1)%24).padStart(2,'0')}:00`;
        const Col = ({title,color,list}:{title:string;color:string;list:any[]}) => list.length ? (
          <div style={{ flex:1, minWidth:220 }}>
            <div style={{ fontSize:10.5, fontWeight:800, letterSpacing:'.06em', textTransform:'uppercase' as const, color, marginBottom:8 }}>{title}</div>
            {list.map((h:any,i:number)=>(
              <div key={i} style={{ display:'flex', justifyContent:'space-between', gap:10, fontSize:12.5, padding:'5px 0' }}>
                <span style={{ fontWeight:700, fontFamily:MONO }}>{lab(h)}</span>
                <span style={{ color:T.textMid }}>ROAS {fmt.roas(h.roas||0)} · {t('Pay')} %{share(h).toFixed(1)}</span>
              </div>
            ))}
          </div>
        ) : null;
        return (
          <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'18px 22px' }}>
            <div style={{ fontSize:13.5, fontWeight:800, marginBottom:4 }}>{t('Zamanlama Önerisi')}</div>
            <div style={{ fontSize:11.5, color:T.textDim, marginBottom:14 }}>{lang==='en' ? `Account average ROAS is ${fmt.roas(base)}. Consider bid adjustments in Google Ads ad schedules.` : `Hesap ortalama ROAS'ı ${fmt.roas(base)}. Google Ads reklam zamanlaması (ad schedule) ile teklif ayarı değerlendirilebilir.`}</div>
            <div style={{ display:'flex', gap:24, flexWrap:'wrap' as const }}>
              <Col title={t('Teklifi artırmayı düşün')} color={T.greenText} list={strong}/>
              <Col title={t('Teklifi düşürmeyi düşün')} color={T.redText} list={weak}/>
            </div>
            <div style={{ fontSize:11, color:T.textDim, marginTop:12, lineHeight:1.6 }}>{t('Bu öneri yalnızca seçili dönemin verisine dayanır; marka/bilinirlik kampanyaları ROAS ile değerlendirilmez. Değişiklik otomatik uygulanmaz.')}</div>
          </div>
        );
      })()}

      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'2fr 1fr', gap:14 }}>
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ display:'flex', flexDirection:isMobile?'column' as const:'row' as const, justifyContent:'space-between', alignItems:isMobile?'flex-start' as const:'center' as const, marginBottom:18, gap:isMobile?8:0 }}>
            <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Haftalık Performans Isı Haritası')}</div>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:10.5, color:T.textDim }}>{t('Düşük')}</span>
              <div style={{ display:'flex', height:7, width:60, borderRadius:999, overflow:'hidden' }}>
                {[0.18,0.45,0.72,1].map((a,i)=><div key={i} style={{ flex:1, background:`rgba(201,168,76,${a})` }}/>)}
              </div>
              <span style={{ fontSize:10.5, color:T.textDim }}>{t('Yüksek')}</span>
            </div>
          </div>

          <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any, marginLeft:isMobile?-8:0, marginRight:isMobile?-8:0 }}>
            <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:isMobile?360:640 }}>
              <thead>
                <tr>
                  <th style={{ width:isMobile?30:44 }}/>
                  {HOURS24.map(h=>(
                    <th key={h} style={{ fontSize:isMobile?9:10, fontWeight:600, color:T.textDim, textAlign:'center' as const, padding:'0 0 6px', overflow:'visible', whiteSpace:'nowrap' as const }}>{h%hourLabelEvery===0?String(h).padStart(2,'0'):''}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {heatRows.map(row=>(
                  <tr key={row.key} style={{ height:isMobile?26:34 }}>
                    <td style={{ fontSize:isMobile?9:10.5, fontWeight:700, color:'var(--py-text-mid-alt)', paddingRight:isMobile?4:8, whiteSpace:'nowrap' as const }}>{row.label}</td>
                    {HOURS24.map(h=>{
                      const c = cellOf(row.key, h);
                      const roas = c ? (c.roas||0) : 0;
                      return (
                        <td key={h} style={{ padding:isMobile?1:1.5 }}>
                          <div title={c && c.spend>0 ? `${row.key==='ALL'?'':row.label+' '}${String(h).padStart(2,'0')}:00 — ROAS ${roas.toFixed(2)}× · ${fmt.k(c.spend||0)} · ${Math.round(c.conversions||0)} ${t('Dönüşüm')}` : `${row.key==='ALL'?'':row.label+' '}${String(h).padStart(2,'0')}:00 — ${t('Veri yok')}`}
                            style={{ width:'100%', height:isMobile?22:28, borderRadius:isMobile?3:5, background:heatColor(c), cursor:'default', transition:'transform .15s' }}
                            onMouseEnter={e=>{ if(!isMobile) e.currentTarget.style.transform='scale(1.2)'; }}
                            onMouseLeave={e=>{ if(!isMobile) e.currentTarget.style.transform='scale(1)'; }}/>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
            {!hasMatrix && <div style={{ fontSize:11, color:T.textDim, marginTop:10 }}>{t('Gün bazlı kırılım bu hesap için henüz mevcut değil; satır tüm günlerin saatlik toplamını gösterir.')}</div>}
          </div>
        </div>

        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, marginBottom:18 }}>{t('Günlük ROAS & Harcama Dağılımı')}</div>
          <div style={{ display:'flex', flexDirection:'column' as const, gap:14 }}>
            {days.map((d:any,i:number)=>(
              <div key={i}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:5 }}>
                  <span style={{ fontSize:11.5, color:T.textMid }}>{DAY_NAMES[d.day]||d.day}</span>
                  <span style={{ fontSize:11.5, fontWeight:700, color:T.accentDeep, fontFamily:MONO }}>{fmt.roas(d.roas)} ROAS</span>
                </div>
                <div style={{ height:6, width:'100%', background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                  <div style={{ height:'100%', borderRadius:999, background:T.accent, width:`${Math.min((d.roas||0)/maxDayRoas*100,100)}%`, transition:'width .4s' }}/>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}` }}>
        <div style={{ padding:'15px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center', gap:10 }}>
          <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Saatlik Performans Tablosu')}</div>
          <button onClick={()=>exportCsv(`gads-gun-saat-${start}-${end}.csv`, [...hours].sort((a:any,b:any)=>parseHour(a)-parseHour(b)).map((h:any)=>({
            hour_range: `${parseHour(h)}:00 - ${parseHour(h)+1}:00`,
            spend: h.spend||0,
            clicks: h.clicks||0,
            cpc: (h.clicks||0)>0 ? ((h.spend||0)/(h.clicks||1)).toFixed(2) : '0.00',
            conversions: Math.round(h.conversions||0),
            roas: h.roas||0,
            spend_pct: ((h.spend||0)/hourSpendTotal*100).toFixed(1),
          })), [
            { key:'hour_range', label:t('Saat Aralığı') }, { key:'spend', label:t('Harcama') },
            { key:'clicks', label:t('Tıklama') }, { key:'cpc', label:'CPC' },
            { key:'conversions', label:t('Dönüşüm') }, { key:'roas', label:'ROAS' },
            { key:'spend_pct', label:t('Harcama %') },
          ])} disabled={hours.length===0} style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:hours.length?'pointer':'not-allowed', opacity:hours.length?1:.5 }}>
            {t('Dışa Aktar')}
          </button>
        </div>

        <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
          <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:isMobile?480:600 }}>
            <thead>
              <tr style={{ background:'var(--py-subtle-bg)' }}>
                {[t('Saat Aralığı'),t('Harcama'),t('Tıklama'),'CPC',t('Dönüşüm'),'ROAS',t('Harcama %')].map((h,i)=>(
                  <th key={i} style={{ padding:isMobile?'8px 12px':'11px 18px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign:'left' as const, whiteSpace:'nowrap' as const, borderBottom:'1px solid var(--py-table-divider)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedHours.map((h:any,i:number)=>{
                const isBest = (h.roas||0) === Math.max(...hours.map((x:any)=>x.roas||0));
                const spendPct = ((h.spend||0)/hourSpendTotal*100);
                const cpc = (h.clicks||0)>0 ? (h.spend||0)/(h.clicks||1) : 0;
                return (
                  <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)', background:isBest?'var(--py-amber-tint)':'transparent' }}>
                    <td style={{ padding:'12px 18px', fontSize:12.5, fontWeight:600, whiteSpace:'nowrap' as const }}>{parseHour(h)}:00 - {parseHour(h)+1}:00</td>
                    <td style={{ padding:'12px 18px', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.k(h.spend)}</td>
                    <td style={{ padding:'12px 18px', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(h.clicks)}</td>
                    <td style={{ padding:'12px 18px', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>₺{cpc.toFixed(2)}</td>
                    <td style={{ padding:'12px 18px', fontSize:12.5, fontWeight:700, color:isBest?T.accentDeep:T.text, fontFamily:MONO }}>{Math.round(h.conversions||0)}</td>
                    <td style={{ padding:'12px 18px' }}>
                      <span style={{ padding:'3px 9px', borderRadius:999, background:isBest?T.accent:'var(--py-green-tint)', color:isBest?'var(--py-accent-ink)':T.greenText, fontSize:11, fontWeight:700 }}>{fmt.roas(h.roas)}</span>
                    </td>
                    <td style={{ padding:'12px 18px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <div style={{ flex:1, height:4, background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden', minWidth:60 }}>
                          <div style={{ height:'100%', background:isBest?T.accent:T.borderSoft, borderRadius:999, width:`${Math.min(spendPct/15*100,100)}%` }}/>
                        </div>
                        <span style={{ fontSize:11, color:T.textDim, fontFamily:MONO, minWidth:34 }}>{spendPct.toFixed(1)}%</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {!showAllHours && hours.length > 5 && (
          <div style={{ padding:'14px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'center' }}>
            <button onClick={()=>setShowAllHours(true)}
              style={{ fontSize:12, fontWeight:700, color:T.accentDeep, background:'none', border:'none', cursor:'pointer' }}>
              {t('Tüm Saat Dilimlerini Gör')}
            </button>
          </div>
        )}
      </div>

    </div>
  );
}
function MetaAdSetsTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData]     = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage]     = useState(0);
  const [search, setSearch] = useState('');
  const [statusF, setStatusF] = useState<'all'|'active'|'paused'>('all');
  const [applyBusy, setApplyBusy] = useState(false);
  const [applyMsg, setApplyMsg] = useState<{ok:boolean;text:string}|null>(null);
  const PAGE_SIZE = 10;
  const { accountId } = config.platforms.meta;
  const { t, lang } = useLang();

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/meta/${accountId}/adsets?start_date=${start}&end_date=${end}`)
      .then(r => { setData(r.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, accountId]);

  const filtered = useMemo(() => data.filter(d =>
    (statusF==='all' || (statusF==='active' ? d.status==='ENABLED' : d.status!=='ENABLED')) &&
    (!search ||
    (d.name||d.adset_name||'').toLowerCase().includes(search.toLowerCase()) ||
    (d.campaign||d.campaign_name||'').toLowerCase().includes(search.toLowerCase()))
  ), [data, search, statusF]);

  const totalPages  = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged       = filtered.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);
  const bestRoas    = data.length ? Math.max(...data.map(d=>d.roas||0)) : 0;
  const totalSpend  = data.reduce((s,d)=>s+(d.spend||0),0);
  const totalConv   = data.reduce((s,d)=>s+(d.purchases||d.conversions||0),0);
  // "Yapay Zeka Tavsiyesi" kutusu sadece AKTİF (kampanyası da dahil, effective_status
  // üzerinden zaten hesaba katılıyor) ad set'leri öneri adayı yapmalı — kullanıcı canlıda
  // yakaladı: kampanyası kapalı bir ad set'e bütçe kaydırma öneriliyordu. d.status backend'in
  // get_adset_performance()'ından geliyor (ENABLED/PAUSED, effective_status'e dayanıyor).
  const activeAdSets = data.filter(d=>d.status==='ENABLED');
  const bestAdSet   = [...activeAdSets].sort((a,b)=>(b.roas||0)-(a.roas||0))[0];
  const worstAdSet  = [...activeAdSets].filter(d=>(d.roas||0)<2).sort((a,b)=>(a.roas||0)-(b.roas||0))[0];

  const roasColor = (r:number) => r >= 4 ? T.greenText : r >= 2 ? T.amberText : T.redText;

  if (loading) return <Loader/>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:14 }}>
        {[
          { label:t('Toplam Reklam Seti'),   value: fmt.n(data.length)  },
          { label:t('En İyi ROAS'),     value: fmt.roas(bestRoas), gold:true },
          { label:t('Toplam Harcama'),  value: fmt.k(totalSpend)   },
          { label:t('Toplam Satış'),    value: fmt.n(totalConv)    },
        ].map((k,i) => (
          <div key={i} style={{ background:T.surface, padding:'18px 19px', borderRadius:14, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:12 }}>{k.label}</div>
            <div style={{ fontSize:22, fontWeight:800, color: (k as any).gold?T.greenText:T.text, fontFamily:MONO }}>{k.value}</div>
          </div>
        ))}
      </div>

      {/* Performans Tablosu */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}` }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', flexDirection:isMobile?'column' as const:'row' as const, justifyContent:'space-between', alignItems:isMobile?'flex-start' as const:'center' as const, gap:isMobile?10:0 }}>
          <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Performans Detayları')}</div>
          <div style={{ display:'flex', gap:8, width:isMobile?'100%':'auto', flexWrap:isMobile?'wrap' as const:'nowrap' as const }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, flex:isMobile?'1 1 100%':'none', border:`1px solid ${T.borderMid}`, borderRadius:9, padding:'7px 11px' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.textDim} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>
              <input value={search} onChange={e=>{setSearch(e.target.value);setPage(0);}} placeholder={t('Reklam seti veya kampanya…')}
                style={{ border:'none', outline:'none', fontSize:12, color:T.text, width:isMobile?'100%':170, fontFamily:'inherit', background:'transparent' }}/>
            </div>
            <select value={statusF} onChange={e=>{setStatusF(e.target.value as any);setPage(0);}} aria-label={t('Durum')}
              style={{ padding:'7px 11px', fontSize:12, fontWeight:700, border:`1px solid ${T.borderMid}`, borderRadius:9, background:T.surface, color:'var(--py-text-mid-alt)', fontFamily:'inherit', cursor:'pointer' }}>
              <option value="all">{t('Tüm Durumlar')}</option><option value="active">{t('Aktif')}</option><option value="paused">{t('Aktif Değil')}</option>
            </select>
            <button onClick={()=>exportCsv(`meta-ad-sets-${start}-${end}.csv`, filtered.map((d:any)=>{
                const conv = d.purchases||d.conversions||0;
                return { adset: d.adset_name||d.name||'', campaign: d.campaign||d.campaign_name||'', spend: (d.spend||0).toFixed(2), roas: (d.roas||0).toFixed(2), clicks: d.clicks||0, ctr: (d.ctr||0).toFixed(2), conv: Math.round(conv), cpa: conv>0?((d.spend||0)/conv).toFixed(2):'0' };
              }), [
                { key:'adset', label:'Ad Set' }, { key:'campaign', label:t('Kampanya') }, { key:'spend', label:t('Harcama') },
                { key:'roas', label:'ROAS' }, { key:'clicks', label:t('Tıklama') }, { key:'ctr', label:'CTR %' },
                { key:'conv', label:t('Satış') }, { key:'cpa', label:'CPA' },
              ])} disabled={filtered.length===0} style={{ padding:'7px 13px', fontSize:12, fontWeight:700, border:`1px solid ${T.borderMid}`, borderRadius:9, background:T.surface, cursor:filtered.length?'pointer':'not-allowed', opacity:filtered.length?1:.5, color:'var(--py-text-mid-alt)' }}>
                {t('Dışa Aktar')}
              </button>
          </div>
        </div>

        <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
          <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:600 }}>
            <thead>
              <tr style={{ background:'var(--py-subtle-bg)' }}>
                {[t('Reklam Seti'),t('Günlük Bütçe'),t('Harcama'),'ROAS',t('Erişim'),'CTR',t('Satış'),'CPA'].map((h,i)=>(
                  <th key={i} style={{ padding:'11px 16px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign: i>0?'right' as const:'left' as const, whiteSpace:'nowrap' as const, borderBottom:'1px solid var(--py-table-divider)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paged.length===0 && (
                <tr><td colSpan={8} style={{ padding:48, textAlign:'center' as const, color:T.textDim, fontSize:12.5 }}>{t('Reklam seti bulunamadı')}</td></tr>
              )}
              {paged.map((d:any,i:number)=>{
                const cpa = (d.purchases||d.conversions||0)>0 ? (d.spend||0)/(d.purchases||d.conversions||1) : 0;
                return (
                  <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)' }}
                    onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                    onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                    <td style={{ padding:'13px 16px', maxWidth:300 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <span title={d.status==='ENABLED'?t('Aktif'):t('Duraklatıldı')} style={{ width:7, height:7, borderRadius:'50%', flexShrink:0, background:d.status==='ENABLED'?T.greenText:'var(--py-border-soft)' }}/>
                        <div style={{ minWidth:0 }}>
                          <div style={{ fontSize:12.5, fontWeight:700, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{d.adset_name||d.name||'—'}</div>
                          {(d.campaign||d.campaign_name) && <div style={{ fontSize:10.5, color:T.textDim, marginTop:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{d.campaign||d.campaign_name}</div>}
                        </div>
                      </div>
                    </td>
                    <td title={d.budget_level==='campaign'?t('Bütçe kampanya düzeyinde'):undefined} style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{d.daily_budget?`${fmt.k(d.daily_budget)}${d.budget_level==='campaign'?' *':''}`:'—'}</td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.k(d.spend)}</td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const }}>
                      <span style={{ fontSize:12.5, fontWeight:700, color:roasColor(d.roas), fontFamily:MONO }}>{fmt.roas(d.roas)}</span>
                    </td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(d.reach||0)}</td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.pct(d.ctr)}</td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, fontWeight:700, fontFamily:MONO }}>{Math.round(d.purchases||0)}</td>
                    <td style={{ padding:'13px 16px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>₺{cpa>0?Math.round(cpa).toLocaleString('tr-TR'):'—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>{lang==='en' ? `Showing ${filtered.length} ad sets total.` : `Toplam ${filtered.length} reklam seti gösteriliyor.`}{data.some((x:any)=>x.budget_level==='campaign') && (lang==='en' ? ' * Budget is set at campaign level.' : ' * Bütçe kampanya düzeyinde ayarlı.')}</span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
              style={{ width:28,height:28,borderRadius:8,border:`1px solid ${T.borderMid}`,background:T.surface,cursor:page===0?'not-allowed':'pointer',opacity:page===0?0.4:1,display:'flex',alignItems:'center',justifyContent:'center',fontSize:14 }}>‹</button>
            {pageWindow(page,totalPages).map(n=>(
              <button key={n} onClick={()=>setPage(n)}
                style={{ width:28,height:28,borderRadius:8,border:`1px solid ${page===n?T.accent:T.borderMid}`,background:page===n?T.accent:T.surface,color:page===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)',cursor:'pointer',fontSize:11,fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
              style={{ width:28,height:28,borderRadius:8,border:`1px solid ${T.borderMid}`,background:T.surface,cursor:page>=totalPages-1?'not-allowed':'pointer',opacity:page>=totalPages-1?.4:1,display:'flex',alignItems:'center',justifyContent:'center',fontSize:14 }}>›</button>
          </div>
        </div>
      </div>

      {/* Alt Row: Trend + AI Tavsiye */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'2fr 1fr', gap:14 }}>
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16, flexWrap:'wrap' as const, gap:8 }}>
            <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Reklam Seti Harcama Dağılımı')}</div>
            <div style={{ display:'flex', gap:12 }}>
              {[[T.greenText,'ROAS ≥ 4×'],[T.amberText,'ROAS ≥ 2×'],[T.redText,'ROAS < 2×']].map(([c,l])=>(
                <div key={l} style={{ display:'flex', alignItems:'center', gap:5 }}>
                  <div style={{ width:7,height:7,borderRadius:'50%',background:c }}/>
                  <span style={{ fontSize:10.5,color:T.textDim }}>{l}</span>
                </div>
              ))}
            </div>
          </div>
          {(() => {
            const chartData = [...data].sort((a,b)=>(b.spend||0)-(a.spend||0)).slice(0,10).map(d=>({
              name: (()=>{ const n = d.adset_name||d.name||''; return n.length>14 ? n.slice(0,13)+'…' : n; })(),
              spend: d.spend||0,
              roas: d.roas||0,
            }));
            return (
              <ResponsiveContainer width="100%" height={190}>
                <BarChart data={chartData} margin={{ top:0,right:0,left:-20,bottom:0 }}>
                  <XAxis dataKey="name" tick={{ fontSize:9,fill:T.textDim }} axisLine={false} tickLine={false} interval={0} angle={-15} textAnchor="end" height={44}/>
                  <YAxis tick={{ fontSize:9,fill:T.textDim }} axisLine={false} tickLine={false} tickFormatter={(v:number)=>v>=1000?`${Math.round(v/1000)}K`:`${v}`}/>
                  <Tooltip content={<CT/>} cursor={{ fill:'rgba(20,22,43,.03)' }}/>
                  <Bar dataKey="spend" radius={[4,4,0,0]}>
                    {chartData.map((d:any,i:number)=><Cell key={i} fill={(d.roas||0)>=4?T.greenText:(d.roas||0)>=2?T.amberText:T.redText}/>)}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            );
          })()}
        </div>

        <div style={{ background:T.ink, borderRadius:16, padding:'22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, color:'#fff', marginBottom:10 }}>{t('Yapay Zeka Tavsiyesi')}</div>
          <div style={{ fontSize:11.5, color:'rgba(255,255,255,.55)', lineHeight:1.7, marginBottom:18 }}>
            {lang==='en' ? (
              bestAdSet
              ? `"${bestAdSet.adset_name||bestAdSet.name}" delivers the highest efficiency with ${fmt.roas(bestAdSet.roas)} ROAS. ${worstAdSet ? `Shifting some of the ${worstAdSet.daily_budget?`₺${Math.round(worstAdSet.daily_budget).toLocaleString('tr-TR')} daily budget`:'daily budget'} from "${worstAdSet.adset_name||worstAdSet.name}" here could increase overall ROAS.` : 'Consider shifting budget from low-performing sets here.'}`
              : 'Ad set data is being analyzed. Optimization suggestions will be ready soon.'
            ) : (
              bestAdSet
              ? `"${bestAdSet.adset_name||bestAdSet.name}" seti ${fmt.roas(bestAdSet.roas)} ROAS ile en yüksek verimi sağlıyor. ${worstAdSet ? `"${worstAdSet.adset_name||worstAdSet.name}" setinin ${worstAdSet.daily_budget?`günlük ₺${Math.round(worstAdSet.daily_budget).toLocaleString('tr-TR')} bütçesinin`:'günlük bütçesinin'} bir kısmını buraya kaydırmak toplam ROAS'ı artırabilir.` : 'Düşük performanslı setlerin bütçesini buraya kaydırmayı değerlendirin.'}`
              : 'Ad set verisi analiz ediliyor. Optimizasyon önerileri yakında hazır olacak.'
            )}
          </div>
          <button onClick={()=>{
            if(!bestAdSet || !bestAdSet.adset_id) return;
            const clientId = config?.client_id || 1;
            // Meta'nın Graph API'si campaign/adset/ad için aynı genel node güncelleme uç
            // noktasını kullanıyor — /optimize/apply'ın 'campaign_id' alanına adset_id
            // vermek burada da gerçekten çalışır, ayrı bir dispatcher gerekmiyor.
            const requests = [
              axios.post(`${API}/optimize/apply`, {
                client_id: clientId, platform: 'meta',
                campaign_id: bestAdSet.adset_id, campaign_name: bestAdSet.adset_name||bestAdSet.name,
                account_id: accountId,
                title: `"${bestAdSet.adset_name||bestAdSet.name}" setine bütçe artışı`,
                impact_label: `ROAS ${fmt.roas(bestAdSet.roas)}`,
                action: { type: 'budget', current: 100, suggested: 120 },
              }),
            ];
            if (worstAdSet && worstAdSet.adset_id) {
              requests.push(axios.post(`${API}/optimize/apply`, {
                client_id: clientId, platform: 'meta',
                campaign_id: worstAdSet.adset_id, campaign_name: worstAdSet.adset_name||worstAdSet.name,
                account_id: accountId,
                title: `"${worstAdSet.adset_name||worstAdSet.name}" setinden bütçe azalt`,
                impact_label: `ROAS ${fmt.roas(worstAdSet.roas)}`,
                action: { type: 'budget', current: 100, suggested: 80 },
              }));
            }
            setApplyBusy(true); setApplyMsg(null);
            Promise.all(requests)
              .then(rs=>{
                const bad = rs.find(r=>r.data?.status && r.data.status!=='pending');
                if(bad) setApplyMsg({ ok:false, text: bad.data?.message || t('Öneri kuyruğa eklenemedi.') });
                else setApplyMsg({ ok:true, text: t('Öneri onay kuyruğuna eklendi (+%20 / −%20 bütçe). Onaylayana kadar değişiklik yapılmaz.') });
              })
              .catch((e:any)=>setApplyMsg({ ok:false, text: e?.response?.data?.detail || t('Öneri kuyruğa eklenemedi, tekrar deneyin.') }))
              .finally(()=>setApplyBusy(false));
          }} disabled={applyBusy||!bestAdSet} style={{ background:T.accent, color:'#fff', padding:'9px 16px', borderRadius:11, border:'none', fontSize:13, fontWeight:700, cursor:applyBusy?'wait':'pointer', opacity:bestAdSet?1:.5 }}>
            {applyBusy ? t('Gönderiliyor…') : t('Stratejiyi Uygula')}
          </button>
          {applyMsg && (
            <div style={{ marginTop:12, fontSize:11.5, lineHeight:1.6, color:applyMsg.ok?T.greenText:T.redText, fontWeight:600 }}>
              {applyMsg.text}
              {applyMsg.ok && <button onClick={()=>window.dispatchEvent(new CustomEvent('poyais-nav',{detail:'poyaisone-recommendations'}))} style={{ display:'block', marginTop:6, background:'none', border:'none', padding:0, color:T.accent, fontSize:11.5, fontWeight:700, cursor:'pointer' }}>{t('Onay Bekleyenlere Git →')}</button>}
            </div>
          )}
        </div>
      </div>

    </div>
  );
}
function MetaPlacementsTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData]     = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [overview, setOverview] = useState<any>({});
  const [search, setSearch] = useState('');
  const [page, setPage]     = useState(0);
  const [platFilter, setPlatFilter] = useState<string>('');
  const [showPlatFilter, setShowPlatFilter] = useState(false);
  const PAGE_SIZE = 10;
  const { accountId } = config.platforms.meta;
  const { t, lang } = useLang();

  useEffect(() => {
    if (!accountId) return;
    setLoading(true);
    axios.get(`${API}/meta/${accountId}/placements?start_date=${start}&end_date=${end}`)
      .then(r => { setData(r.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, accountId]);

  const filtered = useMemo(() => data.filter(d => {
    const matchSearch = !search || (d.label||d.placement||d.name||'').toLowerCase().includes(search.toLowerCase());
    const matchPlat = !platFilter || (d.platform||'').toLowerCase() === platFilter;
    return matchSearch && matchPlat;
  }), [data, search, platFilter]);

  const totalPages  = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged       = filtered.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);
  const totalSpend  = data.reduce((s,d)=>s+(d.spend||0),0)||1;
  const bestRoas    = data.length ? Math.max(...data.map(d=>d.roas||0)) : 0;
  const bestPl      = data.find(d=>(d.roas||0)===bestRoas);

  // Platform dagilimi
  const platforms: Record<string,number> = {};
  data.forEach(d => {
    const pl = (d.platform||'').toLowerCase();
    const key = pl.includes('instagram')?'Instagram':pl.includes('facebook')?'Facebook':pl.includes('messenger')?'Messenger':pl.includes('audience')?'Audience Network':'Diğer';
    platforms[key] = (platforms[key]||0) + (d.spend||0);
  });
  const igSpend  = platforms['Instagram']||0;
  const fbSpend  = platforms['Facebook']||0;
  const igPct    = totalSpend>0?Math.round(igSpend/totalSpend*100):0;
  const fbPct    = totalSpend>0?Math.round(fbSpend/totalSpend*100):0;

  const platColors: Record<string,string> = { Instagram:'#e91e8c', Facebook:'#1877f2', 'Audience Network':T.textDim, Messenger:'#00b2ff', 'Diğer':T.borderSoft };
  const worstAdSet  = data.filter(d=>(d.roas||0)<2).sort((a,b)=>(a.roas||0)-(b.roas||0))[0];
  const roasColor = (r:number) => r >= 4 ? T.greenText : r >= 2 ? T.amberText : T.redText;

  const placementIcon = (name:string) => {
    const n = (name||'').toLowerCase();
    if (n.includes('stories') || n.includes('hikaye')) return '▣';
    if (n.includes('reels'))    return '▶';
    if (n.includes('feed') || n.includes('akış'))     return '⊞';
    if (n.includes('explore') || n.includes('keşfet')) return '✦';
    if (n.includes('market'))   return '⊕';
    return '□';
  };

  if (loading) return <Loader/>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:14 }}>
        {[
          { label:t('Yerleşim Sayısı'), value: fmt.n(data.length) },
          { label:t('En İyi ROAS'),      value: fmt.roas(bestRoas), gold:true },
          { label:t('Instagram Payı'),   value: `%${igPct}`,        accent:'#e91e8c' },
          { label:t('Facebook Payı'),    value: `%${fbPct}`,        accent:'#1877f2' },
        ].map((k,i) => (
          <div key={i} style={{ background:T.surface, padding:'18px 19px', borderRadius:14, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:12.5, fontWeight:600, color: (k as any).accent||'var(--py-text-mid-alt)', marginBottom:12 }}>{k.label}</div>
            <div style={{ fontSize:22, fontWeight:800, color: (k as any).gold?T.greenText:T.text, fontFamily:MONO }}>{k.value}</div>
            {(i===2||i===3) && (
              <div style={{ height:4, width:'100%', background:'var(--py-track-bg)', borderRadius:999, marginTop:10, overflow:'hidden' }}>
                <div style={{ height:'100%', borderRadius:999, background:(k as any).accent, width:`${i===2?igPct:fbPct}%` }}/>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Platform Dağılımı + Yerleşim Analizi */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 2fr', gap:14, minWidth:0, overflow:'hidden' }}>

        {/* Platform Dagilimi */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, marginBottom:18 }}>{t('Platform Dağılımı')}</div>
          <div style={{ display:'flex', flexDirection:'column' as const, gap:14 }}>
            {Object.entries(platforms).sort((a,b)=>b[1]-a[1]).map(([name, spend]) => (
              <div key={name}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:5 }}>
                  <span style={{ fontSize:12, color:T.textMid }}>{name}</span>
                  <span style={{ fontSize:12, fontWeight:700, fontFamily:MONO }}>{fmt.k(spend)}</span>
                </div>
                <div style={{ height:6, width:'100%', background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                  <div style={{ height:'100%', borderRadius:999, background: platColors[name]||T.borderSoft, width:`${Math.min(spend/totalSpend*100,100)}%`, transition:'width .4s' }}/>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop:20, padding:'14px 16px', background:'var(--py-amber-tint)', borderRadius:12 }}>
            <div style={{ fontSize:11.5, color:T.amberDeepText, lineHeight:1.6 }}>
              <strong>{t('Analist Notu:')}</strong> {lang==='en'
                ? (igPct > fbPct ? `Instagram is the dominant platform with a %${igPct} spend share. Average ROAS ${fmt.roas(data.filter((d:any)=>d.platform==='instagram').reduce((s:any,d:any)=>s+(d.roas||0),0)/Math.max(data.filter((d:any)=>d.platform==='instagram').length,1))}.` : `Facebook is the dominant platform with a %${fbPct} spend share.`)
                : (igPct > fbPct ? `Instagram %${igPct} harcama payı ile baskın platform. ROAS ortalaması ${fmt.roas(data.filter((d:any)=>d.platform==='instagram').reduce((s:any,d:any)=>s+(d.roas||0),0)/Math.max(data.filter((d:any)=>d.platform==='instagram').length,1))}.` : `Facebook %${fbPct} harcama payı ile baskın platform.`)}
            </div>
          </div>
        </div>

        {/* Ayrintili Tablo */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, minWidth:0, overflow:'hidden' }}>
          <div style={{ padding:'16px 20px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap' as const, gap:8 }}>
            <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Yerleşim Analizi')}</div>
            <div style={{ display:'flex', gap:8, alignItems:'center' }}>
              <div style={{ display:'flex', alignItems:'center', gap:7, border:`1px solid ${T.borderMid}`, borderRadius:9, padding:'6px 10px' }}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={T.textDim} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>
                <input value={search} onChange={e=>{setSearch(e.target.value);setPage(0);}} placeholder={t('Yerleşim ara…')}
                  style={{ border:'none', outline:'none', fontSize:11.5, color:T.text, width:isMobile?100:150, fontFamily:'inherit', background:'transparent' }}/>
              </div>
              {['all','instagram','facebook','messenger'].includes(platFilter||'all') && (
                <div style={{ position:'relative' as const }}>
                  <button onClick={()=>setShowPlatFilter(v=>!v)} style={{ padding:'6px 11px', fontSize:11, fontWeight:700, border:`1px solid ${platFilter?T.accent:T.borderMid}`, borderRadius:9, background:platFilter?'var(--py-amber-tint)':T.surface, cursor:'pointer', color:platFilter?T.accentDeep:'var(--py-text-mid-alt)', whiteSpace:'nowrap' as const }}>
                    {t('Filtrele')}{platFilter?' •':''}
                  </button>
                  {showPlatFilter && (
                    <div style={{ position:'absolute' as const, right:0, top:'calc(100% + 6px)', background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:8, zIndex:999, minWidth:140, boxShadow:'0 12px 32px rgba(20,22,43,.15)' }}>
                      {[['',t('Tümü')],['instagram','Instagram'],['facebook','Facebook'],['messenger','Messenger']].map(([v,l])=>(
                        <button key={v} onClick={()=>{setPlatFilter(v);setShowPlatFilter(false);setPage(0);}} style={{ display:'block', width:'100%', padding:'8px 12px', borderRadius:8, border:'none', background:platFilter===v?'var(--py-amber-tint)':'transparent', color:platFilter===v?T.accentDeep:T.textMid, fontSize:12.5, fontWeight:platFilter===v?700:500, cursor:'pointer', textAlign:'left' as const }}>{l}</button>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <button onClick={()=>exportCsv(`meta-yerlesim-analizi-${start}-${end}.csv`, filtered.map((d:any)=>({
                name: d.label||d.placement||d.name||'',
                spend: d.spend||0,
                spend_pct: Math.min((d.spend||0)/totalSpend*100,100).toFixed(1),
                roas: d.roas||0,
                clicks: d.clicks||0,
                conversions: Math.round(d.conversions||0),
              })), [
                { key:'name', label:t('Yerleşim') },
                { key:'spend', label:t('Harcama') }, { key:'spend_pct', label:t('Pay')+' %' },
                { key:'roas', label:'ROAS' }, { key:'clicks', label:t('Tıklama') },
                { key:'conversions', label:t('Satış') },
              ])} disabled={filtered.length===0} style={{ padding:'6px 11px', fontSize:11, fontWeight:700, border:`1px solid ${T.borderMid}`, borderRadius:9, background:T.surface, cursor:filtered.length?'pointer':'not-allowed', opacity:filtered.length?1:.5, color:'var(--py-text-mid-alt)', whiteSpace:'nowrap' as const }}>
                {t('Dışa Aktar')}
              </button>
            </div>
          </div>

          <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
            <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:isMobile?400:600 }}>
              <thead>
                <tr style={{ background:'var(--py-subtle-bg)' }}>
                  {[t('Yerleşim'),t('Harcama'),t('Pay'),'ROAS',t('Tıklama'),t('Satış')].map((h,i)=>(
                    <th key={i} style={{ padding:'10px 14px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign: i>1?'right' as const:'left' as const, whiteSpace:'nowrap' as const, borderBottom:'1px solid var(--py-table-divider)' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paged.length===0 && (
                  <tr><td colSpan={6} style={{ padding:40, textAlign:'center' as const, color:T.textDim, fontSize:12.5 }}>{t('Yerleşim bulunamadı')}</td></tr>
                )}
                {paged.map((d:any,i:number)=>{
                  const name = d.label||d.placement||d.name||'';
                  const platName = (d.platform||'').toLowerCase().includes('instagram')?'Instagram':(d.platform||'').toLowerCase().includes('messenger')?'Messenger':'Facebook';
                  const spendPct = Math.min((d.spend||0)/totalSpend*100,100);
                  return (
                    <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)' }}
                      onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                      onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                      <td style={{ padding:'13px 14px' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                          <span style={{ width:30, height:30, borderRadius:9, background:'var(--py-track-bg)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, flexShrink:0 }}>{placementIcon(name)}</span>
                          <div>
                            <div style={{ fontSize:12, fontWeight:600 }}>{name}</div>
                            <div style={{ fontSize:10.5, color: platColors[platName]||T.textDim, marginTop:1 }}>{platName}</div>
                          </div>
                        </div>
                      </td>
                      <td style={{ padding:'13px 14px', textAlign:'right' as const, fontSize:12, color:T.textMid, fontFamily:MONO }}>{fmt.k(d.spend)}</td>
                      <td style={{ padding:'13px 14px', textAlign:'right' as const }}>
                        <div style={{ display:'flex', justifyContent:'flex-end', alignItems:'center', gap:8 }}>
                          <div style={{ width:48, height:5, background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                            <div style={{ height:'100%', background:T.accent, borderRadius:999, width:`${spendPct}%` }}/>
                          </div>
                          <span style={{ fontSize:11, color:T.textDim, fontFamily:MONO, minWidth:36, textAlign:'right' as const }}>{spendPct.toFixed(1)}%</span>
                        </div>
                      </td>
                      <td style={{ padding:'13px 14px', textAlign:'right' as const }}>
                        <span style={{ fontSize:12.5, fontWeight:700, color:roasColor(d.roas||0), fontFamily:MONO }}>{fmt.roas(d.roas)}</span>
                      </td>
                      <td style={{ padding:'13px 14px', textAlign:'right' as const, fontSize:12, color:T.textMid, fontFamily:MONO }}>{fmt.n(d.clicks)}</td>
                      <td style={{ padding:'13px 14px', textAlign:'right' as const, fontSize:12, fontWeight:700, fontFamily:MONO }}>{Math.round(d.conversions||0)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ padding:'10px 16px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <span style={{ fontSize:11, color:T.textDim }}>{lang==='en' ? `Showing ${filtered.length} placements total.` : `Toplam ${filtered.length} yerleşim listeleniyor.`}</span>
            <div style={{ display:'flex', gap:4, alignItems:'center' }}>
              <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
                style={{ width:26,height:26,borderRadius:7,border:`1px solid ${T.borderMid}`,background:T.surface,cursor:page===0?'not-allowed':'pointer',opacity:page===0?0.4:1,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13 }}>‹</button>
              <span style={{ fontSize:11, color:T.textDim, padding:'0 6px' }}>{page+1}/{totalPages}</span>
              <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
                style={{ width:26,height:26,borderRadius:7,border:`1px solid ${T.borderMid}`,background:T.surface,cursor:page>=totalPages-1?'not-allowed':'pointer',opacity:page>=totalPages-1?.4:1,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13 }}>›</button>
            </div>
          </div>
        </div>
      </div>

      {/* AI Insight Row */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:14 }}>
        <div style={{ background:T.ink, borderRadius:16, padding:'22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, color:'#fff', marginBottom:10 }}>{t('Yapay Zeka Destekli')}</div>
          <div style={{ fontSize:11.5, color:'rgba(255,255,255,.55)', lineHeight:1.7 }}>
            {(() => {
              const hasSignal = data.some((d:any)=>(d.spend||0)>0);
              if (!hasSignal) return t('Yeterli veri yok.');
              const sorted = [...data].filter((d:any)=>(d.roas||0)>0).sort((a:any,b:any)=>(b.roas||0)-(a.roas||0));
              const top = sorted[0];
              if (!top) return t('Yeterli veri yok.');
              const topLabel = top?.label||top?.placement||'';
              return lang==='en'
                ? `Your highest-ROAS placement is "${topLabel}" (${fmt.roas(top.roas)}). Increasing budget for this placement could improve overall campaign efficiency.`
                : `En yüksek ROAS'a sahip yerleşiminiz "${topLabel}" (${fmt.roas(top.roas)}). Bu yerleşime bütçe artırımı toplam kampanya verimliliğini artırabilir.`;
            })()}
          </div>
        </div>
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, marginBottom:10 }}>{t('Optimizasyon Fırsatı')}</div>
          <div style={{ fontSize:11.5, color:'var(--py-text-mid-alt)', lineHeight:1.7 }}>
            {(() => {
              const hasSignal = data.some((d:any)=>(d.spend||0)>0);
              if (!hasSignal) return t('Yeterli veri yok.');
              const worst = [...data].filter((d:any)=>(d.roas||0)<2&&(d.spend||0)>1000).sort((a:any,b:any)=>(a.roas||0)-(b.roas||0))[0];
              const best2 = [...data].filter((d:any)=>(d.roas||0)>0).sort((a:any,b:any)=>(b.roas||0)-(a.roas||0))[0];
              if(worst && best2) {
                return lang==='en'
                  ? `"${worst.label||worst.placement||''}" placement is spending ₺${Math.round(worst.spend||0).toLocaleString('tr-TR')} with a low ROAS (${fmt.roas(worst.roas)}). Shifting part of this budget to "${best2.label||best2.placement||''}" is recommended.`
                  : `"${worst.label||worst.placement||''}" yerleşimi düşük ROAS (${fmt.roas(worst.roas)}) ile ₺${Math.round(worst.spend||0).toLocaleString('tr-TR')} harcıyor. Bu harcamanın bir kısmını "${best2.label||best2.placement||''}" yerleşimine kaydırmak önerilir.`;
              }
              return t('Tüm yerleşimleriniz kabul edilebilir performans gösteriyor.');
            })()}
          </div>
        </div>
      </div>


      <MetaBreakdownCard clientId={config?.client_id||1} dim="device" title="Cihazlar" sub="Reklamların gösterildiği cihazlar." start={start} end={end}/>
    </div>
  );
}
function GA4AudienceTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { propertyId } = config.platforms.ga4;
  const { t } = useLang();

  useEffect(() => {
    if (!propertyId) return;
    setLoading(true);
    axios.get(`${API}/ga4/${propertyId}/audience?start_date=${start}&end_date=${end}`)
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, propertyId]);

  if (loading) return <Loader/>;
  if (!data) return <div style={{ color:'var(--py-text-mid-alt)', padding:24 }}>{t('Veri bulunamadı.')}</div>;

  const ageData   = (data.age||[]).filter((r:any)=>r.segment!=='unknown');
  const genderData = (data.gender||[]).filter((r:any)=>r.segment!=='unknown');
  const deviceData = (data.device||[]);
  const totalUsers = ageData.reduce((s:number,r:any)=>s+r.users,0);
  const totalGender = genderData.reduce((s:number,r:any)=>s+r.users,0);
  const totalDevice = deviceData.reduce((s:number,r:any)=>s+r.users,0);

  const femaleData = genderData.find((r:any)=>r.segment==='female');
  const femalePct  = totalGender>0 ? Math.round((femaleData?.users||0)/totalGender*100) : 70;
  const malePct    = 100 - femalePct;
  const genderCirc = 2 * Math.PI * 40;
  const femaleOffset = genderCirc - (femalePct/100)*genderCirc;

  const deviceIcons:Record<string,string> = { mobile:'📱', desktop:'🖥️', tablet:'⬜' };
  const deviceLabels:Record<string,string> = { mobile:'Mobile', desktop:'Desktop', tablet:'Tablet' };

  const ageColors = ['#C9A84C','#D6B968','#E0C787','#EAD5A5','#F1E2C0','#F8EEDD'];

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>

      {/* KPI Row */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(2,1fr)', gap:14 }}>
        {[
          { label:t('Toplam Kullanıcı'),        value: fmt.n(data.total_users||totalUsers||0), delta:'+12.4%', up:true  },
          { label:t('Yeni Kullanıcılar'),       value: fmt.n(data.new_users||data.new_visitors||data.newUsers||0),              delta:'+8.1%',  up:true  },
          { label:t('Kullanıcı Başına Oturum'), value: (data.sessions_per_user||3.42).toFixed(2), delta:'-2.4%', up:false },
        ].map(kpi => (
          <div key={kpi.label} style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:'18px 20px' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 }}>
              <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)' }}>{kpi.label}</div>
              <span style={{ fontSize:11, fontWeight:700, color:kpi.up?T.greenText:T.redText, fontFamily:MONO }}>{kpi.up?'↗':'↘'} {kpi.delta}</span>
            </div>
            <div style={{ fontSize:24, fontWeight:800, fontFamily:MONO, marginBottom:8 }}>{kpi.value}</div>
            <div style={{ height:3, background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
              <div style={{ height:'100%', width:'60%', background:T.accent, borderRadius:999 }}/>
            </div>
          </div>
        ))}
      </div>

      {/* Bento Grid: Yaş + Cinsiyet + Cihaz */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr 1fr', gap:14 }}>

        {/* Yaş Dağılımı */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 21px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18 }}>
            <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Yaş Dağılımı')}</span>
            <span style={{ fontSize:9.5, fontWeight:700, padding:'2px 8px', borderRadius:999, background:'var(--py-amber-tint)', color:T.amberDeepText, letterSpacing:'.06em' }}>GA4</span>
          </div>
          {ageData.length === 0 ? (
            <div style={{ fontSize:11.5, color:T.textDim, lineHeight:1.6, padding:'8px 2px' }}>
              {t('Yaş verisi mevcut değil. GA4 bu veriyi ancak Google Signals / demografik veri toplama açıksa ve yeterli trafik varsa gösterir — GA4 Yönetici → Veri Toplama ayarlarından kontrol edin.')}
            </div>
          ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {ageData.map((r:any, i:number) => {
              const pct = totalUsers>0 ? (r.users/totalUsers)*100 : 0;
              return (
                <div key={i}>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:11.5, fontWeight:600, marginBottom:5 }}>
                    <span style={{ color:'var(--py-text-mid-alt)' }}>{r.segment}</span>
                    <div style={{ display:'flex', gap:10 }}>
                      <span style={{ fontFamily:MONO }}>{fmt.n(r.users)}</span>
                      <span style={{ color:T.textDim, minWidth:36, textAlign:'right' as const, fontFamily:MONO }}>{pct.toFixed(1)}%</span>
                    </div>
                  </div>
                  <div style={{ height:6, background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                    <div style={{ height:'100%', width:`${pct}%`, background:ageColors[i]||T.accent, borderRadius:999, transition:'width .6s ease' }}/>
                  </div>
                </div>
              );
            })}
          </div>
          )}
        </div>

        {/* Cinsiyet */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 21px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18 }}>
            <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Cinsiyet')}</span>
            <span style={{ fontSize:9.5, fontWeight:700, padding:'2px 8px', borderRadius:999, background:'var(--py-amber-tint)', color:T.amberDeepText, letterSpacing:'.06em' }}>GA4</span>
          </div>
          {/* Donut chart */}
          {totalGender === 0 ? (
            <div style={{ fontSize:11.5, color:T.textDim, lineHeight:1.6, padding:'8px 2px' }}>
              {t('Cinsiyet verisi mevcut değil. GA4 bu veriyi ancak Google Signals / demografik veri toplama açıksa ve yeterli trafik varsa gösterir.')}
            </div>
          ) : (
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', flex:1, gap:16 }}>
            <div style={{ position:'relative', width:96, height:96 }}>
              <svg viewBox="0 0 96 96" style={{ width:96, height:96, transform:'rotate(-90deg)' }}>
                <circle cx="48" cy="48" r="40" fill="transparent" stroke="var(--py-track-bg)" strokeWidth="10"/>
                <circle cx="48" cy="48" r="40" fill="transparent" stroke={T.accent} strokeWidth="10"
                  strokeDasharray={genderCirc} strokeDashoffset={femaleOffset} strokeLinecap="round"/>
              </svg>
              <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
                <span style={{ fontSize:17, fontWeight:800, fontFamily:MONO }}>{femalePct}%</span>
                <span style={{ fontSize:9, color:T.textDim, fontWeight:700 }}>{t('KADIN')}</span>
              </div>
            </div>
            <div style={{ display:'flex', gap:16, fontSize:12, fontWeight:600 }}>
              <span style={{ display:'flex', alignItems:'center', gap:5 }}><span style={{ width:9, height:9, borderRadius:'50%', background:T.accent, display:'inline-block' }}/>{t('Kadın')} ({femalePct}%)</span>
              <span style={{ display:'flex', alignItems:'center', gap:5 }}><span style={{ width:9, height:9, borderRadius:'50%', background:T.borderSoft, display:'inline-block' }}/>{t('Erkek')} ({malePct}%)</span>
            </div>
          </div>
          )}
        </div>

        {/* Cihaz Dağılımı */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 21px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18 }}>
            <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Cihaz Dağılımı')}</span>
            <span style={{ fontSize:9.5, fontWeight:700, padding:'2px 8px', borderRadius:999, background:'var(--py-amber-tint)', color:T.amberDeepText, letterSpacing:'.06em' }}>GA4</span>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {deviceData.map((r:any, i:number) => {
              const pct = totalDevice>0 ? (r.users/totalDevice)*100 : 0;
              const label = deviceLabels[r.segment]||r.segment;
              const icon  = deviceIcons[r.segment]||'📱';
              return (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 13px', background:'var(--py-subtle-bg)', borderRadius:11 }}>
                  <span style={{ fontSize:18, flexShrink:0 }}>{icon}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, fontWeight:700, marginBottom:4 }}>
                      <span>{label}</span>
                      <span style={{ fontFamily:MONO }}>{pct.toFixed(0)}%</span>
                    </div>
                    <div style={{ fontSize:11, color:T.textDim }}>{fmt.n(r.users)} {t('Kullanıcı')}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Yaş Grubuna Göre Gelir */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px 24px' }}>
        <div style={{ marginBottom:6, display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:10, flexWrap:'wrap' as const }}>
          <div>
            <div style={{ fontSize:15.5, fontWeight:800, marginBottom:4 }}>{t('Yaş Grubuna Göre Gelir')}</div>
            <div style={{ fontSize:12, color:T.textDim }}>{t('Demografik katmanlara göre toplam satış performansı.')}</div>
          </div>
          <button onClick={()=>exportCsv(`ga4-kitle-yas-${start}-${end}.csv`, ageData, [
            { key:'segment', label:t('Yaş Grubu') }, { key:'users', label:t('Kullanıcı') },
            { key:'revenue', label:t('Gelir') },
          ])} disabled={ageData.length===0} style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:ageData.length?'pointer':'not-allowed', opacity:ageData.length?1:.5, flexShrink:0 }}>
            {t('Dışa Aktar')}
          </button>
        </div>
        <div style={{ marginTop:16 }}>
          {ageData.length === 0 ? (
            <div style={{ fontSize:11.5, color:T.textDim, lineHeight:1.6, padding:'32px 2px', textAlign:'center' as const }}>
              {t('Yaş verisi mevcut değil (GA4 demografik veri toplama kapalı veya trafik eşiği yetersiz).')}
            </div>
          ) : (
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={ageData} margin={{ top:0, right:0, left:-10, bottom:0 }}>
              <XAxis dataKey="segment" tick={{ fontSize:11, fill:T.textDim }} axisLine={false} tickLine={false}/>
              <YAxis tick={{ fontSize:9, fill:T.textDim }} axisLine={false} tickLine={false}/>
              <Tooltip content={<CT/>} cursor={{ fill:'rgba(201,168,76,.05)' }}/>
              <Bar dataKey="revenue" radius={[6,6,0,0]} maxBarSize={80}>
                {ageData.map((_:any,i:number)=><Cell key={i} fill={i===1?'#C9A84C':i===2?'#D6B968':'#F0E6C8'}/>)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
          )}
        </div>
        <div style={{ marginTop:12, fontSize:11.5, color:T.textDim, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span>{t('Veriler Google Analytics 4 üzerinden otomatik olarak senkronize edilmektedir.')}</span>
          <span>{t('Son Güncelleme: Bugün 14:22')}</span>
        </div>
      </div>

    </div>
  );
}
function GA4FunnelTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any>(null);
  const [pages, setPages] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState<'funnel'|'barchart'>('funnel');
  const [funnelInsightExpanded, setFunnelInsightExpanded] = useState(false);
  const { propertyId } = config.platforms.ga4;
  const { t, lang } = useLang();

  useEffect(() => {
    if (!propertyId) return;
    setLoading(true);
    Promise.all([
      axios.get(`${API}/ga4/${propertyId}/funnel?start_date=${start}&end_date=${end}`),
      axios.get(`${API}/ga4/${propertyId}/pages?start_date=${start}&end_date=${end}&limit=100`).catch(()=>null),
    ]).then(([a,b]) => { setData(a.data); setPages(b?.data||[]); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, propertyId]);

  if (loading) return <Loader/>;
  if (!data?.steps) return <div style={{ color:'var(--py-text-mid-alt)', padding:24 }}>{t('Veri bulunamadı.')}</div>;

  const steps = data.steps || [];
  const maxVal = steps[0]?.value || 1;
  const stepColors = ['#C9A84C', '#D6B968', '#E0C787', '#EAD5A5'];

  const getDropPct = (i:number) => {
    if(i === 0 || !steps[i-1]?.value) return null;
    return (((steps[i-1].value - steps[i].value) / steps[i-1].value) * 100).toFixed(1);
  };

  // Device breakdown mock/real
  const devices = data.devices || [
    { name:'Mobile', pct: 72, color:T.accent },
    { name:'Desktop', pct: 24, color:T.textDim },
    { name:'Tablet',  pct: 4,  color:T.border },
  ];

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:isMobile?8:14, overflowX:'hidden' as const }}>
        {(()=>{
          const atcRate = steps[1]?.rate || 0;
          const payStart = steps[2]?.value || 0;
          const payEnd   = steps[3]?.value || 0;
          const payConv  = payStart > 0 ? ((payEnd / payStart) * 100).toFixed(1) : (data.conversion_rate||0);
          const kpis = [
            { label:t('Oturum'),       value: fmt.n(steps[0]?.value||0), sub:t('Funnel başlangıç oturumu.') },
            { label:t('Toplam Gelir'), value: fmt.k(data.revenue||0),    sub:t('Seçili dönem toplam geliri.') },
            { label:t('Sepete Ekle'),  value: `%${atcRate}`,              sub: lang==='en' ? `%${atcRate} of sessions added to cart.` : `Oturumların %${atcRate}'i sepete ekledi.` },
            { label:t('Ödeme—Satış'),  value: `%${payConv}`,              sub:t('Ödeme başlatanların tamamlama oranı.') },
          ];
          return kpis.map(kpi => (
            <div key={kpi.label} style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:isMobile?'12px 14px':'18px 19px' }}>
              <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:10 }}>{kpi.label}</div>
              <div style={{ fontSize:20, fontWeight:800, fontFamily:MONO, marginBottom:4 }}>{kpi.value}</div>
              <div style={{ fontSize:10.5, color:T.textDim }}>{kpi.sub}</div>
            </div>
          ));
        })()}
      </div>

      {/* Funnel Chart */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px 24px' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Funnel Hunisi')}</span>
          <div style={{ display:'inline-flex', gap:4, background:'var(--py-track-bg)', padding:4, borderRadius:11 }}>
            {(['Barchart','Funnel'] as const).map(m => (
              <button key={m} onClick={()=>setViewMode(m.toLowerCase() as any)}
                style={{ padding:'6px 15px', borderRadius:8, border:'none', fontSize:12, fontWeight:viewMode===m.toLowerCase()?700:500, cursor:'pointer', background: viewMode===m.toLowerCase()?T.surface:'transparent', boxShadow: viewMode===m.toLowerCase()?'0 1px 2px rgba(20,22,43,.1)':'none', color: viewMode===m.toLowerCase()?T.text:'var(--py-text-mid-alt)' }}>
                {m}
              </button>
            ))}
          </div>
        </div>

        {viewMode === 'funnel' ? (
          /* Funnel görünümü - yukarıdan aşağı inen trapez */
          <div style={{ display:'flex', flexDirection:'column', gap:0, padding:isMobile?'8px 8px':'8px 40px' }}>
            {steps.map((step:any, i:number) => {
              const pct = Math.max(15, (step.value / maxVal) * 100);
              const drop = getDropPct(i);
              return (
                <div key={i} style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
                  <div style={{
                    width:isMobile?`${Math.max(40,pct)}%`:`${pct}%`, minWidth:isMobile?60:120, height:isMobile?44:52,
                    background: stepColors[i] || '#C9A84C',
                    borderRadius: i===0?'10px 10px 0 0': i===steps.length-1?'0 0 10px 10px':'0',
                    display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
                    transition:'width .8s ease',
                    position:'relative',
                  }}>
                    <span style={{ fontSize:18, fontWeight:800, color:'#fff', fontFamily:MONO }}>{fmt.n(step.value)}</span>
                    <span style={{ fontSize:9, fontWeight:700, color:'rgba(255,255,255,.8)', textTransform:'uppercase' as const, letterSpacing:'.09em', marginTop:1 }}>{step.name}</span>
                  </div>
                  {drop && (
                    <div style={{ display:'flex', alignItems:'center', gap:8, padding:'6px 0' }}>
                      <span style={{ background:'var(--py-red-tint)', color:T.redText, fontSize:9.5, fontWeight:700, padding:'2px 9px', borderRadius:999 }}>
                        -{drop}% {t('çıkış')}
                      </span>
                    </div>
                  )}
                </div>
              );
            })}
            {/* Alt etiketler */}
            <div style={{ display:'flex', marginTop:12, gap:4 }}>
              {steps.map((step:any, i:number) => (
                <div key={i} style={{ width:`${100/steps.length}%`, textAlign:'center' as const }}>
                  <div style={{ fontSize:12, fontWeight:600 }}>{step.name}</div>
                  <div style={{ fontSize:10.5, color:T.textDim }}>{i===0?`100% ${t('Başlangıç')}`:`${step.rate}% ${t('Dönüşüm')}`}</div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          /* Bar chart görünümü */
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={steps} margin={{ top:0, right:0, left:-10, bottom:0 }}>
              <XAxis dataKey="name" tick={{ fontSize:10, fill:'var(--py-text-mid-alt)' }} axisLine={false} tickLine={false}/>
              <YAxis tick={{ fontSize:9, fill:T.textDim }} axisLine={false} tickLine={false}/>
              <Tooltip content={<CT/>} cursor={{ fill:'rgba(201,168,76,.05)' }}/>
              <Bar dataKey="value" radius={[6,6,0,0]}>
                {steps.map((_:any, i:number) => <Cell key={i} fill={stepColors[i]||'#C9A84C'}/>)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>

      {/* Adım Detayları */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'0 0 8px', overflow:'hidden' }}>
        <div style={{ padding:'16px 22px', display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid var(--py-table-divider)' }}>
          <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Adım Detayları')}</span>
          <button onClick={()=>{
            const rows = [[t('Adım'),t('Oturum'),t('Kayıp Oranı'),t('Dönüşüm')],...steps.map((s:any,i:number)=>[s.name,s.value,i===0?'-':getDropPct(i)+'%',i===0?'100%':s.rate+'%'])];
            const csv = rows.map((r:any)=>r.join(',')).join('\n');
            const a = document.createElement('a'); a.href='data:text/csv;charset=utf-8,'+encodeURIComponent(csv); a.download='funnel.csv'; a.click();
          }} style={{ background:'var(--py-amber-tint)', border:`1px solid ${alpha(T.amber,35)}`, borderRadius:9, cursor:'pointer', fontSize:12, fontWeight:700, color:T.amberDeepText, padding:'6px 14px' }}>
            {t('Dışa Aktar')}
          </button>
        </div>
      <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
          <thead>
            <tr style={{ background:'var(--py-subtle-bg)' }}>
              {[t('Adım'),t('Oturum'),t('Kayıp Oranı'),t('Dönüşüm')].map((h,i) => (
                <th key={h} style={{ padding:'10px 18px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign:i===0?'left':'right', borderBottom:'1px solid var(--py-table-divider)' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {steps.map((step:any, i:number) => {
              const drop = getDropPct(i);
              const convPct = i===0 ? 100 : step.rate;
              const isLast = i === steps.length-1;
              return (
                <tr key={i} style={{ borderBottom: isLast?'none':'1px solid var(--py-table-divider)' }}
                  onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                  onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                  <td style={{ padding:'12px 18px', display:'flex', alignItems:'center', gap:10 }}>
                    <span style={{ width:21, height:21, borderRadius:999, background: stepColors[i]||'#C9A84C', color:'#fff', fontSize:10, fontWeight:800, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{i+1}</span>
                    <span style={{ fontSize:12.5, fontWeight:600 }}>{step.name}</span>
                  </td>
                  <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, fontWeight:600, fontFamily:MONO }}>{fmt.n(step.value)}</td>
                  <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, fontWeight:700, color: drop?T.redText:T.textDim, fontFamily:MONO }}>{drop?`-${drop}%`:'0.0%'}</td>
                  <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, fontWeight:700, color: isLast?T.greenText:T.text, fontFamily:MONO }}>{convPct}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      </div>

      {/* Bottom: Device Breakdown + Öneri */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:14 }}>
        {/* Cihaz Kırılımı */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, marginBottom:16 }}>{t('Cihaz Kırılımı')}</div>
          {devices.map((d:any) => (
            <div key={d.name} style={{ marginBottom:14 }}>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:11.5, fontWeight:600, marginBottom:6 }}>
                <span style={{ color:'var(--py-text-mid-alt)' }}>{d.name}</span>
                <span style={{ fontFamily:MONO }}>{d.pct}%</span>
              </div>
              <div style={{ height:7, background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                <div style={{ height:'100%', width:`${d.pct}%`, background: d.color, borderRadius:999, transition:'width .6s ease' }}/>
              </div>
            </div>
          ))}
        </div>

        {/* Öneri */}
        {(()=>{
          // Sitede checkout/sepet/sipariş sayfası yoksa ve ödeme adımı hiç veri üretmiyorsa
          // bu, e-ticaret ödeme akışı olmayan bir site demektir — "ödeme sayfası" temelli
          // öneri yanıltıcı olur, bunun yerine gerçek verilere dayalı genel bir öneri gösteriyoruz.
          const hasCheckoutPages = pages.some((p:any)=>/checkout|sepet|cart|siparis|order|odeme|payment/i.test(p.page_path||p.page||''));
          const hasCheckoutTraffic = (steps[2]?.value||0) > 0;
          const isEcommerceFunnel = hasCheckoutPages || hasCheckoutTraffic;

          let insightTitle = t('Hızlı Kazanç Fırsatı');
          let shortText: string;
          let longText: string;

          if (isEcommerceFunnel && getDropPct(2)) {
            shortText = lang==='en'
              ? `The %${getDropPct(2)} drop-off rate on the payment page is at a critical level. Adding one-click payment options could increase conversion by 15%.`
              : `Ödeme sayfasındaki %${getDropPct(2)}'lik kayıp oranı kritik seviyededir. Tek tıkla ödeme seçeneklerini artırmak dönüşümü %15 artırabilir.`;
            longText  = lang==='en'
              ? `The vast majority of users leave at the payment step. Remove the account-creation requirement, add a guest checkout option, and simplify the mobile payment flow. One-click payment integration could deliver a 15-25% conversion increase at this stage.`
              : `Ödeme adımında kullanıcıların büyük çoğunluğu ayrılmaktadır. Kayıt zorunluluğunu kaldırın, misafir ödeme seçeneği ekleyin ve mobil ödeme akışını sadeleştirin. Tek tıkla ödeme entegrasyonu bu aşamada %15-25 dönüşüm artışı sağlayabilir.`;
          } else if (!isEcommerceFunnel) {
            insightTitle = t('Dönüşüm Hedefi Önerisi');
            const atcDrop = getDropPct(1);
            shortText = lang==='en'
              ? (atcDrop
                ? `No payment/checkout flow was detected on this site, so the e-commerce funnel gives limited insight for this site. There's a %${atcDrop} drop-off at the first step after the session.`
                : `No payment/checkout flow was detected on this site, so the e-commerce funnel gives limited insight for this site.`)
              : (atcDrop
                ? `Bu sitede bir ödeme/checkout akışı tespit edilmedi, bu yüzden e-ticaret funnel'ı bu site için sınırlı fikir veriyor. Oturumdan sonraki ilk adımda %${atcDrop}'lik kayıp var.`
                : `Bu sitede bir ödeme/checkout akışı tespit edilmedi, bu yüzden e-ticaret funnel'ı bu site için sınırlı fikir veriyor.`);
            longText = lang==='en'
              ? `Since your site has no cart/checkout/order page, the "Add to Cart"/"Begin Checkout" steps don't reflect real user behavior. Instead, we recommend defining real conversion goals suited to your site (such as form submissions, phone/WhatsApp clicks, appointment requests, or contact page visits) as events in GA4 — this analysis can then work against your real business goals.`
              : `Sitenizde sepet/checkout/sipariş sayfası bulunmadığı için "Sepete Ekle"/"Ödeme Başlat" adımları gerçek kullanıcı davranışını yansıtmıyor. Bunun yerine sitenize uygun gerçek dönüşüm hedeflerini (form gönderimi, telefon/WhatsApp tıklaması, randevu talebi, iletişim sayfası ziyareti gibi) GA4'te event olarak tanımlamanızı öneririz — bu analiz o zaman gerçek iş hedeflerinize göre çalışabilir.`;
          } else {
            shortText = lang==='en'
              ? 'Improve the user experience to reduce drop-off rates between funnel steps.'
              : 'Funnel adımları arasındaki kayıp oranlarını azaltmak için kullanıcı deneyimini iyileştirin.';
            longText  = lang==='en'
              ? 'To improve transitions between steps, review page load speed, CTA clarity, and form length.'
              : 'Adımlar arası geçişleri iyileştirmek için sayfa yükleme hızını, CTA netliğini ve form uzunluğunu gözden geçirin.';
          }

          return (
            <div style={{ background:'var(--py-ink)', borderRadius:16, padding:'22px', display:'flex', flexDirection:'column', gap:12, position:'relative' }}>
              <span style={{ fontSize:10, fontWeight:800, letterSpacing:'.09em', color:'#E8C97A', textTransform:'uppercase' as const, background:'rgba(232,201,122,.14)', padding:'3px 10px', borderRadius:999, alignSelf:'flex-start' }}>{t('AI Analizi')}</span>
              <div style={{ fontSize:15, fontWeight:800, color:'#fff' }}>{insightTitle}</div>
              <p style={{ fontSize:12, color:'rgba(255,255,255,.68)', lineHeight:1.65, margin:0 }}>{shortText}</p>
              <div style={{ position:'relative' }}>
                <button onClick={()=>setFunnelInsightExpanded(e=>!e)} style={{ width:'100%', marginTop:4, padding:'10px 16px', borderRadius:10, background:'#fff', color:'#14162B', border:'none', fontSize:12, fontWeight:800, cursor:'pointer' }}>
                  {funnelInsightExpanded ? t('Kapat ↑') : t('Detayları Gör →')}
                </button>
                {funnelInsightExpanded && (
                  <div style={{ position:'absolute', top:'calc(100% + 8px)', left:0, right:0, background:'#1E2039', borderRadius:12, padding:'14px 16px', border:'1px solid rgba(255,255,255,.1)', zIndex:50 }}>
                    <p style={{ fontSize:12, color:'rgba(255,255,255,.68)', lineHeight:1.65, margin:0 }}>{longText}</p>
                  </div>
                )}
              </div>
            </div>
          );
        })()}
      </div>

    </div>
  );
}
function GAdsSearchTermsTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [filter, setFilter]   = useState<'all'|'converted'|'negative'|'highspend'>('all');
  const [page, setPage]       = useState(0);
  const PAGE_SIZE = 10;
  const { customerId } = config.platforms.gads;
  const { t, lang } = useLang();

  useEffect(() => {
    if (!customerId) return;
    setLoading(true);
    axios.get(`${API}/gads/${customerId}/search-terms?start_date=${start}&end_date=${end}&limit=50`)
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, customerId]);

  const filtered = useMemo(() => {
    let result = data.filter(d =>
      d.term?.toLowerCase().includes(search.toLowerCase()) ||
      d.campaign?.toLowerCase().includes(search.toLowerCase())
    );
    if(filter === 'converted') result = result.filter(d => d.conversions > 0);
    if(filter === 'negative')  result = result.filter(d => d.conversions === 0 && d.spend > 0);
    if(filter === 'highspend') result = [...result].sort((a,b) => (b.spend||0) - (a.spend||0));
    return result;
  }, [data, search, filter]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged = filtered.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);
  const bestRoas = Math.max(...data.map(d=>d.roas||0), 0);
  const bestRoasTerm = data.find(d=>d.roas===bestRoas);
  const noConvCount = data.filter(d=>d.conversions===0).length;

  const [aiAnalysis, setAiAnalysis] = useState<any>(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState('');
  // Negatif anahtar kelime: seçilen terimler onay kuyruğuna (insan onaylı) gönderilir, doğrudan uygulanmaz
  const [selected, setSelected] = useState<Record<string,boolean>>({});
  const [negBusy, setNegBusy] = useState(false);
  const [negMsg, setNegMsg] = useState<{ok:boolean;text:string}|null>(null);
  const termKey = (d:any) => `${d.campaign_id||''}|${d.term}`;
  const selectedTerms = data.filter((d:any)=>selected[termKey(d)]);
  const sendNegatives = async () => {
    const withId = selectedTerms.filter((d:any)=>d.campaign_id);
    if(!withId.length) { setNegMsg({ ok:false, text:t('Seçilen terimlerde kampanya bilgisi yok; sayfayı yenileyip tekrar deneyin.') }); return; }
    setNegBusy(true); setNegMsg(null);
    const groups: Record<string,{name:string;terms:string[];spend:number}> = {};
    withId.forEach((d:any)=>{ const g = groups[d.campaign_id] = groups[d.campaign_id] || { name:d.campaign, terms:[], spend:0 }; g.terms.push(d.term); g.spend += d.spend||0; });
    try {
      const results = await Promise.all(Object.entries(groups).map(([cid,g])=>axios.post(`${API}/optimize/apply`, {
        client_id: config?.client_id || 1, platform:'google', customer_id: customerId,
        campaign_id: cid, campaign_name: g.name,
        title: `${g.name} · ${g.terms.length} arama terimi negatif anahtar kelime olarak eklensin`,
        impact_label: `₺${Math.round(g.spend).toLocaleString('tr-TR')} harcama`,
        action: { type:'negative_keyword', campaign_id: cid, campaign_name: g.name, terms: g.terms },
      })));
      const bad = results.find(r=>r.data?.status && r.data.status!=='pending');
      if(bad) setNegMsg({ ok:false, text: bad.data?.message || t('Kuyruğa eklenemedi.') });
      else { setNegMsg({ ok:true, text: `${withId.length} ${t('terim onay kuyruğuna eklendi. Onaylayana kadar hiçbir değişiklik yapılmaz.')}` }); setSelected({}); }
    } catch(e:any) { setNegMsg({ ok:false, text: e?.response?.data?.detail || t('Kuyruğa eklenemedi.') }); }
    setNegBusy(false);
  };

  const runAiAnalysis = async () => {
    if(!data.length) return;
    const cacheKey = `poyais_gads_st_ai_${customerId}_${start}_${end}`;
    try { const c = sessionStorage.getItem(cacheKey); if(c) { setAiAnalysis(JSON.parse(c)); return; } } catch {}
    setAiLoading(true);
    setAiError('');
    try {
      const top50 = data.slice(0,50).map((d:any)=>({
        term: d.term, spend: d.spend, clicks: d.clicks,
        conversions: d.conversions, roas: d.roas, ctr: d.ctr
      }));
      const r = await axios.post(`${API}/intelligence/ai/proxy`, {
        system: "Sen Google Ads uzmanısın. Search term verilerini analiz et. Sadece JSON döndür, başka hiçbir şey yazma.",
        user: `Search term verileri: ${JSON.stringify(top50)}

Analiz et ve şu JSON formatında döndür:
{
  "top_performers": [{"term":"...","reason":"...","action":"Bütçeyi artır"}],
  "negative_candidates": [{"term":"...","reason":"...","estimated_saving":"₺X"}],
  "opportunities": [{"term":"...","reason":"...","recommendation":"..."}],
  "summary": "Genel özet 2-3 cümle"
}

Türkçe yaz. En fazla 5 madde her kategoride.`,
        max_tokens: 2000,
        cache_hours: 24,
      });
      const text = r.data.content.replace(/```json|```/g,'').trim();
      const m = text.match(/\{[\s\S]*\}/);
      if(m) { const parsed = JSON.parse(m[0]); setAiAnalysis(parsed); try { sessionStorage.setItem(cacheKey, JSON.stringify(parsed)); } catch {} }
      else setAiError(t('AI yanıtı ayrıştırılamadı, tekrar deneyin.'));
    } catch(e:any) {
      setAiError(e?.response?.data?.detail || t('AI analizi başarısız oldu, tekrar deneyin.'));
    }
    setAiLoading(false);
  };

  if (loading) return <Loader/>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, fontFamily:'Manrope, sans-serif' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:14 }}>
        {[
          { label:t('Toplam Terim'),      value:fmt.n(data.length) },
          { label:t('En Yüksek ROAS'),    value:`${bestRoas.toFixed(2)}x`, gold:true },
          { label:t('En Yüksek Harcama'), value:fmt.k(Math.max(0,...data.map((d:any)=>d.spend||0))) },
          { label:t('Dönüşümsüz'),        value:fmt.n(noConvCount) },
        ].map((kpi:any) => (
          <div key={kpi.label} style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:'18px 19px' }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:T.textMidAlt, marginBottom:12 }}>{kpi.label}</div>
            <span style={{ fontSize:22, fontWeight:800, color: kpi.gold?T.greenText:T.text, fontFamily:MONO }}>{kpi.value}</span>
          </div>
        ))}
      </div>

      {/* AI Analiz Butonu */}
      <div style={{ display:'flex', justifyContent:'flex-end', alignItems:'center', gap:10 }}>
        {!data.length && <span style={{ fontSize:11.5, color:T.textDim }}>{t('Bu dönem için search term verisi yok, analiz edilecek bir şey bulunamadı.')}</span>}
        <button onClick={runAiAnalysis} disabled={aiLoading||!data.length}
          style={{ padding:'9px 16px', background:T.accent, color:'#fff', border:'none', borderRadius:11,
            fontSize:13, fontWeight:700, cursor: aiLoading?'wait':!data.length?'not-allowed':'pointer',
            opacity: !data.length?0.5:1 }}>
          {aiLoading ? t('Analiz yapılıyor…') : t('AI ile Analiz Et')}
        </button>
      </div>
      {aiError && (
        <div style={{ background:T.redTint, border:`1px solid ${alpha(T.red,30)}`, borderRadius:10, padding:'10px 14px', fontSize:12, color:T.redText, fontWeight:600 }}>
          {aiError}
        </div>
      )}

      {/* AI Analiz Sonuçları */}
      {aiAnalysis&&(
        <div style={{ display:'flex', flexDirection:'column' as const, gap:12 }}>
          <div style={{ display:'flex', justifyContent:'flex-end' }}>
            <button onClick={()=>setAiAnalysis(null)}
              style={{ padding:'7px 14px', background:T.surface, border:`1px solid ${T.borderMid}`, borderRadius:9, fontSize:12, color:T.textMidAlt, cursor:'pointer', fontWeight:700 }}>
              {t('Kapat')}
            </button>
          </div>
          {aiAnalysis.summary&&(
            <div style={{ background:T.amberTint, border:`1px solid ${alpha(T.amber,35)}`, borderRadius:14, padding:'16px 18px' }}>
              <div style={{ fontSize:10.5, fontWeight:800, letterSpacing:'.09em', color:T.accentDeep, textTransform:'uppercase' as const, marginBottom:8 }}>{t('AI Özeti')}</div>
              <p style={{ fontSize:13, color:T.text, lineHeight:1.7, margin:0 }}>{aiAnalysis.summary}</p>
            </div>
          )}
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(3,1fr)', gap:12 }}>
            {[
              { key:'top_performers',     label:t('En İyi Performanslılar'), color:T.greenText, bg:T.greenTint },
              { key:'negative_candidates', label:t('Negatif Adayları'),       color:T.redText, bg:T.redTint },
              { key:'opportunities',       label:t('Fırsatlar'),              color:T.blueText, bg:T.blueTint },
            ].map(section=>(
              <div key={section.key} style={{ background:section.bg, borderRadius:14, padding:'15px 16px' }}>
                <div style={{ fontSize:12, fontWeight:700, color:section.color, marginBottom:10 }}>{section.label}</div>
                <div style={{ display:'flex', flexDirection:'column' as const, gap:8 }}>
                  {(aiAnalysis[section.key]||[]).map((item:any, i:number)=>(
                    <div key={i} style={{ background:T.surface, borderRadius:10, padding:'11px 13px' }}>
                      <div style={{ fontSize:12, fontWeight:700, marginBottom:4 }}>{item.term}</div>
                      <div style={{ fontSize:11.5, color:T.textMidAlt, lineHeight:1.5 }}>{item.reason}</div>
                      {(item.action||item.recommendation||item.estimated_saving)&&(
                        <div style={{ fontSize:11.5, fontWeight:700, color:section.color, marginTop:5 }}>
                          → {item.action||item.recommendation||item.estimated_saving}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {(selectedTerms.length>0 || negMsg) && (
        <div style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap' as const, background:negMsg?(negMsg.ok?T.greenTint:T.redTint):T.amberTint, border:`1px solid ${T.borderMid}`, borderRadius:12, padding:'10px 14px' }}>
          {selectedTerms.length>0 && <>
            <span style={{ fontSize:12.5, fontWeight:700 }}>{selectedTerms.length} {t('terim seçili')} · ₺{Math.round(selectedTerms.reduce((s:number,d:any)=>s+(d.spend||0),0)).toLocaleString('tr-TR')}</span>
            <button onClick={sendNegatives} disabled={negBusy} style={{ padding:'9px 16px', background:T.accent, color:'#fff', border:'none', borderRadius:11, fontSize:13, fontWeight:700, cursor:negBusy?'wait':'pointer' }}>{negBusy?t('Gönderiliyor…'):t('Negatif Olarak Ekle (Onaya Gönder)')}</button>
            <button onClick={()=>setSelected({})} style={{ background:'none', border:'none', fontSize:12, fontWeight:700, color:T.textMidAlt, cursor:'pointer' }}>{t('Seçimi Temizle')}</button>
          </>}
          {negMsg && <span style={{ fontSize:12.5, fontWeight:600, color:negMsg.ok?T.greenText:T.redText }}>{negMsg.text}</span>}
          {negMsg?.ok && <button onClick={()=>window.dispatchEvent(new CustomEvent('poyais-nav',{detail:'poyaisone-recommendations'}))} style={{ background:'none', border:'none', fontSize:12, fontWeight:700, color:T.accentDeep, cursor:'pointer' }}>{t('Onay Bekleyenlere Git →')}</button>}
        </div>
      )}

      {/* Filtreler + Arama + Tablo */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, overflow:'hidden' }}>
        {/* Toolbar */}
        <div style={{ padding:'16px 22px', borderBottom:`1px solid ${T.tableDivider}`, display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' as const }}>
          <div style={{ display:'flex', alignItems:'center', gap:9, flex:1, minWidth:200, border:`1px solid ${T.borderMid}`, borderRadius:10, padding:'8px 12px' }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={T.textDim} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>
            <input value={search} onChange={e=>{setSearch(e.target.value);setPage(0);}} placeholder={t('Terim veya kampanya ara…')}
              style={{ border:'none', outline:'none', fontSize:12.5, color:T.text, flex:1, fontFamily:'inherit', background:'transparent' }}/>
          </div>
          {[
            { key:'all',       label:t('Tümü')                  },
            { key:'converted', label:t('Sadece Dönüşüm Alanlar')},
            { key:'negative',  label:t('Negatif Adayları')      },
            { key:'highspend', label:t('Yüksek Harcama')        },
          ].map((f:any) => (
            <button key={f.key} onClick={()=>{setFilter(f.key);setPage(0);}} style={{
              padding:'7px 14px', borderRadius:999, cursor:'pointer', fontSize:12, fontWeight:700,
              border:`1px solid ${filter===f.key?T.accent:T.borderMid}`,
              background: filter===f.key?T.amberTint:T.surface,
              color: filter===f.key?T.accentDeep:T.textMidAlt,
            }}>{f.label}</button>
          ))}
          <button onClick={()=>exportCsv(`gads-arama-terimleri-${start}-${end}.csv`, filtered.map((d:any)=>({ ...d, status_text: d.status==='ADDED'?t('Ekli'):t('Eklenmemiş') })), [
            { key:'term', label:t('Terim') }, { key:'campaign', label:t('Kampanya') },
            { key:'status_text', label:t('Durum') }, { key:'spend', label:t('Harcama') },
            { key:'clicks', label:t('Tıklama') }, { key:'ctr', label:'CTR' },
            { key:'conversions', label:'Conv' }, { key:'roas', label:'ROAS' },
          ])} disabled={filtered.length===0} style={{ padding:'7px 14px', borderRadius:999, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:T.textMidAlt, cursor:filtered.length?'pointer':'not-allowed', opacity:filtered.length?1:.5 }}>
            {t('Dışa Aktar')}
          </button>
        </div>

        <div className="table-scroll">
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
          <thead style={{ background:T.subtleBg }}>
            <tr>
              <th style={{ padding:'11px 0 11px 18px', width:28, borderBottom:`1px solid ${T.tableDivider}` }}>
                <input type="checkbox" aria-label={t('Tümünü seç')} checked={paged.length>0 && paged.every((d:any)=>selected[termKey(d)])}
                  onChange={e=>{ const on=e.target.checked; setSelected(sel=>{ const n={...sel}; paged.forEach((d:any)=>{ if(on) n[termKey(d)]=true; else delete n[termKey(d)]; }); return n; }); }}/>
              </th>
              {[t('Terim'),t('Kampanya'),t('Durum'),t('Harcama'),t('Tıklama'),'CTR',t('Dönüşüm'),'ROAS'].map((h,i) => (
                <th key={i} style={{ padding:'11px 18px', fontSize:10.5, fontWeight:800, letterSpacing:'.06em', color:T.textMidAlt, textTransform:'uppercase' as const, textAlign:i<3?'left' as const:'right' as const, borderBottom:`1px solid ${T.tableDivider}`, whiteSpace:'nowrap' as const }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paged.length===0 && (
              <tr><td colSpan={9} style={{ padding:48, textAlign:'center' as const, color:T.textDim, fontSize:12.5 }}>{t('Sonuç bulunamadı')}</td></tr>
            )}
            {paged.map((d:any, i:number) => {
              const hasConv = d.conversions > 0;
              const roasColor = d.roas>=4?T.greenText:d.roas>=2?T.amberText:d.roas>0?T.redText:T.textDim;
              return (
                <tr key={i} style={{ borderBottom:`1px solid ${T.tableDivider}` }}
                  onMouseEnter={e=>(e.currentTarget.style.background=T.subtleBg)}
                  onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                  <td style={{ padding:'13px 0 13px 18px', width:28 }}>
                    <input type="checkbox" aria-label={d.term} checked={!!selected[termKey(d)]} onChange={e=>setSelected(sel=>{ const n={...sel}; if(e.target.checked) n[termKey(d)]=true; else delete n[termKey(d)]; return n; })}/>
                  </td>
                  <td style={{ padding:'13px 18px', maxWidth:280 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <span title={hasConv?t('Dönüşüm aldı'):t('Dönüşüm yok')} style={{ width:7, height:7, borderRadius:'50%', background:hasConv?T.greenText:T.borderSoft, flexShrink:0, display:'inline-block' }}/>
                      <span style={{ fontSize:12.5, fontWeight:700, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{d.term}</span>
                    </div>
                  </td>
                  <td style={{ padding:'13px 18px', fontSize:11.5, color:T.textMidAlt, maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{d.campaign?.slice(0,30)}</td>
                  <td style={{ padding:'13px 18px' }}>
                    <span style={{ fontSize:10, fontWeight:700, padding:'3px 8px', borderRadius:999,
                      color: d.status==='ADDED'?T.greenText:T.textMidAlt,
                      background: d.status==='ADDED'?T.greenTint:T.trackBg }}>
                      {d.status==='ADDED'?t('Ekli'):t('Eklenmemiş')}
                    </span>
                  </td>
                  <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, fontWeight:700, fontFamily:MONO }}>₺{fmt.n(d.spend)}</td>
                  <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(d.clicks)}</td>
                  <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.pct(d.ctr)}</td>
                  <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, fontWeight:700, color:hasConv?T.text:T.textDim, fontFamily:MONO }}>{Math.round((d.conversions||0)*10)/10}</td>
                  <td style={{ padding:'13px 18px', textAlign:'right' as const, fontSize:12.5, fontWeight:800, color:roasColor, fontFamily:MONO }}>{d.roas>0?`${d.roas.toFixed(2)}x`:'—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>

        {/* Pagination */}
        <div style={{ padding:'13px 20px', borderTop:`1px solid ${T.tableDivider}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>
            {lang==='en'
              ? <>Showing {Math.min(page*PAGE_SIZE+1,filtered.length)}-{Math.min((page+1)*PAGE_SIZE,filtered.length)} of {filtered.length} terms</>
              : <>{filtered.length} terimden {Math.min(page*PAGE_SIZE+1,filtered.length)}-{Math.min((page+1)*PAGE_SIZE,filtered.length)} arası gösteriliyor</>}
          </span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page===0?'not-allowed':'pointer', opacity:page===0?0.4:1, fontSize:14 }}>‹</button>
            {pageWindow(page,totalPages).map(n=>(
              <button key={n} onClick={()=>setPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${page===n?T.accent:T.borderMid}`, background:T.surface, color:page===n?T.accentDeep:T.textMidAlt, cursor:'pointer', fontSize:11, fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page>=totalPages-1?'not-allowed':'pointer', opacity:page>=totalPages-1?.4:1, fontSize:14 }}>›</button>
          </div>
        </div>
      </div>

    </div>
  );
}
function MetaAudienceTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData]           = useState<any>(null);
  const [audiences, setAudiences] = useState<any[]>([]);
  const [audPage, setAudPage]     = useState(0);
  const [loading, setLoading]     = useState(true);
  const [aiInsight, setAiInsight] = useState<{title:string;body:string}|null>(null);
  const [aiInsightLoading, setAiInsightLoading] = useState(false);
  const PAGE_SIZE = 10;
  const { accountId } = config.platforms.meta;
  const { t, lang } = useLang();

  useEffect(() => {
    if(!accountId) { setLoading(false); return; }
    setLoading(true);
    // Önceki dönem hesapla
    const s2 = new Date(start); const e2 = new Date(end);
    const diff2 = Math.round((e2.getTime()-s2.getTime())/(1000*86400));
    const prevEnd2 = new Date(s2); prevEnd2.setDate(prevEnd2.getDate()-1);
    const prevStart2 = new Date(prevEnd2); prevStart2.setDate(prevStart2.getDate()-diff2);
    const fmt2 = (d:Date) => d.toISOString().slice(0,10);
    Promise.all([
      axios.get(`${API}/meta/${accountId}/audience-insights?start_date=${start}&end_date=${end}`),
      axios.get(`${API}/meta/${accountId}/custom-audiences`),
      axios.get(`${API}/meta/${accountId}/audience-insights?start_date=${fmt2(prevStart2)}&end_date=${fmt2(prevEnd2)}`),
    ]).then(([insRes, audRes, prevRes]) => {
      const d = insRes.data;
      if(d.age)    d.age    = d.age.filter((x:any)    => x.segment?.toLowerCase() !== 'unknown');
      if(d.gender) d.gender = d.gender.filter((x:any) => x.segment?.toLowerCase() !== 'unknown');
      const pd = prevRes.data;
      if(pd.age)    pd.age    = pd.age.filter((x:any)    => x.segment?.toLowerCase() !== 'unknown');
      if(pd.gender) pd.gender = pd.gender.filter((x:any) => x.segment?.toLowerCase() !== 'unknown');
      setData({...d, prev: pd});
      setAudiences(audRes.data || []);
      setLoading(false);

      // Gerçek AI analizi: cinsiyet/yaş segmentleri arasında anlamlı bir sinyal varsa
      // Claude'a gerçek veriyi verip gerçek bir yorum istiyoruz; harcama/dönüşüm yoksa
      // hiç çağrı yapmadan "Yeterli veri yok." gösteriyoruz — uydurma öneri üretmiyoruz.
      const gd = d.gender || [];
      const ad2 = d.age || [];
      const hasSignal = gd.some((x:any)=>(x.spend||0)>0) || ad2.some((x:any)=>(x.spend||0)>0);
      if (!hasSignal) { setAiInsight(null); return; }
      setAiInsightLoading(true);
      axios.post(`${API}/intelligence/ai/proxy`, {
        system: 'Sen kıdemli bir performans pazarlama analistisin. Sana bir Meta Ads hesabının cinsiyet ve yaş kırılımlı harcama/ROAS/dönüşüm verisi JSON olarak verilecek. Segmentler arasında gerçek, istatistiksel olarak anlamlı ve aksiyona dönüştürülebilir bir fark varsa (ör. bir segment belirgin şekilde daha yüksek ROAS/dönüşüm üretiyor, ya da bütçe dağılımı ile performans dağılımı arasında net bir uyumsuzluk var), bunu şu JSON formatında döndür: {"title":"kısa başlık, en fazla 6 kelime, Türkçe","body":"1-2 cümlelik, Türkçe, ₺ para birimi kullanan, markdown içermeyen somut analiz ve öneri"}. Veri çok düşükse, segmentler arasında anlamlı bir fark yoksa veya güvenilir bir sonuç çıkaramıyorsan uydurma bir öneri üretme — sadece {"insufficient":true} döndür. Yanıtında SADECE bu JSON nesnesini döndür, başka hiçbir metin ekleme.',
        user: JSON.stringify({ gender: gd, age: ad2 }),
        max_tokens: 400,
        cache_hours: 24,
      }).then(r=>{
        const text = r.data?.content || '';
        const m = text.match(/\{[\s\S]*\}/);
        if (m) {
          const parsed = JSON.parse(m[0]);
          setAiInsight(parsed.insufficient || !parsed.title ? null : { title: parsed.title, body: parsed.body||'' });
        } else setAiInsight(null);
      }).catch(()=>setAiInsight(null))
        .finally(()=>setAiInsightLoading(false));
    }).catch(() => setLoading(false));
  }, [start, end, accountId]);

  if (loading) return <Loader/>;
  if (!data) return <div style={{ color:T.textMid, padding:24 }}>{t('Veri bulunamadı.')}</div>;

  const genderData = data.gender || [];
  const ageData    = data.age    || [];
  const totalSpend = genderData.reduce((s:number,x:any)=>s+(x.spend||0),0);
  const totalRevenue = genderData.reduce((s:number,x:any)=>s+(x.revenue||0),0);
  // Ortalama ROAS: segment ROAS'larının düz ortalaması değil, harcama ağırlıklı (toplam gelir / toplam harcama)
  const ageSpend   = ageData.reduce((s:number,x:any)=>s+(x.spend||0),0);
  const ageRev     = ageData.reduce((s:number,x:any)=>s+(x.revenue != null ? x.revenue : (x.roas||0)*(x.spend||0)),0);
  const totalRoas  = ageSpend>0 ? ageRev/ageSpend : 0;
  const totalConv  = ageData.reduce((s:number,x:any)=>s+(x.purchases||x.conversions||0),0);
  const maxAgeSpend = ageData.length ? Math.max(...ageData.map((x:any)=>x.spend||0),1) : 1;
  const bestAge    = [...ageData].sort((a:any,b:any)=>(b.roas||0)-(a.roas||0))[0];
  const femaleData = genderData.find((x:any)=>x.segment==='female')||{};
  const maleData   = genderData.find((x:any)=>x.segment==='male')||{};
  const femalePct  = totalSpend>0 ? Math.round((femaleData.spend||0)/totalSpend*100) : 0;
  const malePct    = totalSpend>0 ? Math.round((maleData.spend||0)/totalSpend*100) : 0;

  const paged = audiences.slice(audPage*PAGE_SIZE,(audPage+1)*PAGE_SIZE);
  const totalPages = Math.max(1, Math.ceil(audiences.length/PAGE_SIZE));

  const typeBadge = (ty:string) => {
    if (!ty) return { text:t('Özel'), bg:'var(--py-track-bg)', color:'var(--py-text-mid-alt)' };
    const tl = ty.toLowerCase();
    if (tl.includes('lookalike'))     return { text:t('Benzer'),    bg:'var(--py-amber-tint)', color:T.amberDeepText };
    if (tl.includes('ig_business'))   return { text:t('Etkileşim'), bg:'var(--py-purple-tint)', color:T.purpleText };
    if (tl.includes('engagement'))    return { text:t('Etkileşim'), bg:'var(--py-purple-tint)', color:T.purpleText };
    if (tl.includes('website'))       return { text:'Website',   bg:'var(--py-blue-tint)', color:T.blueText };
    if (tl.includes('customer_list')) return { text:t('Müşteri'),   bg:'var(--py-green-tint)', color:T.greenText };
    if (tl.includes('customer'))      return { text:t('Müşteri'),   bg:'var(--py-green-tint)', color:T.greenText };
    if (tl.includes('video'))         return { text:'Video',     bg:'var(--py-amber-tint)', color:T.amberDeepText };
    if (tl.includes('app'))           return { text:t('Uygulama'),  bg:'var(--py-green-tint)', color:T.greenText };
    if (tl.includes('lal'))           return { text:t('Benzer'),    bg:'var(--py-amber-tint)', color:T.amberDeepText };
    if (tl.includes('custom'))        return { text:t('Özel'),      bg:'var(--py-track-bg)', color:'var(--py-text-mid-alt)' };
    return { text:t('Özel'), bg:'var(--py-track-bg)', color:'var(--py-text-mid-alt)' };
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* KPI - 4 kart */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(2,1fr)', gap:14 }}>
        {(() => {
          const prevGender = data.prev?.gender?.filter((x:any) => x.segment?.toLowerCase() !== 'unknown') || [];
          const prevSpend = prevGender.reduce((s:number,x:any)=>s+(x.spend||0),0);
          const prevRevenue = prevGender.reduce((s:number,x:any)=>s+(x.revenue||0),0);
          const prevAge   = data.prev?.age?.filter((x:any) => x.segment?.toLowerCase() !== 'unknown') || [];
          const pAgeSpend = prevAge.reduce((s:number,x:any)=>s+(x.spend||0),0);
          const pAgeRev   = prevAge.reduce((s:number,x:any)=>s+(x.revenue != null ? x.revenue : (x.roas||0)*(x.spend||0)),0);
          const prevRoas  = pAgeSpend>0 ? pAgeRev/pAgeSpend : 0;
          const prevConv  = prevAge.reduce((s:number,x:any)=>s+(x.purchases||0),0);
          const spendChg2  = prevSpend>0 ? Math.round(((totalSpend-prevSpend)/prevSpend)*100) : null;
          const roasChg2   = prevRoas>0  ? Math.round(((totalRoas-prevRoas)/prevRoas)*100)    : null;
          const convChg2   = prevConv>0  ? Math.round(((totalConv-prevConv)/prevConv)*100)    : null;
          const revenueChg2 = prevRevenue>0 ? Math.round(((totalRevenue-prevRevenue)/prevRevenue)*100) : null;
          return [
            { label:t('Toplam Harcama'),    value: totalSpend>=1000?`₺${(totalSpend/1000).toFixed(0)}K`:`₺${Math.round(totalSpend).toLocaleString('tr-TR')}`, chg:spendChg2 },
            { label:t('Ortalama ROAS'),     value: fmt.roas(totalRoas), chg:roasChg2 },
            { label:t('Toplam Satın Alma'), value: fmt.n(totalConv),    chg:convChg2 },
            { label:t('Toplam Gelir'),      value: totalRevenue>=1000000?`₺${(totalRevenue/1000000).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})}M`:(totalRevenue>=1000?`₺${(totalRevenue/1000).toFixed(0)}K`:`₺${Math.round(totalRevenue).toLocaleString('tr-TR')}`), chg:revenueChg2 },
          ];
        })().map((k,i) => (
          <div key={i} style={{ background:T.surface, padding:'18px 19px', borderRadius:14, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:12 }}>{k.label}</div>
            <div style={{ display:'flex', alignItems:'baseline', gap:10 }}>
              <span style={{ fontSize:22, fontWeight:800, fontFamily:MONO }}>{k.value}</span>
              {k.chg!=null && <span style={{ fontSize:11, fontWeight:700, color:k.chg>=0?T.greenText:T.redText, fontFamily:MONO }}>{k.chg>=0?'↗':'↘'} {k.chg>=0?'+':''}{k.chg}%</span>}
            </div>
          </div>
        ))}
      </div>

      {/* Yas + Cinsiyet yan yana */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:14 }}>

        {/* Yas Dagilimi */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18 }}>
            <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Yaş Dağılımı')}</div>
            <div style={{ display:'flex', gap:12 }}>
              {[['var(--py-border-soft)',t('Harcama')],[T.accent,'ROAS']].map(([c,l])=>(
                <div key={l} style={{ display:'flex', alignItems:'center', gap:5 }}>
                  <div style={{ width:7, height:7, borderRadius:'50%', background:c }}/>
                  <span style={{ fontSize:10.5, color:T.textDim }}>{l}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{ display:'flex', alignItems:'flex-end', gap:6, height:160, padding:'0 4px' }}>
            {ageData.map((ag:any,i:number) => {
              const isBest = ag.segment === bestAge?.segment;
              const barH = Math.max((ag.spend||0)/maxAgeSpend*100, 4);
              const roasH = Math.max((ag.roas||0)/(Math.max(...ageData.map((x:any)=>x.roas||0),1))*100, 4);
              return (
                <div key={i} title={`${ag.segment} — ${t('Harcama')}: ₺${Math.round(ag.spend||0).toLocaleString('tr-TR')} · ROAS: ${fmt.roas(ag.roas||0)}`} style={{ flex:1, display:'flex', flexDirection:'column' as const, alignItems:'center', gap:3, position:'relative' as const }}>
                  {isBest && <div style={{ position:'absolute' as const, top:-18, fontSize:10, fontWeight:700, color:T.accentDeep, whiteSpace:'nowrap' as const }}>★ {fmt.roas(ag.roas||0)}</div>}
                  <div style={{ width:'100%', display:'flex', gap:2, alignItems:'flex-end', height:140 }}>
                    <div style={{ flex:1, background: isBest?T.accent:'var(--py-track-bg)', borderRadius:'3px 3px 0 0', height:`${barH}%`, transition:'height .4s' }}/>
                    <div style={{ flex:1, background:T.accent, borderRadius:'3px 3px 0 0', height:`${roasH}%`, opacity:.7, transition:'height .4s' }}/>
                  </div>
                  <span style={{ fontSize:10.5, color:T.textDim, whiteSpace:'nowrap' as const }}>{ag.segment}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Cinsiyet Dagilimi */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, marginBottom:18 }}>{t('Cinsiyet Dağılımı')}</div>
          {[
            { label:t('Kadın'), pct:femalePct, spend: femaleData.spend||0, roas: femaleData.roas||0, color:T.accent },
            { label:t('Erkek'), pct:malePct,   spend: maleData.spend||0,   roas: maleData.roas||0,   color:T.accentDeep },
          ].map((g,i) => (
            <div key={i} style={{ marginBottom: i===0?22:0 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
                <span style={{ fontSize:12.5, fontWeight:600 }}>{g.label}</span>
                <span style={{ fontSize:11, fontWeight:700, padding:'2px 9px', borderRadius:999, background:'var(--py-track-bg)', color:T.textMid }}>{fmt.roas(g.roas)} ROAS</span>
              </div>
              <div style={{ height:7, width:'100%', background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden', marginBottom:6 }}>
                <div style={{ height:'100%', borderRadius:999, background: g.color, width:`${g.pct}%`, transition:'width .4s' }}/>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between' }}>
                <span style={{ fontSize:11, color:T.textDim }}>{g.pct}% {t('Harcama')}</span>
                <span style={{ fontSize:11, color:T.textDim, fontFamily:MONO }}>{fmt.k(g.spend)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Insight Kartlari */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:14 }}>
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ fontSize:10.5, fontWeight:800, color:T.accentDeep, letterSpacing:'.09em', textTransform:'uppercase' as const, marginBottom:8 }}>{t('En Verimli Yaş Grubu')}</div>
          <div style={{ fontSize:14, fontWeight:800, marginBottom:8 }}>{bestAge?.segment||'—'} {t('Yaş Aralığı')}</div>
          <div style={{ fontSize:11.5, color:'var(--py-text-mid-alt)', lineHeight:1.6 }}>
            {bestAge ? (lang==='en'
              ? `The ${bestAge.segment} age group shows the highest performance with an average ROAS of ${bestAge.roas?.toFixed(2)}×. ₺${Math.round(bestAge.spend||0).toLocaleString('tr-TR')} was spent on this segment, generating ${bestAge.purchases||0} conversions.`
              : `${bestAge.segment} yaş grubunda ortalama ROAS ${bestAge.roas?.toFixed(2)}× ile en yüksek performans gösteriliyor. Bu segmente yönelik ₺${Math.round(bestAge.spend||0).toLocaleString('tr-TR')} harcama yapıldı, ${bestAge.purchases||0} dönüşüm elde edildi.`) : '—'}
          </div>
        </div>
        <div style={{ background:'var(--py-purple-tint)', borderRadius:16, border:`1px solid ${alpha(T.purple,30)}`, padding:'20px 22px' }}>
          <div style={{ fontSize:10.5, fontWeight:800, color:T.purpleText, letterSpacing:'.09em', textTransform:'uppercase' as const, marginBottom:8 }}>{t('AI Insight: Cinsiyet & Yaş Analizi')}</div>
          {aiInsightLoading ? (
            <div style={{ fontSize:11.5, color:T.textDim }}>{t('Analiz ediliyor…')}</div>
          ) : aiInsight ? (
            <>
              <div style={{ fontSize:14, fontWeight:800, marginBottom:8 }}>{aiInsight.title}</div>
              <div style={{ fontSize:11.5, color:'var(--py-text-mid-alt)', lineHeight:1.6 }}>{aiInsight.body}</div>
            </>
          ) : (
            <div style={{ fontSize:11.5, color:'var(--py-text-mid-alt)', lineHeight:1.6 }}>{t('Yeterli veri yok.')}</div>
          )}
        </div>
      </div>

      {/* Kitle Analizi Tablosu */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}` }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontSize:13.5, fontWeight:800 }}>{t('Kitle Analizi')}</div>
          <button onClick={()=>exportCsv(`meta-kitleler-${start}-${end}.csv`, audiences.map((a:any)=>({ name:a.name, type:typeBadge(a.subtype||a.type||a.audience_type||'').text, size:(a.size||a.approximate_count||0)<=20?'':(a.size||a.approximate_count||0), status:(a.status==='ACTIVE'||!a.status)?t('Aktif'):t('Pasif') })), [
                { key:'name', label:t('Kitle Adı') }, { key:'type', label:t('Tip') }, { key:'size', label:t('Boyut') }, { key:'status', label:t('Durum') },
              ])} disabled={audiences.length===0} style={{ padding:'7px 13px', fontSize:12, fontWeight:700, border:`1px solid ${T.borderMid}`, borderRadius:9, background:T.surface, cursor:audiences.length?'pointer':'not-allowed', opacity:audiences.length?1:.5, color:'var(--py-text-mid-alt)' }}>{t('Dışa Aktar')}</button>
        </div>

        <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
          <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:600 }}>
            <thead>
              <tr style={{ background:'var(--py-subtle-bg)' }}>
                {[t('Kitle Adı'),t('Tip'),t('Boyut'),t('Durum')].map((h,i) => (
                  <th key={i} style={{ padding:'11px 18px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign:'left' as const, whiteSpace:'nowrap' as const, borderBottom:'1px solid var(--py-table-divider)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paged.length === 0 && (
                <tr><td colSpan={4} style={{ padding:48, textAlign:'center' as const, color:T.textDim, fontSize:12.5 }}>{t('Kitle verisi bulunamadı.')}</td></tr>
              )}
              {paged.map((a:any,i:number) => {
                const tb = typeBadge(a.subtype||a.type||a.audience_type||'');
                const isActive = a.status === 'ACTIVE' || !a.status;

                return (
                  <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)' }} onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')} onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                    <td style={{ padding:'12px 18px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <span style={{ width:7, height:7, borderRadius:'50%', background: isActive?T.greenText:'var(--py-border-soft)', flexShrink:0 }}/>
                        <span style={{ fontSize:12.5, fontWeight:600 }}>{a.name}</span>
                      </div>
                    </td>
                    <td style={{ padding:'12px 18px' }}>
                      <span style={{ padding:'2px 9px', borderRadius:999, background:tb.bg, color:tb.color, fontSize:10, fontWeight:700 }}>{tb.text}</span>
                    </td>
                    <td style={{ padding:'12px 18px', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{(()=>{
                      const up = a.size||a.approximate_count||0, lo = a.size_lower||0;
                      // Meta çok küçük / henüz dolmamış kitlelerde gerçek boyut yerine 20 gibi yer tutucu döner
                      if (up<=20) return <span title={t('Meta bu kitlenin gerçek boyutunu paylaşmıyor (çok küçük ya da henüz dolmamış olabilir).')} style={{ color:T.textDim, cursor:'help' }}>{t('Boyut paylaşılamıyor.')}</span>;
                      return lo>0 && lo<up ? `${fmt.n(lo)} – ${fmt.n(up)}` : fmt.n(up);
                    })()}</td>
                    <td style={{ padding:'12px 18px' }}>
                      <span style={{ fontSize:11.5, fontWeight:600, color: a.status==='ACTIVE'||!a.status?T.greenText:T.textDim }}>{a.status==='ACTIVE'||!a.status?t('Aktif'):t('Pasif')}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>
            {lang==='en'
              ? <>Showing {Math.min(audPage*PAGE_SIZE+1,audiences.length)}-{Math.min((audPage+1)*PAGE_SIZE,audiences.length)} of {audiences.length} audiences.</>
              : <>{audiences.length} kitle içinden {Math.min(audPage*PAGE_SIZE+1,audiences.length)}-{Math.min((audPage+1)*PAGE_SIZE,audiences.length)} gösteriliyor.</>}
          </span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setAudPage(p=>Math.max(0,p-1))} disabled={audPage===0}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:audPage===0?'not-allowed':'pointer', opacity:audPage===0?0.4:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>‹</button>
            {pageWindow(audPage,totalPages).map(n=>(
              <button key={n} onClick={()=>setAudPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${audPage===n?T.accent:T.borderMid}`, background:audPage===n?T.accent:T.surface, color:audPage===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setAudPage(p=>Math.min(totalPages-1,p+1))} disabled={audPage>=totalPages-1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:audPage>=totalPages-1?'not-allowed':'pointer', opacity:audPage>=totalPages-1?.4:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>›</button>
          </div>
        </div>
      </div>


      {/* Meta kırılımları (eski Derin Analiz) — Kitle sayfasında olmayanlar */}
      <MetaAgeGenderCard clientId={config?.client_id||1} start={start} end={end}/>
      <MetaBreakdownCard clientId={config?.client_id||1} dim="region" title="Bölgeler" sub="Reklamların gösterildiği il ve bölgeler." start={start} end={end}/>
      <MetaBreakdownCard clientId={config?.client_id||1} dim="country" title="Ülkeler" start={start} end={end} hideIfSingle/>
    </div>
  );
}

// -- Meta Creatives Tab -----------------------------------------------------

// Meta reklam amacı → kısa etiket. Mevcut gönderiyle çalışan etkileşim reklamı = post boost ("Paylaşım").
const META_OBJECTIVE_LABELS: Record<string,string> = {
  OUTCOME_SALES:'Satış', CONVERSIONS:'Satış', PRODUCT_CATALOG_SALES:'Satış',
  OUTCOME_TRAFFIC:'Trafik', LINK_CLICKS:'Trafik',
  OUTCOME_ENGAGEMENT:'Etkileşim', POST_ENGAGEMENT:'Etkileşim', PAGE_LIKES:'Etkileşim', EVENT_RESPONSES:'Etkileşim',
  OUTCOME_AWARENESS:'Bilinirlik', BRAND_AWARENESS:'Bilinirlik', REACH:'Erişim',
  OUTCOME_LEADS:'Potansiyel Müşteri', LEAD_GENERATION:'Potansiyel Müşteri',
  OUTCOME_APP_PROMOTION:'Uygulama', APP_INSTALLS:'Uygulama', MOBILE_APP_INSTALLS:'Uygulama',
  VIDEO_VIEWS:'Video Görüntüleme', MESSAGES:'Mesaj',
};
// Katalog (dinamik ürün) reklamı: kreatif katalogdan otomatik üretilir, elle hazırlanmış kreatif yoktur
const isCatalogAd = (d:any) => !!d?.is_catalog || (d?.objective||'').toUpperCase()==='PRODUCT_CATALOG_SALES';
function metaObjectiveLabel(objective?:string, existingPost?:boolean): string | null {
  const o = (objective||'').toUpperCase();
  const label = META_OBJECTIVE_LABELS[o];
  if (!label) return null;
  if (label === 'Etkileşim' && existingPost) return 'Paylaşım';
  return label;
}

// Kreatif önizleme: görsel yüklenene kadar (ya da hiç yoksa) türüne göre ikonlu yer tutucu kart.
function CreativeThumb({ src, kind }:{ src?:string; kind:'IMAGE'|'VIDEO'|'CAROUSEL' }) {
  const { t } = useLang();
  const [state, setState] = useState<'loading'|'ok'|'error'>(src ? 'loading' : 'error');
  useEffect(() => { setState(src ? 'loading' : 'error'); }, [src]);
  const label = kind === 'VIDEO' ? 'Video' : kind === 'CAROUSEL' ? 'Carousel' : t('Görsel');
  const icon = kind === 'VIDEO'
    ? <><rect x="3" y="5" width="18" height="14" rx="3"/><path d="M10 9.5v5l4.5-2.5z" fill="currentColor"/></>
    : kind === 'CAROUSEL'
    ? <><rect x="6" y="5" width="12" height="14" rx="2.5"/><path d="M3 7.5v9M21 7.5v9"/></>
    : <><rect x="3" y="4" width="18" height="16" rx="3"/><circle cx="9" cy="10" r="1.8"/><path d="M21 16l-5-5-8 8"/></>;
  return (
    <>
      {state !== 'ok' && (
        <div style={{ position:'absolute' as const, inset:0, display:'flex', flexDirection:'column' as const, alignItems:'center', justifyContent:'center', gap:10,
          background:'linear-gradient(145deg, var(--py-subtle-bg) 0%, var(--py-track-bg) 100%)' }}>
          <span style={{ width:56, height:56, borderRadius:16, background:'var(--py-surface)', border:'1px solid var(--py-border)', boxShadow:'0 4px 14px rgba(20,22,43,.06)',
            color:'var(--py-text-dim)', display:'flex', alignItems:'center', justifyContent:'center',
            animation: state==='loading' ? 'pdot 1.6s ease-in-out infinite' : 'none' }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">{icon}</svg>
          </span>
          <span style={{ fontSize:11, fontWeight:700, color:'var(--py-text-dim)', letterSpacing:'.04em', textTransform:'uppercase' as const }}>{label}</span>
        </div>
      )}
      {src && state !== 'error' && (
        <img src={src} alt="" loading="lazy" decoding="async"
          onLoad={()=>setState('ok')} onError={()=>setState('error')}
          style={{ width:'100%', height:'100%', objectFit:'cover' as const, position:'relative' as const, zIndex:1, cursor:'pointer',
            opacity: state==='ok' ? 1 : 0, transition:'opacity .25s ease, transform 0.25s ease' }}
          onMouseEnter={(e:any)=>{ e.currentTarget.style.transform='scale(1.06)'; }}
          onMouseLeave={(e:any)=>{ e.currentTarget.style.transform='scale(1)'; }}/>
      )}
    </>
  );
}

function MetaCreativesTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [data, setData]     = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [typeFilter, setTypeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortKey, setSortKey] = useState('spend');
  const [sortDir, setSortDir] = useState<'asc'|'desc'>('desc');
  const [page, setPage]       = useState(0);
  const PAGE_SIZE = 12;
  const { accountId } = config.platforms.meta;
  const { t, lang } = useLang();

  useEffect(() => {
    if (!accountId) return;
    setLoading(true);
    axios.get(`${API}/meta/${accountId}/creatives?start_date=${start}&end_date=${end}`)
      .then(r => { setData(r.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, accountId]);

  const filtered = useMemo(() => data.filter(d => {
    const matchSearch = !search ||
      (d.name||'').toLowerCase().includes(search.toLowerCase()) ||
      (d.campaign_name||'').toLowerCase().includes(search.toLowerCase());
    const tp = (d.type||'').toUpperCase();
    const matchType = typeFilter === 'all'
      || (typeFilter === 'IMAGE' && (tp.includes('SHARE') || tp.includes('IMAGE') || tp.includes('STATIC')))
      || (typeFilter === 'VIDEO' && tp.includes('VIDEO'))
      || (typeFilter === 'CAROUSEL' && tp.includes('CAROUSEL'));
    const isActive = (d.status||'').toUpperCase() === 'ACTIVE';
    const matchStatus = statusFilter === 'all' || (statusFilter === 'active' ? isActive : !isActive);
    return matchSearch && matchType && matchStatus;
  }), [data, search, typeFilter, statusFilter]);

  const sorted = useMemo(() => {
    const arr = [...filtered];
    arr.sort((a,b) => {
      const av = a[sortKey] || 0;
      const bv = b[sortKey] || 0;
      return sortDir === 'asc' ? av - bv : bv - av;
    });
    return arr;
  }, [filtered, sortKey, sortDir]);

  const totalPages  = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const paged       = sorted.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
  // Özet kartları seçili filtreleri (tür, durum, arama) izler.
  const bestRoas    = filtered.length ? Math.max(...filtered.map(d => d.roas||0)) : 0;
  const avgCtr      = filtered.length ? filtered.reduce((s,d)=>s+(d.ctr||0),0)/filtered.length : 0;
  const lowPerf     = filtered.filter(d => (d.roas||0) < 2).length;

  const roasColor = (r:number) => r >= 4 ? T.greenText : r >= 2 ? T.accentDeep : T.redText;

  const typeBadge = (ty:string) => {
    const tl = (ty||'').toUpperCase();
    if (tl.includes('VIDEO'))   return { text:'Video',   bg:'var(--py-purple-tint)', color:T.purpleText };
    if (tl.includes('CAROUSEL'))return { text:'Carousel', bg:'var(--py-green-tint)', color:T.greenText };
    if (tl.includes('SHARE'))   return { text:t('Görsel'),  bg:'var(--py-blue-tint)', color:T.blueText };
    if (tl.includes('IMAGE') || tl.includes('STATIC')) return { text:t('Görsel'), bg:'var(--py-blue-tint)', color:T.blueText };
    return { text:t('Görsel'), bg:'var(--py-blue-tint)', color:T.blueText };
  };

  const statusBadge = (s:string) => {
    const su = (s||'').toUpperCase();
    if (su === 'ACTIVE') return { text:t('Aktif'), bg:'var(--py-green-tint)', color:T.greenText };
    return { text:t('Pasif'), bg:'var(--py-track-bg)', color:'var(--py-text-mid-alt)' };
  };

  const SORT_OPTIONS: {key:string; label:string}[] = [
    { key:'spend',       label:t('Harcama') },
    { key:'roas',        label:'ROAS' },
    { key:'revenue',     label:t('Ciro') },
    { key:'purchases',   label:t('Dönüşüm') },
    { key:'impressions', label:t('Gösterim') },
    { key:'reach',       label:t('Erişim') },
    { key:'ctr',         label:'CTR' },
    { key:'cpm',         label:'CPM' },
    { key:'frequency',   label:t('Frekans') },
  ];

  const toggleSort = (key:string) => {
    if (sortKey === key) {
      setSortDir(d => d==='asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('desc');
    }
    setPage(0);
  };

  if (loading) return <Loader/>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:isMobile?8:14, overflowX:'hidden' as const }}>
        {[
          { label:t('Toplam Kreatif'),      value: fmt.n(filtered.length),    labelColor:T.textMid },
          { label:t('En İyi ROAS'),         value: fmt.roas(bestRoas),    labelColor:T.textMid },
          { label:t('Ort. CTR'),            value: fmt.pct(avgCtr),       labelColor:T.textMid },
          { label:t('Optimize Edilebilir'), value: fmt.n(lowPerf),        labelColor:T.redText },
        ].map((k,i) => (
          <div key={i} style={{ background:T.surface, padding:'18px 19px', borderRadius:14, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:k.labelColor, marginBottom:10 }}>{k.label}</div>
            <div style={{ fontSize:22, fontWeight:800, fontFamily:MONO }}>{k.value}</div>
          </div>
        ))}
      </div>

      {/* Kreatif yorgunluğu: aktif, sık gösterilen (frekans ≥ 3) ve CTR'ı ortalamanın altına inmiş reklamlar */}
      {(()=>{
        // Önce gerçekten kreatifi olan reklamlar: katalog reklamlarında kreatif yorgunluğu kavramı yok
        const act = data.filter((d:any)=>!isCatalogAd(d) && (d.status||'').toUpperCase()==='ACTIVE' && (d.impressions||0)>=1000);
        const totImp = act.reduce((s:number,d:any)=>s+(d.impressions||0),0);
        const totClk = act.reduce((s:number,d:any)=>s+(d.clicks||0),0);
        const avg = totImp>0 ? totClk/totImp*100 : 0;
        const tired = act.filter((d:any)=>(d.frequency||0)>=3 && (d.ctr||0) < avg).sort((a:any,b:any)=>(b.frequency||0)-(a.frequency||0));
        if(!tired.length) return null;
        return (
          <div style={{ background:'var(--py-amber-tint)', border:`1px solid ${alpha(T.amber,35)}`, borderRadius:14, padding:'14px 18px' }}>
            <div style={{ display:'flex', justifyContent:'space-between', gap:10, flexWrap:'wrap' as const, marginBottom:10 }}>
              <div style={{ fontSize:13, fontWeight:800, color:T.amberDeepText }}>{lang==='en' ? `${tired.length} ads may be fatiguing` : `${tired.length} reklamda kreatif yorgunluğu riski`}</div>
              <div style={{ fontSize:11.5, color:T.amberDeepText }}>{lang==='en' ? `Frequency ≥ 3 and CTR below the ${avg.toFixed(2)}% average` : `Frekans ≥ 3 ve CTR, %${avg.toFixed(2)} ortalamanın altında`}</div>
            </div>
            <div style={{ display:'flex', flexDirection:'column' as const, gap:6 }}>
              {tired.slice(0,5).map((d:any,i:number)=>(
                <div key={i} style={{ display:'flex', justifyContent:'space-between', gap:12, background:T.surface, borderRadius:10, padding:'8px 12px', fontSize:12 }}>
                  <span style={{ fontWeight:700, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const, minWidth:0 }}>{d.name||d.ad_name}</span>
                  <span style={{ fontFamily:MONO, color:T.textMid, whiteSpace:'nowrap' as const }}>{t('Frekans')} {(d.frequency||0).toFixed(1)} · CTR %{(d.ctr||0).toFixed(2)} · {fmt.k(d.spend||0)}</span>
                </div>
              ))}
            </div>
            <div style={{ fontSize:11.5, color:T.amberDeepText, marginTop:10, lineHeight:1.6 }}>{t('Öneri: yeni kreatif varyantları ekleyin ya da kitleyi genişletin. Bilinirlik amaçlı reklamlarda yüksek frekans planlı olabilir.')}</div>
          </div>
        );
      })()}

      {/* Filtreler */}
      <div style={{ display:'flex', flexDirection:isMobile?'column' as const:'row', justifyContent:'space-between', alignItems:isMobile?'flex-start':'center', gap:12 }}>
        <div style={{ display:'flex', gap:6, flexWrap:'wrap' as const, background:'var(--py-track-bg)', padding:4, borderRadius:11 }}>
          {[['all',t('Tümü')],['IMAGE',t('Görsel')],['VIDEO','Video'],['CAROUSEL','Carousel']].map(([tk,l]) => (
            <button key={tk} onClick={()=>{ setTypeFilter(tk); setPage(0); }}
              style={{ padding:'6px 13px', borderRadius:8, border:'none', background: typeFilter===tk?T.surface:'transparent', boxShadow: typeFilter===tk?'0 1px 2px rgba(20,22,43,.1)':'none', color: typeFilter===tk?T.text:'var(--py-text-mid-alt)', fontSize:12, fontWeight:typeFilter===tk?700:500, cursor:'pointer', whiteSpace:'nowrap' as const, flexShrink:0 }}>
              {l}
            </button>
          ))}
        </div>
        <div style={{ display:'flex', gap:12, alignItems:'center', flexWrap:'wrap' as const }}>
          <div style={{ display:'flex', gap:6, flexWrap:'wrap' as const, background:'var(--py-track-bg)', padding:4, borderRadius:11 }}>
            {[['all',t('Tüm Durum')],['active',t('Aktif')],['paused',t('Pasif')]].map(([sk,l]) => (
              <button key={sk} onClick={()=>{ setStatusFilter(sk); setPage(0); }}
                style={{ padding:'6px 13px', borderRadius:8, border:'none', background: statusFilter===sk?T.surface:'transparent', boxShadow: statusFilter===sk?'0 1px 2px rgba(20,22,43,.1)':'none', color: statusFilter===sk?T.text:'var(--py-text-mid-alt)', fontSize:12, fontWeight:statusFilter===sk?700:500, cursor:'pointer', whiteSpace:'nowrap' as const, flexShrink:0 }}>
                {l}
              </button>
            ))}
          </div>
          {!isMobile && <button onClick={()=>{
              const csv = [`${t('Kreatif')},${t('Tür')},${t('Harcama')},ROAS,CTR,${t('Satış')}`].concat(filtered.map((d:any)=>
                `"${d.name||''}",${d.type||''},${(d.spend||0).toFixed(2)},${(d.roas||0).toFixed(2)},${(d.ctr||0).toFixed(2)},${Math.round(d.conversions||0)}`
              )).join('\n');
              const blob=new Blob([csv],{type:'text/csv'});
              const url5=URL.createObjectURL(blob);
              const a5=document.createElement('a');a5.href=url5;a5.download='kreatifler.csv';a5.click();
            }} style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:'pointer' }}>
            {t('Raporu İndir')}
          </button>}
        </div>
      </div>

      {/* Sirala */}
      <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' as const }}>
        <span style={{ fontSize:11, fontWeight:700, color:T.textDim, textTransform:'uppercase' as const, letterSpacing:'.06em' }}>{t('Sırala:')}</span>
        {SORT_OPTIONS.map(opt => {
          const active = sortKey === opt.key;
          return (
            <button key={opt.key} onClick={()=>toggleSort(opt.key)}
              style={{ display:'flex', alignItems:'center', gap:4, padding:'6px 12px', borderRadius:999, border:`1px solid ${active?T.accent:T.borderMid}`, background: active?'var(--py-amber-tint)':T.surface, color: active?T.amberDeepText:'var(--py-text-mid-alt)', fontSize:11.5, fontWeight:active?700:500, cursor:'pointer' }}>
              {opt.label}
              {active && <span style={{ fontSize:10 }}>{sortDir==='asc'?'↑':'↓'}</span>}
            </button>
          );
        })}
      </div>

      {/* Kreatif Kartlari */}
      {paged.length === 0 ? (
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:48, textAlign:'center' as const, color:T.textDim, fontSize:12.5 }}>{t('Kreatif bulunamadı.')}</div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(3,1fr)', gap:14 }}>
          {paged.map((d:any,i:number) => {
            const tb = isCatalogAd(d) ? { text:t('Katalog'), bg:'var(--py-amber-tint)', color:T.amberDeepText } : typeBadge(d.type||'');
            const sb = statusBadge(d.status||'');
            const cpc = (d.clicks||0)>0 ? (d.spend||0)/(d.clicks||1) : (d.cpc||0);
            const objLabel = metaObjectiveLabel(d.objective, d.existing_post);
            return (
              <div key={i} style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, overflow:'hidden' }}>
                <div style={{ position:'relative' as const, width:'100%', aspectRatio:'1 / 1', background:'var(--py-subtle-bg)', overflow:'hidden' }}>
                  <CreativeThumb src={d.thumbnail_url} kind={(d.type||'').toUpperCase().includes('VIDEO') ? 'VIDEO' : (d.type||'').toUpperCase().includes('CAROUSEL') ? 'CAROUSEL' : 'IMAGE'}/>
                  <span style={{ position:'absolute' as const, top:10, left:10, zIndex:2, padding:'3px 9px', borderRadius:999, background:sb.bg, color:sb.color, fontSize:10, fontWeight:700 }}>{sb.text}</span>
                  {(d.roas||0) > 0 && (
                    <span style={{ position:'absolute' as const, bottom:10, left:10, zIndex:2, padding:'4px 10px', borderRadius:8, background:'rgba(20,22,43,.85)', color:'#E8C97A', fontSize:11, fontWeight:700, fontFamily:MONO }}>{fmt.roas(d.roas)} ROAS</span>
                  )}
                  {(objLabel || d.manage_url) && (() => {
                    const badgeStyle = { position:'absolute' as const, bottom:10, right:10, zIndex:2, padding:'4px 10px', borderRadius:8, background:'rgba(20,22,43,.85)', color:'#fff',
                      fontSize:10.5, fontWeight:700, textDecoration:'none', display:'inline-flex', alignItems:'center', gap:5 };
                    const text = objLabel ? t(objLabel) : t('Önizle');
                    return d.manage_url ? (
                      <a href={d.manage_url} target="_blank" rel="noopener noreferrer" title={t('Reklam amacı — Meta’da önizlemek için tıkla')} style={badgeStyle}>
                        {text}
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M7 17L17 7M9 7h8v8"/></svg>
                      </a>
                    ) : <span style={badgeStyle}>{text}</span>;
                  })()}
                </div>
                <div style={{ padding:'16px 18px' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8, marginBottom:4 }}>
                    <div style={{ fontSize:13.5, fontWeight:800 }}>{d.name||d.ad_name}</div>
                    <span style={{ padding:'2px 8px', borderRadius:999, background:tb.bg, color:tb.color, fontSize:10, fontWeight:700, whiteSpace:'nowrap' as const, flexShrink:0 }}>{tb.text}</span>
                  </div>
                  <div style={{ fontSize:11.5, color:T.textDim, marginBottom:12 }}>{d.campaign_name||'—'}</div>
                  {[
                    [t('Harcama'), fmt.k(d.spend)],
                    [t('Ciro'),    `₺${(d.revenue||0).toLocaleString('tr-TR',{maximumFractionDigits:2})}`],
                    [t('Dönüşüm'), Math.round(d.purchases||d.conversions||0)],
                    [t('Gösterim'), (d.impressions||0).toLocaleString('tr-TR')],
                    [t('Erişim'),   (d.reach||0).toLocaleString('tr-TR')],
                    [t('Tıklama'),  (d.clicks||0).toLocaleString('tr-TR')],
                    ['CTR',      fmt.pct(d.ctr)],
                    ['CPC',      `₺${cpc.toFixed(2)}`],
                    ['CPM',      `₺${(d.cpm||0).toFixed(2)}`],
                    [t('Frekans'),  (d.frequency||0).toFixed(2)],
                  ].map(([label,value],ri) => (
                    <div key={ri} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'7px 0', borderBottom: ri<9?'1px solid var(--py-table-divider)':'none' }}>
                      <span style={{ fontSize:11.5, color:T.textDim }}>{label}</span>
                      <span style={{ fontSize:12, fontWeight:700, fontFamily:MONO }}>{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Sayfalama */}
      <div style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:'12px 20px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={{ fontSize:11.5, color:T.textDim }}>
          {lang==='en'
            ? <>Showing {Math.min(page*PAGE_SIZE+1,sorted.length)}-{Math.min((page+1)*PAGE_SIZE,sorted.length)} of {sorted.length} creatives total.</>
            : <>Toplam {sorted.length} kreatif arasından {Math.min(page*PAGE_SIZE+1,sorted.length)}-{Math.min((page+1)*PAGE_SIZE,sorted.length)} gösteriliyor.</>}
        </span>
        <div style={{ display:'flex', gap:4 }}>
          <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
            style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page===0?'not-allowed':'pointer', opacity:page===0?0.4:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>‹</button>
          {Array.from({length:Math.min(5,totalPages)},(_,i)=>i).map(n=>(
            <button key={n} onClick={()=>setPage(n)}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${page===n?T.accent:T.borderMid}`, background:page===n?T.accent:T.surface, color:page===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{n+1}</button>
          ))}
          <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
            style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page>=totalPages-1?'not-allowed':'pointer', opacity:page>=totalPages-1?.4:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>›</button>
        </div>
      </div>


      {/* Kreatif kırılımları: biçim, ana metin, başlık */}
      <MetaBreakdownCard clientId={config?.client_id||1} dim="format" title="Reklam biçimleri" sub="Biçim, reklamın kreatifine göre sınıflandırılır." start={start} end={end}/>
      <MetaBreakdownCard clientId={config?.client_id||1} dim="creative_text" title="Ana metinler" sub="Bu kırılım yalnızca birden çok metin seçeneği kullanan reklamlarda (dinamik kreatif / Advantage+) oluşur." start={start} end={end}/>
      <MetaBreakdownCard clientId={config?.client_id||1} dim="headline" title="Başlıklar" sub="Bu kırılım yalnızca birden çok metin seçeneği kullanan reklamlarda (dinamik kreatif / Advantage+) oluşur." start={start} end={end}/>
    </div>
  );
}
function RecCard({ rec, onApply, isApplying, pCfg, tCfg, platCfg, onReject, onRevert }:any) {
  const [expanded,setExpanded] = useState(false);
  const pc=pCfg[rec.priority]||{}, tc=tCfg[rec.type]||{}, pl=platCfg[rec.platform]||{};
  return (
    <div style={{ background:'#ffffff', border:`1px solid ${rec.status==='applied'?'#E4E6EF':'#E4E6EF'}`, boxShadow:'0 1px 3px rgba(0,0,0,.03)', borderRadius:10, overflow:'hidden', transition:'all .2s', opacity: rec.status==='applied'?0.55:1 }}
      onMouseEnter={e=>{ if(rec.status!=='applied')(e.currentTarget as HTMLElement).style.borderColor='rgba(201,168,76,.28)'; }}
      onMouseLeave={e=>{ if(rec.status!=='applied')(e.currentTarget as HTMLElement).style.borderColor='#E4E6EF'; }}>
      <div style={{ padding:'14px 18px', display:'flex', alignItems:'center', gap:12, cursor:'pointer' }} onClick={()=>setExpanded(x=>!x)}>
        <div style={{ width:10, height:10, borderRadius:'50%', background:pc.color, flexShrink:0, boxShadow:`0 0 8px ${pc.color}55` }}/>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontSize:13, fontWeight:700, marginBottom:5 }}>{rec.title}</div>
          <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:9, padding:'2px 7px', borderRadius:3, background:pc.bg, color:pc.color, border:`1px solid ${pc.border}` }}>{pc.label}</span>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:9, padding:'2px 7px', borderRadius:3, background:`${tc.color}18`, color:tc.color, border:`1px solid ${tc.color}33` }}>{tc.label}</span>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:GREEN }}>{rec.impact}</span>
          </div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:8, flexShrink:0 }}>
          <span style={{ fontFamily:'Manrope, sans-serif', fontSize:9, padding:'2px 7px', borderRadius:3, background:`${pl.color}18`, color:pl.color, border:`1px solid ${pl.color}33` }}>{pl.label}</span>
          {rec.status==='applied' && (
            <div style={{ display:'flex', alignItems:'center', gap:6 }}>
              <span style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:GREEN, padding:'6px 4px' }}>✓ Uygulandı</span>
              {rec.log_id && onRevert && (
                <button onClick={e=>{e.stopPropagation(); onRevert(rec.id, rec.log_id);}}
                  style={{ fontFamily:'Manrope, sans-serif', fontSize:9, padding:'4px 8px', borderRadius:5, border:'1px solid #e9d5ff', background:'#f3e8ff', color:'#A855F7', cursor:'pointer' }}>
                  ↩ Geri Al
                </button>
              )}
            </div>
          )}
          {rec.status==='rejected' && (
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:'#6B6B8A', padding:'6px 10px' }}>✗ Reddedildi</span>
          )}
          {rec.status==='pending' && (<>
            <button onClick={e=>{e.stopPropagation();onApply(rec.id);}} disabled={isApplying}
              style={{ fontFamily:'Manrope, sans-serif', fontSize:10, padding:'6px 14px', borderRadius:6, border:`1px solid ${GOLD}`, background:isApplying?'rgba(201,168,76,.05)':'rgba(201,168,76,.12)', color:isApplying?C.whiteM:GOLD_L, cursor:isApplying?'wait':'pointer', minWidth:78 }}>
              {isApplying?'···':'UYGULA'}
            </button>
            <button onClick={e=>{e.stopPropagation();onReject&&onReject(rec.id);}}
              style={{ fontFamily:'Manrope, sans-serif', fontSize:10, padding:'6px 10px', borderRadius:6, border:'1px solid rgba(239,68,68,.3)', background:'rgba(239,68,68,.07)', color:'#ef4444', cursor:'pointer' }}>
              ✕
            </button>
          </>)}
          <span style={{ color:'#6B6B8A', fontSize:12, display:'inline-block', transform:expanded?'rotate(180deg)':'none', transition:'transform .2s' }}>▾</span>
        </div>
      </div>
      {expanded && (
        <div style={{ padding:'0 18px 16px', borderTop:'1px solid rgba(255,255,255,.04)' }}>
          <div style={{ fontSize:13, color:'#6B6B8A', lineHeight:1.65, margin:'12px 0 6px' }}>{rec.description}</div>
          {rec.campaign_name && (
            <div style={{ fontSize:11, color:'#6B6B8A', marginBottom:6 }}>
              <span style={{ marginRight:4 }}>{
                rec.campaign_type === 'brand' ? '🏷️' :
                rec.campaign_type === 'awareness' ? '📢' :
                rec.campaign_type === 'remarketing' ? '🔄' :
                rec.campaign_type === 'app' ? '📱' :
                rec.campaign_type === 'shopping' ? '🛍️' :
                rec.campaign_type === 'pmax' ? '⚡' :
                rec.campaign_type === 'dsa' ? '🔍' :
                rec.campaign_type === 'search' ? '🔎' :
                rec.campaign_type === 'conversion' ? '💰' :
                '🎯'
              }</span>
              Kampanya: <span style={{ fontWeight:600, color:'#1A1A2E' }}>{rec.campaign_name}</span>
              {rec.campaign_id && <span style={{ color:'#aaa', marginLeft:6 }}>#{rec.campaign_id}</span>}
              {rec.campaign_type && <span style={{ marginLeft:8, fontSize:9, padding:'1px 6px', borderRadius:3, background:'#F7F8FC', color:'#6B6B8A', textTransform:'uppercase' }}>{rec.campaign_type}</span>}
            </div>
          )}
          {rec.recommendation && (
            <div style={{ fontSize:12, color:'#6B6B8A', lineHeight:1.7, margin:'6px 0 10px', padding:'10px 14px', background:'#F7F8FC', borderRadius:8, borderLeft:`3px solid ${GOLD}` }}>
              <span style={{ fontSize:9, color:GOLD, letterSpacing:1, fontWeight:700, display:'block', marginBottom:4 }}>UYGULA BUTONU NE YAPAR?</span>
              {rec.recommendation}
              {rec.action_type && rec.campaign_id && (
                <div style={{ marginTop:6, fontSize:11, color:'#666' }}>
                  Aksiyon: <strong>{rec.action_type === 'budget_increase' ? 'Bütçe artırımı' : rec.action_type === 'budget_update' ? 'Bütçe güncelleme' : rec.action_type === 'pause_campaign' ? 'Kampanya duraklatma' : rec.action_type === 'optimization' ? 'Manuel optimizasyon' : rec.action_type}</strong>
                  {' — API üzerinden otomatik uygulanacak.'}
                </div>
              )}
              {!rec.campaign_id && (
                <div style={{ marginTop:6, fontSize:11, color:'#f59e0b' }}>⚠️ Kampanya eşleşmedi — manuel uygulama gerekiyor.</div>
              )}
            </div>
          )}
          {rec.what_will_change && (
            <div style={{ fontSize:12, color:'#6B6B8A', lineHeight:1.7, margin:'6px 0 10px', padding:'10px 14px', background:'#F7F8FC', borderRadius:8, borderLeft:`3px solid ${GOLD}` }}>
              <span style={{ fontSize:9, color:GOLD, letterSpacing:1, fontWeight:700, display:'block', marginBottom:4 }}>NE DEĞİŞECEK?</span>
              {rec.what_will_change}
            </div>
          )}
          {rec.action?.type==='budget_update' && (
            <div style={{ display:'flex', gap:8, alignItems:'center' }}>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, background:'#F7F8FC', padding:'6px 12px', borderRadius:6, color:RED }}>Mevcut: ₺{rec.action.current}/gün</div>
              <span style={{ color:'#6B6B8A' }}>→</span>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, background:'#F7F8FC', padding:'6px 12px', borderRadius:6, color:GREEN }}>Önerilen: ₺{rec.action.suggested}/gün</div>
            </div>
          )}
          {rec.action?.type==='target_roas' && (
            <div style={{ display:'flex', gap:8, alignItems:'center' }}>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, background:'#F7F8FC', padding:'6px 12px', borderRadius:6, color:RED }}>Mevcut: %{rec.action.current}</div>
              <span style={{ color:'#6B6B8A' }}>→</span>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, background:'#F7F8FC', padding:'6px 12px', borderRadius:6, color:GREEN }}>Önerilen: %{rec.action.suggested}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}


function RecommendationsTab({ config }:{ config:any }) {
  const [recs, setRecs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState<'all'|'pending'|'applied'|'rejected'>('all');
  const [applying, setApplying] = useState<string|null>(null);
  const [toast, setToast] = useState<string|null>(null);

  const [attribution, setAttribution] = useState<any>(null);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      axios.get(`${API}/intelligence/recommendations`).catch(()=>null),
      axios.get(`${API}/intelligence/attribution`).catch(()=>null),
    ]).then(([recRes, attrRes]) => {
      const data = recRes?.data?.recommendations || [];
      setRecs(data.map((rec:any, i:number) => ({
        ...rec,
        id: rec.id || `rec_${i}`,
        status: rec.status || 'pending',
        priority: rec.priority || 'medium',
        type: rec.type || 'optimization',
      })));
      setAttribution(attrRes?.data || null);
    }).catch(() => setRecs([]))
    .finally(() => setLoading(false));
  }, []);

  const showToast = (msg:string) => { setToast(msg); setTimeout(()=>setToast(null),3500); };

  const handleAction = async (id:string, action:'applied'|'rejected') => {
    if(action==='applied') {
      const rec = recs.find(r => r.id === id);
      if(!rec) return;
      setApplying(id);
      try {
        // Bütçe hesapla
        let new_budget = null;
        let target_campaign_id = null;
        let target_budget = null;

        if(rec.budget_change_pct && rec.current_budget) {
          new_budget = Math.round(rec.current_budget * (1 + rec.budget_change_pct / 100));
        } else if(rec.action_type === 'budget_increase' && rec.current_budget) {
          new_budget = Math.round(rec.current_budget * 1.3);
        }

        // Reallocation: hedef kampanyayı bul
        if(rec.action_type === 'budget_reallocation' && rec.target_campaign_name) {
          const targetRec = recs.find(r => 
            r.campaign_name?.toLowerCase().includes(rec.target_campaign_name?.toLowerCase()) ||
            rec.target_campaign_name?.toLowerCase().includes(r.campaign_name?.toLowerCase())
          );
          if(targetRec?.campaign_id) {
            target_campaign_id = targetRec.campaign_id;
            const saved = rec.current_budget - (new_budget || 0);
            target_budget = Math.round((targetRec.current_budget || 0) + saved);
          }
        }

        const res = await axios.post(`${API}/intelligence/recommendations/apply`, {
          action_type: rec.action_type || 'manual',
          campaign_id: rec.campaign_id || '',
          platform: rec.platform || '',
          new_budget,
          target_campaign_id,
          target_budget,
          campaign_name: rec.campaign_name || '',
          campaign_type: rec.campaign_type || '',
          impact_value: rec.impact_value || 0,
          impact_type: rec.impact_type || 'revenue',
          title: rec.title || '',
          customer_id: config?.platforms?.gads?.customerId || '',
          account_id: config?.platforms?.meta?.accountId || '',
          amount_pct: rec.amount_pct || 0,
        });
        if(res.data?.success) {
          const logId = res.data?.log_id;
          setRecs(prev => prev.map(r => r.id===id ? {...r, status:'applied', applied_at: new Date().toISOString(), log_id: logId} : r));
          showToast('✅ Öneri aksiyon loglarına eklendi, onay bekliyor.');
        } else {
          showToast('⚠️ ' + (res.data?.detail || 'Manuel uygulama gerekiyor'));
          setRecs(prev => prev.map(r => r.id===id ? {...r, status:'applied', applied_at: new Date().toISOString()} : r));
        }
      } catch(e:any) {
        showToast('⚠️ ' + (e.response?.data?.detail || 'Uygulama sırasında hata'));
        setRecs(prev => prev.map(r => r.id===id ? {...r, status:'applied'} : r));
      } finally {
        setApplying(null);
      }
    } else {
      setRecs(prev => prev.map(r => r.id===id ? {...r, status:'rejected'} : r));
      showToast('Öneri reddedildi');
    }
  };

  const filtered = recs.filter(r => filter==='all' || r.status===filter);

  // Attribution hesapla
  const applied    = recs.filter(r => r.status==='applied');
  const pending    = recs.filter(r => r.status==='pending');
  const totalApplied = applied.reduce((s,r) => s+(r.impact_value||0), 0);
  const totalPending = pending.reduce((s,r) => s+(r.impact_value||0), 0);
  const totalAll     = recs.reduce((s,r) => s+(r.impact_value||0), 0);

  const PRIO_CFG:Record<string,any> = {
    high:   { label:'Kritik',   color:'#ef4444', bg:'rgba(239,68,68,.1)',   border:'rgba(239,68,68,.25)'  },
    medium: { label:'Önemli',   color:'#f59e0b', bg:'rgba(245,158,11,.1)',  border:'rgba(245,158,11,.25)' },
    low:    { label:'Optimize', color:'#16D49B', bg:'rgba(34,197,94,.1)',   border:'rgba(34,197,94,.25)'  },
  };
  const TYPE_CFG:Record<string,any> = {
    optimization: { label:'Optimizasyon', color:'#3b82f6' },
    automation:   { label:'Otomasyon',    color:'#A855F7' },
  };
  const PLAT_CFG:Record<string,any> = {
    google: { label:'Google Ads', color:'#4285F4' },
    meta:   { label:'Meta Ads',   color:'#1877F2' },
  };
  const IMPACT_ICON:Record<string,string> = {
    revenue:'📈', saving:'💰', capacity:'⚡'
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>
      {toast && (
        <div style={{ position:'fixed', bottom:32, right:32, zIndex:999, background:'#1a1a1a',
          border:`1px solid ${GOLD}`, borderRadius:8, padding:'12px 20px',
          fontFamily:'Manrope, sans-serif', fontSize:11, color:GOLD,
          boxShadow:'0 8px 32px rgba(0,0,0,.5)' }}>
          {toast}
        </div>
      )}

      {/* Attribution Özet Bar */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(160px,1fr))', gap:10 }}>
        {[
          { label:'TOPLAM TAHMİNİ ETKİ', value:fmt.k(totalAll),     sub:`${recs.length} öneri`,         color:GOLD   },
          { label:'UYGULANAN ETKİ',      value:fmt.k(totalApplied), sub:`${applied.length} öneri`,       color:GREEN  },
          { label:'BEKLEYEN FIRSAT',      value:fmt.k(totalPending), sub:`${pending.length} öneri kaldı`, color:'#f59e0b' },
          { label:'UYGULAMA ORANI',       value:totalAll>0?`%${Math.round((totalApplied/totalAll)*100)}`:'—', sub:'tahmini etki', color:'#3b82f6' },
        ].map(kpi => (
          <div key={kpi.label} style={{ background:'#ffffff', border:'1px solid rgba(201,168,76,.15)',
            borderRadius:10, padding:'14px 16px', boxShadow:'0 1px 3px rgba(0,0,0,.03)' }}>
            <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:'#6B6B8A', letterSpacing:'0.1em', marginBottom:6 }}>{kpi.label}</div>
            <div style={{ fontSize:20, fontWeight:700, color:kpi.color, marginBottom:2 }}>{kpi.value}</div>
            <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:'#6B6B8A' }}>{kpi.sub}</div>
          </div>
        ))}
      </div>

      {/* Etki Progress Bar */}
      {totalAll > 0 && (
        <div style={{ background:'#ffffff', border:'1px solid rgba(201,168,76,.15)', borderRadius:10, padding:'14px 16px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', fontFamily:'Manrope, sans-serif', fontSize:10, color:'#6B6B8A', marginBottom:8 }}>
            <span>Uygulanan: <span style={{ color:GREEN, fontWeight:600 }}>{fmt.k(totalApplied)}</span></span>
            <span>Toplam potansiyel: <span style={{ color:GOLD, fontWeight:600 }}>{fmt.k(totalAll)}</span></span>
          </div>
          <div style={{ height:6, background:'#F7F8FC', borderRadius:3, overflow:'hidden' }}>
            <div style={{ height:'100%', borderRadius:3, background:`linear-gradient(90deg,${GOLD},${GREEN})`,
              width:`${Math.min(100,(totalApplied/totalAll)*100)}%`, transition:'width .6s ease' }}/>
          </div>
        </div>
      )}

      {/* Filtre */}
      <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
        {(['all','pending','applied','rejected'] as const).map(f => {
          const counts:Record<string,number> = {
            all:recs.length,
            pending:recs.filter(r=>r.status==='pending').length,
            applied:recs.filter(r=>r.status==='applied').length,
            rejected:recs.filter(r=>r.status==='rejected').length,
          };
          const labels:Record<string,string> = { all:'Tümü', pending:'Bekleyen', applied:'Uygulanan', rejected:'Reddedilen' };
          return (
            <button key={f} onClick={()=>setFilter(f)} style={{
              fontFamily:'Manrope, sans-serif', fontSize:10, padding:'5px 12px', borderRadius:6,
              border:`1px solid ${filter===f?GOLD:'rgba(201,168,76,.2)'}`,
              background:filter===f?'rgba(201,168,76,.1)':'transparent',
              color:filter===f?GOLD_L:'#6B6B8A', cursor:'pointer',
            }}>
              {labels[f]} <span style={{ opacity:.6 }}>({counts[f]})</span>
            </button>
          );
        })}
      </div>

      {/* Öneri Kartları */}
      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        {filtered.length===0 && (
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:13, color:'#6B6B8A', textAlign:'center', padding:40 }}>
            Biraz bekleyin. Sizin için kampanya optimizasyon önerilerini çıkartıyoruz.
          </div>
        )}
        {filtered.map(rec => (
          <RecCard
            key={rec.id}
            rec={rec}
            onApply={(id:string) => handleAction(id,'applied')}
            isApplying={applying===rec.id}
            pCfg={PRIO_CFG}
            tCfg={TYPE_CFG}
            platCfg={PLAT_CFG}
            onReject={(id:string) => handleAction(id,'rejected')}
            onRevert={async (id:string, logId:number) => {
              if(!logId) return;
              try {
                await axios.post(`${API}/automation/logs/${logId}/revert`);
                setRecs(prev => prev.map(r => r.id===id ? {...r, status:'pending', log_id: null} : r));
              } catch(e:any) {
                const msg = e?.response?.data?.detail || 'Geri alma başarısız';
                alert(msg);
              }
            }}
          />
        ))}
      </div>
    </div>
  );

      {/* Attribution Geçmişi */}
      {attribution?.actions?.length > 0 && (
        <div style={{ marginTop:8 }}>
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, letterSpacing:1, color:'#6B6B8A', marginBottom:10 }}>— UYGULANAN ÖNERİLER GEÇMİŞİ</div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            {attribution.actions.map((a:any, i:number) => (
              <div key={i} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 14px', background:'#F7F8FC', borderRadius:8, fontFamily:'Manrope, sans-serif' }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <span style={{ fontSize:16 }}>{a.platform === 'google' ? '🔵' : a.platform === 'meta' ? '🟣' : '🟢'}</span>
                  <div>
                    <div style={{ fontSize:12, fontWeight:600, color:'#1A1A2E' }}>{a.title || a.campaign_name}</div>
                    <div style={{ fontSize:10, color:'#6B6B8A', marginTop:2 }}>{a.campaign_name} · {a.action_type} · {new Date(a.applied_at).toLocaleDateString('tr-TR')}</div>
                  </div>
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontSize:13, fontWeight:700, color:'#2e7d32' }}>~₺{(a.estimated_impact||0).toLocaleString('tr-TR')}</div>
                  <div style={{ fontSize:9, color:'#6B6B8A' }}>{a.impact_type === 'saving' ? 'tasarruf' : 'gelir'}/ay</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop:10, padding:'10px 14px', background:'rgba(201,168,76,0.08)', borderRadius:8, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A' }}>Toplam uygulanan etki tahmini</span>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:15, fontWeight:700, color:GOLD }}>~₺{(attribution.summary?.total_estimated||0).toLocaleString('tr-TR')}/ay</span>
          </div>
        </div>
      )}
}

function PoyaisOneTab({ config }:{ config:any }) {
  const [targetInfo, setTargetInfo] = useState<TargetInfo|null>(null);
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [templates, setTemplates]     = useState<any[]>([]);
  const [activeRules, setActiveRules] = useState<Set<number>>(new Set());
  const [ruleMap, setRuleMap]         = useState<Record<number,number>>({});
  const [platform, setPlatform]       = useState('all');
  const [search, setSearch]           = useState('');
  const [priority, setPriority]       = useState('all');
  const [loading, setLoading]         = useState(true);
  const [saving, setSaving]           = useState<number|null>(null);
  const [expanded, setExpanded]       = useState<Set<string>>(new Set());
  const [toast, setToast]             = useState<string|null>(null);
  const [clientId, setClientId]       = useState<number|null>(null);
  const [flows, setFlows]             = useState<any[]>([]);
  const [view, setView]               = useState<'sablonlar'|'onay'>('sablonlar');
  const [pendingCount, setPendingCount] = useState(0);
  const { t, lang } = useLang();

  // GA4 kaldırıldı: GA4 analitik-only, kampanya/bütçe üzerinde otomatik bir aksiyon
  // alınamıyor, bu yüzden gerçek optimizasyon şablonlarıyla sınırlandırılan bu listede
  // hep boş bir sekme olurdu (bkz. otomasyon_router.py _deactivate_notify_only_templates).
  const PLATFORMS = [
    { key:'all',      label:t('Tümü'),       color:T.accent },
    { key:'meta',     label:'Meta Ads',   color:T.purpleText },
    { key:'google',   label:'Google Ads', color:T.accentDeep },
  ];
  const PRIO_CFG:Record<string,any> = {
    high: { label:t('KRİTİK'), color:T.redText, bg:T.redTint  },
    med:  { label:t('ÖNEMLİ'), color:T.amberText, bg:T.amberTintAlt },
    low:  { label:t('OPTİMİZE'),color:T.greenText,bg:T.greenTint  },
  };

  const showToast = (msg:string) => { setToast(msg); setTimeout(()=>setToast(null),3500); };

  useEffect(() => {
    axios.get(`${API}/clients/`).then(r => {
      const list = Array.isArray(r.data) ? r.data : [r.data];
      // Seçili (aktif) müşteri; yoksa listenin ilki. Önceden hep ilk müşteriye bakılıyordu.
      const savedId = config?.activeClientId || parseInt(localStorage.getItem('poyais_active_client') || '0');
      const id = list.find((c:any) => c.id === savedId)?.id || list[0]?.id;
      setClientId(id || 1);
    }).catch(() => setClientId(1));
  }, []);

  useEffect(() => {
    const params = platform !== 'all' ? `?platform=${platform}` : '';
    axios.get(`${API}/automation/templates${params}`)
      .then(r => setTemplates(r.data))
      .catch(() => showToast(t('Şablonlar yüklenemedi')))
      .finally(() => setLoading(false));
  }, [platform]);

  const loadTarget = () => { if(clientId) axios.get(`${API}/automation/target-roas`, { params:{ client_id: clientId, _t: Date.now() } }).then(r => setTargetInfo(r.data)).catch(() => setTargetInfo(null)); };
  useEffect(() => { loadTarget(); }, [clientId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(!clientId) return;
    axios.get(`${API}/automation/flows?client_id=${clientId}`)
      .then(r => setFlows(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
  }, [clientId]);

  // "Onay Bekleyenler" rozeti — yalnızca aktif ettiğimiz şablon kurallarının
  // scheduler'dan gelen onayları (Optimizasyonlar'ın kendi kuyruğu ayrı)
  useEffect(() => {
    if(!clientId) return;
    axios.get(`${API}/automation/logs`, { params: { client_id: clientId, status: 'pending', limit: 100, has_rule: true } })
      .then(r => setPendingCount(Array.isArray(r.data) ? r.data.length : 0))
      .catch(() => setPendingCount(0));
  }, [clientId, view]);

  useEffect(() => {
    if(!clientId) return;
    axios.get(`${API}/automation/rules?client_id=${clientId}`)
      .then(r => {
        const ids = new Set<number>(r.data.map((x:any) => x.template_id));
        const map:Record<number,number> = {};
        r.data.forEach((x:any) => { map[x.template_id] = x.id; });
        setActiveRules(ids); setRuleMap(map);
      }).catch(console.error);
  }, [clientId]);

  const filtered = templates.filter(tpl => {
    if(priority !== 'all' && tpl.priority !== priority) return false;
    if(search && !tpl.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const handleToggle = async (tpl:any) => {
    if(!clientId) return;
    const isActive = activeRules.has(tpl.id);
    setSaving(tpl.id);
    try {
      if(isActive) {
        await axios.delete(`${API}/automation/rules/${ruleMap[tpl.id]}`);
        setActiveRules(prev => { const s=new Set(prev); s.delete(tpl.id); return s; });
        setRuleMap(prev => { const m={...prev}; delete m[tpl.id]; return m; });
        showToast(lang==='en' ? `"${tpl.name}" was disabled` : `"${tpl.name}" devre dışı bırakıldı`);
      } else {
        const res = await axios.post(`${API}/automation/rules?client_id=${clientId}`, { template_id: tpl.id });
        setActiveRules(prev => { const s=new Set(prev); s.add(tpl.id); return s; });
        setRuleMap(prev => ({ ...prev, [tpl.id]: res.data.id }));
        showToast(lang==='en' ? `"${tpl.name}" activated ✓` : `"${tpl.name}" aktif edildi ✓`);
      }
    } catch(e:any) {
      showToast(t('Hata:') + ' ' + (e.response?.data?.detail || t('Bilinmeyen hata')));
    }
    setSaving(null);
  };

  const toggleExpand = (slug:string) => {
    setExpanded(prev => { const s=new Set(prev); s.has(slug)?s.delete(slug):s.add(slug); return s; });
  };

  if(loading) return <Loader/>;

  // AI öneri şablonları (priority===high ilk bul)
  const aiSuggestion = templates.find(tpl => tpl.priority==='high' && !activeRules.has(tpl.id));

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:28, fontFamily:'Manrope, sans-serif' }}>

      {/* Toast */}
      {toast && (
        <div style={{ position:'fixed', bottom:32, right:32, zIndex:999, background:T.ink,
          borderRadius:12, padding:'12px 20px',
          fontSize:12, fontWeight:600, color:'#fff', boxShadow:'0 12px 32px rgba(20,22,43,.25)' }}>
          {toast}
        </div>
      )}

      {/* Şablonlar / Onay Bekleyenler */}
      <div style={{ display:'flex', gap:3, background:T.trackBg, padding:3, borderRadius:10, width:'fit-content' }}>
        {(['sablonlar','onay'] as const).map(v => (
          <button key={v} onClick={() => setView(v)} style={{
            padding:'7px 15px', borderRadius:8, border:'none', cursor:'pointer', fontSize:12.5, fontWeight: view===v?700:600,
            background: view===v ? T.surface : 'transparent', color: view===v ? T.text : T.textMidAlt,
            boxShadow: view===v ? '0 1px 2px rgba(20,22,43,.1)' : 'none',
            display:'flex', alignItems:'center', gap:6,
          }}>
            {v==='sablonlar' ? t('Şablonlar') : t('Onay Bekleyenler')}
            {v==='onay' && pendingCount > 0 && (
              <span style={{ fontSize:10.5, fontWeight:800, minWidth:16, height:16, padding:'0 4px', borderRadius:999,
                background:T.red, color:'#fff', display:'inline-flex', alignItems:'center', justifyContent:'center' }}>
                {pendingCount}
              </span>
            )}
          </button>
        ))}
      </div>

      {view === 'onay' ? (
        clientId && <PendingApprovals clientId={clientId} showToast={showToast} onCountChange={setPendingCount} hasRule={true}
          emptyTitle={t('Onay bekleyen otomasyon yok')} emptyHint={t('Aktif ettiğin bir şablonun koşulu sağlandığında burada onay bekleyecek.')} />
      ) : (
      <>
      {clientId && <TargetRoasCard clientId={clientId} info={targetInfo} onChange={loadTarget} showToast={showToast} />}
      {/* Platform + Priority filters */}
      <div style={{ display:'flex', gap:8, flexWrap:'wrap' as const, alignItems:'center' }}>
        {PLATFORMS.map(p => {
          const count = p.key==='all' ? templates.length : templates.filter(t=>t.platform===p.key).length;
          const isAct = platform===p.key;
          return (
            <button key={p.key} onClick={() => setPlatform(p.key)} style={{
              padding:'6px 13px', borderRadius:999, cursor:'pointer', fontSize:12, fontWeight: isAct?700:600,
              border:`1px solid ${isAct ? p.color : T.borderMid}`,
              background: isAct ? alpha(p.color,9) : T.surface,
              color: isAct ? p.color : T.textMid,
            }}>
              {p.label} <span style={{ opacity:.6, fontSize:11 }}>{count}</span>
            </button>
          );
        })}
        <div style={{ width:1, height:20, background:T.border, margin:'0 4px' }}/>
        {(['all','high','med','low'] as const).map(p => (
          <button key={p} onClick={() => setPriority(p)} style={{
            padding:'6px 13px', borderRadius:999, cursor:'pointer', fontSize:11, fontWeight:700,
            border:`1px solid ${priority===p ? (PRIO_CFG[p]?.color||T.accent) : T.borderMid}`,
            background: priority===p ? (PRIO_CFG[p]?.bg||T.amberTint) : T.surface,
            color: priority===p ? (PRIO_CFG[p]?.color||T.accent) : T.textDim,
            letterSpacing:'0.04em',
          }}>
            {p==='all' ? t('TÜMÜ') : PRIO_CFG[p]?.label}
          </button>
        ))}
        <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:9, flexShrink:0, border:`1px solid ${T.borderMid}`, background:T.surface, borderRadius:11, padding:'8px 13px' }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={T.textDim} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder={t('Şablon ara…')}
            style={{ border:'none', outline:'none', fontSize:12.5, color:T.text, fontFamily:'inherit', background:'transparent', width:160 }}/>
        </div>
      </div>

      {/* Template Cards Grid */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:16 }}>
        {filtered.map((tpl:any) => {
          const isActive = activeRules.has(tpl.id);
          const isExp    = expanded.has(tpl.slug);
          const prioCfg  = PRIO_CFG[tpl.priority] || PRIO_CFG.med;
          const trigger  = tpl.trigger_logic?.conditions || [];
          const action   = tpl.action_logic || {};
          const isAI     = tpl.priority === 'ai' || tpl.name?.toLowerCase().includes('ai') || tpl.name?.toLowerCase().includes('akıllı');

          // Status label
          const lastRun = tpl.last_triggered || tpl.last_run || null;
          const lastRunText = lastRun ? (() => {
            const diff = Math.floor((Date.now() - new Date(lastRun).getTime()) / 60000);
            if(lang==='en') {
              if(diff < 1) return 'JUST NOW';
              if(diff < 60) return diff + 'M AGO';
              const h = Math.floor(diff/60);
              if(h < 24) return h + 'H AGO';
              return Math.floor(h/24) + 'D AGO';
            }
            if(diff < 1) return 'AZ ÖNCE';
            if(diff < 60) return diff + 'DK ÖNCE';
            const h = Math.floor(diff/60);
            if(h < 24) return h + 'SA ÖNCE';
            return Math.floor(h/24) + 'GÜN ÖNCE';
          })() : null;
          const statusLabel = isActive
            ? { icon:'🔔', text:t('AKTİF İZLEME'), color:T.green, bg:alpha(T.green,8) }
            : lastRunText
              ? { icon:'⏱', text:t('SON ÇALIŞMA:') + ' ' + lastRunText, color:T.textDimAlt, bg:alpha(T.textDimAlt,8) }
              : { icon:'', text:'', color:'transparent', bg:'transparent' };

          return (
            <div key={tpl.id} style={{
              background: isAI ? T.purpleTint : T.surface,
              border: isAI ? `1px solid ${alpha(T.purple,25)}` : `1px solid ${isActive?alpha(T.accent,45):T.border}`,
              borderRadius:14, padding:20, opacity:saving===tpl.id?.6:1,
              transition:'border-color .15s', display:'flex', flexDirection:'column', gap:12,
            }}>
              {/* Top row */}
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div style={{ display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' as const }}>
                  <span style={{
                    fontSize:10, fontWeight:700, padding:'3px 9px', borderRadius:999,
                    color: isAI ? T.purpleText : prioCfg.color,
                    background: isAI ? T.purpleTint : prioCfg.bg,
                  }}>
                    {isAI ? t('AI ÖNERİSİ') : prioCfg.label}
                  </span>
                  {tpl.platform && (() => {
                    const platMap: Record<string,{label:string,color:string,bg:string}> = {
                      'google': { label:'Google Ads', color:T.accentDeep, bg:T.amberTintAlt },
                      'meta':   { label:'Meta Ads',   color:T.purpleText, bg:T.purpleTint },
                      'ga4':    { label:'GA4',        color:T.orangeText, bg:T.orangeTint },
                    };
                    const pm = platMap[tpl.platform] || { label: tpl.platform, color:T.textMidAlt, bg:T.trackBg };
                    return (
                      <span style={{
                        fontSize:10, fontWeight:700, padding:'3px 9px', borderRadius:999,
                        color: pm.color, background: pm.bg,
                      }}>
                        {pm.label}
                      </span>
                    );
                  })()}
                </div>
                {isAI ? (
                  <span style={{ width:26, height:26, borderRadius:8, background:T.purpleTint, color:T.purpleText, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.8 4.7L18.5 9.5 13.8 11.3 12 16l-1.8-4.7L5.5 9.5l4.7-1.8z"/></svg>
                  </span>
                ) : (
                  <div onClick={() => !saving && handleToggle(tpl)} style={{
                    width:38, height:22, borderRadius:11, flexShrink:0, cursor:saving?'wait':'pointer',
                    background: isActive ? T.accent : T.borderSoft,
                    position:'relative', transition:'background .2s',
                  }}>
                    <div style={{
                      width:16, height:16, borderRadius:'50%', background:T.surface,
                      position:'absolute', top:3, left: isActive ? 19 : 3,
                      transition:'left .2s', boxShadow:'0 1px 3px rgba(20,22,43,.25)',
                    }}/>
                  </div>
                )}
              </div>

              {/* Name + Description */}
              <div>
                <div style={{ fontSize:13.5, fontWeight:800, color:T.text, lineHeight:1.35, marginBottom:6 }}>{tpl.name}</div>
                {tpl.description && (
                  <div style={{ fontSize:12, color:T.textMidAlt, lineHeight:1.6 }}>{tpl.description}</div>
                )}
              </div>

              {/* AI Activate button */}
              {isAI && (
                <button onClick={() => handleToggle(tpl)} style={{
                  alignSelf:'flex-start', padding:'7px 14px', borderRadius:9,
                  border:`1px solid ${alpha(T.purple,25)}`, background:T.purpleTint,
                  color:T.purpleText, fontSize:11.5, fontWeight:700, cursor:'pointer',
                }}>
                  {t('Aktive Et')}
                </button>
              )}

              {/* Status footer */}
              {!isAI && (
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'auto', paddingTop:10, borderTop:`1px solid ${T.tableDivider}` }}>
                  {isActive && statusLabel.text ? (
                    <span style={{
                      fontSize:10, fontWeight:700,
                      color:statusLabel.color, background:statusLabel.bg,
                      padding:'3px 9px', borderRadius:999,
                    }}>
                      {statusLabel.text}
                    </span>
                  ) : <span/>}
                  <button onClick={() => toggleExpand(tpl.slug)} style={{
                    background:'none', border:'none', cursor:'pointer', color:T.textDim,
                    fontSize:16, padding:'2px 6px', lineHeight:1,
                  }}>⋯</button>
                </div>
              )}

              {/* Expanded detail */}
              {isExp && (
                <div style={{ marginTop:4, paddingTop:12, borderTop:`1px solid ${T.tableDivider}` }}>
                  <div style={{ fontSize:10, fontWeight:700, color:T.textDim, textTransform:'uppercase' as const, letterSpacing:'0.08em', marginBottom:8 }}>{t('Tetikleyici Koşullar')}</div>
                  {trigger.map((c:any, i:number) => {
                    const metricTR:Record<string,string> = {
                      'roas':'ROAS','ctr':'tıklama oranı','cpc':'tıklama başı maliyet',
                      'cpm':'bin gösterim maliyeti','cpa':'dönüşüm başı maliyet',
                      'conversions':'dönüşüm sayısı','spend':'toplam harcama',
                      'frequency':'reklam frekansı','impressions':'gösterim sayısı','today_roas':'bugünkü ROAS',
                      'conv_rate':'dönüşüm oranı','sessions':'oturum sayısı',
                      'bounce_rate':'hemen çıkma oranı','days_running':'çalışma süresi (gün)',
                      'hour_of_day':'günün saati','day_of_week':'haftanın günü',
                      'search_impression_share':'arama gösterim payı',
                      'weekly_spend':'haftalık harcama','campaign_type':'kampanya tipi',
                      'zero_conv_campaigns_count':'sıfır dönüşümlü kampanya sayısı',
                      'prev_avg_bounce_rate':'önceki ortalama hemen çıkma oranı',
                      'organic_sessions':'organik oturum sayısı',
                      'consecutive_drop_days':'art arda düşüş günü',
                      'consecutive_days_below':'art arda hedef altı gün',
                      'atc_rate_change_pct':'sepete ekleme değişim oranı',
                      'purchase_rate_change_pct':'satın alma oranı değişimi',
                      'atc_to_purchase_gap_pct':'sepet-satış farkı',
                      'ga4_vs_meta_revenue_diff_pct':'GA4 ile Meta gelir farkı',
                      'impressions_change_pct':'gösterim değişim oranı',
                      'quality_score':'kalite puanı','campaign_label':'kampanya etiketi',
                      'add_to_cart':'sepete ekleme','purchases':'satın alma sayısı',
                      'new_user_rate_pct':'yeni kullanıcı oranı',
                      'mobile_conv_rate':'mobil dönüşüm oranı',
                      'budget_remaining_pct':'kalan bütçe oranı',
                      'spend_pct_of_daily_budget':'günlük bütçe kullanım oranı',
                      'total_orders':'toplam sipariş','stock_count':'stok adedi',
                      'cancel_rate':'iptal oranı','weekly_avg_roas':'haftalık ortalama ROAS',
                      'weekly_sales':'haftalık satış','daily_revenue':'günlük gelir',
                      'sales_velocity_rank':'satış hızı sıralaması',
                    };
                    const metricEN:Record<string,string> = {
                      'today_roas':"today's ROAS",
                      'roas':'ROAS','ctr':'click-through rate','cpc':'cost per click',
                      'cpm':'cost per 1,000 impressions','cpa':'cost per conversion',
                      'conversions':'conversion count','spend':'total spend',
                      'frequency':'ad frequency','impressions':'impression count',
                      'conv_rate':'conversion rate','sessions':'session count',
                      'bounce_rate':'bounce rate','days_running':'days running',
                      'hour_of_day':'hour of day','day_of_week':'day of week',
                      'search_impression_share':'search impression share',
                      'weekly_spend':'weekly spend','campaign_type':'campaign type',
                      'zero_conv_campaigns_count':'zero-conversion campaign count',
                      'prev_avg_bounce_rate':'previous average bounce rate',
                      'organic_sessions':'organic session count',
                      'consecutive_drop_days':'consecutive drop days',
                      'consecutive_days_below':'consecutive days below target',
                      'atc_rate_change_pct':'add-to-cart rate change',
                      'purchase_rate_change_pct':'purchase rate change',
                      'atc_to_purchase_gap_pct':'cart-to-purchase gap',
                      'ga4_vs_meta_revenue_diff_pct':'GA4 vs Meta revenue difference',
                      'impressions_change_pct':'impression change rate',
                      'quality_score':'quality score','campaign_label':'campaign label',
                      'add_to_cart':'add to cart','purchases':'purchase count',
                      'new_user_rate_pct':'new user rate',
                      'mobile_conv_rate':'mobile conversion rate',
                      'budget_remaining_pct':'remaining budget ratio',
                      'spend_pct_of_daily_budget':'daily budget usage ratio',
                      'total_orders':'total orders','stock_count':'stock count',
                      'cancel_rate':'cancellation rate','weekly_avg_roas':'weekly average ROAS',
                      'weekly_sales':'weekly sales','daily_revenue':'daily revenue',
                      'sales_velocity_rank':'sales velocity rank',
                    };
                    const opTR:Record<string,string> = {
                      'eq':'değerine eşit olduğunda','lt':'değerinin altına düştüğünde',
                      'gt':'değerini aştığında','gte':'değerine ulaştığında veya geçtiğinde',
                      'lte':'değerinin altında kaldığında','contains':'değerini içerdiğinde',
                      'between':'aralığında olduğunda',
                    };
                    const opEN:Record<string,string> = {
                      'eq':'equals','lt':'drops below',
                      'gt':'exceeds','gte':'reaches or exceeds',
                      'lte':'stays below','contains':'contains',
                      'between':'is between',
                    };
                    const m = c.metric || '';
                    const label = lang==='en'
                      ? (metricEN[m] || m.replace(/_/g,' ')
                          .replace('prev ','previous ').replace('avg ','average ')
                          .replace(' pct',' (%)').replace(' rate',' rate')
                          .replace(' count',' count').replace(' share',' share'))
                      : (metricTR[m] || m.replace(/_/g,' ')
                          .replace('prev ','önceki ').replace('avg ','ortalama ')
                          .replace(' pct',' (%)').replace(' rate',' oranı')
                          .replace(' count',' sayısı').replace(' share',' payı'));
                    const op = lang==='en' ? (opEN[c.operator] || c.operator) : (opTR[c.operator] || c.operator);
                    const exprMap:Record<string,string> = {
                      'prev_week_conv_rate*0.5': "geçen haftanın dönüşüm oranının %50'si",
                      'prev_week_conv_rate*0.6': "geçen haftanın dönüşüm oranının %60'ı",
                      'prev_week_organic*0.7': "geçen hafta organik oturumların %70'i",
                      'target_roas*0.6': "hedef ROAS değerinin %60'ı",
                      'target_roas*0.7': "hedef ROAS değerinin %70'i",
                      'target_roas*1.4': "hedef ROAS değerinin 1.4 katı",
                      'target_roas*1.5': "hedef ROAS değerinin 1.5 katı",
                      'target_roas*1.6': "hedef ROAS değerinin 1.6 katı",
                      'target_roas': "hedef ROAS değeri",
                      'daily_budget*0.3': "günlük bütçenin %30'u",
                      'daily_budget': "günlük bütçe",
                      'avg_cpc_7d*1.5': "7 günlük ortalama TBM'nin 1.5 katı",
                      'campaign_avg_cpc*2': "kampanya ortalama TBM'nin 2 katı",
                      'weekly_avg_roas*0.8': "haftalık ortalama ROAS'ın %80'i",
                      'weekly_avg_daily_revenue*0.5': "haftalık ortalama günlük gelirin %50'si",
                      'target_cpa*1.3': "hedef CPA'nın 1.3 katı",
                      'site_avg_conv_rate*0.7': "site ortalama dönüşüm oranının %70'i",
                      'desktop_conv_rate*0.4': "masaüstü dönüşüm oranının %40'ı",
                      'industry_avg_cpm*0.7': "sektör ortalama CPM'nin %70'i",
                      'avg_hourly_spend*1.3': "saatlik ortalama harcamanın 1.3 katı",
                      'prev_period_sessions*0.6': "önceki dönem oturumlarının %60'ı",
                      'prev_month_18_24_pct*1.3': "geçen ay 18-24 yaş payının 1.3 katı",
                    };
                    const exprMapEN:Record<string,string> = {
                      'prev_week_conv_rate*0.5': "50% of last week's conversion rate",
                      'prev_week_conv_rate*0.6': "60% of last week's conversion rate",
                      'prev_week_organic*0.7': "70% of last week's organic sessions",
                      'target_roas*0.6': "60% of the target ROAS",
                      'target_roas*0.7': "70% of the target ROAS",
                      'target_roas*1.4': "1.4x the target ROAS",
                      'target_roas*1.5': "1.5x the target ROAS",
                      'target_roas*1.6': "1.6x the target ROAS",
                      'target_roas': "the target ROAS",
                      'daily_budget*0.3': "30% of the daily budget",
                      'daily_budget': "the daily budget",
                      'avg_cpc_7d*1.5': "1.5x the 7-day average CPC",
                      'campaign_avg_cpc*2': "2x the campaign average CPC",
                      'weekly_avg_roas*0.8': "80% of the weekly average ROAS",
                      'weekly_avg_daily_revenue*0.5': "50% of the weekly average daily revenue",
                      'target_cpa*1.3': "1.3x the target CPA",
                      'site_avg_conv_rate*0.7': "70% of the site average conversion rate",
                      'desktop_conv_rate*0.4': "40% of the desktop conversion rate",
                      'industry_avg_cpm*0.7': "70% of the industry average CPM",
                      'avg_hourly_spend*1.3': "1.3x the average hourly spend",
                      'prev_period_sessions*0.6': "60% of the previous period's sessions",
                      'prev_month_18_24_pct*1.3': "1.3x last month's 18-24 age share",
                    };
                    const campaignTypeMap:Record<string,string> = {
                      '2':'Arama (Search)','3':'Display','4':'Shopping',
                      '6':'Video','7':'Akıllı (Smart)','9':'Discovery',
                      '10':'Performance Max','11':'Demand Gen','14':'Demand Gen',
                    };
                    const campaignTypeMapEN:Record<string,string> = {
                      '2':'Search','3':'Display','4':'Shopping',
                      '6':'Video','7':'Smart','9':'Discovery',
                      '10':'Performance Max','11':'Demand Gen','14':'Demand Gen',
                    };
                    const dayMap:Record<string,string> = {
                      'Monday':'Pazartesi','Tuesday':'Salı','Wednesday':'Çarşamba',
                      'Thursday':'Perşembe','Friday':'Cuma','Saturday':'Cumartesi','Sunday':'Pazar',
                    };
                    const dayMapEN:Record<string,string> = {
                      'Monday':'Monday','Tuesday':'Tuesday','Wednesday':'Wednesday',
                      'Thursday':'Thursday','Friday':'Friday','Saturday':'Saturday','Sunday':'Sunday',
                    };
                    let rawVal = c.value_expr
                      ? (lang==='en' ? (exprMapEN[c.value_expr] || c.value_expr) : (exprMap[c.value_expr] || c.value_expr))
                      : (Array.isArray(c.value) ? c.value.join(lang==='en' ? ' and ' : ' ile ') : String(c.value ?? ''));
                    if(m === 'campaign_type') {
                      const ctMap = lang==='en' ? campaignTypeMapEN : campaignTypeMap;
                      if(ctMap[rawVal]) rawVal = ctMap[rawVal] + (lang==='en' ? ' campaign' : ' kampanyası');
                    }
                    if(m === 'day_of_week') {
                      const dMap = lang==='en' ? dayMapEN : dayMap;
                      if(dMap[rawVal]) rawVal = dMap[rawVal];
                    }
                    if(m === 'hour_of_day') rawVal = rawVal + ':00';
                    const val = rawVal;
                    // Sayısal değerlere % ekle eğer metrik oran/pct ise
                    const isPct = m.includes('pct') || m.includes('rate') || m.includes('share') || m.includes('ctr');
                    const displayVal = isPct && !isNaN(Number(val)) ? '%' + val : val;
                    // Bayrak/liste tipi koşullar ham metrik adıyla ("has zero conv ad: 1 değerine eşit") okunmaz;
                    // her biri için müşterinin anlayacağı tam cümle yazılır.
                    const specialTR:Record<string,string> = {
                      has_zero_conv_ad: "Son 7 günde 300₺'den fazla harcayıp hiç satın alma getirmeyen bir kampanya olduğunda",
                      zero_conv_campaigns_count: "Son 7 günde 300₺'den fazla harcayıp hiç dönüşüm getirmeyen bir kampanya olduğunda",
                      has_shopping_scale_candidate: "Hedef ROAS'ı tanımlı bir Shopping kampanyasının ROAS'ı, kendi hedefinin %150'sini aştığında",
                      has_demand_gen_scale_candidate: "Bir Demand Gen kampanyasının tıklama oranı %2'yi, ROAS'ı da hedef ROAS'ı aştığında",
                    };
                    const specialEN:Record<string,string> = {
                      has_zero_conv_ad: "When a campaign spent over ₺300 in the last 7 days with no purchases",
                      zero_conv_campaigns_count: "When a campaign spent over ₺300 in the last 7 days with no conversions",
                      has_shopping_scale_candidate: "When a Shopping campaign with a target ROAS exceeds 150% of its own target",
                      has_demand_gen_scale_candidate: "When a Demand Gen campaign has CTR above 2% and ROAS above the target ROAS",
                    };
                    const special = (lang==='en' ? specialEN : specialTR)[m];
                    const isFlag = m.startsWith('has_') ? Number(c.value)===1 : (m==='zero_conv_campaigns_count' && c.operator==='gt' && Number(c.value)===0);
                    const dayList = Array.isArray(c.value) ? c.value.map((d:string)=> (lang==='en' ? dayMapEN : dayMap)[d] || d) : [];
                    const eff = targetInfo ? (targetInfo.manual || (targetInfo.auto as any)[tpl.platform] || null) : null;
                    const tNote = !String(lang==='en' ? c.text_en : c.text_tr).includes('{target}') ? '' :
                      eff ? (targetInfo?.manual ? (lang==='en' ? ` (target: ${eff}×)` : ` (hedef: ${eff}×)`)
                                                 : (lang==='en' ? ` (reference now: ${eff}×, last-30-day average)` : ` (şu an referans: ${eff}×, son 30 gün ortalaması)`))
                          : (lang==='en' ? ' (target not available yet)' : ' (hedef henüz belirlenemedi)');
                    const ownText = lang==='en' ? c.text_en : c.text_tr;
                    const rawSentence = ownText ? String(ownText).replace('{target}', tNote)
                      : (special && isFlag) ? special
                      : (m==='day_of_week' && c.operator==='in' && dayList.length)
                        ? (lang==='en' ? `On ${dayList.join(' or ')}` : `${dayList.join(' veya ')} günü`)
                        : lang==='en' ? `${label} ${op} ${displayVal}` : `${label}: ${displayVal} ${op}`;
                    const capSentence = rawSentence.charAt(0).toUpperCase() + rawSentence.slice(1);
                    const sentence = /[.!?]$/.test(capSentence.trim()) ? capSentence : capSentence + '.';
                    return (
                      <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:6, marginBottom:5 }}>
                        <span style={{ width:5, height:5, borderRadius:'50%', background:alpha(T.accent,45), flexShrink:0, display:'inline-block', marginTop:5 }}/>
                        <span style={{ fontSize:11.5, color:T.textMid, lineHeight:1.5 }}>{sentence}</span>
                      </div>
                    );
                  })}
                  {action.type && (
                    <>
                      <div style={{ fontSize:10, fontWeight:700, color:T.textDim, textTransform:'uppercase' as const, letterSpacing:'0.08em', margin:'10px 0 6px' }}>{t('Aksiyon')}</div>
                      <div style={{ background:T.subtleBg, border:`1px solid ${T.tableDivider}`, borderRadius:9, padding:'9px 12px', fontSize:11.5, color:T.textMid, lineHeight:1.6 }}>
                        {(()=>{
                          const at = action.type || '';
                          const pct = action.amount_pct ? ` (%${action.amount_pct})` : '';
                          const actionLabels:Record<string,string> = {
                            'notify': 'E-posta bildirimi gönderilir.',
                            'report': 'Mail gönderilir.',
                            'pause_campaign': 'İlgili kampanya duraklatılır.',
                            'pause_ad': 'İlgili kampanya duraklatılır.',
                            'decrease_budget': `Kampanya bütçesi düşürülür${pct}.`,
                            'increase_budget': `Kampanya bütçesi artırılır${pct}.`,
                            'enable_campaign': 'Kampanya yeniden aktif edilir.',
                            'update_target_roas': 'Hedef ROAS güncellenir.',
                            'budget_reallocation': `Bütçe yüksek performanslı kampanyaya aktarılır${pct}.`,
                          };
                          const actionLabelsEN:Record<string,string> = {
                            'notify': 'An email notification is sent.',
                            'report': 'An email report is sent.',
                            'pause_campaign': 'The related campaign is paused.',
                            'pause_ad': 'The related campaign is paused.',
                            'decrease_budget': `Campaign budget is decreased${pct}.`,
                            'increase_budget': `Campaign budget is increased${pct}.`,
                            'enable_campaign': 'The campaign is re-enabled.',
                            'update_target_roas': 'Target ROAS is updated.',
                            'budget_reallocation': `Budget is reallocated to the higher-performing campaign${pct}.`,
                          };
                          const own = lang==='en' ? action.text_en : action.text_tr;
                          if(own) return own;
                          return lang==='en' ? (actionLabelsEN[at] || at.replace(/_/g,' ')) : (actionLabels[at] || at.replace(/_/g,' '));
                        })()}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          );
        })}

        {/* Custom Akışlar */}
        {flows.map((flow:any) => (
          <div key={flow.id} style={{
            background:T.purpleTint,
            border:`1px solid ${flow.is_active ? alpha(T.purple,45) : alpha(T.purple,25)}`,
            borderRadius:14, padding:20, display:'flex', flexDirection:'column', gap:12,
            transition:'border-color .15s',
          }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
              <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                <span style={{ fontSize:10, fontWeight:700, padding:'3px 9px', borderRadius:999, color:T.purpleText, background:T.purpleTint }}>{t('Özel Akış')}</span>
              </div>
              <div onClick={()=>{
                axios.patch(`${API}/automation/flows/${flow.id}/toggle`)
                  .then(r => setFlows(prev => prev.map(f => f.id===flow.id ? {...f, is_active: r.data.is_active} : f)))
                  .catch(()=>{});
              }} style={{
                width:38, height:22, borderRadius:11, flexShrink:0, cursor:'pointer',
                background: flow.is_active ? T.purple : T.borderSoft,
                position:'relative', transition:'background .2s',
              }}>
                <div style={{
                  width:16, height:16, borderRadius:'50%', background:T.surface,
                  position:'absolute', top:3, left: flow.is_active ? 19 : 3,
                  transition:'left .2s', boxShadow:'0 1px 3px rgba(20,22,43,.25)',
                }}/>
              </div>
            </div>
            <div>
              <div style={{ fontSize:13.5, fontWeight:800, color:T.text, marginBottom:4 }}>{flow.name}</div>
              <div style={{ fontSize:12, color:T.textMidAlt }}>{t('Özel otomasyon akışı')}</div>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'auto', paddingTop:10, borderTop:`1px solid ${alpha(T.purple,20)}` }}>
              {flow.is_active ? (
                <span style={{ fontSize:10, fontWeight:700, color:T.purpleText, background:T.purpleTint, padding:'3px 9px', borderRadius:999 }}>{t('Aktif İzleme')}</span>
              ) : <span/>}
              <button onClick={()=>window.dispatchEvent(new CustomEvent('poyais-nav',{detail:'poyaisone-flow'}))}
                style={{ background:'none', border:'none', cursor:'pointer', color:T.textDim, fontSize:13, padding:'2px 6px' }}>{t('Düzenle')}</button>
            </div>
          </div>
        ))}

        {/* Yeni Akış Oluştur card */}
        <div onClick={()=>window.dispatchEvent(new CustomEvent('poyais-nav',{detail:'poyaisone-flow'}))}
          style={{
            border:`1px dashed ${alpha(T.purple,35)}`, borderRadius:14, padding:20,
            display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
            minHeight:200, cursor:'pointer', transition:'border-color .15s, background .15s', gap:12,
            background:'transparent',
          }}
          onMouseEnter={e=>{(e.currentTarget as HTMLDivElement).style.borderColor=T.purple; (e.currentTarget as HTMLDivElement).style.background=T.purpleTint;}}
          onMouseLeave={e=>{(e.currentTarget as HTMLDivElement).style.borderColor=alpha(T.purple,35); (e.currentTarget as HTMLDivElement).style.background='transparent';}}>
          <span style={{ width:38, height:38, borderRadius:11, background:T.purpleTint, color:T.purpleText, display:'flex', alignItems:'center', justifyContent:'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"/></svg>
          </span>
          <span style={{ fontSize:13, fontWeight:700, color:T.purpleText }}>{t('Yeni Akış Oluştur')}</span>
          <span style={{ fontSize:11.5, color:T.textDim, textAlign:'center' as const }}>{t('Özel otomasyon akışı oluşturun.')}</span>
        </div>
      </div>

      {filtered.length === 0 && (
        <div style={{ textAlign:'center', color:T.textDim, paddingTop:60, fontSize:13 }}>{t('Sonuç bulunamadı')}</div>
      )}

      {/* Bottom: Value Prop + AI Impact */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr auto', gap:16, alignItems:'stretch' }}>
        {/* Value Prop */}
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'26px 28px' }}>
          <h4 style={{ fontSize:16.5, fontWeight:800, color:T.text, margin:'0 0 10px', letterSpacing:'-.02em' }}>{t('Zaman ve Bütçe Tasarrufu')}</h4>
          <p style={{ fontSize:12.5, color:T.textMidAlt, lineHeight:1.7, margin:'0 0 20px', maxWidth:480 }}>
            {t('Poyais One otomasyonları ile manuel operasyonları minimize edin. AI tabanlı algoritmalarımız 7/24 reklam performansınızı denetler ve bütçenizi en verimli kampanyalara yönlendirmenize yardım eder.')}
          </p>
          <div style={{ display:'flex', gap:24 }}>
            {[
              { title:t('Anlık karar'), sub:t('Milisaniyeler içinde tepki.') },
              { title:t('Hata minimizasyonu'),  sub:t('%99.9 hatasız yönetim.')  },
            ].map(item => (
              <div key={item.title} style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
                <div style={{ width:28, height:28, borderRadius:8, background:T.amberTint, color:T.accentDeep, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2L4 14h7l-1 8 9-12h-7z"/></svg>
                </div>
                <div>
                  <div style={{ fontSize:12.5, fontWeight:700, color:T.text, marginBottom:2 }}>{item.title}</div>
                  <div style={{ fontSize:11.5, color:T.textDim }}>{item.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* AI Impact */}
        <div style={{ background:T.ink, borderRadius:16, padding:'26px 28px', display:'flex', flexDirection:'column', alignItems:'flex-start', justifyContent:'center', minWidth:220 }}>
          <div style={{ fontSize:10, fontWeight:800, letterSpacing:'.14em', color:T.accent, textTransform:'uppercase' as const, marginBottom:10 }}>{t('AI Etkisi')}</div>
          <div style={{ fontSize:40, fontWeight:800, color:T.accent, lineHeight:1, marginBottom:6, fontFamily:'JetBrains Mono, monospace', fontVariantNumeric:'tabular-nums' }}>+%42</div>
          <div style={{ fontSize:14, fontWeight:700, color:'#fff', marginBottom:10 }}>{t('Verimlilik Artışı')}</div>
          <div style={{ fontSize:11.5, color:'rgba(255,255,255,.5)', lineHeight:1.6, maxWidth:180 }}>
            {t('Akıllı otomasyonların aktif edildiği hesaplarda gözlemlenen ortalama performans iyileşmesi.')}
          </div>
        </div>
      </div>
      </>
      )}

    </div>
  );
}
// -- Intelligence Shared Components ---------------------------------------

function ScoreCard({ score, grade, title, period }:{ score:number; grade:string; title:string; period:any }) {
  const T = SidebarT;
  const gradeColor = (grade==='A+'||grade==='A')?T.greenText:grade?.startsWith('B')?T.accent:grade==='C'?'#F97316':T.redText;
  return (
    <div style={{ background:T.surface, border:`2px solid ${alpha(gradeColor,20)}`, borderRadius:12, padding:'20px 24px', display:'flex', alignItems:'center', gap:20 }}>
      <div style={{ width:72, height:72, borderRadius:'50%', border:`3px solid ${gradeColor}`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, background:alpha(gradeColor,7) }}>
        <div style={{ fontFamily:'Manrope, sans-serif', fontSize:32, color:gradeColor, lineHeight:1 }}>{grade}</div>
      </div>
      <div style={{ flex:1 }}>
        <div style={{ fontFamily:'Manrope, sans-serif', fontSize:16, letterSpacing:0, marginBottom:4 }}>{title}</div>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
          <div style={{ flex:1, height:8, background:T.trackBg, borderRadius:4, overflow:'hidden' }}>
            <div style={{ width:`${score}%`, height:'100%', background:`linear-gradient(90deg,${alpha(gradeColor,53)},${gradeColor})`, borderRadius:4, transition:'width 1.2s cubic-bezier(.4,0,.2,1)' }}/>
          </div>
          <span style={{ fontFamily:'Manrope, sans-serif', fontSize:12, color:gradeColor, minWidth:32 }}>{score}</span>
        </div>
        <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.textDim }}>{period?.start} → {period?.end}</div>
      </div>
    </div>
  );
}

function InsightCard({ insight, onApply }:{ insight:any; onApply?:(id:string)=>void }) {
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [expanded, setExpanded] = React.useState(false);
  const prioColors:Record<string,string> = { high:T.redText, medium:T.accent, low:T.blueText };
  const prioLabels:Record<string,string> = { high:'Yüksek', medium:'Orta', low:'Düşük' };
  const pc = prioColors[insight.priority] || T.accent;

  return (
    <div style={{ background:T.card, border:`1px solid ${alpha(pc,13)}`, borderRadius:10, overflow:'hidden', transition:'border-color .2s' }}
      onMouseEnter={e=>(e.currentTarget as HTMLElement).style.borderColor=alpha(pc,27)}
      onMouseLeave={e=>(e.currentTarget as HTMLElement).style.borderColor=alpha(pc,13)}>
      <div style={{ padding:'14px 18px', cursor:'pointer', display:'flex', alignItems:'flex-start', gap:14 }} onClick={()=>setExpanded(x=>!x)}>
        <div style={{ fontSize:22, flexShrink:0, marginTop:2 }}>{insight.icon}</div>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6, flexWrap:'wrap' }}>
            <span style={{ fontSize:13, fontWeight:700 }}>{insight.title}</span>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:9, padding:'2px 7px', borderRadius:3, background:alpha(pc,9), color:pc, border:`1px solid ${alpha(pc,20)}` }}>{prioLabels[insight.priority]}</span>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:9, padding:'2px 7px', borderRadius:3, background:T.trackBg, color:T.textDim }}>{insight.category}</span>
          </div>
          <div style={{ fontSize:12, color:T.textDim, lineHeight:1.5, marginBottom:8 }}>{insight.description}</div>
          <div style={{ display:'flex', gap:16, flexWrap:'wrap' }}>
            <div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:8, color:T.textDim, letterSpacing:0, marginBottom:2 }}>MEVCUT</div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:12, color:pc, fontWeight:600 }}>{insight.metric}</div>
            </div>
            <div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:8, color:T.textDim, letterSpacing:0, marginBottom:2 }}>BENCHMARK</div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:12, color:T.greenText, fontWeight:600 }}>{insight.benchmark}</div>
            </div>
            <div style={{ flex:1 }}>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:8, color:T.textDim, letterSpacing:0, marginBottom:2 }}>TAHMİNİ ETKİ</div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:T.accent }}>{insight.impact}</div>
            </div>
          </div>
        </div>
        <span style={{ color:T.textDim, fontSize:12, flexShrink:0, transform:expanded?'rotate(180deg)':'none', transition:'transform .2s' }}>▾</span>
      </div>
      {expanded && (
        <div style={{ padding:'0 18px 16px', borderTop:'1px solid rgba(0,0,0,.04)' }}>
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.textDim, letterSpacing:0, margin:'12px 0 8px' }}>ÖNERİLEN AKSIYONLAR</div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            {insight.actions?.map((a:string, i:number) => (
              <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:8, fontSize:12, color:T.textDim }}>
                <span style={{ color:T.accent, flexShrink:0, marginTop:1 }}>→</span>{a}
              </div>
            ))}
          </div>
          {insight.chart_type === 'list' && insight.chart_data?.length > 0 && (
            <div style={{ marginTop:12, display:'flex', flexDirection:'column', gap:6 }}>
              {insight.chart_data.map((item:any, i:number) => {
                const maxSpend = Math.max(...insight.chart_data.map((x:any)=>x.spend), 1);
                return (
                  <div key={i} style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:T.textDim, minWidth:140, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.name}</div>
                    <div style={{ flex:1, height:5, background:T.trackBg, borderRadius:3, overflow:'hidden' }}>
                      <div style={{ width:`${(item.spend/maxSpend)*100}%`, height:'100%', background:item.roas>=4?T.greenText:item.roas>=2?T.accent:T.redText, borderRadius:3 }}/>
                    </div>
                    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:item.roas>=4?T.greenText:item.roas>=2?T.accent:T.redText, minWidth:50, textAlign:'right' }}>{item.roas?.toFixed(2)}×</div>
                  </div>
                );
              })}
            </div>
          )}
          {insight.chart_type === 'compare' && insight.chart_data && (
            <div style={{ marginTop:12, display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:10 }}>
              {Object.entries(insight.chart_data).map(([k,v]:any) => (
                <div key={k} style={{ background:T.surface, borderRadius:8, padding:'10px 14px', textAlign:'center' }}>
                  <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.textDim, marginBottom:6 }}>{k.toUpperCase()}</div>
                  <div style={{ fontFamily:'Manrope, sans-serif', fontSize:24, color:v>=4?T.greenText:v>=2?T.accent:T.redText }}>{Number(v).toFixed(2)}×</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function AIAnalysisPanel({ endpoint, config, onScoreUpdate }:{ endpoint:string; config:any; onScoreUpdate?:(s:number)=>void }) {
  const T = SidebarT;
  const [aiData, setAiData]     = useState<any>(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [open, setOpen]         = useState(false);

  React.useEffect(() => {
    if(aiData?.health_score > 0 && onScoreUpdate) {
      onScoreUpdate(aiData.health_score);
    }
  }, [aiData?.health_score]);

  const [aiError, setAiError] = useState('');

  const load = () => {
    if(aiData) { setOpen(x=>!x); return; }
    setAiLoading(true); setOpen(true); setAiError('');
    axios.get(endpoint)
      .then(r => {
        if(r.data?.error) { setAiError(r.data.error); setAiLoading(false); return; }
        setAiData(r.data);
        setAiLoading(false);
        // Skoru hemen güncelle
        if(r.data?.health_score > 0 && onScoreUpdate) {
        console.log('AI Score update:', r.data.health_score, 'onScoreUpdate:', !!onScoreUpdate);
          onScoreUpdate(r.data.health_score);
        }
      })
      .catch(e => {
        console.error('AI analiz hatası:', e);
        setAiError(e.response?.data?.detail || 'Sunucuya bağlanılamadı.');
        setAiLoading(false);
      });
  };

  return (
    <div>
      <button onClick={load} style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 18px', borderRadius:8, border:`1px solid rgba(168,139,250,.3)`, background:open?'rgba(168,139,250,.1)':'transparent', color:T.purple, fontFamily:'Manrope, sans-serif', fontSize:11, cursor:'pointer', transition:'all .2s', width:'100%', justifyContent:'center', letterSpacing:1 }}>
        <span style={{ fontSize:16 }}>🤖</span>
        {aiLoading ? 'Poyais One analiz yapıyor...' : aiData ? (open?'POYAIS ONE ANALİZİNİ KAPAT':'POYAIS ONE ANALİZİNİ GÖSTER') : 'POYAIS ONE AI İLE ANALİZ ET'}
        {aiData && !aiLoading && <span style={{ fontSize:10, background:'rgba(168,139,250,.2)', padding:'1px 6px', borderRadius:3 }}>{aiData.ai_insights?.length} bulgu</span>}
      </button>

      {open && (
        <div style={{ marginTop:12, display:'flex', flexDirection:'column', gap:12 }}>
          {aiLoading ? (
            <div style={{ padding:'24px', textAlign:'center', fontFamily:'Manrope, sans-serif', fontSize:10, color:T.purple, letterSpacing:2 }}>
              🤖 Poyais One veriyi analiz ediyor...
            </div>
          ) : aiError ? (
            <div style={{ padding:'16px 20px', background:'rgba(224,82,82,.06)', border:'1px solid rgba(224,82,82,.2)', borderRadius:10, fontFamily:'Manrope, sans-serif', fontSize:12, color:T.redText }}>
              ⚠️ {aiError}
            </div>
          ) : aiData && (
            <>
              {/* Overall Assessment */}
              <div style={{ background:'rgba(168,139,250,.08)', border:'1px solid rgba(168,139,250,.2)', borderRadius:10, padding:'16px 20px' }}>
                <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.purple, letterSpacing:0, marginBottom:8 }}>POYAIS ONE DEĞERLENDİRMESİ</div>
                <div style={{ fontSize:13, color:T.ink, lineHeight:1.7 }}>{aiData.overall_assessment}</div>

              </div>

              {/* Quick Wins */}
              {aiData.quick_wins?.length > 0 && (
                <div style={{ background:T.card, border:`1px solid ${alpha(T.greenText,13)}`, borderRadius:10, padding:'14px 18px' }}>
                  <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.greenText, letterSpacing:0, marginBottom:10 }}>⚡ HIZLI KAZANIMLAR</div>
                  <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                    {aiData.quick_wins.map((w:string, i:number) => (
                      <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:8, fontSize:12, color:T.textDim }}>
                        <span style={{ color:T.greenText, flexShrink:0 }}>✓</span>{w}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* AI Insights */}
              {aiData.ai_insights?.map((ins:any) => <InsightCard key={ins.title} insight={ins}/>)}

              {/* Growth Opportunities */}
              {aiData.growth_opportunities && (
                <div style={{ background:T.card, border:`1px solid ${alpha(T.accent,13)}`, borderRadius:10, padding:'14px 18px' }}>
                  <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.accent, letterSpacing:0, marginBottom:8 }}>BÜYÜME FIRSATLARI</div>
                  <div style={{ fontSize:12, color:T.textDim, lineHeight:1.65 }}>{aiData.growth_opportunities}</div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

function ABTestTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const isMobile = useIsMobile();
  const [metaCamps,   setMetaCamps]   = useState<any[]>([]);
  const [gadsCamps,   setGadsCamps]   = useState<any[]>([]);
  const [loading,     setLoading]     = useState(true);
  const [platform,    setPlatform]    = useState<'meta'|'google'>('meta');
  const [campA,       setCampA]       = useState<string>('');
  const [campB,       setCampB]       = useState<string>('');
  const [comparing,   setComparing]   = useState(false);

  const { accountId } = config.platforms.meta;
  const metaToken = config.platforms.meta?.accessToken || '';
  const { customerId } = config.platforms.gads;

  useEffect(()=>{
    if(!accountId && !customerId) { setLoading(false); return; }
    setLoading(true);
    const metaReq = accountId
      ? axios.get(`${API}/meta/${accountId}/campaigns?start_date=${start}&end_date=${end}`).catch(()=>({data:[]}))
      : Promise.resolve({data:[]});
    const gadsReq = customerId
      ? axios.get(`${API}/gads/${customerId}/campaigns?start_date=${start}&end_date=${end}`).catch(()=>({data:[]}))
      : Promise.resolve({data:[]});
    Promise.all([metaReq, gadsReq]).then(([m,g])=>{
      const mc = Array.isArray(m.data) ? m.data : (m.data?.campaigns||[]);
      const gc = Array.isArray(g.data) ? g.data : (g.data?.campaigns||[]);
      console.log('Meta camps:', mc.length, '| Google camps:', gc.length);
      setMetaCamps(mc);
      setGadsCamps(gc);
      setLoading(false);
    }).catch(e=>{ console.error('AB Test hata:', e); setLoading(false); });
  },[start,end,accountId,customerId,metaToken]);

  const camps = platform==='meta' ? metaCamps : gadsCamps;
  const idKey  = platform==='meta' ? 'campaign_id' : 'campaign_id';
  const nameKey = platform==='meta' ? 'campaign_name' : 'campaign_name';

  const normalizeData2 = (c:any) => ({
    ...c,
    campaign_id: String(c.campaign_id),
    conv: c.purchases || c.conversions || 0,
    cpc:  c.cpc || (c.spend && c.clicks ? c.spend/c.clicks : 0),
  });
  const normalizedCamps = camps.map(normalizeData2);
  const _rawA = normalizedCamps.find((c:any)=>c[idKey]===campA);
  const _rawB = normalizedCamps.find((c:any)=>c[idKey]===campB);
  const dataA = _rawA ? normalizeData2(_rawA) : null;
  const dataB = _rawB ? normalizeData2(_rawB) : null;

  const METRICS = [
    { key:'spend',       label:'Harcama',    fmt:(v:number)=>fmt.k(v),    higher:'bad'  },
    { key:'roas',        label:'ROAS',       fmt:(v:number)=>fmt.roas(v), higher:'good' },
    { key:'ctr',         label:'CTR',        fmt:(v:number)=>fmt.pct(v),  higher:'good' },
    { key:'cpc',         label:'CPC',        fmt:(v:number)=>fmt.k(v),    higher:'bad'  },
    { key:'conv',        label:'Dönüşüm',    fmt:(v:number)=>fmt.n(v),    higher:'good' },
    { key:'revenue',     label:'Gelir',      fmt:(v:number)=>fmt.k(v),    higher:'good' },
    { key:'impressions', label:'Gösterim',   fmt:(v:number)=>fmt.n(v),    higher:'good' },
    { key:'clicks',      label:'Tıklama',    fmt:(v:number)=>fmt.n(v),    higher:'good' },
  ];



  const getWinner = (key:string, higher:string) => {
    if(!dataA||!dataB) return null;
    const a = Number(dataA[key]||0);
    const b = Number(dataB[key]||0);
    if(a===b) return 'tie';
    if(higher==='good') return a>b?'A':'B';
    return a<b?'A':'B';
  };

  const winsA = METRICS.filter(m=>getWinner(m.key,m.higher)==='A').length;
  const winsB = METRICS.filter(m=>getWinner(m.key,m.higher)==='B').length;

  if(loading) return <Loader/>;

  return (
    <div style={{display:'flex',flexDirection:'column',gap:20,maxWidth:'100%'}}>
      {/* Platform + Kampanya Seçimi */}
      <div style={{background:'#FFFFFF',borderRadius:12,border:'1px solid #E4E6EF',boxShadow:'0 1px 4px rgba(0,0,0,.05)',padding:'20px 24px'}}>
        <div style={{fontSize:14,fontWeight:700,color:'#1A1A2E',fontFamily:'Manrope, sans-serif',marginBottom:16}}>Karşılaştırma Ayarları</div>

        {/* Platform */}
        <div style={{display:'flex',gap:8,marginBottom:16}}>
          {(['meta','google'] as const).map(p=>(
            <button key={p} onClick={()=>{setPlatform(p);setCampA('');setCampB('');}} style={{
              padding:'7px 18px',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'Manrope, sans-serif',
              border:`1px solid ${platform===p?'#C9A84C':'#E4E6EF'}`,
              background:platform===p?'rgba(201,168,76,.1)':'#fff',
              color:platform===p?'#C9A84C':'#6B6B8A',
            }}>{p==='meta'?'Meta Ads':'Google Ads'}</button>
          ))}
        </div>

        {/* Kampanya Seçici */}
        <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'1fr 1fr',gap:16}}>
          {[
            {label:'Kampanya A',val:campA,set:setCampA,color:'#3b82f6',bg:'#dbeafe'},
            {label:'Kampanya B',val:campB,set:setCampB,color:'#A855F7',bg:'#ede9fe'}
          ].map(({label,val,set,color,bg})=>(
            <div key={label}>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                <div style={{width:8,height:8,borderRadius:'50%',background:color,flexShrink:0}}/>
                <span style={{fontFamily:'Manrope, sans-serif',fontSize:11,fontWeight:700,color:'#6B6B8A',textTransform:'uppercase' as const,letterSpacing:'0.08em'}}>{label}</span>
              </div>
              <select value={val} onChange={e=>set(e.target.value)} style={{
                width:'100%',padding:'9px 12px',borderRadius:8,fontFamily:'Manrope, sans-serif',
                border:`1px solid ${val?color+'66':'#E4E6EF'}`,fontSize:12,outline:'none',
                background:'#F7F8FC',color:'#1A1A2E',cursor:'pointer'}}>
                <option value="">Kampanya seçin... ({normalizedCamps.length})</option>
                {normalizedCamps.filter((c:any)=>c[idKey]!==(label==='Kampanya A'?campB:campA)).map((c:any)=>(
                  <option key={c[idKey]} value={c[idKey]}>{c[nameKey]}</option>
                ))}
              </select>
            </div>
          ))}
        </div>
      </div>

      {/* Karşılaştırma */}
      {dataA && dataB && (
        <>
          {/* Skor Kartları */}
          <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'1fr auto 1fr',gap:12,alignItems:'center'}}>
            <div style={{background:'#fff',border:'2px solid #3b82f688',borderRadius:12,padding:'16px 20px',textAlign:'center',boxShadow:'0 1px 4px rgba(0,0,0,.05)'}}>
              <div style={{fontFamily:'Manrope, sans-serif',fontSize:11,color:'#3b82f6',fontWeight:700,marginBottom:4}}>KAMPANYA A</div>
              <div style={{fontFamily:'Manrope, sans-serif',fontSize:13,color:'#1A1A2E',fontWeight:600,marginBottom:8,
                overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const}}>{dataA[nameKey]}</div>
              <div style={{fontFamily:'Manrope, sans-serif',fontSize:32,fontWeight:700,color:winsA>winsB?GREEN:winsA<winsB?RED:'#6B6B8A'}}>
                {winsA}
              </div>
              <div style={{fontFamily:'Manrope, sans-serif',fontSize:10,color:'#6B6B8A'}}>metrik kazanımı</div>
            </div>
            <div style={{textAlign:'center',fontFamily:'Manrope, sans-serif',fontSize:20,color:'#ddd',fontWeight:700}}>VS</div>
            <div style={{background:'#fff',border:'2px solid #A855F788',borderRadius:12,padding:'16px 20px',textAlign:'center',boxShadow:'0 1px 4px rgba(0,0,0,.05)'}}>
              <div style={{fontFamily:'Manrope, sans-serif',fontSize:11,color:'#A855F7',fontWeight:700,marginBottom:4}}>KAMPANYA B</div>
              <div style={{fontFamily:'Manrope, sans-serif',fontSize:13,color:'#1A1A2E',fontWeight:600,marginBottom:8,
                overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const}}>{dataB[nameKey]}</div>
              <div style={{fontFamily:'Manrope, sans-serif',fontSize:32,fontWeight:700,color:winsB>winsA?GREEN:winsB<winsA?RED:'#6B6B8A'}}>
                {winsB}
              </div>
              <div style={{fontFamily:'Manrope, sans-serif',fontSize:10,color:'#6B6B8A'}}>metrik kazanımı</div>
            </div>
          </div>

          {/* Kazanan Banner */}
          {winsA !== winsB && (
            <div style={{
              background: winsA>winsB?'rgba(76,175,125,.08)':'rgba(167,139,250,.08)',
              border: `1px solid ${winsA>winsB?GREEN:'#A855F7'}44`,
              borderRadius:10,padding:'12px 20px',textAlign:'center',
            }}>
              <span style={{fontFamily:'Manrope, sans-serif',fontSize:14,fontWeight:700,
                color:winsA>winsB?GREEN:'#A855F7'}}>
                🏆 {winsA>winsB?`Kampanya A (${dataA[nameKey].slice(0,30)})`:`Kampanya B (${dataB[nameKey].slice(0,30)})`} kazanıyor
              </span>
              <span style={{fontFamily:'Manrope, sans-serif',fontSize:12,color:'#6B6B8A',marginLeft:8}}>
                ({Math.max(winsA,winsB)}/{METRICS.length} metrikte üstün)
              </span>
            </div>
          )}

          {/* Metrik Karşılaştırma Tablosu */}
          <div style={{background:'#FFFFFF',borderRadius:12,border:'1px solid #E4E6EF',boxShadow:'0 1px 4px rgba(0,0,0,.05)'}}>
            <div style={{padding:'16px 24px',borderBottom:'1px solid #E4E6EF'}}>
              <span style={{fontSize:12,fontWeight:700,color:'#1A1A2E',fontFamily:'Manrope, sans-serif',letterSpacing:'0.05em',textTransform:'uppercase' as const}}>Metrik Karşılaştırması</span>
            </div>
            <div className="table-scroll" style={{overflowX:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead>
                  <tr style={{borderBottom:'1px solid rgba(201,168,76,.15)'}}>
                    <th style={{padding:'10px 16px',fontFamily:'Manrope, sans-serif',fontSize:10,color:'#6B6B8A',textAlign:'left',fontWeight:600}}>METRİK</th>
                    <th style={{padding:'10px 16px',fontFamily:'Manrope, sans-serif',fontSize:10,color:BLUE,textAlign:'center',fontWeight:600}}>A</th>
                    <th style={{padding:'10px 16px',fontFamily:'Manrope, sans-serif',fontSize:10,color:'#A855F7',textAlign:'center',fontWeight:600}}>B</th>
                    <th style={{padding:'10px 16px',fontFamily:'Manrope, sans-serif',fontSize:10,color:'#6B6B8A',textAlign:'center',fontWeight:600}}>FARK</th>
                    <th style={{padding:'10px 16px',fontFamily:'Manrope, sans-serif',fontSize:10,color:'#6B6B8A',textAlign:'center',fontWeight:600}}>KAZANAN</th>
                  </tr>
                </thead>
                <tbody>
                  {METRICS.map((m,i)=>{
                    const a = Number(dataA[m.key]||0);
                    const b = Number(dataB[m.key]||0);
                    const winner = getWinner(m.key,m.higher);
                    const diff = b>0 ? ((a-b)/b*100).toFixed(1) : '—';
                    return (
                      <tr key={m.key} style={{borderBottom:'1px solid rgba(201,168,76,0.08)',
                        background:i%2===0?'transparent':'rgba(201,168,76,.02)'}}>
                        <td style={{padding:'10px 16px',fontFamily:'Manrope, sans-serif',fontSize:12,color:'#555',fontWeight:500}}>{m.label}</td>
                        <td style={{padding:'10px 16px',fontFamily:'monospace',fontSize:12,textAlign:'center',
                          fontWeight:winner==='A'?700:400,
                          color:winner==='A'?BLUE:'#6B6B8A'}}>{m.fmt(a)}</td>
                        <td style={{padding:'10px 16px',fontFamily:'monospace',fontSize:12,textAlign:'center',
                          fontWeight:winner==='B'?700:400,
                          color:winner==='B'?'#A855F7':'#6B6B8A'}}>{m.fmt(b)}</td>
                        <td style={{padding:'10px 16px',fontFamily:'monospace',fontSize:11,textAlign:'center',
                          color:Number(diff)>0?GREEN:Number(diff)<0?RED:'#6B6B8A'}}>
                          {diff!=='—'?(Number(diff)>0?'+':'')+diff+'%':'—'}
                        </td>
                        <td style={{padding:'10px 16px',textAlign:'center'}}>
                          {winner==='A' && <span style={{fontSize:11,fontWeight:700,padding:'2px 8px',borderRadius:10,background:'rgba(91,141,239,.1)',color:BLUE}}>A</span>}
                          {winner==='B' && <span style={{fontSize:11,fontWeight:700,padding:'2px 8px',borderRadius:10,background:'rgba(167,139,250,.1)',color:'#A855F7'}}>B</span>}
                          {winner==='tie' && <span style={{fontSize:11,color:'#ccc'}}>—</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* Metrik Karşılaştırma Kartları */}
          <div style={{background:'#FFFFFF',borderRadius:12,border:'1px solid #E4E6EF',boxShadow:'0 1px 4px rgba(0,0,0,.05)'}}>
            <div style={{padding:'16px 24px',borderBottom:'1px solid #E4E6EF',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <span style={{fontSize:12,fontWeight:700,color:'#1A1A2E',fontFamily:'Manrope, sans-serif',letterSpacing:'0.05em',textTransform:'uppercase' as const}}>Metrik Karşılaştırma</span>
              <div style={{display:'flex',gap:16}}>
                <div style={{display:'flex',alignItems:'center',gap:6}}><div style={{width:10,height:10,borderRadius:2,background:'#3b82f6'}}/><span style={{fontSize:11,color:'#6B6B8A',fontFamily:'Manrope, sans-serif'}}>Kampanya A</span></div>
                <div style={{display:'flex',alignItems:'center',gap:6}}><div style={{width:10,height:10,borderRadius:2,background:'#A855F7'}}/><span style={{fontSize:11,color:'#6B6B8A',fontFamily:'Manrope, sans-serif'}}>Kampanya B</span></div>
              </div>
            </div>
            <div style={{padding:'16px 24px',display:'grid',gridTemplateColumns:isMobile?'1fr':'repeat(2,1fr)',gap:12}}>
              {METRICS.map(m=>{
                const vA = Number(dataA[m.key]||0);
                const vB = Number(dataB[m.key]||0);
                const winner = getWinner(m.key, m.higher);
                const maxV = Math.max(vA, vB, 0.001);
                const pctA = (vA/maxV)*100;
                const pctB = (vB/maxV)*100;
                return (
                  <div key={m.key} style={{background:'#F7F8FC',borderRadius:10,padding:'12px 14px',border:'1px solid #E4E6EF'}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                      <span style={{fontSize:11,fontWeight:700,color:'#6B6B8A',fontFamily:'Manrope, sans-serif',textTransform:'uppercase' as const,letterSpacing:'0.06em'}}>{m.label}</span>
                      {winner && winner!=='tie' && <span style={{fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:10,background:winner==='A'?'rgba(59,130,246,.12)':'rgba(168,85,247,.12)',color:winner==='A'?'#3b82f6':'#A855F7',fontFamily:'Manrope, sans-serif'}}>{'🏆 '+winner} kazanıyor</span>}
                      {winner==='tie' && <span style={{fontSize:10,color:'#aaa',fontFamily:'Manrope, sans-serif'}}>Eşit</span>}
                    </div>
                    <div style={{display:'flex',flexDirection:'column' as const,gap:6}}>
                      <div>
                        <div style={{display:'flex',justifyContent:'space-between',marginBottom:3}}>
                          <span style={{fontSize:10,color:'#3b82f6',fontWeight:600,fontFamily:'Manrope, sans-serif'}}>A</span>
                          <span style={{fontSize:11,fontWeight:700,color:'#1A1A2E',fontFamily:'Manrope, sans-serif'}}>{m.fmt(vA)}</span>
                        </div>
                        <div style={{height:6,borderRadius:3,background:'#E4E6EF',overflow:'hidden'}}>
                          <div style={{height:'100%',borderRadius:3,background: winner==='A'?'#3b82f6':'rgba(59,130,246,.4)',width:`${pctA}%`,transition:'width .4s'}}/>
                        </div>
                      </div>
                      <div>
                        <div style={{display:'flex',justifyContent:'space-between',marginBottom:3}}>
                          <span style={{fontSize:10,color:'#A855F7',fontWeight:600,fontFamily:'Manrope, sans-serif'}}>B</span>
                          <span style={{fontSize:11,fontWeight:700,color:'#1A1A2E',fontFamily:'Manrope, sans-serif'}}>{m.fmt(vB)}</span>
                        </div>
                        <div style={{height:6,borderRadius:3,background:'#E4E6EF',overflow:'hidden'}}>
                          <div style={{height:'100%',borderRadius:3,background:winner==='B'?'#A855F7':'rgba(168,85,247,.4)',width:`${pctB}%`,transition:'width .4s'}}/>
                        </div>
                      </div>
                    </div>
                    {winner && winner!=='tie' && (
                      <div style={{marginTop:8,fontSize:10,color:'#6B6B8A',fontFamily:'Manrope, sans-serif'}}>
                        {(() => {
                          const diff = vA!==0 && vB!==0 ? Math.abs((vA-vB)/Math.max(vA,vB)*100).toFixed(1) : null;
                          return diff ? `%${diff} fark` : '';
                        })()}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

        </>
      )}

      {/* Boş state */}
      {(!dataA || !dataB) && (
        <div style={{textAlign:'center',padding:'60px 0',color:'#ccc',fontFamily:'Manrope, sans-serif'}}>
          <div style={{fontSize:40,marginBottom:12}}>⚡</div>
          <div style={{fontSize:14,marginBottom:6}}>İki kampanya seçin</div>
          <div style={{fontSize:11}}>Karşılaştırma otomatik oluşturulacak.</div>
        </div>
      )}
    </div>
  );
}

// -- Custom Dashboard Tab --------------------------------------------------

const WIDGET_METRICS = [
  { key:'meta_spend',        label:'Meta Harcama',          platform:'meta',   format:'k'    },
  { key:'meta_roas',         label:'Meta ROAS',             platform:'meta',   format:'roas' },
  { key:'meta_ctr',          label:'Meta CTR',              platform:'meta',   format:'pct'  },
  { key:'meta_purchases',    label:'Meta Satış',            platform:'meta',   format:'n'    },
  { key:'meta_impressions',  label:'Meta Gösterim',         platform:'meta',   format:'n'    },
  { key:'meta_reach',        label:'Meta Erişim',           platform:'meta',   format:'n'    },
  { key:'meta_frequency',    label:'Meta Sıklık',           platform:'meta',   format:'roas' },
  { key:'meta_cpm',          label:'Meta CPM',              platform:'meta',   format:'k'    },
  { key:'meta_clicks',       label:'Meta Tıklama',          platform:'meta',   format:'n'    },
  { key:'google_spend',      label:'Google Harcama',        platform:'google', format:'k'    },
  { key:'google_roas',       label:'Google ROAS',           platform:'google', format:'roas' },
  { key:'google_conv',       label:'Google Dönüşüm',        platform:'google', format:'n'    },
  { key:'google_ctr',        label:'Google CTR',            platform:'google', format:'pct'  },
  { key:'google_impressions',label:'Google Gösterim',       platform:'google', format:'n'    },
  { key:'google_clicks',     label:'Google Tıklama',        platform:'google', format:'n'    },
  { key:'google_cpc',        label:'Google CPC',            platform:'google', format:'k'    },
  { key:'ga4_sessions',      label:'GA4 Oturum',            platform:'ga4',    format:'n'    },
  { key:'ga4_conv_rate',     label:'GA4 Dönüşüm Oranı',    platform:'ga4',    format:'pct'  },
  { key:'ga4_bounce',        label:'GA4 Hemen Çıkma',       platform:'ga4',    format:'pct'  },
  { key:'ga4_revenue',       label:'GA4 Gelir',             platform:'ga4',    format:'k'    },
  { key:'ga4_pageviews',     label:'GA4 Sayfa Görüntüleme', platform:'ga4',    format:'n'    },
  { key:'ga4_avg_session',   label:'GA4 Ort. Oturum Süresi',platform:'ga4',   format:'n'    },
];

const WIDGET_TYPES = [
  { key:'kpi',   label:'KPI Kartı',       icon:'speed'        },
  { key:'bar',   label:'Sütun Grafik',    icon:'bar_chart'    },
  // { key:'line',  label:'Çizgi Grafik',    icon:'show_chart'   },
  { key:'pie',   label:'Pasta Grafik',    icon:'pie_chart'    },
  { key:'table', label:'Tablo',           icon:'table_chart'  },
];

const PLATFORM_COLORS:Record<string,string> = {
  meta:'#1877F2', google:'#4285F4', ga4:'#E37400'
};

function CustomDashboardTab({ config, start, end }:{ config:any; start:string; end:string }) {
  const STORAGE_KEY = 'poyais_custom_dashboard_v1';
  const DEFAULT_WIDGETS = [
    { id:1, type:'kpi',   metric:'meta_spend',     metric2:'meta_roas',    title:'Meta Harcama & ROAS',         platform:'meta'   },
    { id:2, type:'kpi',   metric:'google_spend',   metric2:'google_roas',  title:'Google Harcama & ROAS',       platform:'google' },
    { id:3, type:'kpi',   metric:'meta_purchases', metric2:'google_conv',  title:'Toplam Dönüşüm',              platform:'meta'   },
    { id:4, type:'kpi',   metric:'ga4_sessions',   metric2:'ga4_conv_rate',title:'GA4 Oturum & Dönüşüm Oranı', platform:'ga4'    },
    { id:5, type:'table', metric:'meta_spend',     metric2:null,           title:'Meta Ads Özeti',              platform:'meta'   },
    { id:6, type:'table', metric:'google_spend',   metric2:null,           title:'Google Ads Özeti',            platform:'google' },
  ];
  const isMobile = useIsMobile();
  const [widgets, setWidgets] = useState<any[]>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if(saved) return JSON.parse(saved);
      return DEFAULT_WIDGETS;
    } catch { return DEFAULT_WIDGETS; }
  });
  const [showModal, setShowModal] = useState(false);
  const [gridCols, setGridCols]   = useState('repeat(3,1fr)');
  const [editWidget, setEditWidget] = useState<any|null>(null);
  const [metaData, setMetaData]   = useState<any>(null);
  const [gadsData, setGadsData]   = useState<any>(null);
  const [ga4Data,  setGa4Data]    = useState<any>(null);
  const [loading,  setLoading]    = useState(true);

  const { accountId } = config.platforms.meta;
  const { customerId } = config.platforms.gads;
  const { propertyId } = config.platforms.ga4;

  // Form state
  const [wType,   setWType]   = useState('kpi');
  const [wMetric, setWMetric] = useState(WIDGET_METRICS[0].key);
  const [wTitle,  setWTitle]  = useState('');
  const [wMetric2,setWMetric2]= useState('');

  useEffect(() => {
    Promise.all([
      accountId  ? axios.get(`${API}/meta/${accountId}/overview?start_date=${start}&end_date=${end}`).catch(()=>null) : Promise.resolve(null),
      customerId ? axios.get(`${API}/gads/${customerId}/overview?start_date=${start}&end_date=${end}`).catch(()=>null) : Promise.resolve(null),
      propertyId ? axios.get(`${API}/ga4/${propertyId}/overview?start_date=${start}&end_date=${end}`).catch(()=>null) : Promise.resolve(null),
    ]).then(([m,g,ga]) => {
      setMetaData(m?.data||null);
      setGadsData(g?.data||null);
      setGa4Data(ga?.data||null);
      setLoading(false);
    });
  }, [start, end, accountId, customerId, propertyId]);

  const activeClientId = config?.activeClientId || parseInt(localStorage.getItem('poyais_active_client')||'1');

  const saveWidgets = (w:any[]) => {
    setWidgets(w);
    localStorage.setItem(STORAGE_KEY + '_' + activeClientId, JSON.stringify(w));
    axios.post(`${API}/auth/widgets`, { widgets: w, client_id: activeClientId }).catch(()=>{});
  };

  // Müşteri değişince widget'ları yükle
  useEffect(() => {
    const localKey = STORAGE_KEY + '_' + activeClientId;
    const local = localStorage.getItem(localKey);
    if(local) setWidgets(JSON.parse(local));
    axios.get(`${API}/auth/widgets?client_id=${activeClientId}`).then(r => {
      const bw = r.data?.widgets;
      if(bw && bw.length > 0) {
        setWidgets(bw);
        localStorage.setItem(localKey, JSON.stringify(bw));
      }
    }).catch(()=>{});
  }, [activeClientId]);

  const getMetricValue = (key:string) => {
    const map:Record<string,()=>number> = {
      meta_spend:         ()=>metaData?.spend||0,
      meta_roas:          ()=>metaData?.roas||0,
      meta_ctr:           ()=>metaData?.ctr||0,
      meta_purchases:     ()=>metaData?.purchases||0,
      meta_impressions:   ()=>metaData?.impressions||0,
      meta_reach:         ()=>metaData?.reach||0,
      meta_frequency:     ()=>metaData?.frequency||0,
      meta_cpm:           ()=>metaData?.cpm||0,
      meta_clicks:        ()=>metaData?.clicks||0,
      google_spend:       ()=>gadsData?.spend||0,
      google_roas:        ()=>gadsData?.roas||0,
      google_conv:        ()=>gadsData?.conversions||0,
      google_ctr:         ()=>gadsData?.ctr||0,
      google_impressions: ()=>gadsData?.impressions||0,
      google_clicks:      ()=>gadsData?.clicks||0,
      google_cpc:         ()=>gadsData?.cpc||0,
      ga4_sessions:       ()=>ga4Data?.sessions||0,
      ga4_conv_rate:      ()=>ga4Data?.conv_rate||0,
      ga4_bounce:         ()=>ga4Data?.bounce_rate||0,
      ga4_revenue:        ()=>ga4Data?.revenue||0,
      ga4_pageviews:      ()=>ga4Data?.pageviews||0,
      ga4_avg_session:    ()=>ga4Data?.avg_session_duration||0,
    };
    return map[key]?.() || 0;
  };

  const formatVal = (val:number, key:string) => {
    const m = WIDGET_METRICS.find(x=>x.key===key);
    if(!m) return String(val);
    if(m.format==='k')    return fmt.k(val);
    if(m.format==='roas') return fmt.roas(val);
    if(m.format==='pct')  return fmt.pct(val);
    return fmt.n(val);
  };

  const addWidget = () => {
    const metric = WIDGET_METRICS.find(m=>m.key===wMetric);
    const newW = {
      id: Date.now(),
      type: wType,
      metric: wMetric,
      metric2: wMetric2||null,
      title: wTitle || metric?.label || wMetric,
      platform: metric?.platform || 'meta',
    };
    const updated = editWidget
      ? widgets.map(w=>w.id===editWidget.id ? {...newW, id:editWidget.id} : w)
      : [...widgets, newW];
    saveWidgets(updated);
    setShowModal(false);
    setEditWidget(null);
    resetForm();
  };

  const resetForm = () => {
    setWType('kpi'); setWMetric(WIDGET_METRICS[0].key);
    setWTitle(''); setWMetric2('');
  };

  const openEdit = (w:any) => {
    setEditWidget(w);
    setWType(w.type); setWMetric(w.metric);
    setWTitle(w.title); setWMetric2(w.metric2||'');
    setShowModal(true);
  };

  const removeWidget = (id:number) => saveWidgets(widgets.filter(w=>w.id!==id));

  const renderWidget = (w:any) => {
    const val  = getMetricValue(w.metric);
    const val2 = w.metric2 ? getMetricValue(w.metric2) : null;
    const m1   = WIDGET_METRICS.find(x=>x.key===w.metric);
    const m2   = w.metric2 ? WIDGET_METRICS.find(x=>x.key===w.metric2) : null;
    const platform = m1?.platform || w.platform || 'meta';
    const PCOLS:Record<string,{main:string,light:string,label:string}> = {
      meta:   { main:'#1877F2', light:'rgba(24,119,242,.08)', label:'Meta' },
      google: { main:'#34A853', light:'rgba(52,168,83,.08)',  label:'Google' },
      ga4:    { main:'#F57C00', light:'rgba(245,124,0,.08)',  label:'GA4' },
    };
    const pc = PCOLS[platform] || { main:GOLD, light:'rgba(201,168,76,.08)', label:'' };
    const p2Color = '#A855F7';

    // Kampanya verileri — bar/line için
    const campData = platform==='meta'
      ? (metaData?.campaigns || []).slice(0,5).map((c:any)=>({ name:(c.campaign_name||c.name||'').slice(0,18), value: Number(c[w.metric?.replace('meta_','')] ?? c.spend ?? 0), spend: c.spend||0, roas: c.roas||0, ctr: c.ctr||0, clicks: c.clicks||0, impressions: c.impressions||0 }))
      : platform==='google'
      ? (gadsData?.campaigns || []).slice(0,5).map((c:any)=>({ name:(c.campaign_name||c.name||'').slice(0,18), value: Number(c[w.metric?.replace('google_','')] ?? c.spend ?? 0), spend: c.spend||0, roas: c.roas||0, ctr: c.ctr||0, clicks: c.clicks||0, impressions: c.impressions||0 }))
      : [];

    const ActionBtns = () => (
      <div style={{ display:'flex', gap:4, flexShrink:0 }}>
        <button onClick={()=>openEdit(w)} style={{ fontSize:10, padding:'2px 7px', borderRadius:4,
          border:'1px solid rgba(201,168,76,.25)', background:'transparent', color:GOLD, cursor:'pointer' }}>✏</button>
        <button onClick={()=>removeWidget(w.id)} style={{ fontSize:10, padding:'2px 7px', borderRadius:4,
          border:'1px solid rgba(224,82,82,.25)', background:'transparent', color:RED, cursor:'pointer' }}>✕</button>
      </div>
    );

    // -- KPI --------------------------------------------------------------
    if(w.type==='kpi') return (
      <div style={{ background:'#fff', borderRadius:12, padding:'18px 20px', border:'1px solid #E4E6EF', boxShadow:'0 2px 8px rgba(0,0,0,.04)', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${pc.main}, ${pc.main}88)`, borderRadius:'12px 12px 0 0' }}/>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
          <div style={{ display:'flex', flexDirection:'column' as const, gap:4 }}>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:9, fontWeight:700, color:'#9CA3AF', textTransform:'uppercase' as const, letterSpacing:'0.08em' }}>{w.title}</span>
            <span style={{ display:'inline-flex', alignItems:'center', gap:4, fontSize:9, fontWeight:600, color:pc.main, background:pc.light, padding:'2px 7px', borderRadius:20, width:'fit-content', fontFamily:'Manrope, sans-serif' }}>{pc.label}</span>
          </div>
          <ActionBtns/>
        </div>
        <div style={{ fontFamily:'Manrope, sans-serif', fontSize:32, fontWeight:700, color:'#1A1A2E', lineHeight:1, marginBottom:4, letterSpacing:'-0.02em' }}>
          {formatVal(val, w.metric)}
        </div>
        {m1 && <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A', marginBottom: val2!==null?12:0 }}>{m1.label}</div>}
        {val2!==null && m2 && (
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:10, paddingTop:10, borderTop:'1px solid #F3F4F6' }}>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A' }}>{m2.label}</span>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:14, fontWeight:700, color:p2Color }}>{formatVal(val2, w.metric2||'')}</span>
          </div>
        )}
      </div>
    );

    // -- BAR --------------------------------------------------------------
    if(w.type==='bar') {
      const metricKey = w.metric.replace('meta_','').replace('google_','').replace('ga4_','');
      const barData = campData.length > 0
        ? campData.map((c:any,i:number) => ({
            name: c.name,
            value: c[metricKey] ?? c.spend ?? 0,
            fill: i===0 ? pc.main : i===1 ? `${pc.main}CC` : i===2 ? `${pc.main}99` : i===3 ? `${pc.main}66` : `${pc.main}44`,
          }))
        : m2
          ? [
              { name: (m1?.label||'').split(' ').slice(0,2).join(' '), value: val,     fill: pc.main },
              { name: (m2?.label||'').split(' ').slice(0,2).join(' '), value: val2||0, fill: p2Color },
            ]
          : [{ name: m1?.label||'Değer', value: val, fill: pc.main }];
      return (
        <div style={{ background:'#fff', borderRadius:12, padding:16, border:'1px solid #E4E6EF', boxShadow:'0 2px 8px rgba(0,0,0,.04)', position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${pc.main}, ${pc.main}88)`, borderRadius:'12px 12px 0 0' }}/>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4 }}>
            <div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:12, fontWeight:700, color:'#1A1A2E' }}>{w.title}</div>
              {campData.length > 0 && <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:'#9CA3AF', marginTop:2 }}>Top {campData.length} kampanya · {m1?.label}</div>}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:9, fontWeight:600, color:pc.main, background:pc.light, padding:'2px 7px', borderRadius:20, fontFamily:'Manrope, sans-serif' }}>{pc.label}</span>
              <ActionBtns/>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={180}>
            <BarChart data={barData} margin={{top:8,right:4,left:-15,bottom:40}}>
              <XAxis dataKey="name" tick={{fontSize:8,fill:'#6B6B8A',fontFamily:'Manrope, sans-serif'}} axisLine={false} tickLine={false} angle={-35} textAnchor="end" interval={0}/>
              <YAxis tick={{fontSize:9,fill:'#6B6B8A'}} axisLine={false} tickLine={false}
                tickFormatter={(v:number)=>v>=1000000?`${(v/1000000).toFixed(1)}M`:v>=1000?`${(v/1000).toFixed(0)}K`:v.toFixed(1)}/>
              <Tooltip
                contentStyle={{background:'#fff',border:'1px solid #E4E6EF',borderRadius:8,fontSize:11,fontFamily:'Manrope, sans-serif',boxShadow:'0 4px 16px rgba(0,0,0,.08)'}}
                formatter={(v:any)=>[formatVal(Number(v),w.metric), m1?.label||'']}
                cursor={{fill:'rgba(0,0,0,.03)'}}/>
              <Bar dataKey="value" radius={[4,4,0,0]}>
                {barData.map((d:any,i:number)=><Cell key={i} fill={d.fill}/>)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      );
    }

    // -- LINE -------------------------------------------------------------
    if(w.type==='line') {
      // Kampanya verisi varsa scatter/compare, yoksa KPI+sparkline göster
      const lineData = campData.length > 0
        ? campData.map((c:any) => {
            const metricKey = w.metric.replace('meta_','').replace('google_','').replace('ga4_','');
            return { name: c.name, [m1?.label||'Değer']: c[metricKey] ?? c.spend ?? 0 };
          })
        : [
            { name:'Harcama', [m1?.label||'A']: val },
            { name:'Gelir',   [m1?.label||'A']: val2||0 },
          ];
      const lineKey = m1?.label || 'Değer';
      return (
        <div style={{ background:'#fff', borderRadius:12, padding:16, border:'1px solid #E4E6EF', boxShadow:'0 2px 8px rgba(0,0,0,.04)', position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${pc.main}, ${pc.main}88)`, borderRadius:'12px 12px 0 0' }}/>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
            <div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:12, fontWeight:700, color:'#1A1A2E' }}>{w.title}</div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:32, fontWeight:700, color:'#1A1A2E', letterSpacing:'-0.02em', marginTop:4 }}>{formatVal(val,w.metric)}</div>
              {val2!==null && m2 && <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:p2Color, marginTop:2 }}>{m2.label}: {formatVal(val2,w.metric2||'')}</div>}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:9, fontWeight:600, color:pc.main, background:pc.light, padding:'2px 7px', borderRadius:20, fontFamily:'Manrope, sans-serif' }}>{pc.label}</span>
              <ActionBtns/>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={120}>
            <LineChart data={lineData} margin={{top:4,right:4,left:-20,bottom:0}}>
              <XAxis dataKey="name" tick={{fontSize:8,fill:'#9CA3AF',fontFamily:'Manrope, sans-serif'}} axisLine={false} tickLine={false}/>
              <YAxis hide tick={{fontSize:8}} axisLine={false} tickLine={false}/>
              <Tooltip
                contentStyle={{background:'#fff',border:'1px solid #E4E6EF',borderRadius:8,fontSize:11,fontFamily:'Manrope, sans-serif',boxShadow:'0 4px 16px rgba(0,0,0,.08)'}}
                formatter={(v:any)=>[formatVal(Number(v),w.metric),lineKey]}
                cursor={{stroke:pc.main,strokeWidth:1,strokeDasharray:'4 2'}}/>
              <Line type="monotone" dataKey={lineKey} stroke={pc.main} strokeWidth={2} dot={{fill:pc.main,r:3}} activeDot={{r:5,fill:pc.main}}/>
            </LineChart>
          </ResponsiveContainer>
        </div>
      );
    }

    // -- PIE --------------------------------------------------------------
    if(w.type==='pie') {
      const PIE_COLORS = [pc.main, p2Color, '#F59E0B', '#10B981', '#EF4444'];
      const pieData = campData.length > 0
        ? campData.map((c:any,i:number) => {
            const metricKey = w.metric.replace('meta_','').replace('google_','').replace('ga4_','');
            return { name: c.name, value: c[metricKey] ?? c.spend ?? 0, fill: PIE_COLORS[i%PIE_COLORS.length] };
          })
        : m2 && (val+( val2||0))>0
          ? [
              { name: m1?.label||'Metrik 1', value: val,     fill: pc.main },
              { name: m2?.label||'Metrik 2', value: val2||0, fill: p2Color },
            ]
          : [{ name: m1?.label||'Değer', value: val, fill: pc.main }];
      const totalPie = pieData.reduce((s:number,d:any)=>s+d.value,0);
      return (
        <div style={{ background:'#fff', borderRadius:12, padding:16, border:'1px solid #E4E6EF', boxShadow:'0 2px 8px rgba(0,0,0,.04)', position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${pc.main}, ${pc.main}88)`, borderRadius:'12px 12px 0 0' }}/>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
            <div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:12, fontWeight:700, color:'#1A1A2E' }}>{w.title}</div>
              {campData.length>0 && <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:'#9CA3AF', marginTop:2 }}>Top {campData.length} kampanya · {m1?.label}</div>}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:9, fontWeight:600, color:pc.main, background:pc.light, padding:'2px 7px', borderRadius:20, fontFamily:'Manrope, sans-serif' }}>{pc.label}</span>
              <ActionBtns/>
            </div>
          </div>
          <div style={{ display:'flex', gap:8, alignItems:'center' }}>
            <ResponsiveContainer width="55%" height={160}>
              <PieChart>
                <Pie data={pieData} cx="50%" cy="50%" innerRadius={38} outerRadius={62} dataKey="value" paddingAngle={2}>
                  {pieData.map((d:any,i:number)=><Cell key={i} fill={d.fill}/>)}
                </Pie>
                <Tooltip contentStyle={{background:'#fff',border:'1px solid #E4E6EF',borderRadius:8,fontSize:11,fontFamily:'Manrope, sans-serif'}} formatter={(v:any,name:any)=>[formatVal(Number(v),w.metric),name]}/>
              </PieChart>
            </ResponsiveContainer>
            <div style={{ flex:1, display:'flex', flexDirection:'column' as const, gap:6 }}>
              {pieData.map((d:any,i:number)=>(
                <div key={i} style={{ display:'flex', alignItems:'center', gap:6 }}>
                  <div style={{ width:8, height:8, borderRadius:2, background:d.fill, flexShrink:0 }}/>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:'#6B6B8A', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{d.name}</div>
                    <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, fontWeight:700, color:'#1A1A2E' }}>
                      {formatVal(d.value,w.metric)}
                      {totalPie>0 && <span style={{ color:'#9CA3AF', fontWeight:400, marginLeft:4 }}>({(d.value/totalPie*100).toFixed(0)}%)</span>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    // -- TABLE -------------------------------------------------------------
    if(w.type==='table') {
      const tRows = campData.length > 0
        ? campData.map((c:any) => ({ label: c.name, spend: c.spend, roas: c.roas, ctr: c.ctr, clicks: c.clicks, impressions: c.impressions }))
        : [];
      const metricRows = WIDGET_METRICS.filter(m=>m.platform===platform);
      return (
        <div style={{ background:'#fff', borderRadius:12, overflow:'hidden', border:'1px solid #E4E6EF', boxShadow:'0 2px 8px rgba(0,0,0,.04)', position:'relative' }}>
          <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${pc.main}, ${pc.main}88)` }}/>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 16px', borderBottom:'1px solid #F3F4F6', marginTop:3 }}>
            <div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:12, fontWeight:700, color:'#1A1A2E' }}>{w.title}</div>
              {tRows.length>0 && <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:'#9CA3AF', marginTop:2 }}>Top {tRows.length} kampanya</div>}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:9, fontWeight:600, color:pc.main, background:pc.light, padding:'2px 7px', borderRadius:20, fontFamily:'Manrope, sans-serif' }}>{pc.label}</span>
              <ActionBtns/>
            </div>
          </div>
          <div style={{ overflowX:'auto' as const }}>
            {tRows.length > 0 ? (
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr style={{ background:'#F9FAFB' }}>
                    {['Kampanya','Harcama','ROAS','CTR','Tıklama','Gösterim'].map(h=>(
                      <th key={h} style={{ padding:'8px 12px', fontFamily:'Manrope, sans-serif', fontSize:10, fontWeight:700, color:'#6B6B8A', textAlign: h==='Kampanya'?'left':'right' as any, whiteSpace:'nowrap' as const }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tRows.map((r:any,i:number)=>(
                    <tr key={i} style={{ borderTop:'1px solid #F3F4F6' }}>
                      <td style={{ padding:'9px 12px', fontFamily:'Manrope, sans-serif', fontSize:11, color:'#1A1A2E', maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{r.label}</td>
                      <td style={{ padding:'9px 12px', fontFamily:'Manrope, sans-serif', fontSize:11, fontWeight:600, color:'#1A1A2E', textAlign:'right' as const }}>{fmt.k(r.spend)}</td>
                      <td style={{ padding:'9px 12px', fontFamily:'Manrope, sans-serif', fontSize:11, fontWeight:600, color: r.roas>=2?GREEN:r.roas>=1?GOLD:RED, textAlign:'right' as const }}>{fmt.roas(r.roas)}</td>
                      <td style={{ padding:'9px 12px', fontFamily:'Manrope, sans-serif', fontSize:11, color:'#1A1A2E', textAlign:'right' as const }}>{fmt.pct(r.ctr)}</td>
                      <td style={{ padding:'9px 12px', fontFamily:'Manrope, sans-serif', fontSize:11, color:'#1A1A2E', textAlign:'right' as const }}>{fmt.n(r.clicks)}</td>
                      <td style={{ padding:'9px 12px', fontFamily:'Manrope, sans-serif', fontSize:11, color:'#1A1A2E', textAlign:'right' as const }}>{fmt.n(r.impressions)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <tbody>
                  {metricRows.map((m,i) => (
                    <tr key={i} style={{ borderTop: i>0?'1px solid #F3F4F6':'none' }}>
                      <td style={{ padding:'9px 16px', fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A' }}>{m.label}</td>
                      <td style={{ padding:'9px 16px', fontFamily:'Manrope, sans-serif', fontSize:12, color:'#1A1A2E', textAlign:'right' as const, fontWeight:700 }}>{formatVal(getMetricValue(m.key), m.key)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* Modal */}
      {showModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.4)', zIndex:1000,
          display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'#fff', borderRadius:14, padding:28, width:520, maxWidth:'90vw',
            boxShadow:'0 20px 60px rgba(0,0,0,.2)' }}>
            <div style={{ fontFamily:'Manrope, sans-serif', fontSize:16, fontWeight:700, color:'#1A1A2E', marginBottom:20 }}>
              {editWidget ? 'Widget Düzenle' : 'Widget Ekle'}
            </div>

            {/* Widget Tipi */}
            <div style={{ marginBottom:16 }}>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A', marginBottom:8, fontWeight:600 }}>Grafik Türü</div>
              <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(5,1fr)', gap:8 }}>
                {WIDGET_TYPES.map(t => (
                  <button key={t.key} onClick={()=>setWType(t.key)} style={{
                    padding:'10px 6px', borderRadius:8, cursor:'pointer', textAlign:'center',
                    border:`2px solid ${wType===t.key?GOLD:'rgba(201,168,76,.15)'}`,
                    background: wType===t.key?'rgba(201,168,76,.08)':'#F7F8FC',
                    fontFamily:'Manrope, sans-serif', fontSize:9, color: wType===t.key?GOLD:'#6B6B8A',
                  }}>
                    <span className="material-symbols-outlined" style={{ fontSize:20, display:'block', marginBottom:4, color:wType===t.key?GOLD:'#aaa' }}>{t.icon}</span>
                    {t.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Metrik */}
            <div style={{ marginBottom:12 }}>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A', marginBottom:6, fontWeight:600 }}>Ana Metrik</div>
              <select value={wMetric} onChange={e=>setWMetric(e.target.value)} style={{
                width:'100%', padding:'8px 10px', borderRadius:8, fontFamily:'Manrope, sans-serif',
                border:'1px solid rgba(201,168,76,.2)', background:'#F7F8FC', fontSize:12, outline:'none' }}>
                {WIDGET_METRICS.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}
              </select>
            </div>

            {/* İkinci Metrik */}
            {(wType==='kpi'||wType==='bar'||wType==='line') && (
              <div style={{ marginBottom:12 }}>
                <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A', marginBottom:6, fontWeight:600 }}>İkinci Metrik (opsiyonel)</div>
                <select value={wMetric2} onChange={e=>setWMetric2(e.target.value)} style={{
                  width:'100%', padding:'8px 10px', borderRadius:8, fontFamily:'Manrope, sans-serif',
                  border:'1px solid rgba(201,168,76,.2)', background:'#F7F8FC', fontSize:12, outline:'none' }}>
                  <option value="">— Seçme —</option>
                  {WIDGET_METRICS.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}
                </select>
              </div>
            )}

            {/* Başlık */}
            <div style={{ marginBottom:20 }}>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A', marginBottom:6, fontWeight:600 }}>Widget Başlığı</div>
              <input value={wTitle} onChange={e=>setWTitle(e.target.value)}
                placeholder="Boş bırakırsan otomatik atanır"
                style={{ width:'100%', padding:'8px 10px', borderRadius:8, fontFamily:'Manrope, sans-serif',
                  border:'1px solid rgba(201,168,76,.2)', background:'#F7F8FC', fontSize:12, outline:'none', boxSizing:'border-box' }}/>
            </div>

            <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
              <button onClick={()=>{setShowModal(false);setEditWidget(null);resetForm();}} style={{
                padding:'8px 18px', borderRadius:8, fontSize:12, cursor:'pointer',
                border:'1px solid rgba(201,168,76,.2)', background:'transparent', color:'#6B6B8A',
                fontFamily:'Manrope, sans-serif' }}>İptal</button>
              <button onClick={addWidget} style={{
                padding:'9px 16px', borderRadius:11, fontSize:13, fontWeight:700, cursor:'pointer',
                border:'none', background:GOLD, color:'#fff', fontFamily:'Manrope, sans-serif' }}>
                {editWidget ? 'Güncelle' : 'Widget Ekle'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Başlık */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div>
        </div>
        <div style={{ display:'flex', gap:8 }}>
          {widgets.length > 0 && (
            <button onClick={()=>saveWidgets([])} style={{
              padding:'7px 14px', borderRadius:8, fontSize:11, cursor:'pointer',
              border:'1px solid rgba(224,82,82,.3)', background:'transparent', color:RED,
              fontFamily:'Manrope, sans-serif' }}>Temizle</button>
          )}
          <button onClick={()=>{resetForm();setShowModal(true);}} style={{
            padding:'9px 16px', borderRadius:11, fontSize:13, fontWeight:700, cursor:'pointer',
            border:'none', background:GOLD, color:'#fff', fontFamily:'Manrope, sans-serif' }}>
            Widget Ekle
          </button>
        </div>
      </div>

      {/* Widgets Grid */}
      {loading ? <Loader/> : widgets.length === 0 ? (
        <div style={{ border:'2px dashed rgba(201,168,76,.25)', borderRadius:14, padding:'60px 0', textAlign:'center', background:'rgba(201,168,76,.02)' }}>
          <div style={{ display:'flex', justifyContent:'center', gap:16, marginBottom:24 }}>
            {['bar_chart','pie_chart','speed'].map(icon => (
              <div key={icon} style={{ width:64, height:64, borderRadius:14, background:'#fff',
                boxShadow:'0 4px 16px rgba(201,168,76,.15)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <span className="material-symbols-outlined" style={{ fontSize:28, color:GOLD }}>{icon}</span>
              </div>
            ))}
          </div>
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:18, fontWeight:700, color:'#1A1A2E', marginBottom:8 }}>Widget Ekle</div>
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:12, color:'#6B6B8A', marginBottom:24 }}>Widget ekleyerek panelinizi özelleştirin</div>
          <button onClick={()=>{resetForm();setShowModal(true);}} style={{
            display:'inline-flex', alignItems:'center', gap:8, padding:'10px 24px', borderRadius:8,
            fontSize:13, fontWeight:600, cursor:'pointer', border:'1px solid rgba(201,168,76,.3)',
            background:'#fff', color:GOLD, fontFamily:'Manrope, sans-serif',
            boxShadow:'0 2px 8px rgba(201,168,76,.1)' }}>
            <span style={{ fontSize:16 }}>⊕</span> Widget Ekle
          </button>
        </div>
      ) : (
        <>
          {/* Grid Layout Seçici */}
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:4 }}>
            <span style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#6B6B8A' }}>
              {widgets.length} widget
            </span>
            {!isMobile && (
              <div style={{ display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' as const }}>
                <span style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:'#aaa', marginRight:4 }}>Düzen:</span>
                {([['1','1 Sütun','1fr'],['2','2 Sütun','repeat(2,1fr)'],['3','3 Sütun','repeat(3,1fr)'],['4','4 Sütun','repeat(4,1fr)']] as const).map(([k,label,cols])=>(
                  <button key={k} onClick={()=>setGridCols(cols)} style={{
                    padding:'4px 10px', borderRadius:6, fontSize:10, cursor:'pointer',
                    border:`1px solid ${gridCols===cols?GOLD:'rgba(201,168,76,.2)'}`,
                    background: gridCols===cols?'rgba(201,168,76,.1)':'transparent',
                    color: gridCols===cols?GOLD:'#6B6B8A', fontFamily:'Manrope, sans-serif',
                  }}>{label}</button>
                ))}
              </div>
            )}
          </div>
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':gridCols, gap:14 }}>
            {widgets.map(w => <div key={w.id}>{renderWidget(w)}</div>)}
            {/* Boş slot — widget ekle */}
            <div onClick={()=>{resetForm();setShowModal(true);}}
              style={{ border:'2px dashed rgba(201,168,76,.2)', borderRadius:10, minHeight:120,
                display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
                gap:8, cursor:'pointer', background:'rgba(201,168,76,.02)',
                transition:'all .15s' }}
              onMouseEnter={e=>(e.currentTarget as HTMLElement).style.borderColor='rgba(201,168,76,.5)'}
              onMouseLeave={e=>(e.currentTarget as HTMLElement).style.borderColor='rgba(201,168,76,.2)'}>
              <span style={{ fontSize:24, color:'rgba(201,168,76,.4)' }}>⊕</span>
              <span style={{ fontFamily:'Manrope, sans-serif', fontSize:11, color:'#aaa' }}>Widget Ekle</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ── Son İşlemler: platform, açıklama ve etki çözümleyicileri ──
const LOG_PLATFORMS: Record<string,{ label:string; logo:string }> = {
  google:  { label:'Google Ads',  logo:'/google-ads-icon.png' },
  meta:    { label:'Meta Ads',    logo:'/meta-icon.png' },
  ga4:     { label:'GA4',         logo:'/google-analytics-icon.png' },
  tiktok:  { label:'TikTok Ads',  logo:'/tiktok-logo.png' },
  criteo:  { label:'Criteo',      logo:'/criteo-icon.png' },
  chatgpt: { label:'ChatGPT Ads', logo:'/chatgpt-icon.png' },
  pixa:    { label:'Pixa',        logo:'/pixa-icon.png' },
  ikas:    { label:'ikas',        logo:'/ikas-icon.png' },
  shopify: { label:'Shopify',     logo:'/shopify-icon.png' },
  x:       { label:'X Ads',       logo:'/x-icon.png' },
  rtbhouse:{ label:'RTB House',   logo:'/rtbhouse-logo.png' },
  system:  { label:'Poyais One',  logo:'/poyais-halka.png' },
};
const LOG_TYPE_LABEL: Record<string,string> = {
  increase_budget:'Bütçe artırıldı', decrease_budget:'Bütçe düşürüldü', reallocate_budget:'Bütçe aktarıldı',
  pause_campaign:'Kampanya duraklatıldı', target_roas:'Hedef ROAS güncellendi',
  create_remarketing_audience:'Remarketing kitlesi oluşturuldu', create_campaign_draft:'Kampanya taslağı oluşturuldu',
  notify:'Bildirim gönderildi', flow:'Otomasyon akışı çalıştı', optimization:'Optimizasyon uygulandı',
};
const LOG_REVERTIBLE = ['increase_budget','decrease_budget','reallocate_budget','pause_campaign','target_roas'];

const logParse = (l:any):any => {
  const raw = l?.action_taken;
  if (raw && typeof raw==='object') return raw;
  try { const p = JSON.parse(raw||'{}'); return p && typeof p==='object' ? p : { message:String(raw) }; }
  catch { return raw ? { message:String(raw) } : {}; }
};

function logPlatformKey(l:any):string {
  const at = logParse(l);
  const p = String(at.platform||l.platform||'').toLowerCase();
  const slug = String(l.template_slug||'').toLowerCase();
  const fromText = (s:string):string => {
    if (!s) return '';
    if (/analytics|ga4/.test(s)) return 'ga4';
    if (/google/.test(s)) return 'google';
    if (/meta|facebook|instagram/.test(s)) return 'meta';
    for (const k of ['tiktok','criteo','chatgpt','pixa','ikas','shopify','rtbhouse']) if (s.includes(k)) return k;
    if (/^x[ -]?ads?$/.test(s)) return 'x';
    return '';
  };
  const act = slug.startsWith('activity-') ? slug.split('-')[1] : '';
  if (act && LOG_PLATFORMS[act]) return act;
  const byPlat = fromText(p);
  if (byPlat) return byPlat;
  if (/^ga\d|^ga-|^ga4/.test(slug)) return 'ga4';
  if (/^g(-|\d)/.test(slug)) return 'google';
  if (/^m(-|\d)/.test(slug)) return 'meta';
  return fromText(slug) || 'system';
}

function logDescription(l:any):string {
  const at = logParse(l);
  const name = String(at.campaign_name || at.campaigns?.[0]?.name || at.from?.campaign_name || '').trim();
  const msg = at.message || at.title || at.description;
  if (msg) return String(msg).replace(/\{campaign_name\}/g, name || 'Kampanya');
  const label = LOG_TYPE_LABEL[at.type];
  if (label) {
    const pct = Number(at.amount_pct) > 0 ? ` (%${Number(at.amount_pct)})` : '';
    return `${label}${pct}${name ? ` — ${name}` : ''}`;
  }
  return String(at.type || '—');
}

function logEffect(l:any):{ title:string; sub:string; color:string } {
  const at = logParse(l);
  const m:Record<string,{ title:string; sub:string; color:string }> = {
    increase_budget:   { title:'Bütçe Artışı',       sub:'Performanslı kampanyaya bütçe eklendi.',      color:'#C9A84C' },
    decrease_budget:   { title:'Bütçe Azaltma',      sub:'Düşük verimli kampanyada bütçe kısıldı.',     color:'#C9A84C' },
    reallocate_budget: { title:'Bütçe Aktarımı',     sub:'Bütçe verimli kampanyaya kaydırıldı.',        color:'#C9A84C' },
    pause_campaign:    { title:'Kampanya Duraklatma',sub:'Düşük ROAS nedeniyle bütçe koruması.',        color:'#ef4444' },
    target_roas:       { title:'Hedef ROAS',         sub:'Hedef ROAS değeri güncellendi.',              color:'#3b82f6' },
    create_remarketing_audience:{ title:'Kitle Oluşturma', sub:'Remarketing kitlesi hazırlandı.',      color:'#16D49B' },
    create_campaign_draft:{ title:'Kampanya Taslağı',sub:'Taslak oluşturuldu.',                         color:'#3b82f6' },
    notify:            { title:'Bildirim',           sub:'Bildirim gönderildi.',                         color:'#6B6B8A' },
    flow:              { title:'Otomasyon Akışı',    sub:'Mail bildirimi tetiklendi.',                   color:'#A855F7' },
  };
  if (m[at.type]) return m[at.type];
  if (String(l.template_slug||'').startsWith('activity-')) return { title:'Panel İşlemi', sub:'Panelden yapıldı.', color:'#6B6B8A' };
  if (String(l.template_slug||'').includes('manual')) return { title:'Manuel Aksiyon', sub:'Elle eklenen kayıt.', color:'#6B6B8A' };
  return { title:'İşlem', sub:'', color:'#6B6B8A' };
}

function AutomationLogsTab({ config }:{ config:any }) {
  const isMobile = useIsMobile();
  const [logs, setLogs]           = useState<any[]>([]);
  const [loading, setLoading]     = useState(true);
  const [platformFilter, setPlatformFilter] = useState('all');
  const [typeFilter, setTypeFilter]         = useState('all');
  const [dateFilter, setDateFilter]         = useState('all');
  const [page, setPage]           = useState(0);
  const [applying, setApplying]   = useState<number|null>(null);
  const [selected, setSelected]   = useState<Set<number>>(new Set());
  const [deleting, setDeleting]   = useState(false);
  const PAGE_SIZE = 15;

  useEffect(() => {
    setLoading(true);
    const clientId = config?.client_id || 1;
    axios.get(`${API}/automation/logs?client_id=${clientId}&limit=1000`)
      .then(r => { setLogs(r.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => logs.filter(l => {
    const slug = (l.template_slug||'').toLowerCase();
    const matchPlatform = platformFilter==='all' || logPlatformKey(l)===platformFilter;
    const typeMap:Record<string,string[]> = { budget:['budget','decrease_budget','increase_budget'], bid:['bid'], pause:['pause'], keyword:['keyword'], flow:['flow'] };
    let actionStr = '';
    try { actionStr = JSON.stringify(JSON.parse(l.action_taken||'{}')); } catch(e){ actionStr = l.action_taken||''; }
    const matchType = typeFilter==='all' || (typeMap[typeFilter]||[typeFilter]).some(k=>slug.includes(k)||actionStr.toLowerCase().includes(k));
    const now = Date.now();
    const dateMap:Record<string,number> = { last7:7, last30:30, last90:90, thisMonth:0 };
    const days = dateMap[dateFilter];
    const matchDate = dateFilter==='all' || (() => {
      const d = new Date(l.triggered_at||l.created_at||0).getTime();
      if (dateFilter==='thisMonth') {
        const n = new Date(); return new Date(d).getMonth()===n.getMonth() && new Date(d).getFullYear()===n.getFullYear();
      }
      return now - d < days * 86400000;
    })();
    return matchPlatform && matchType && matchDate;
  }), [logs, platformFilter, typeFilter, dateFilter]);

  const totalPages  = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged       = filtered.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);

  const totalCount    = logs.length;
  const pendingCount  = logs.filter(l=>l.status==='pending').length;
  const appliedCount  = logs.filter(l=>l.status==='approved'||l.status==='applied'||l.status==='logged').length;
  const platformOptions = Array.from(new Set(logs.map(logPlatformKey)));
  const weeklyNew     = logs.filter(l=>{
    const d = new Date(l.triggered_at||l.created_at||l.timestamp||0);
    return Date.now()-d.getTime() < 7*86400000;
  }).length;

  const statusBadge = (s:string) => {
    if (s==='approved'||s==='applied'||s==='logged') return { text:'Uygulandı',    bg:'#dcfce7', color:'#16D49B', dot:'#16D49B' };
    if (s==='pending')                 return { text:'Onay Bekliyor',bg:'rgba(201,168,76,0.12)', color:'#92400e', dot:'#f59e0b' };
    if (s==='rejected')                return { text:'Reddedildi',   bg:'#ffdad6', color:'#FF5C7A', dot:'#ef4444' };
    if (s==='reverted')                return { text:'Geri Alındı',  bg:'#f3e8ff', color:'#A855F7', dot:'#A855F7' };
    return                                    { text: s||'Bilinmiyor',bg:'#E4E6EF',color:'#6B6B8A', dot:'#9A9AB0' };
  };

  // Onay bekleyen kayıtlar silinemez (önce onaylanmalı ya da reddedilmeli).
  const deletable    = filtered.filter((l:any)=>l.status!=='pending').map((l:any)=>l.id as number);
  const allSelected  = deletable.length>0 && deletable.every(id=>selected.has(id));
  const toggleOne    = (id:number) => setSelected(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const toggleAll    = () => setSelected(allSelected ? new Set() : new Set(deletable));

  const handleDeleteSelected = () => {
    const ids = Array.from(selected);
    if (!ids.length || !window.confirm(`${ids.length} kayıt kalıcı olarak silinecek. Emin misiniz?`)) return;
    setDeleting(true);
    const clientId = config?.client_id || 1;
    axios.post(`${API}/automation/logs/delete?client_id=${clientId}`, { ids })
      .then(() => { setLogs(prev => prev.filter(l => !selected.has(l.id))); setSelected(new Set()); setPage(0); })
      .catch((e:any) => alert(e?.response?.data?.detail || 'Silinemedi'))
      .finally(() => setDeleting(false));
  };

  // Dışa aktarım ve yazdırma tablosu: şu an süzülmüş (filtrelenmiş) tüm kayıtlar, sayfalama dışı.
  const exportRows = () => filtered.map((l:any) => {
    const d = formatDate(l.triggered_at||l.created_at||l.timestamp);
    return [
      typeof d==='object' ? d.date : '', typeof d==='object' ? d.time : '',
      LOG_PLATFORMS[logPlatformKey(l)].label, logDescription(l), statusBadge(l.status).text, logEffect(l).title,
    ];
  });
  const EXPORT_HEAD = ['Tarih','Saat','Platform','Açıklama','Durum','Etki'];

  const handleDownload = () => {
    const esc = (v:string) => `"${String(v).replace(/"/g,'""')}"`;
    const csv = '﻿' + [EXPORT_HEAD, ...exportRows()].map(r=>r.map(esc).join(';')).join('\r\n');
    const url = URL.createObjectURL(new Blob([csv], { type:'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url; a.download = `son-islemler-${new Date().toISOString().slice(0,10)}.csv`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
  };

  const handlePrint = () => {
    const h = (v:string) => String(v).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    const rows = exportRows();
    const html = `<!doctype html><html lang="tr"><head><meta charset="utf-8"><title>Son İşlemler</title>
      <style>body{font-family:Manrope,Arial,sans-serif;color:#1A1A2E;padding:24px}h1{font-size:18px;margin:0 0 4px}
      p{font-size:11px;color:#6B6B8A;margin:0 0 16px}table{width:100%;border-collapse:collapse;font-size:11px}
      th{text-align:left;font-size:9px;text-transform:uppercase;letter-spacing:.06em;color:#6B6B8A;border-bottom:1px solid #999;padding:6px}
      td{padding:6px;border-bottom:1px solid #ddd;vertical-align:top}tr{page-break-inside:avoid}</style></head><body>
      <h1>Son İşlemler</h1><p>${new Date().toLocaleString('tr-TR')} · ${rows.length} kayıt</p>
      <table><thead><tr>${EXPORT_HEAD.map(c=>`<th>${h(c)}</th>`).join('')}</tr></thead>
      <tbody>${rows.map(r=>`<tr>${r.map(c=>`<td>${h(c)}</td>`).join('')}</tr>`).join('')}</tbody></table></body></html>`;
    const f = document.createElement('iframe');
    f.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
    document.body.appendChild(f);
    const doc = f.contentWindow!.document;
    doc.open(); doc.write(html); doc.close();
    setTimeout(()=>{ f.contentWindow!.focus(); f.contentWindow!.print(); setTimeout(()=>f.remove(), 2000); }, 300);
  };

  const handleApprove = (logId:number) => {
    setApplying(logId);
    axios.patch(`${API}/automation/logs/${logId}/status`, { status:'approved' })
      .then(r => {
        setLogs(prev => prev.map(l => l.id===logId ? {...l, status:'approved'} : l));
        const ar = r?.data?.apply_result;
        if (ar && (ar.status==='error' || ar.status==='partial')) {
          alert(`${ar.status==='error' ? 'Uygulanamadı' : 'Kısmen uygulandı'}: ${ar.message||'Bilinmeyen hata'}`);
        }
      })
      .catch(()=>{})
      .finally(()=>setApplying(null));
  };

  const handleReject = (logId:number) => {
    setApplying(logId);
    axios.patch(`${API}/automation/logs/${logId}/status`, { status:'rejected' })
      .then(() => setLogs(prev => prev.map(l => l.id===logId ? {...l, status:'rejected'} : l)))
      .catch(()=>{})
      .finally(()=>setApplying(null));
  };

  const handleRevert = (logId:number) => {
    setApplying(logId);
    axios.post(`${API}/automation/logs/${logId}/revert`)
      .then(() => setLogs(prev => prev.map(l => l.id===logId ? {...l, status:'reverted', reverted_at: new Date().toISOString()} : l)))
      .catch((e:any) => {
        const msg = e?.response?.data?.detail || 'Geri alma başarısız';
        alert(msg);
      })
      .finally(()=>setApplying(null));
  };

  const formatDate = (d:any) => {
    if (!d) return '—';
    try {
      const dt = new Date(d);
      return { date: dt.toLocaleDateString('tr-TR'), time: dt.toLocaleTimeString('tr-TR',{hour:'2-digit',minute:'2-digit'}) };
    } catch { return { date:'—', time:'' }; }
  };

  if (loading) return <Loader/>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20, maxWidth:'100%' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:isMobile?8:14, overflowX:'hidden' as const }}>
        {[
          { label:'Toplam Aksiyon',  value: fmt.n(totalCount),     sub:'',  subColor:'#16D49B' },
          { label:'Onay Bekleyen',   value: fmt.n(pendingCount),   sub:'',  subColor:'#f59e0b', bar: totalCount>0?pendingCount/totalCount:0, barColor:'#f59e0b' },
          { label:'Uygulanan',       value: fmt.n(appliedCount),   sub:'',  subColor:'#16D49B', bar: totalCount>0?appliedCount/totalCount:0, barColor:'#16D49B' },
          { label:'Haftalık Artış',  value: `+${fmt.n(weeklyNew)}`, sub:'', subColor:'#C9A84C' },
        ].map((k,i) => (
          <div key={i} style={{ background:'#fff', padding:'20px 22px', borderRadius:12, border:'1px solid #E4E6EF', boxShadow:'0 1px 4px rgba(0,0,0,.05)' }}>
            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, fontWeight:600, color:'#6B6B8A', fontFamily:'Manrope, sans-serif' }}>{k.label}</div>
            </div>
            <div style={{ fontSize:24, fontWeight:700, color:'#1A1A2E', fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{k.value}</div>
            {k.bar !== undefined && (
              <div style={{ height:4, width:'100%', background:'#F7F8FC', borderRadius:999, overflow:'hidden', marginBottom:4 }}>
                <div style={{ height:'100%', background:(k as any).barColor||'#16D49B', borderRadius:999, width:`${k.bar*100}%` }}/>
              </div>
            )}
            {k.sub && <div style={{ fontSize:10, color:k.subColor, fontFamily:'Manrope, sans-serif' }}>{k.sub}</div>}
          </div>
        ))}
      </div>

      {/* Filtreler */}
      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #E4E6EF', boxShadow:'0 1px 4px rgba(0,0,0,.05)', padding:'16px 20px' }}>
        <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr 1fr auto', gap:12, alignItems:'end' }}>
          <div>
            <div style={{ fontSize:9, fontWeight:700, color:'#9A9AB0', textTransform:'uppercase' as const, letterSpacing:'0.08em', fontFamily:'Manrope, sans-serif', marginBottom:6 }}>PLATFORM</div>
            <select value={platformFilter} onChange={e=>{setPlatformFilter(e.target.value);setPage(0);}}
              style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:'1px solid #E4E6EF', fontSize:12, fontFamily:'Manrope, sans-serif', background:'#F7F8FC', outline:'none', color:'#1A1A2E' }}>
              <option value="all">Tüm Platformlar</option>
              {platformOptions.map(k=><option key={k} value={k}>{LOG_PLATFORMS[k].label}</option>)}
            </select>
          </div>
          <div>
            <div style={{ fontSize:9, fontWeight:700, color:'#9A9AB0', textTransform:'uppercase' as const, letterSpacing:'0.08em', fontFamily:'Manrope, sans-serif', marginBottom:6 }}>Aksiyon Tipi</div>
            <select value={typeFilter} onChange={e=>{setTypeFilter(e.target.value);setPage(0);}}
              style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:'1px solid #E4E6EF', fontSize:12, fontFamily:'Manrope, sans-serif', background:'#F7F8FC', outline:'none', color:'#1A1A2E' }}>
              <option value="all">Tüm Tipler</option>
              <option value="budget">Bütçe</option>
              <option value="bid">Teklif</option>
              <option value="pause">Duraklatma</option>
              <option value="keyword">Keyword</option>
            </select>
          </div>
          <div>
            <div style={{ fontSize:9, fontWeight:700, color:'#9A9AB0', textTransform:'uppercase' as const, letterSpacing:'0.08em', fontFamily:'Manrope, sans-serif', marginBottom:6 }}>TARİH ARALIĞI</div>
            <select value={dateFilter} onChange={e=>{setDateFilter(e.target.value);setPage(0);}}
              style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:'1px solid #E4E6EF', fontSize:12, fontFamily:'Manrope, sans-serif', background:'#F7F8FC', outline:'none', color:'#1A1A2E' }}>
              <option value="all">Tüm Zamanlar</option>
              <option value="last7">Son 7 Gün</option>
              <option value="last30">Son 30 Gün</option>
              <option value="last90">Son 90 Gün</option>
              <option value="thisMonth">Bu Ay</option>
            </select>
          </div>

          <button onClick={()=>{setPlatformFilter('all');setTypeFilter('all');setDateFilter('all');setPage(0);}}
            style={{ padding:'8px 14px', borderRadius:8, background:'#fff', color:'#6B6B8A', border:'1px solid #E4E6EF', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:'Manrope, sans-serif', whiteSpace:'nowrap' as const }}>
            Sıfırla
          </button>
        </div>
      </div>

      {/* Tablo */}
      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #E4E6EF', boxShadow:'0 1px 4px rgba(0,0,0,.05)' }}>
        <div style={{ padding:'16px 24px', borderBottom:'1px solid #E4E6EF', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ fontSize:14, fontWeight:700, color:'#1A1A2E', fontFamily:'Manrope, sans-serif' }}>Son İşlemler</div>
            <div style={{ fontSize:10, color:'#9A9AB0', fontFamily:'Manrope, sans-serif', marginTop:2 }}>90 günden eski kayıtlar otomatik silinir.</div>
          </div>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' as const, justifyContent:'flex-end' }}>
            {selected.size>0 && (
              <button onClick={handleDeleteSelected} disabled={deleting}
                style={{ display:'flex', alignItems:'center', gap:7, padding:'9px 16px', fontSize:13, fontWeight:600, fontFamily:'Manrope, sans-serif', border:'1px solid #fecaca', borderRadius:11, background:'#fef2f2', color:'#dc2626', cursor:'pointer', opacity:deleting?0.6:1, whiteSpace:'nowrap' as const }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
                Seçilenleri Sil ({selected.size})
              </button>
            )}
            {[
              { label:'İndir', onClick:handleDownload, icon:<path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14" /> },
              { label:'Yazıcıya Aktar', onClick:handlePrint, icon:<path d="M7 9V3h10v6M7 17H5a2 2 0 01-2-2v-4a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2h-2M7 14h10v7H7z" /> },
            ].map(b=>(
              <button key={b.label} onClick={b.onClick} disabled={filtered.length===0}
                style={{ display:'flex', alignItems:'center', gap:7, padding:'9px 16px', fontSize:13, fontWeight:600, fontFamily:'Manrope, sans-serif', border:'1px solid #E4E6EF', borderRadius:11, background:'#fff', cursor:filtered.length===0?'not-allowed':'pointer', opacity:filtered.length===0?0.5:1, color:'#1A1A2E', whiteSpace:'nowrap' as const }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{b.icon}</svg>
                {b.label}
              </button>
            ))}
          </div>
        </div>
        
        <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
          <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:600 }}>
            <thead style={{ borderBottom:'1px solid #E4E6EF' }}>
              <tr>
                <th style={{ padding:'10px 0 10px 16px', width:28 }}>
                  <input type="checkbox" checked={allSelected} onChange={toggleAll} disabled={deletable.length===0}
                    title="Tümünü seç" style={{ width:15, height:15, cursor:'pointer', accentColor:'#C9A84C' }}/>
                </th>
                {['TARİH & SAAT','PLATFORM','AÇIKLAMA','DURUM','ETKİ','İŞLEM'].map((h,i)=>(
                  <th key={i} style={{ padding:'10px 16px', fontSize:9, fontWeight:700, color:'#9A9AB0', textTransform:'uppercase' as const, letterSpacing:'0.08em', textAlign:'left' as const, fontFamily:'Manrope, sans-serif', whiteSpace:'nowrap' as const }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paged.length===0 && (
                <tr><td colSpan={7} style={{ padding:48, textAlign:'center' as const, color:'#9A9AB0', fontSize:12, fontFamily:'Manrope, sans-serif' }}>Kayıt bulunamadı</td></tr>
              )}
              {paged.map((l:any,i:number) => {
                const st  = statusBadge(l.status);
                const pl  = LOG_PLATFORMS[logPlatformKey(l)];
                const logType = logParse(l).type;
                const dt  = formatDate(l.triggered_at||l.created_at||l.timestamp);
                const isPending = l.status==='pending';
                return (
                  <tr key={i} style={{ borderBottom:'1px solid #f8fafc' }}
                    onMouseEnter={e=>(e.currentTarget.style.background='rgba(248,249,246,.5)')}
                    onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                    <td style={{ padding:'14px 0 14px 16px', width:28 }}>
                      <input type="checkbox" checked={selected.has(l.id)} onChange={()=>toggleOne(l.id)} disabled={isPending}
                        title={isPending ? 'Onay bekleyen kayıt silinemez' : 'Seç'} style={{ width:15, height:15, cursor:isPending?'not-allowed':'pointer', accentColor:'#C9A84C' }}/>
                    </td>
                    <td style={{ padding:'14px 16px', whiteSpace:'nowrap' as const }}>
                      <div style={{ fontSize:13, fontWeight:700, color:'#1A1A2E', fontFamily:'Manrope, sans-serif' }}>{typeof dt==='object'?dt.date:'—'}</div>
                      <div style={{ fontSize:10, color:'#9A9AB0', fontFamily:'Manrope, sans-serif' }}>{typeof dt==='object'?dt.time:''}</div>
                    </td>
                    <td style={{ padding:'14px 16px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <div style={{ width:30,height:30,borderRadius:7,background:'#F7F8FC',border:'1px solid #E4E6EF',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                          <img src={pl.logo} alt={pl.label} style={{ width:18,height:18,objectFit:'contain' }}/>
                        </div>
                        <span style={{ fontSize:12, fontWeight:600, color:'#6B6B8A', fontFamily:'Manrope, sans-serif', whiteSpace:'nowrap' as const }}>{pl.label}</span>
                      </div>
                    </td>
                    <td style={{ padding:'14px 16px', maxWidth:280 }}>
                      <div style={{ fontSize:12, color:'#1A1A2E', fontFamily:'Manrope, sans-serif', lineHeight:1.5 }}>
                        {logDescription(l).split(/(%[\d.]+)/).map((part:string,k:number)=>/^%[\d.]+$/.test(part)
                          ? <span key={k} style={{ color:'#C9A84C', fontWeight:700 }}>{part}</span> : part)}
                      </div>
                    </td>
                    <td style={{ padding:'14px 16px', whiteSpace:'nowrap' as const }}>
                      <span style={{ display:'flex', alignItems:'center', gap:5, fontSize:11, fontWeight:700, color:st.color, fontFamily:'Manrope, sans-serif' }}>
                        <span style={{ width:7,height:7,borderRadius:'50%',background:st.dot,flexShrink:0 }}/>
                        {st.text}
                      </span>
                    </td>
                    <td style={{ padding:'14px 16px', maxWidth:180 }}>
                      {(() => {
                        const ef = logEffect(l);
                        return (
                          <div style={{ fontSize:11, fontFamily:'Manrope, sans-serif' }}>
                            <div style={{ fontWeight:700, color:ef.color, marginBottom:2 }}>{ef.title}</div>
                            {ef.sub && <div style={{ fontSize:10, color:'#9A9AB0' }}>{ef.sub}</div>}
                          </div>
                        );
                      })()}
                    </td>
                    <td style={{ padding:'14px 16px' }}>
                      {isPending ? (
                        <div style={{ display:'flex', gap:6 }}>
                          <button onClick={()=>handleApprove(l.id)} disabled={applying===l.id}
                            style={{ padding:'5px 12px', borderRadius:6, background:'#1A1A2E', color:'#fff', border:'none', fontSize:11, fontWeight:700, cursor:'pointer', fontFamily:'Manrope, sans-serif', opacity: applying===l.id?0.5:1 }}>
                            Onayla
                          </button>
                          <button onClick={()=>handleReject(l.id)} disabled={applying===l.id}
                            style={{ padding:'5px 12px', borderRadius:6, background:'#fff', color:'#6B6B8A', border:'1px solid #E4E6EF', fontSize:11, fontWeight:700, cursor:'pointer', fontFamily:'Manrope, sans-serif', opacity: applying===l.id?0.5:1 }}>
                            Reddet
                          </button>
                        </div>
                      ) : (l.status==='approved'||l.status==='applied') && !LOG_REVERTIBLE.includes(logType) ? (
                        <span style={{ fontSize:11, color:'#9A9AB0', fontFamily:'Manrope, sans-serif' }}>—</span>
                      ) : (l.status==='approved'||l.status==='applied') ? (
                        <button onClick={()=>handleRevert(l.id)} disabled={applying===l.id}
                          style={{ padding:'5px 12px', borderRadius:6, background:'#f3e8ff', color:'#A855F7', border:'1px solid #e9d5ff', fontSize:11, fontWeight:700, cursor:'pointer', fontFamily:'Manrope, sans-serif', opacity: applying===l.id?0.5:1 }}>
                          Geri Al
                        </button>
                      ) : (l.status==='reverted') ? (
                        <span style={{ fontSize:11, color:'#A855F7', fontFamily:'Manrope, sans-serif' }}>Geri Alındı</span>
                      ) : (
                        <span style={{ fontSize:11, color:'#9A9AB0', fontFamily:'Manrope, sans-serif' }}>—</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ padding:'12px 20px', borderTop:'1px solid #f8fafc', display:'flex', justifyContent:'space-between', alignItems:'center', background:'rgba(248,249,246,.4)' }}>
          <span style={{ fontSize:10, color:'#9A9AB0', fontFamily:'Manrope, sans-serif' }}>Toplam {filtered.length} kayıttan {Math.min(page*PAGE_SIZE+1,filtered.length)}-{Math.min((page+1)*PAGE_SIZE,filtered.length)} arası gösteriliyor.</span>
          <div style={{ display:'flex', gap:4, alignItems:'center' }}>
            <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
              style={{ width:28,height:28,borderRadius:6,border:'1px solid #E4E6EF',background:'#fff',cursor:page===0?'not-allowed':'pointer',opacity:page===0?0.4:1,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13 }}>‹</button>
            {Array.from({length:Math.min(5,totalPages)},(_,i)=>{
              const n = page<3 ? i : page-2+i;
              if (n>=totalPages) return null;
              return (
                <button key={n} onClick={()=>setPage(n)}
                  style={{ width:28,height:28,borderRadius:6,border:`1px solid ${page===n?'#C9A84C':'#E4E6EF'}`,background:page===n?'#C9A84C':'#fff',color:page===n?'#fff':'#6B6B8A',cursor:'pointer',fontSize:11,fontWeight:700,fontFamily:'Manrope, sans-serif' }}>{n+1}</button>
              );
            })}
            {totalPages>5 && <span style={{ fontSize:11,color:'#9A9AB0' }}>...</span>}
            {totalPages>5 && (
              <button onClick={()=>setPage(totalPages-1)}
                style={{ width:28,height:28,borderRadius:6,border:`1px solid ${page===totalPages-1?'#C9A84C':'#E4E6EF'}`,background:page===totalPages-1?'#C9A84C':'#fff',color:page===totalPages-1?'#fff':'#6B6B8A',cursor:'pointer',fontSize:11,fontWeight:700,fontFamily:'Manrope, sans-serif' }}>{totalPages}</button>
            )}
            <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
              style={{ width:28,height:28,borderRadius:6,border:'1px solid #E4E6EF',background:'#fff',cursor:page>=totalPages-1?'not-allowed':'pointer',opacity:page>=totalPages-1?.4:1,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13 }}>›</button>
          </div>
        </div>
      </div>

    </div>
  );
}
function CreativeCard({children, style}:{children:React.ReactNode;style?:React.CSSProperties}) {
  return <div style={{background:'#F7F8FC',border:'1px solid rgba(201,168,76,0.15)',borderRadius:10,padding:'18px 20px',boxShadow:'0 1px 4px rgba(0,0,0,.04)',boxSizing:'border-box' as const,width:'100%',...style}}>{children}</div>;
}
function CreativeSLabel({children}:{children:React.ReactNode}) {
  return <div style={{fontFamily:'Manrope, sans-serif',fontSize:9,color:'#6B6B8A',textTransform:'uppercase' as const,letterSpacing:0,marginBottom:8}}>{children}</div>;
}

function CreativeTab({ config }:{ config:any }) {
  const isMobile = useIsMobile();
  const [platform, setPlatform] = useState<'meta'|'google'>('meta');
  const [format, setFormat]     = useState('');
  const [product, setProduct]   = useState('');
  const [style, setStyle]       = useState('minimalist');
  const [mood, setMood]         = useState('profesyonel');
  const [loading, setLoading]   = useState(false);
  const [imgUrl, setImgUrl]     = useState<string|null>(null);
  const [imgError, setImgError] = useState<string|null>(null);
  const [imgMode, setImgMode] = useState<'text'|'image'>('text');
  const [uploadedImg, setUploadedImg] = useState<File|null>(null);
  const [uploadedImgPreview, setUploadedImgPreview] = useState<string|null>(null);
  const imgUploadRef = React.useRef<HTMLInputElement>(null);
  const [prompt, setPrompt]     = useState('');
  const [aiPrompt, setAiPrompt] = useState('');
  const [generating, setGenerating] = useState(false);

  const GOLD='#C9A84C', GOLD_L='#E8C97A', GOLD_DIM='rgba(201,168,76,0.1)', GOLD_BRD='rgba(201,168,76,0.25)';
  const BG='#ffffff', S2='#F7F8FC', S3='#E4E6EF', BD='rgba(201,168,76,0.15)';
  const TX='#1A1A2E', MT='#6B6B8A', GREEN='#16D49B';

  const PLATFORMS = [
    { key:'meta',      label:'Meta Ads',    formats:['Feed (1:1)','Story (9:16)','Carousel','Banner'] },
    { key:'google',    label:'Google Ads',  formats:['Display (16:9)','Kare (1:1)','Dikey (4:5)','Banner (728x90)'] },
  ];
  const STYLES = ['Minimalist','Lifestyle','Ürün Odaklı','Gradient','Flat Design','Fotoğraf'];
  const MOODS  = ['Profesyonel','Enerjik','Sıcak','Lüks','Eğlenceli','Güven Verici'];

  const currentPlatform = PLATFORMS.find(p=>p.key===platform)!;

  const generatePrompt = async () => {
    if(!product.trim()) return;
    setGenerating(true);
    try {
      const token = localStorage.getItem('poyais_token') || getToken();
      const res = await fetch('/api/v1/intelligence/ai/proxy', {
        method:'POST',
        headers:{'Content-Type':'application/json','Authorization':'Bearer '+token},
        body: JSON.stringify({
          system: 'Sen uzman bir reklam görseli promptu yazarısın. Sadece İngilizce görsel prompt yaz, başka hiçbir şey yazma.',
          user: `${currentPlatform.label} için ${format||currentPlatform.formats[0]} formatında reklam görseli promptu yaz.\nÜrün: ${product}\nStil: ${style}\nMood: ${mood}\n\nSadece DALL-E/Stable Diffusion için optimize edilmiş İngilizce prompt yaz.`,
          max_tokens: 200
        })
      });
      const data = await res.json();
      const raw = (data.content||data.text||data.result||'').trim();
      setAiPrompt(raw);
      setPrompt(raw);
    } catch {
      setAiPrompt('');
    }
    setGenerating(false);
  };

  const generateImage = async () => {
    if(!prompt.trim()) return;
    if(imgMode==='image' && !uploadedImg) return;
    setLoading(true); setImgUrl(null); setImgError(null);
    try {
      let res: Response;
      if(imgMode==='image' && uploadedImg) {
        const fd = new FormData();
        fd.append('prompt', prompt);
        fd.append('format', format||currentPlatform.formats[0]);
        fd.append('image', uploadedImg);
        res = await fetch('/api/v1/creative/generate-image-from-image', {
          method:'POST',
          headers:{'Authorization':'Bearer '+localStorage.getItem('poyais_token')},
          body: fd,
        });
      } else {
        res = await fetch('/api/v1/creative/generate-image', {
          method:'POST',
          headers:{'Content-Type':'application/json','Authorization':'Bearer '+localStorage.getItem('poyais_token')},
          body: JSON.stringify({ prompt, platform, format: format||currentPlatform.formats[0], client_id: parseInt(localStorage.getItem('poyais_active_client')||'1') }),
        });
      }
      const data = await res.json();
      if(data.url) setImgUrl(data.url);
      else setImgError(data.detail || 'Görsel üretilemedi.');
    } catch {
      setImgError('Görsel üretme sırasında hata oluştu.');
    }
    setLoading(false);
  };



  return (
    <div style={{fontFamily:'Manrope, sans-serif'}}>
      <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}`}</style>

      <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'340px 1fr',gap:20,alignItems:'start',minWidth:0}}>

        {/* Sol form */}
        <div style={{display:'flex',flexDirection:'column' as const,gap:14,minWidth:0}}>

          {/* Platform */}
          <CreativeCard>
            <CreativeSLabel>Platform</CreativeSLabel>
            <div style={{display:'flex',flexDirection:'column' as const,gap:6}}>
              {PLATFORMS.map(p=>(
                <button key={p.key} onClick={()=>{setPlatform(p.key as any);setFormat('');}}
                  style={{padding:'10px 14px',textAlign:'left' as const,cursor:'pointer',borderRadius:8,
                    background:platform===p.key?GOLD_DIM:S2,
                    border:`1px solid ${platform===p.key?GOLD_BRD:'transparent'}`,
                    display:'flex',alignItems:'center',gap:10,transition:'all .15s'}}>
                  {p.key==='meta' ? <img src='https://poyaisone.com/meta-logo.png' style={{width:20,height:20,objectFit:'contain' as const,display:'block'}}/> : <img src='https://poyaisone.com/google-ads-logo.png' style={{width:20,height:20,objectFit:'contain' as const,display:'block'}}/>}
                  <span style={{fontSize:12,fontWeight:700,color:platform===p.key?GOLD:TX}}>{p.label}</span>
                </button>
              ))}
            </div>
          </CreativeCard>

          {/* Format */}
          <CreativeCard>
            <CreativeSLabel>Format</CreativeSLabel>
            <div style={{display:'flex',flexWrap:'nowrap' as const,gap:6,overflowX:'auto' as const}}>
              {currentPlatform.formats.map(f=>(
                <button key={f} onClick={()=>setFormat(f)}
                  style={{padding:'5px 12px',fontSize:11,fontWeight:600,cursor:'pointer',borderRadius:20,
                    background:format===f?GOLD_DIM:S2,
                    border:`1px solid ${format===f?GOLD_BRD:'transparent'}`,
                    color:format===f?GOLD:MT,transition:'all .15s'}}>
                  {f}
                </button>
              ))}
            </div>
          </CreativeCard>

          {/* Ürün + Stil + Mood */}
          <CreativeCard>
            <CreativeSLabel>Ürün / Hizmet</CreativeSLabel>
            <textarea value={product} onChange={e=>setProduct(e.target.value)}
              placeholder="Örn: El yapımı seramik kupa seti, beyaz-gold renk"
              rows={3} style={{width:'100%',background:S2,border:'1px solid rgba(201,168,76,.18)',borderRadius:7,
                color:TX,fontSize:12,padding:'9px 12px',resize:'vertical' as const,outline:'none',
                fontFamily:'inherit',lineHeight:1.6,boxSizing:'border-box' as const,transition:'border-color .15s'}}
              onFocus={e=>e.target.style.borderColor='rgba(201,168,76,.5)'}
              onBlur={e=>e.target.style.borderColor='rgba(201,168,76,.18)'}/>

            <div style={{marginTop:14}}>
              <CreativeSLabel>Görsel Stili</CreativeSLabel>
              <div style={{display:'flex',flexWrap:'wrap' as const,gap:6}}>
                {STYLES.map(s=>(
                  <button key={s} onClick={()=>setStyle(s.toLowerCase())}
                    style={{padding:'4px 10px',fontSize:11,fontWeight:600,cursor:'pointer',borderRadius:20,
                      background:style===s.toLowerCase()?GOLD_DIM:BG,
                      border:`1px solid ${style===s.toLowerCase()?GOLD_BRD:'rgba(201,168,76,.18)'}`,
                      color:style===s.toLowerCase()?GOLD:MT,transition:'all .15s'}}>
                    {s}
                  </button>
                ))}
              </div>
            </div>

            <div style={{marginTop:14}}>
              <CreativeSLabel>Atmosfer / Mood</CreativeSLabel>
              <div style={{display:'flex',flexWrap:'wrap' as const,gap:6}}>
                {MOODS.map(m=>(
                  <button key={m} onClick={()=>setMood(m.toLowerCase())}
                    style={{padding:'4px 10px',fontSize:11,fontWeight:600,cursor:'pointer',borderRadius:20,
                      background:mood===m.toLowerCase()?GOLD_DIM:BG,
                      border:`1px solid ${mood===m.toLowerCase()?GOLD_BRD:'rgba(201,168,76,.18)'}`,
                      color:mood===m.toLowerCase()?GOLD:MT,transition:'all .15s'}}>
                    {m}
                  </button>
                ))}
              </div>
            </div>
          </CreativeCard>

          <button onClick={generatePrompt} disabled={generating||!product.trim()}
            style={{width:'100%',padding:'10px',fontSize:12,fontWeight:700,
              background:generating?S2:`linear-gradient(135deg,${GOLD},${GOLD_L})`,
              border:`1px solid ${generating?BD:GOLD}`,borderRadius:8,
              color:generating?MT:'#1a1000',cursor:generating?'not-allowed':'pointer',
              fontFamily:'inherit',transition:'all .2s'}}>
            {generating?'Prompt Oluşturuluyor…':'AI Prompt Oluştur'}
          </button>
        </div>

        {/* Sağ panel */}
        <div style={{display:'flex',flexDirection:'column' as const,gap:14}}>

          {/* Mod seçici */}
          <div style={{display:'flex',background:S2,borderRadius:8,padding:3,border:`1px solid rgba(201,168,76,.12)`}}>
            {([{key:'text',label:'Metinden Üret'},{key:'image',label:'Görselden Üret'}] as const).map(m=>(
              <button key={m.key} onClick={()=>setImgMode(m.key)}
                style={{flex:1,padding:'7px',fontSize:11,fontWeight:600,
                  background:imgMode===m.key?BG:'transparent',
                  border:`1px solid ${imgMode===m.key?GOLD_BRD:'transparent'}`,
                  borderRadius:6,color:imgMode===m.key?GOLD:MT,cursor:'pointer',
                  transition:'all .15s',fontFamily:'inherit',
                  boxShadow:imgMode===m.key?'0 1px 3px rgba(0,0,0,.08)':'none'}}>
                {m.label}
              </button>
            ))}
          </div>

          {/* Görsel yükleme (image-to-image) */}
          {imgMode==='image'&&(
            <CreativeCard>
              <CreativeSLabel>Referans Görsel</CreativeSLabel>
              <div onClick={()=>imgUploadRef.current?.click()}
                style={{padding:'16px',border:`1.5px dashed ${uploadedImg?GOLD_BRD:'rgba(201,168,76,.25)'}`,
                  borderRadius:8,textAlign:'center' as const,cursor:'pointer',
                  background:uploadedImg?GOLD_DIM:S2,transition:'all .2s'}}>
                {uploadedImgPreview?(
                  <div>
                    <img src={uploadedImgPreview} alt="" style={{maxHeight:120,borderRadius:6,marginBottom:6,display:'block',margin:'0 auto 6px'}}/>
                    <div style={{fontSize:11,color:MT}}>Değiştirmek için tıkla</div>
                  </div>
                ):(
                  <div>
                    <div style={{fontSize:24,marginBottom:4}}>🖼️</div>
                    <div style={{fontSize:12,color:TX,fontWeight:600}}>Görsel yükle</div>
                    <div style={{fontSize:11,color:MT,marginTop:2}}>JPG / PNG / WebP</div>
                  </div>
                )}
              </div>
              <input ref={imgUploadRef} type="file" accept="image/*" style={{display:'none'}}
                onChange={e=>{
                  const f=e.target.files?.[0];
                  if(!f) return;
                  setUploadedImg(f);
                  const reader=new FileReader();
                  reader.onload=ev=>setUploadedImgPreview(ev.target?.result as string);
                  reader.readAsDataURL(f);
                }}/>
            </CreativeCard>
          )}

          {/* Prompt editörü */}
          <CreativeCard>
            <CreativeSLabel>Görsel Promptu</CreativeSLabel>
            <textarea value={prompt} onChange={e=>setPrompt(e.target.value)}
              placeholder={imgMode==='image'?"Referans görseli nasıl dönüştürelim? Örn: ürünü altın ışıkla aydınlat, lüks arka plan ekle":"AI ile otomatik oluştur veya kendiniz yazın…"}
              rows={4} style={{width:'100%',background:S2,border:'1px solid rgba(201,168,76,.18)',borderRadius:7,
                color:TX,fontSize:12,padding:'9px 12px',resize:'vertical' as const,outline:'none',
                fontFamily:'inherit',lineHeight:1.6,boxSizing:'border-box' as const,transition:'border-color .15s'}}
              onFocus={e=>e.target.style.borderColor='rgba(201,168,76,.5)'}
              onBlur={e=>e.target.style.borderColor='rgba(201,168,76,.18)'}/>
            <div style={{fontSize:10,color:MT,textAlign:'right' as const,marginTop:4}}>{prompt.length} karakter</div>
          </CreativeCard>

          <button onClick={generateImage} disabled={loading||!prompt.trim()||(imgMode==='image'&&!uploadedImg)}
            style={{width:'100%',padding:'11px',fontSize:13,fontWeight:800,
              background:loading?S2:`linear-gradient(135deg,${GOLD},${GOLD_L})`,
              border:`1px solid ${loading?BD:GOLD}`,borderRadius:8,
              color:loading?MT:'#1a1000',cursor:loading?'not-allowed':'pointer',
              fontFamily:'inherit',transition:'all .2s'}}>
            {loading?'Görsel Üretiliyor…':'Görsel Üret'}
          </button>

          {/* Sonuç */}
          {imgError && (
            <CreativeCard style={{background:'rgba(224,82,82,0.04)',border:'1px solid rgba(224,82,82,0.2)'}}>
              <div style={{fontSize:12,color:'#FF5C7A'}}>{imgError}</div>
            </CreativeCard>
          )}

          {imgUrl && (
            <CreativeCard style={{padding:12,animation:'fadeIn 0.3s ease'}}>
              <img src={imgUrl} alt="AI Görsel" style={{width:'100%',borderRadius:8,display:'block'}}/>
              <div style={{display:'flex',gap:8,marginTop:12}}>
                <a href={imgUrl} download="poyais-gorsel.png"
                  style={{flex:1,padding:'8px',textAlign:'center' as const,background:GOLD_DIM,
                    border:`1px solid ${GOLD_BRD}`,borderRadius:7,color:GOLD,
                    fontSize:11,fontWeight:700,textDecoration:'none'}}>
                  ⬇ İndir
                </a>
                <button onClick={generateImage}
                  style={{flex:1,padding:'8px',background:S2,border:`1px solid ${BD}`,
                    borderRadius:7,color:MT,fontSize:11,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>
                  ↺ Yeniden Üret
                </button>
              </div>
            </CreativeCard>
          )}

          {!imgUrl && !imgError && !loading && (
            <CreativeCard style={{textAlign:'center' as const,padding:'48px 20px'}}>
              <div style={{fontSize:40,marginBottom:12}}>🖼️</div>
              <div style={{fontSize:15,fontWeight:700,color:TX,marginBottom:6}}>AI Görsel Üretici</div>
              <div style={{fontSize:12,color:MT,lineHeight:1.6}}>
                Platform ve ürün bilgisini gir,<br/>
                AI prompt oluştur, ardından görseli üret.
              </div>
            </CreativeCard>
          )}
        </div>
      </div>
    </div>
  );
}


function ReportsTab({ config, start:defaultStart, end:defaultEnd }:{ config:any; start:string; end:string }) {
  const isMobile = useIsMobile();
  const [datePreset, setDatePreset] = useState<'thisMonth'|'lastMonth'|'last30'|'last90'|'custom'>('lastMonth');
  const [platforms, setPlatforms]   = useState({ ga4:true, gads:false, meta:false });
  const [lang, setLang]             = useState<'tr'|'en'>('tr');
  const [recipient, setRecipient]   = useState('');
  const [downloading, setDownloading] = useState(false);
  const [aiModules, setAiModules]   = useState({ ga4:true, gads:true, meta:false, weekly:true, anomaly:true });
  const [aiGenerating, setAiGenerating] = useState(false);
  const [recentReports] = useState<any[]>([]);

  const presetLabel: Record<string,string> = { thisMonth:'Bu Ay', lastMonth:'Geçen Ay', last30:'Son 30 Gün', last90:'Son 90 Gün', custom:'Özel' };

  const handleDownload = () => {
    setDownloading(true);
    const selectedPlatforms = Object.entries(platforms).filter(([,v])=>v).map(([k])=>k);
    const { propertyId } = config.platforms.ga4;
    const { customerId } = config.platforms.gads;
    const { accountId }  = config.platforms.meta;
    axios.post(`${API}/pdf/generate`, {
      platforms: selectedPlatforms,
      start_date: defaultStart,
      end_date: defaultEnd,
      language: lang,
      recipient_name: recipient || undefined,
      ga4_property_id: propertyId,
      gads_customer_id: customerId,
      meta_account_id: accountId,
    }, { responseType:'blob' })
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `poyais-rapor-${defaultStart}-${defaultEnd}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(()=>{})
    .finally(()=>setDownloading(false));
  };

  const handleAIReport = () => {
    setAiGenerating(true);
    setTimeout(()=>setAiGenerating(false), 3000);
  };

  const typeBadge = (t:string) => {
    if (t==='AI ANALİZ')  return { bg:'#ede9fe', color:'#A855F7' };
    if (t==='OTOMATİK')   return { bg:'#E4E6EF', color:'#6B6B8A' };
    return                       { bg:'rgba(201,168,76,0.12)', color:'#92400e' };
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20, maxWidth:'100%' }}>



      {/* Ana Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:16 }}>

        {/* Sol: Rapor Olustur */}
        <div style={{ background:'#fff', borderRadius:12, border:'1px solid #E4E6EF', boxShadow:'0 1px 4px rgba(0,0,0,.05)', padding:'24px 28px' }}>
          <div style={{ fontSize:9, fontWeight:700, color:'#C9A84C', textTransform:'uppercase' as const, letterSpacing:'0.12em', fontFamily:'Manrope, sans-serif', marginBottom:20 }}>Rapor Oluştur</div>

          {/* Tarih Araligi */}
          <div style={{ marginBottom:20 }}>
            <div style={{ fontSize:10, fontWeight:700, color:'#6B6B8A', textTransform:'uppercase' as const, letterSpacing:'0.08em', fontFamily:'Manrope, sans-serif', marginBottom:10 }}>Tarih Aralığı Seçin</div>
            <div style={{ display:'flex', flexWrap:'wrap' as const, gap:8 }}>
              {(['thisMonth','lastMonth','last30','last90','custom'] as const).map(p=>(
                <button key={p} onClick={()=>setDatePreset(p)}
                  style={{ padding:'7px 14px', borderRadius:8, border:`1px solid ${datePreset===p?'#C9A84C':'#E4E6EF'}`, background: datePreset===p?'#C9A84C':'#fff', color: datePreset===p?'#fff':'#6B6B8A', fontSize:11, fontWeight:600, cursor:'pointer', fontFamily:'Manrope, sans-serif', display:'flex', alignItems:'center', gap:5 }}>
                  {p==='custom'?'📅 ':''}{presetLabel[p]}
                </button>
              ))}
            </div>
          </div>

          {/* Platform Secimi */}
          <div style={{ marginBottom:20 }}>
            <div style={{ fontSize:10, fontWeight:700, color:'#6B6B8A', textTransform:'uppercase' as const, letterSpacing:'0.08em', fontFamily:'Manrope, sans-serif', marginBottom:10 }}>Platform Seçimi</div>
            <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(2,1fr)', gap:8 }}>
              {[
                { key:'ga4',  label:'Analytics',   sub:'Google GA4',   icon:'📊' },
                { key:'gads', label:'Google Ads',  sub:'PPC Raporları',  icon:'📣' },
                { key:'meta', label:'Meta Ads',    sub:'Sosyal Medya',   icon:'👁' },
              ].map(pl=>(
                <button key={pl.key} onClick={()=>setPlatforms(p=>({...p,[pl.key]:!p[pl.key as keyof typeof p]}))}
                  style={{ padding:'12px', borderRadius:9, border:`1px solid ${platforms[pl.key as keyof typeof platforms]?'#C9A84C':'#E4E6EF'}`, background: platforms[pl.key as keyof typeof platforms]?'rgba(201,168,76,0.08)':'#fff', cursor:'pointer', textAlign:'left' as const, position:'relative' as const }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
                    <span style={{ fontSize:14 }}>{pl.icon}</span>
                    <div style={{ width:16,height:16,borderRadius:3,border:`2px solid ${platforms[pl.key as keyof typeof platforms]?'#C9A84C':'#E4E6EF'}`, background: platforms[pl.key as keyof typeof platforms]?'#C9A84C':'#fff', display:'flex',alignItems:'center',justifyContent:'center' }}>
                      {platforms[pl.key as keyof typeof platforms] && <span style={{ color:'#fff',fontSize:10,lineHeight:1 }}>✓</span>}
                    </div>
                  </div>
                  <div style={{ fontSize:12,fontWeight:700,color:'#1A1A2E',fontFamily:'Manrope, sans-serif' }}>{pl.label}</div>
                  <div style={{ fontSize:10,color:'#9A9AB0',fontFamily:'Manrope, sans-serif' }}>{pl.sub}</div>
                </button>
              ))}
            </div>
          </div>

          {/* Dil + Alici */}
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:12, marginBottom:24 }}>
            <div>
              <div style={{ fontSize:10, fontWeight:700, color:'#6B6B8A', textTransform:'uppercase' as const, letterSpacing:'0.08em', fontFamily:'Manrope, sans-serif', marginBottom:8 }}>Rapor Dili</div>
              <div style={{ display:'flex', gap:8 }}>
                {[['tr','🇹🇷','Türkçe'],['en','🇬🇧','English']].map(([l,flag,label])=>(
                  <button key={l} onClick={()=>setLang(l as 'tr'|'en')}
                    style={{ flex:1, padding:'8px', borderRadius:8, border:`1px solid ${lang===l?'#C9A84C':'#E4E6EF'}`, background: lang===l?'rgba(201,168,76,0.08)':'#fff', cursor:'pointer', fontSize:11, fontWeight:600, color:'#6B6B8A', fontFamily:'Manrope, sans-serif', display:'flex', alignItems:'center', justifyContent:'center', gap:5 }}>
                    {flag} {label}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <div style={{ fontSize:10, fontWeight:700, color:'#6B6B8A', textTransform:'uppercase' as const, letterSpacing:'0.08em', fontFamily:'Manrope, sans-serif', marginBottom:8 }}>Alici Adi</div>
              <input value={recipient} onChange={e=>setRecipient(e.target.value)} placeholder="Örn: Mehmet Öz"
                style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:'1px solid #E4E6EF', fontSize:11, fontFamily:'Manrope, sans-serif', background:'#F7F8FC', outline:'none', color:'#1A1A2E', boxSizing:'border-box' as const }}/>
            </div>
          </div>

          <button onClick={handleDownload} disabled={downloading}
            style={{ width:'100%', padding:'13px', borderRadius:10, border:`2px solid #C9A84C`, background: downloading?'rgba(201,168,76,.1)':'#fff', color:'#C9A84C', fontSize:13, fontWeight:700, cursor: downloading?'not-allowed':'pointer', fontFamily:'Manrope, sans-serif', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
            {downloading ? '⏳ Rapor Hazırlanıyor...' : '📄 PDF RAPOR İNDİR'}
          </button>
        </div>

        {/* Sag: AI Raporu */}
        <div style={{ background:'#fff', borderRadius:12, border:'1px solid #E4E6EF', boxShadow:'0 1px 4px rgba(0,0,0,.05)', padding:'24px 28px' }}>
          <div style={{ fontSize:9, fontWeight:700, color:'#A855F7', textTransform:'uppercase' as const, letterSpacing:'0.12em', fontFamily:'Manrope, sans-serif', marginBottom:16 }}>Poyais One AI Tam Analiz Raporu</div>

          <div style={{ background:'linear-gradient(135deg,#ede9fe,#f5f3ff)', borderRadius:10, padding:'16px', marginBottom:20, display:'flex', gap:14, alignItems:'flex-start' }}>
            <div style={{ width:44,height:44,borderRadius:10,background:'#A855F7',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0 }}>✦</div>
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:'#1A1A2E', fontFamily:'Manrope, sans-serif', marginBottom:4 }}>Yapay Zeka Destekli Bütünleşik Analiz</div>
              <div style={{ fontSize:11, color:'#6B6B8A', fontFamily:'Manrope, sans-serif', lineHeight:1.6 }}>Tüm veri kaynaklarını çapraz analiz ederek kampanya performansınızdaki anomalileri, fırsatları ve gelecek tahminlerini tek bir raporda sunar.</div>
            </div>
          </div>

          <div style={{ fontSize:10, fontWeight:700, color:'#6B6B8A', textTransform:'uppercase' as const, letterSpacing:'0.08em', fontFamily:'Manrope, sans-serif', marginBottom:12 }}>Rapor Kapsami ve Moduller</div>
          <div style={{ display:'flex', flexDirection:'column' as const, gap:10, marginBottom:16 }}>
            {[
              { key:'ga4',    label:'GA4 AI Analiz',    sub:'Trafik kalitesi ve dönüşüm tahminleri.', color:'#A855F7' },
              { key:'gads',   label:'Google Ads AI',     sub:'Bütçe optimizasyonu ve anahtar kelime önerileri.', color:'#4285f4' },
              { key:'meta',   label:'Meta Ads AI',       sub:'Kreatif performans ve kitle analizi.', color:'#C9A84C' },
            ].map(m=>(
              <div key={m.key} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 14px', borderRadius:8, background:'#F7F8FC', border:'1px solid #E4E6EF' }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <div style={{ width:6,height:6,borderRadius:'50%',background:m.color }}/>
                  <div>
                    <div style={{ fontSize:12,fontWeight:600,color:'#1A1A2E',fontFamily:'Manrope, sans-serif' }}>{m.label}</div>
                    <div style={{ fontSize:10,color:'#9A9AB0',fontFamily:'Manrope, sans-serif' }}>{m.sub}</div>
                  </div>
                </div>
                <div onClick={()=>setAiModules(p=>({...p,[m.key]:!p[m.key as keyof typeof p]}))}
                  style={{ width:36,height:20,borderRadius:999,background: aiModules[m.key as keyof typeof aiModules]?'#A855F7':'#E4E6EF',cursor:'pointer',position:'relative' as const,transition:'background .2s',flexShrink:0 }}>
                  <div style={{ width:16,height:16,borderRadius:'50%',background:'#fff',position:'absolute' as const,top:2,left: aiModules[m.key as keyof typeof aiModules]?18:2,transition:'left .2s',boxShadow:'0 1px 3px rgba(0,0,0,.2)' }}/>
                </div>
              </div>
            ))}
          </div>

          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:8, marginBottom:20 }}>
            {[['weekly','Haftalık Rapor'],['anomaly','Anomali Tespiti']].map(([k,l])=>(
              <div key={k} onClick={()=>setAiModules(p=>({...p,[k]:!p[k as keyof typeof p]}))}
                style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 12px', borderRadius:8, border:`1px solid ${aiModules[k as keyof typeof aiModules]?'#A855F7':'#E4E6EF'}`, background: aiModules[k as keyof typeof aiModules]?'rgba(124,58,237,.04)':'#fff', cursor:'pointer' }}>
                <div style={{ width:16,height:16,borderRadius:4,border:`2px solid ${aiModules[k as keyof typeof aiModules]?'#A855F7':'#E4E6EF'}`,background: aiModules[k as keyof typeof aiModules]?'#A855F7':'#fff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                  {aiModules[k as keyof typeof aiModules] && <span style={{ color:'#fff',fontSize:10 }}>✓</span>}
                </div>
                <span style={{ fontSize:11,fontWeight:600,color:'#6B6B8A',fontFamily:'Manrope, sans-serif' }}>{l}</span>
              </div>
            ))}
          </div>

          <button onClick={handleAIReport} disabled={aiGenerating}
            style={{ width:'100%', padding:'13px', borderRadius:10, border:'none', background: aiGenerating?'#6d28d9':'#A855F7', color:'#fff', fontSize:13, fontWeight:700, cursor: aiGenerating?'not-allowed':'pointer', fontFamily:'Manrope, sans-serif', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
            {aiGenerating ? '⏳ Rapor Oluşturuluyor...' : 'POYAİS ONE AI RAPORU OLUŞTUR'}
          </button>
          <div style={{ textAlign:'center' as const, marginTop:8, fontSize:10, color:'#9A9AB0', fontFamily:'Manrope, sans-serif' }}>Tahmini oluşturma süresi: 45-60 saniye.</div>
        </div>
      </div>

      {/* Son Raporlar */}
      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #E4E6EF', boxShadow:'0 1px 4px rgba(0,0,0,.05)' }}>
        <div style={{ padding:'16px 24px', borderBottom:'1px solid #E4E6EF', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <span style={{ fontSize:16 }}>🕐</span>
            <span style={{ fontSize:14, fontWeight:700, color:'#1A1A2E', fontFamily:'Manrope, sans-serif' }}>Son Oluşturulan Raporlar</span>
          </div>
          <button style={{ fontSize:11, fontWeight:700, color:'#C9A84C', background:'none', border:'none', cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>Tümünü Gör</button>
        </div>
        
        <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
          <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:600 }}>
            <thead style={{ background:'rgba(248,250,252,.5)', borderBottom:'1px solid #E4E6EF' }}>
              <tr>
                {['RAPOR ADI','TARİH ARALIĞI','TIP','DURUM','İŞLEM'].map((h,i)=>(
                  <th key={i} style={{ padding:'10px 20px', fontSize:9, fontWeight:700, color:'#9A9AB0', textTransform:'uppercase' as const, letterSpacing:'0.08em', textAlign:'left' as const, fontFamily:'Manrope, sans-serif', whiteSpace:'nowrap' as const }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {recentReports.map((r,i)=>{
                const tb = typeBadge(r.type);
                return (
                  <tr key={i} style={{ borderBottom:'1px solid #f8fafc' }}
                    onMouseEnter={e=>(e.currentTarget.style.background='rgba(248,249,246,.5)')}
                    onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                    <td style={{ padding:'14px 20px' }}>
                      <div style={{ fontSize:13, fontWeight:600, color:'#1A1A2E', fontFamily:'Manrope, sans-serif' }}>{r.name}</div>
                      <div style={{ fontSize:10, color:'#9A9AB0', fontFamily:'Manrope, sans-serif', marginTop:2 }}>{r.sub}</div>
                    </td>
                    <td style={{ padding:'14px 20px', fontSize:12, color:'#6B6B8A', fontFamily:'Manrope, sans-serif', whiteSpace:'nowrap' as const }}>{r.range}</td>
                    <td style={{ padding:'14px 20px' }}>
                      <span style={{ padding:'2px 8px', borderRadius:4, background:tb.bg, color:tb.color, fontSize:10, fontWeight:700, fontFamily:'Manrope, sans-serif' }}>{r.type}</span>
                    </td>
                    <td style={{ padding:'14px 20px' }}>
                      <span style={{ display:'flex', alignItems:'center', gap:5, fontSize:11, fontWeight:600, color:r.statusColor, fontFamily:'Manrope, sans-serif' }}>
                        <span style={{ width:6,height:6,borderRadius:'50%',background:r.statusColor }}/>
                        {r.status}
                      </span>
                    </td>
                    <td style={{ padding:'14px 20px' }}>
                      <button style={{ background:'none', border:'none', fontSize:16, cursor:'pointer', color:'#9A9AB0' }}>⬇</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
function AIFullReport({ config }:{ config:any }) {
  const T = SidebarT;
  const [loading, setLoading]   = useState(false);
  const [aiEmail, setAiEmail]   = useState(config.profile?.email || '');
  const [sendMail, setSendMail] = useState(false);
  const [toast, setToast]       = useState<string|null>(null);
  const [includes, setIncludes] = useState({ weekly:true, anomalies:true, ga4_ai:true, gads_ai:true, meta_ai:true });

  const showToast = (msg:string) => { setToast(msg); setTimeout(()=>setToast(null),4000); };

  const generateAIReport = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('poyais_token');
      const body = {
        ga4_id:            config.platforms.ga4.propertyId  || '',
        gads_id:           config.platforms.gads.customerId || '',
        meta_id:           config.platforms.meta.accountId  || '',
        client_name:       config.profile?.name ? `${config.profile.name} ${config.profile.surname}` : 'Müşteri',
        email:             aiEmail,
        send_email:        sendMail,
        include_weekly:    includes.weekly,
        include_anomalies: includes.anomalies,
        include_ga4_ai:    includes.ga4_ai,
        include_gads_ai:   includes.gads_ai,
        include_meta_ai:   includes.meta_ai,
      };
      const res = await fetch('/api/v1/pdf/ai-report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });
      if(!res.ok) throw new Error('PDF oluşturulamadı');
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `poyais-ai-analiz-${new Date().toISOString().slice(0,10)}.pdf`;
      a.click();
      showToast(sendMail ? `✓ PDF indirildi ve ${aiEmail} adresine gönderildi` : '✓ AI Raporu indirildi');
    } catch(e:any) {
      showToast('Hata: ' + e.message);
    }
    setLoading(false);
  };

  return (
    <Card>
      {toast && <div style={{ position:'fixed', bottom:32, right:32, zIndex:999, background:T.surface, border:`1px solid ${T.purple}`, borderRadius:8, padding:'12px 20px', fontFamily:'Manrope, sans-serif', fontSize:11, color:T.purple, boxShadow:'0 8px 32px rgba(0,0,0,.5)' }}>{toast}</div>}
      <div style={{ padding:'13px 18px', borderBottom:'1px solid rgba(168,139,250,.15)', display:'flex', alignItems:'center', justifyContent:'space-between', background:'rgba(168,139,250,.05)' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:18 }}>🤖</span>
          <span style={{ fontFamily:'Manrope, sans-serif', fontSize:14, letterSpacing:0, color:T.purple }}>POYAİS ONE AI TAM ANALİZ RAPORU</span>
        </div>

      </div>
      <div style={{ padding:'16px 20px', display:'flex', flexDirection:'column', gap:14, maxWidth:'100%' }}>
        <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:T.textDim }}>
          GA4 Intelligence + Google Ads AI + Meta Ads AI + Haftalık Strateji + Anomali tespitini tek PDF'te birleştirir.
        </div>

        {/* İçerik seçimi */}
        <div>
          <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.textDim, letterSpacing:0, marginBottom:10 }}>RAPORA EKLENECEKLER</div>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            {[
              ['ga4_ai',    '📊 GA4 AI'],
              ['gads_ai',   '🔍 Google Ads AI'],
              ['meta_ai',   '📱 Meta Ads AI'],
              ['weekly',    '📊 Haftalık Rapor'],
              ['anomalies', '🚨 Anomali Tespiti'],
            ].map(([key, label]) => (
              <button key={key} onClick={()=>setIncludes(i=>({...i,[key]:!i[key as keyof typeof i]}))}
                style={{ fontFamily:'Manrope, sans-serif', fontSize:10, padding:'6px 12px', borderRadius:6, background:includes[key as keyof typeof includes]?'rgba(201,168,76,0.12)':T.surface, color:includes[key as keyof typeof includes]?T.amberDeepText:T.textDim, border:`1px solid ${includes[key as keyof typeof includes]?alpha(T.amber,35):T.borderAlt}`, fontWeight:600, cursor:'pointer', transition:'all .15s' }}>
                {label} {includes[key as keyof typeof includes]?'✓':''}
              </button>
            ))}
          </div>
        </div>

        {/* Mail */}
        <div style={{ padding:'12px 14px', background:T.card, borderRadius:8, border:`1px solid ${T.borderAlt}` }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:sendMail?12:0 }}>
            <div>
              <div style={{ fontSize:13, fontWeight:600, marginBottom:2 }}>Mail ile gönder</div>
              <div style={{ fontFamily:'Manrope, sans-serif', fontSize:10, color:T.textDim }}>PDF'i e-posta ekinde at.</div>
            </div>
            <Toggle value={sendMail} onChange={setSendMail}/>
          </div>
          {sendMail && (
            <input value={aiEmail} onChange={e=>setAiEmail(e.target.value)} type="email"
              style={{ width:'100%', background:T.surface, border:'1px solid rgba(168,139,250,.3)', borderRadius:7, padding:'8px 12px', fontFamily:'Manrope, sans-serif', fontSize:12, color:T.ink, outline:'none', marginTop:8 }}
              placeholder="rapor@domain.com"/>
          )}
        </div>

        <button onClick={generateAIReport} disabled={loading}
          style={{ padding:'14px', borderRadius:9, border:'1px solid rgba(168,139,250,.4)', background:loading?'rgba(168,139,250,.05)':'rgba(168,139,250,.18)', color:loading?C.whiteM:T.purple, fontFamily:'Manrope, sans-serif', fontSize:12, cursor:loading?'wait':'pointer', letterSpacing:0, display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}>
          {loading ? <><span style={{ animation:'pulse 1s infinite' }}>🤖</span> AI ANALİZLER TOPLANIYIR...</> : <>🤖 POYAIS ONE AI RAPORU OLUŞTUR</>}
        </button>
      </div>
    </Card>
  );
}

// -- Admin Tab -------------------------------------------------------------

function AdminClientsTab({ config, onClientChange }:{ config:any; onClientChange:(c:any)=>void }) {
  const { t, lang } = useLang();
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [clients, setClients]   = useState<any[]>([]);
  const [users, setUsers]       = useState<any[]>([]);
  const [allFeeds, setAllFeeds] = useState<any[]>([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editClient, setEditClient] = useState<any>(null);
  const [toast, setToast]       = useState('');
  const [planForm, setPlanForm] = useState({ plan:'starter', status:'inactive', ends_at:'' });
  const [planBusy, setPlanBusy] = useState(false);
  const [expandedClient, setExpandedClient] = useState<number|null>(null);
  const [form, setForm] = useState({ name:'', domain:'', ga4_property_id:'', gads_customer_id:'', meta_account_id:'', meta_access_token:'' });

  const showToast = (msg:string) => { setToast(msg); setTimeout(()=>setToast(''),3000); };

  const load = async () => {
    const [c, u, f] = await Promise.all([
      axios.get(`${API}/clients/`),
      axios.get(`${API}/admin/users`),
      fetch('/api/v1/feed-wizard/feeds',{headers:{Authorization:`Bearer ${localStorage.getItem('poyais_token')}`}}).then(r=>r.ok?r.json():[]),
    ]);
    setClients(c.data);
    setUsers(u.data);
    setAllFeeds(f);
    setLoading(false);
  };

  const assignFeed = async (feedId:number, clientId:number|null) => {
    try {
      const r = await fetch(`/api/v1/feed-wizard/feeds/${feedId}/assign`,{
        method:'POST',
        headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('poyais_token')}`},
        body:JSON.stringify({client_id:clientId?String(clientId):''})
      });
      if(!r.ok) throw new Error();
      const f = await fetch('/api/v1/feed-wizard/feeds',{headers:{Authorization:`Bearer ${localStorage.getItem('poyais_token')}`}}).then(r=>r.json());
      setAllFeeds(f);
    } catch(e) { showToast(t('Hata: Feed ataması yapılamadı')); }
  };

  useEffect(()=>{ load(); }, []);

  const save = async () => {
    try {
      if(editClient) {
        const { meta_access_token: _tok, ...editable } = form as any;   // belirteç düzenlenmez; boş gönderilirse zaten korunur
        await axios.put(`${API}/clients/${editClient.id}`, editable);
        showToast(t('Müşteri güncellendi ✓'));
      } else {
        await axios.post(`${API}/clients/`, form);
        showToast(t('Müşteri eklendi ✓'));
      }
      setShowForm(false);
      setEditClient(null);
      setForm({ name:'', domain:'', ga4_property_id:'', gads_customer_id:'', meta_account_id:'', meta_access_token:'' });
      load();
    } catch(e:any) {
      showToast(t('Hata:') + ' ' + (e.response?.data?.detail || t('Bilinmeyen')));
    }
  };

  const del = async (id:number) => {
    if(!window.confirm(t('Bu müşteriyi silmek istediğinizden emin misiniz?'))) return;
    try {
      await axios.delete(`${API}/clients/${id}`);
      showToast(t('Silindi'));
      load();
    } catch(e:any) { showToast(t('Hata:') + ' ' + (e.response?.data?.detail || t('Silinemedi'))); }
  };

  const openEdit = (c:any) => {
    setEditClient(c);
    setForm({ name:c.name||'', domain:c.domain||'', ga4_property_id:c.ga4_property_id||'', gads_customer_id:c.gads_customer_id||'', meta_account_id:c.meta_account_id||'', meta_access_token:'' });
    setPlanForm({ plan:c.plan||'starter', status:c.plan_status||'inactive', ends_at:String(c.plan_ends_at||c.trial_ends_at||'').slice(0,10) });
    setShowForm(false);
    // Form, tıklanan müşterinin kartında açılır; kart görünür alana kaydırılır (liste uzun olduğu için üstte açılan form gözden kaçıyordu)
    setTimeout(()=>document.getElementById(`client-card-${c.id}`)?.scrollIntoView({ behavior:'smooth', block:'start' }), 50);
  };

  const savePlan = async () => {
    if(!editClient) return;
    setPlanBusy(true);
    try {
      const r = await axios.put(`${API}/admin/clients/${editClient.id}/plan`, { plan:planForm.plan, status:planForm.status, ends_at:planForm.ends_at || null });
      showToast(r.data?.warning ? r.data.warning : t('Paket güncellendi ✓'));
      await load();
    } catch(e:any) { showToast(t('Hata:') + ' ' + (e.response?.data?.detail || t('Bilinmeyen'))); }
    setPlanBusy(false);
  };

  if(loading) return <Loader/>;

  // NOT: ayrı bir React bileşeni olarak tanımlanırsa her render'da yeni fonksiyon referansi
  // olur, React input'u söküp yeniden kurar ve her tus vurusunda focus kaybolur. Bu yüzden
  // ayni konumda render edilen düz bir helper çagrisi olarak tutuluyor.
  const inputField = (label:string, field:keyof typeof form, placeholder='') => (
    <div style={{ marginBottom:12 }}>
      <div style={{ fontSize:11, fontWeight:700, color:T.textDim, letterSpacing:'.06em', textTransform:'uppercase' as const, marginBottom:6 }}>{label}</div>
      <input value={form[field]} onChange={e=>setForm(f=>({...f,[field]:e.target.value}))} placeholder={placeholder}
        style={{ width:'100%', background:'var(--py-subtle-bg)', border:`1px solid ${T.borderMid}`, borderRadius:9, padding:'9px 13px', fontSize:13, outline:'none', boxSizing:'border-box' as const }}/>
    </div>
  );

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:14, maxWidth:'100%' }}>
      {toast && <div style={{ position:'fixed', bottom:32, right:32, zIndex:999, background:T.surface, border:`1px solid ${alpha(T.green,30)}`, borderRadius:12, padding:'12px 20px', fontSize:12.5, color:T.greenText }}>{toast}</div>}

      {/* Header */}
      <div style={{ display:'flex', justifyContent:'flex-end', alignItems:'center' }}>
        <button onClick={()=>{ setShowForm(true); setEditClient(null); setForm({ name:'', domain:'', ga4_property_id:'', gads_customer_id:'', meta_account_id:'', meta_access_token:'' }); }}
          style={{ padding:'9px 16px', borderRadius:11, background:T.accent, border:'none', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>
          {t('Yeni Müşteri')}
        </button>
      </div>

      {/* Form */}
      {showForm && !editClient && (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:16, padding:24 }}>
          <div style={{ fontSize:15, fontWeight:800, marginBottom:18 }}>{editClient ? t('Müşteri Düzenle') : t('Yeni Müşteri Ekle')}</div>
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:12 }}>
            {inputField(t('Müşteri Adı'), 'name')}
            {inputField('Domain', 'domain')}
            {inputField('GA4 Property ID', 'ga4_property_id', '443181760')}
            {inputField('Google Ads Customer ID', 'gads_customer_id', '123-456-7890')}
            {inputField('Meta Account ID', 'meta_account_id', '1234567890')}
          </div>
          <div style={{ display:'flex', gap:10, marginTop:16 }}>
            <button onClick={save} style={{ padding:'9px 16px', borderRadius:11, background:T.accent, border:'none', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>
              {editClient ? t('Güncelle') : t('Ekle')}
            </button>
            <button onClick={()=>{ setShowForm(false); setEditClient(null); }} style={{ padding:'10px 20px', borderRadius:9, background:T.surface, border:`1px solid ${T.borderMid}`, color:'var(--py-text-mid-alt)', fontSize:13, cursor:'pointer' }}>
              {t('İptal')}
            </button>
          </div>
        </div>
      )}

      {/* Client listesi */}
      <div style={{ display:'flex', flexDirection:'column' as const, gap:10 }}>
        {clients.map((c:any) => (
          <div key={c.id} id={`client-card-${c.id}`} style={{ background:T.surface, border:`1px solid ${editClient?.id===c.id?T.accent:T.border}`, borderRadius:16, padding:20, scrollMarginTop:80 }}>
            <div style={{ marginBottom:14 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                <div style={{ width:34, height:34, borderRadius:9, background:'var(--py-amber-tint)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, fontWeight:800, color:T.amberDeepText }}>
                  {c.name.charAt(0).toUpperCase()}
                </div>
                <div>
                  <div style={{ fontSize:14.5, fontWeight:800 }}>{c.name}</div>
                  <div style={{ fontSize:12, color:'var(--py-text-mid-alt)' }}>{c.domain}</div>
                </div>
                <span title={t('Müşterinin paketi')} style={{ marginLeft:'auto', padding:'4px 10px', borderRadius:999, fontSize:11.5, fontWeight:700, background:c.plan_status==='active'||c.plan_status==='trialing'||c.plan_status==='canceling'?'var(--py-green-tint)':'var(--py-track-bg)', color:c.plan_status==='active'||c.plan_status==='trialing'||c.plan_status==='canceling'?T.greenText:'var(--py-text-mid-alt)', whiteSpace:'nowrap' as const }}>
                  {({starter:'Başlangıç',professional:'Profesyonel',enterprise:'Kurumsal'} as any)[c.plan] || c.plan || '—'} · {({active:t('Aktif'),trialing:t('Deneme'),canceling:t('İptal Ediliyor'),inactive:t('Pasif')} as any)[c.plan_status] || c.plan_status || t('Pasif')}
                </span>
              </div>
              <div style={{ display:'flex', flexWrap:'wrap' as const, gap:6 }}>
                <button onClick={()=>{ onClientChange(c); showToast(`${c.name} ${t('aktif müşteri olarak seçildi')}`); }}
                  style={{ padding:'6px 12px', borderRadius:8, background:'var(--py-green-tint)', border:`1px solid ${alpha(T.green,30)}`, color:T.greenText, fontSize:11.5, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' as const }}>
                  {t('Seç')}
                </button>
                <select onChange={async(e)=>{
                  const uid = e.target.value;
                  if(!uid) return;
                  try {
                    await axios.post(`/api/v1/clients/${c.id}/users/${uid}`);
                    showToast(`${t('Kullanıcı')} ${c.name} ${t('müşterisine eklendi ✓')}`);
                    e.target.value = '';
                  } catch(e:any) { showToast(t('Hata:') + ' ' + (e.response?.data?.detail||t('Bilinmeyen'))); }
                }}
                  style={{ padding:'6px 12px', borderRadius:8, background:'var(--py-blue-tint)', border:`1px solid ${alpha(T.blue,30)}`, color:T.blueText, fontSize:11.5, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' as const }}>
                  <option value="">{t('Kullanıcı Ata')}</option>
                  {users.map((u:any)=>(
                    <option key={u.id} value={u.id}>{u.name} {u.surname} ({u.email})</option>
                  ))}
                </select>
                <button onClick={()=>setExpandedClient(expandedClient===c.id?null:c.id)}
                  style={{ padding:'6px 12px', borderRadius:8, background:expandedClient===c.id?'var(--py-amber-tint)':'var(--py-track-bg)', border:`1px solid ${expandedClient===c.id?alpha(T.amber,35):'transparent'}`, color:expandedClient===c.id?T.amberDeepText:'var(--py-text-mid-alt)', fontSize:11.5, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' as const }}>
                  {t("Feed'ler")} {allFeeds.filter((f:any)=>String(f.client_id)===String(c.id)).length>0?`(${allFeeds.filter((f:any)=>String(f.client_id)===String(c.id)).length})`:''}
                </button>
                <button onClick={()=>openEdit(c)}
                  style={{ padding:'6px 12px', borderRadius:8, background:'var(--py-amber-tint)', border:`1px solid ${alpha(T.amber,35)}`, color:T.amberDeepText, fontSize:11.5, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' as const }}>
                  {t('Düzenle')}
                </button>
                <button onClick={()=>del(c.id)}
                  style={{ padding:'6px 12px', borderRadius:8, background:'var(--py-red-tint)', border:`1px solid ${alpha(T.red,30)}`, color:T.redText, fontSize:11.5, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' as const }}>
                  {t('Sil')}
                </button>
              </div>
              {editClient?.id===c.id && (
                <div style={{ marginTop:16, paddingTop:16, borderTop:`1px solid ${T.border}` }}>
                  <div style={{ fontSize:13.5, fontWeight:800, marginBottom:14 }}>{t('Müşteri Düzenle')}</div>
                  <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:12 }}>
                    {inputField(t('Müşteri Adı'), 'name')}
                    {inputField('Domain', 'domain')}
                    {inputField('GA4 Property ID', 'ga4_property_id', '443181760')}
                    {inputField('Google Ads Customer ID', 'gads_customer_id', '123-456-7890')}
                    {inputField('Meta Account ID', 'meta_account_id', '1234567890')}
                  </div>
                  <div style={{ display:'flex', gap:10, marginTop:8 }}>
                    <button onClick={save} style={{ padding:'9px 16px', borderRadius:11, background:T.accent, border:'none', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>{t('Güncelle')}</button>
                    <button onClick={()=>{ setEditClient(null); }} style={{ padding:'9px 16px', borderRadius:11, background:T.surface, border:`1px solid ${T.borderMid}`, color:'var(--py-text-mid-alt)', fontSize:13, cursor:'pointer' }}>{t('İptal')}</button>
                  </div>
                  <div style={{ marginTop:20, paddingTop:16, borderTop:`1px dashed ${T.border}` }}>
                    <div style={{ fontSize:13.5, fontWeight:800, marginBottom:4 }}>{t('Paket')}</div>
                    <div style={{ fontSize:12, color:T.textDim, marginBottom:12, lineHeight:1.5 }}>{t('Paketi elle değiştirir; ödeme sağlayıcısındaki aboneliği değiştirmez. Aktif ücretli abonelik varsa sağlayıcıdan gelen bir olay paketi yeniden değiştirebilir.')}</div>
                    <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr 1fr', gap:12 }}>
                      <div>
                        <div style={{ fontSize:11, fontWeight:700, color:T.textDim, letterSpacing:'.06em', textTransform:'uppercase' as const, marginBottom:6 }}>{t('Paket')}</div>
                        <select value={planForm.plan} onChange={e=>setPlanForm(f=>({...f,plan:e.target.value}))} style={{ width:'100%', background:'var(--py-subtle-bg)', border:`1px solid ${T.borderMid}`, borderRadius:9, padding:'9px 13px', fontSize:13, color:T.text, fontFamily:'inherit' }}>
                          <option value="starter">Başlangıç</option><option value="professional">Profesyonel</option><option value="enterprise">Kurumsal</option>
                        </select>
                      </div>
                      <div>
                        <div style={{ fontSize:11, fontWeight:700, color:T.textDim, letterSpacing:'.06em', textTransform:'uppercase' as const, marginBottom:6 }}>{t('Durum')}</div>
                        <select value={planForm.status==='canceling'?'active':planForm.status} onChange={e=>setPlanForm(f=>({...f,status:e.target.value}))} style={{ width:'100%', background:'var(--py-subtle-bg)', border:`1px solid ${T.borderMid}`, borderRadius:9, padding:'9px 13px', fontSize:13, color:T.text, fontFamily:'inherit' }}>
                          <option value="active">{t('Aktif')}</option><option value="trialing">{t('Deneme')}</option><option value="inactive">{t('Pasif')}</option>
                        </select>
                      </div>
                      <div>
                        <div style={{ fontSize:11, fontWeight:700, color:T.textDim, letterSpacing:'.06em', textTransform:'uppercase' as const, marginBottom:6 }}>{t('Bitiş Tarihi (isteğe bağlı)')}</div>
                        <input type="date" value={planForm.ends_at} onChange={e=>setPlanForm(f=>({...f,ends_at:e.target.value}))} disabled={planForm.status==='inactive'}
                          style={{ width:'100%', background:'var(--py-subtle-bg)', border:`1px solid ${T.borderMid}`, borderRadius:9, padding:'8px 13px', fontSize:13, color:T.text, fontFamily:'inherit', boxSizing:'border-box' as const, opacity:planForm.status==='inactive'?0.5:1 }}/>
                      </div>
                    </div>
                    <button onClick={savePlan} disabled={planBusy} style={{ marginTop:12, padding:'9px 16px', borderRadius:11, background:T.accent, border:'none', color:'#fff', fontSize:13, fontWeight:700, cursor:planBusy?'wait':'pointer', opacity:planBusy?0.7:1 }}>
                      {planBusy ? t('Kaydediliyor…') : t('Paketi Güncelle')}
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(2,1fr)', gap:8 }}>
              {[
                ['GA4', c.ga4_property_id, T.greenText],
                ['Google Ads', c.gads_customer_id, T.blueText],
                ['Meta', c.meta_account_id, T.purpleText],
              ].map(([label, value, color]) => (
                <div key={label as string} style={{ background:'var(--py-subtle-bg)', borderRadius:10, padding:'9px 13px' }}>
                  <div style={{ fontSize:10, fontWeight:700, color:T.textDim, letterSpacing:'.06em', textTransform:'uppercase' as const, marginBottom:4 }}>{label}</div>
                  <div style={{ fontSize:12, fontWeight:600, color:value ? color as string : T.textFaint, fontFamily:MONO }}>{value || '—'}</div>
                </div>
              ))}
            </div>

            {/* Feed Yönetimi */}
            {expandedClient===c.id&&(
              <div style={{ marginTop:10, padding:'14px 16px', background:'var(--py-subtle-bg)', borderRadius:12, border:`1px solid ${T.tableDivider}` }}>
                <div style={{ fontSize:11, fontWeight:700, color:T.textDim, textTransform:'uppercase' as const, letterSpacing:'.06em', marginBottom:10 }}>{t('Feed Yönetimi')}</div>
                {/* Bu müşteriye bağlı feed'ler */}
                {allFeeds.filter((f:any)=>String(f.client_id)===String(c.id)).length>0&&(
                  <div style={{ marginBottom:10 }}>
                    <div style={{ fontSize:10.5, color:T.textDim, marginBottom:5 }}>{t("Bağlı Feed'ler")}:</div>
                    {allFeeds.filter((f:any)=>String(f.client_id)===String(c.id)).map((f:any)=>(
                      <div key={f.id} style={{ display:'flex', alignItems:'center', gap:8, padding:'6px 10px', background:T.surface, borderRadius:8, border:`1px solid ${T.border}`, marginBottom:4 }}>
                        <span style={{ fontSize:11.5, fontWeight:600, flex:1 }}>{f.name}</span>
                        <span style={{ fontSize:9.5, padding:'2px 8px', borderRadius:999, background:'var(--py-amber-tint)', color:T.amberDeepText, fontWeight:700 }}>{f.feed_type}</span>
                        <button onClick={()=>assignFeed(f.id,null)} style={{ fontSize:10.5, color:T.redText, background:'none', border:'none', cursor:'pointer', fontWeight:600 }}>{t('Kaldır')}</button>
                      </div>
                    ))}
                  </div>
                )}
                {/* Atanmamış feed'ler */}
                {allFeeds.filter((f:any)=>!f.client_id||f.client_id==='').length>0?(
                  <div>
                    <div style={{ fontSize:10.5, color:T.textDim, marginBottom:5 }}>{t('Feed Ata')}:</div>
                    <div style={{ display:'flex', flexWrap:'wrap' as const, gap:4 }}>
                      {allFeeds.filter((f:any)=>!f.client_id||f.client_id==='').map((f:any)=>(
                        <button key={f.id} onClick={()=>assignFeed(f.id,c.id)} style={{ fontSize:10.5, padding:'4px 11px', borderRadius:999, border:`1px solid ${alpha(T.amber,35)}`, background:'var(--py-amber-tint)', color:T.amberDeepText, cursor:'pointer', fontWeight:600 }}>{f.name}</button>
                      ))}
                    </div>
                  </div>
                ):(
                  <div style={{ fontSize:10.5, color:T.textDim }}>{t("Tüm feed'ler bir müşteriye atanmış.")}</div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function AdminTab({ config }:{ config:any }) {
  const { t } = useLang();
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [users, setUsers]       = useState<any[]>([]);
  const [loading, setLoading]   = useState(true);
  const [roleFilter, setRoleFilter] = useState<'all'|'admin'|'client'|'pending'>('all');
  const [page, setPage]         = useState(0);
  const [showNewUser, setShowNewUser] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [newName, setNewName]   = useState('');
  const [newRole, setNewRole]   = useState('client');
  const [creating, setCreating] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [editingUser, setEditingUser] = useState<any>(null);
  const [editForm, setEditForm] = useState<any>({});
  const [editSaving, setEditSaving] = useState(false);
  const [editClients, setEditClients] = useState<any[]>([]);
  const [allClients, setAllClients] = useState<any[]>([]);
  const PAGE_SIZE = 10;

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/admin/users`)
      .then(r => { setUsers(r.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => users.filter(u => {
    if (roleFilter === 'all') return true;
    if (roleFilter === 'admin')   return u.role === 'admin';
    if (roleFilter === 'client')  return u.role === 'client' || u.role === 'user';
    if (roleFilter === 'pending') return !!u.invite_pending;
    return true;
  }), [users, roleFilter]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged      = filtered.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);

  const totalUsers    = users.length;
  const [clientCount, setClientCount] = React.useState(0);
  React.useEffect(()=>{ axios.get(`${API}/clients/`).then(r=>setClientCount(Array.isArray(r.data)?r.data.length:1)).catch(()=>{}); },[]);
  const newToday      = users.filter(u=>{
    const d = new Date(u.created_at||0);
    return Date.now()-d.getTime() < 86400000;
  }).length;

  const roleBadge = (r:string) => {
    if (r==='admin')  return { text:'Admin',  bg:'var(--py-ink)', color:'#fff' };
    if (r==='client') return { text:'Client', bg:'var(--py-amber-tint)', color:T.amberDeepText };
    return                   { text:'User',   bg:'var(--py-track-bg)', color:'var(--py-text-mid-alt)' };
  };

  const initials = (name:string) => name?.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2)||'?';
  const avatarColor = (name:string) => { const colors=[T.accent,T.accent,'#4285f4',T.green,T.purple]; return colors[name?.charCodeAt(0)%colors.length||0]; };

  const formatDate = (d:any) => {
    try { return new Date(d).toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}); }
    catch { return '—'; }
  };

  const handleDeleteUser = async (id:number, name:string) => {
    if(!window.confirm(t('{name} adlı kullanıcıyı silmek istediğinizden emin misiniz?').replace('{name}', name))) return;
    try {
      await axios.delete(`${API}/admin/users/${id}`);
      setUsers(prev => prev.filter(u => u.id !== id));
    } catch(e:any) { alert(t('Hata:') + ' ' + (e.response?.data?.detail || t('Silinemedi'))); }
  };

  const handleEditUser = async (u:any) => {
    setEditingUser(u);
    setEditForm({ name:u.name||'', surname:u.surname||'', email:u.email||'', role:u.role||'client', password:'' });
    try {
      const [uc, ac] = await Promise.all([
        axios.get(`${API}/admin/users/${u.id}/clients`),
        axios.get(`${API}/clients/`),
      ]);
      setEditClients(uc.data||[]);
      setAllClients(Array.isArray(ac.data)?ac.data:[ac.data]);
    } catch(e) {}
  };
  const handleAddClientToUser = async (clientId:number) => {
    if(!editingUser) return;
    try {
      await axios.post(`${API}/admin/users/${editingUser.id}/clients`, { client_id: clientId, role:'viewer' });
      const c2 = allClients.find((x:any)=>x.id===clientId);
      if(c2) setEditClients(prev=>[...prev, {...c2, role:'viewer'}]);
    } catch(e) {}
  };
  const handleRemoveClientFromUser = async (clientId:number) => {
    if(!editingUser) return;
    try {
      await axios.delete(`${API}/admin/users/${editingUser.id}/clients/${clientId}`);
      setEditClients(prev=>prev.filter((c2:any)=>c2.id!==clientId));
    } catch(e) {}
  };
  const handleChangeClientRole = async (clientId:number, role:string) => {
    if(!editingUser) return;
    const prev = editClients;
    setEditClients(cs=>cs.map((c2:any)=>c2.id===clientId?{...c2, role}:c2));
    try {
      await axios.patch(`${API}/clients/${clientId}/users/${editingUser.id}/role`, { role });
    } catch(e:any) {
      setEditClients(prev);
      alert(t('Hata:') + ' ' + (e.response?.data?.detail || t('Rol güncellenemedi')));
    }
  };
  const handleSaveEditUser = async () => {
    if(!editingUser) return;
    setEditSaving(true);
    try {
      const payload:any = { name:editForm.name, surname:editForm.surname, email:editForm.email, role:editForm.role };
      if(editForm.password) payload.password = editForm.password;
      await axios.put(`${API}/admin/users/${editingUser.id}`, payload);
      setUsers(prev => prev.map(u => u.id===editingUser.id ? {...u,...payload} : u));
      setEditingUser(null);
    } catch(e:any) { alert(t('Hata:')+' '+(e.response?.data?.detail||t('Güncellenemedi'))); }
    setEditSaving(false);
  };

  const [creditAmounts, setCreditAmounts] = React.useState<Record<number,string>>({});
  const [creditLoading, setCreditLoading] = React.useState<number|null>(null);
  const [userCredits, setUserCredits] = React.useState<Record<number,number>>({});

  React.useEffect(()=>{
    if(!users.length) return;
    axios.get(`${API}/credits/admin/users`).then(r=>{
      const map:Record<number,number>={};
      (r.data.users||[]).forEach((u:any)=>{ map[u.id]=u.balance; });
      setUserCredits(map);
    }).catch(()=>{});
  },[users]);

  const handleLoadCredit = async (userId:number) => {
    const amt = parseInt(creditAmounts[userId]||'0');
    if(!amt||amt<=0) return;
    setCreditLoading(userId);
    try {
      await axios.post(`${API}/credits/admin/load`,{user_id:userId,credits:amt,note:'Admin manuel yükleme'});
      setUserCredits(prev=>({...prev,[userId]:(prev[userId]||0)+amt}));
      setCreditAmounts(prev=>({...prev,[userId]:''}));
    } catch(e:any){ alert(t('Hata:')+' '+(e.response?.data?.detail||t('Yüklenemedi'))); }
    setCreditLoading(null);
  };

  const handleCreateUser = () => {
    if (!newEmail||!newName) return;
    setCreating(true);
    axios.post(`${API}/admin/users`, { email:newEmail, name:newName, role:newRole })
      .then(r => {
        setUsers(prev=>[r.data,...prev]); setShowNewUser(false); setNewEmail(''); setNewName('');
        if (r.data && r.data.email_sent === false)
          alert(t('Kullanıcı oluşturuldu ancak davet e-postası gönderilemedi. Kullanıcı satırındaki "Daveti Gönder" ile tekrar deneyebilirsiniz.'));
      })
      .catch((e:any)=>{ alert(t('Kullanıcı oluşturulamadı.') + ' ' + (e.response?.data?.detail || '')); })
      .finally(()=>setCreating(false));
  };

  const [invitingId, setInvitingId] = useState<number|null>(null);
  const handleResendInvite = async (u:any) => {
    setInvitingId(u.id);
    try {
      const r = await axios.post(`${API}/admin/users/${u.id}/resend-invite`);
      if (r.data?.email_sent === false)
        alert(t('Davet bağlantısı yenilendi ancak e-posta gönderilemedi. E-posta servisi ayarlarını kontrol edin.'));
      else
        alert(t('Davet e-postası tekrar gönderildi ✓'));
    } catch(e:any) {
      alert(t('Hata:') + ' ' + (e.response?.data?.detail || t('Davet gönderilemedi')));
    }
    setInvitingId(null);
  };

  if (loading) return <Loader/>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:isMobile?8:14, overflowX:'hidden' as const }}>
        {[
          { label:t('Toplam Kullanıcı'),   value: fmt.n(totalUsers) },
          { label:t('Aktif Müşteriler'),   value: fmt.n(clientCount) },
          { label:t('Bağlı Platformlar'),  value: String(users.reduce((s:number,u:any)=>s+(u.platform_count||0),0)) },
          { label:t('Yeni Kayıtlar'),      value: fmt.n(newToday||42) },
        ].map((k,i) => (
          <div key={i} style={{ background:T.surface, padding:'18px 19px', borderRadius:14, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)', marginBottom:10 }}>{k.label}</div>
            <span style={{ fontSize:22, fontWeight:800, fontFamily:MONO }}>{k.value}</span>
          </div>
        ))}
      </div>
      {/* Filtreler + New User */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8 }}>
        <select value={roleFilter} onChange={e=>{setRoleFilter(e.target.value as any);setPage(0);}}
          style={{ padding:'0 14px', height:38, borderRadius:9, border:`1px solid ${T.borderMid}`, fontSize:12, outline:'none', background:T.surface, color:'var(--py-text-mid-alt)', cursor:'pointer', flexShrink:0 }}>
          <option value="all">{t('Tümü')}</option>
          <option value="admin">{t('Adminler')}</option>
          <option value="client">{t('Müşteriler')}</option>
          <option value="pending">{t('Bekleyenler')}</option>
        </select>
        <div style={{ display:'flex', gap:8, flex:1, justifyContent:'flex-end' }}>
          <input placeholder={t('Kullanıcı ara...')} value={searchQuery} onChange={e=>setSearchQuery(e.target.value)}
            style={{ padding:'0 14px', height:38, borderRadius:9, border:`1px solid ${T.borderMid}`, fontSize:isMobile?10:12, outline:'none', color:'var(--py-text-mid-alt)', flex:1, minWidth:0 }}/>
          <button onClick={()=>setShowNewUser(v=>!v)}
            style={{ padding:'0 16px', height:36, borderRadius:11, border:'none', background:T.accent, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', whiteSpace:'nowrap' as const }}>
            {isMobile?t('Yeni'):t('Yeni Kullanıcı')}
          </button>
        </div>
      </div>
      {/* New User Form */}
      {showNewUser && (
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
          <div style={{ fontSize:13.5, fontWeight:800, marginBottom:16 }}>{t('Yeni Kullanıcı Oluştur')}</div>
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr 1fr auto', gap:12, alignItems:'end' }}>
            <div>
              <div style={{ fontSize:11, color:T.textDim, marginBottom:6 }}>{t('Ad Soyad')}</div>
              <input value={newName} onChange={e=>setNewName(e.target.value)} placeholder={t('Ad Soyad')}
                style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12.5, outline:'none', boxSizing:'border-box' as const }}/>
            </div>
            <div>
              <div style={{ fontSize:11, color:T.textDim, marginBottom:6 }}>Email</div>
              <input value={newEmail} onChange={e=>setNewEmail(e.target.value)} placeholder="ornek@sirket.com"
                style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12.5, outline:'none', boxSizing:'border-box' as const }}/>
            </div>
            <div>
              <div style={{ fontSize:11, color:T.textDim, marginBottom:6 }}>{t('Rol')}</div>
              <select value={newRole} onChange={e=>setNewRole(e.target.value)}
                style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12.5, outline:'none', background:T.surface }}>
                <option value="client">{t('Müşteri')}</option>
                <option value="admin">Admin</option>
                <option value="user">{t('Kullanıcı')}</option>
              </select>
            </div>
            <button onClick={handleCreateUser} disabled={creating||!newEmail||!newName}
              style={{ padding:'9px 16px', borderRadius:11, background:T.accent, color:'#fff', border:'none', fontSize:13, fontWeight:700, cursor:'pointer', whiteSpace:'nowrap' as const, opacity:creating||!newEmail||!newName?.5:1 }}>
              {creating?t('Oluşturuluyor...'):t('Oluştur')}
            </button>
          </div>
        </div>
      )}

      {/* Kullanici Tablosu */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}` }}>
        <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
          <table style={{ width:'100%', borderCollapse:'collapse' as const, minWidth:600 }}>
            <thead>
              <tr style={{ background:'var(--py-subtle-bg)' }}>
                {[t('Kullanıcı'),t('Rol'),t('Platformlar'),t('Kayıt Tarihi'),t('Son Giriş'),t('İşlemler')].map((h,i)=>(
                  <th key={i} style={{ padding:'11px 18px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign:'left' as const, whiteSpace:'nowrap' as const, borderBottom:'1px solid var(--py-table-divider)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paged.length===0 && (
                <tr><td colSpan={6} style={{ padding:48, textAlign:'center' as const, color:T.textDim, fontSize:12.5 }}>{t('Kullanıcı bulunamadı')}</td></tr>
              )}
              {paged.map((u:any,i:number)=>{
                const rb = roleBadge(u.role);
                const ini = initials(u.name||u.full_name||u.email);
                const avc = avatarColor(u.name||u.email||'');
                return (
                  <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)' }}
                    onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                    onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                    <td style={{ padding:'12px 18px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:11 }}>
                        <div style={{ width:32,height:32,borderRadius:'50%',background:avc,display:'flex',alignItems:'center',justifyContent:'center',fontSize:11.5,fontWeight:700,color:'#fff',flexShrink:0 }}>{ini}</div>
                        <div>
                          <div style={{ fontSize:12.5, fontWeight:700 }}>{u.name||u.full_name||'—'}</div>
                          <div style={{ fontSize:11, color:T.textDim }}>{u.email}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ padding:'12px 18px', whiteSpace:'nowrap' as const }}>
                      <span style={{ padding:'2px 10px', borderRadius:999, background:rb.bg, color:rb.color, fontSize:10.5, fontWeight:700 }}>{rb.text}</span>
                      {!!u.invite_pending && (
                        <span style={{ marginLeft:6, padding:'2px 8px', borderRadius:999, background:'var(--py-amber-tint)', color:T.amberDeepText, fontSize:10, fontWeight:700 }}>{t('Davet Bekliyor')}</span>
                      )}
                    </td>
                    <td style={{ padding:'12px 18px', fontSize:12, color:T.textMid, fontFamily:MONO }}>{u.platform_count || 0}</td>
                    <td style={{ padding:'12px 18px', fontSize:12, color:'var(--py-text-mid-alt)', whiteSpace:'nowrap' as const }}>{formatDate(u.created_at)}</td>
                    <td style={{ padding:'12px 18px', fontSize:12, color:'var(--py-text-mid-alt)', whiteSpace:'nowrap' as const }}>{u.last_login ? formatDate(u.last_login) : '—'}</td>
                    <td style={{ padding:'12px 18px' }}>
                      <div style={{ display:'flex', gap:6 }}>
                        {!!u.invite_pending && (
                          <button onClick={()=>handleResendInvite(u)} disabled={invitingId===u.id}
                            style={{ padding:'5px 10px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:11, fontWeight:600, color:T.textMid, cursor:invitingId===u.id?'wait':'pointer', opacity:invitingId===u.id?.5:1, whiteSpace:'nowrap' as const }}>
                            {invitingId===u.id?t('Gönderiliyor...'):t('Daveti Gönder')}
                          </button>
                        )}
                        <button onClick={()=>handleEditUser(u)} style={{ padding:'5px 12px', borderRadius:8, border:`1px solid ${alpha(T.amber,35)}`, background:'var(--py-amber-tint)', fontSize:11, fontWeight:600, color:T.amberDeepText, cursor:'pointer' }}>{t('Düzenle')}</button>
                        <button onClick={()=>handleDeleteUser(u.id, u.name||u.email)} style={{ padding:'5px 10px', borderRadius:8, border:`1px solid ${alpha(T.red,30)}`, background:'var(--py-red-tint)', fontSize:11, fontWeight:600, color:T.redText, cursor:'pointer' }}>{t('Sil')}</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>{t('Gösteriliyor')}: {Math.min(page*PAGE_SIZE+1,filtered.length)}-{Math.min((page+1)*PAGE_SIZE,filtered.length)} / {filtered.length}</span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
              style={{ width:28,height:28,borderRadius:8,border:`1px solid ${T.borderMid}`,background:T.surface,cursor:page===0?'not-allowed':'pointer',opacity:page===0?0.4:1,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13 }}>‹</button>
            {Array.from({length:Math.min(5,totalPages)},(_,i)=>i).map(n=>(
              <button key={n} onClick={()=>setPage(n)}
                style={{ width:28,height:28,borderRadius:8,border:`1px solid ${page===n?T.accent:T.borderMid}`,background:page===n?T.accent:T.surface,color:page===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)',cursor:'pointer',fontSize:11,fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
              style={{ width:28,height:28,borderRadius:8,border:`1px solid ${T.borderMid}`,background:T.surface,cursor:page>=totalPages-1?'not-allowed':'pointer',opacity:page>=totalPages-1?.4:1,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13 }}>›</button>
          </div>
        </div>
      </div>

      {editingUser && (
        <div onClick={e=>{if(e.target===e.currentTarget)setEditingUser(null);}} style={{position:'fixed',inset:0,background:'rgba(20,22,43,.45)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
          <div style={{background:T.surface,borderRadius:18,width:'100%',maxWidth:520,display:'flex',flexDirection:'column' as const,maxHeight:'92vh',overflowY:'auto' as const}}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid var(--py-table-divider)',display:'flex',justifyContent:'space-between',alignItems:'center',flexShrink:0}}>
              <div>
                <div style={{fontSize:14.5,fontWeight:800}}>{t('Kullanıcı Düzenle')}</div>
                <div style={{fontSize:11,color:T.textDim,marginTop:2}}>{editingUser.email}</div>
              </div>
              <button onClick={()=>setEditingUser(null)} style={{background:'none',border:'none',fontSize:18,cursor:'pointer',color:T.textDim}}>✕</button>
            </div>
            <div style={{padding:'20px 24px',display:'flex',flexDirection:'column' as const,gap:14,overflowY:'auto' as const,flex:1}}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div>
                  <div style={{fontSize:11,fontWeight:700,color:T.textDim,marginBottom:6,textTransform:'uppercase' as const,letterSpacing:'.06em'}}>{t('Ad')}</div>
                  <input value={editForm.name||''} onChange={e=>setEditForm((f:any)=>({...f,name:e.target.value}))} style={{width:'100%',padding:'8px 12px',borderRadius:9,border:`1px solid ${T.borderMid}`,fontSize:13,outline:'none',boxSizing:'border-box' as const}}/>
                </div>
                <div>
                  <div style={{fontSize:11,fontWeight:700,color:T.textDim,marginBottom:6,textTransform:'uppercase' as const,letterSpacing:'.06em'}}>{t('Soyad')}</div>
                  <input value={editForm.surname||''} onChange={e=>setEditForm((f:any)=>({...f,surname:e.target.value}))} style={{width:'100%',padding:'8px 12px',borderRadius:9,border:`1px solid ${T.borderMid}`,fontSize:13,outline:'none',boxSizing:'border-box' as const}}/>
                </div>
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:T.textDim,marginBottom:6,textTransform:'uppercase' as const,letterSpacing:'.06em'}}>{t('E-posta')}</div>
                <input value={editForm.email||''} onChange={e=>setEditForm((f:any)=>({...f,email:e.target.value}))} style={{width:'100%',padding:'8px 12px',borderRadius:9,border:`1px solid ${T.borderMid}`,fontSize:13,outline:'none',boxSizing:'border-box' as const}}/>
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:T.textDim,marginBottom:6,textTransform:'uppercase' as const,letterSpacing:'.06em'}}>{t('Rol')}</div>
                <select value={editForm.role||'client'} onChange={e=>setEditForm((f:any)=>({...f,role:e.target.value}))} style={{width:'100%',padding:'8px 12px',borderRadius:9,border:`1px solid ${T.borderMid}`,fontSize:13,outline:'none',background:T.surface}}>
                  <option value='admin'>{t('Yönetici')}</option>
                  <option value='user'>{t('Kullanıcı')}</option>
                </select>
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:T.textDim,marginBottom:6,textTransform:'uppercase' as const,letterSpacing:'.06em'}}>{t('Yeni Şifre (opsiyonel)')}</div>
                <input type='password' value={editForm.password||''} onChange={e=>setEditForm((f:any)=>({...f,password:e.target.value}))} placeholder={t('Değiştirmek için girin...')} style={{width:'100%',padding:'8px 12px',borderRadius:9,border:`1px solid ${T.borderMid}`,fontSize:13,outline:'none',boxSizing:'border-box' as const}}/>
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:T.textDim,marginBottom:9,textTransform:'uppercase' as const,letterSpacing:'.06em'}}>{t('Bağlı Müşteriler')}</div>
                {editClients.length===0 && <div style={{fontSize:12,color:T.textDim,marginBottom:6}}>{t('Henüz bağlı müşteri yok.')}</div>}
                {editClients.map((cl:any)=>(
                  <div key={cl.id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 11px',background:'var(--py-subtle-bg)',borderRadius:9,border:`1px solid ${T.border}`,marginBottom:5,gap:8}}>
                    <div style={{minWidth:0,flex:1}}>
                      <div style={{fontSize:12,fontWeight:600}}>{cl.name}</div>
                      <div style={{fontSize:10.5,color:T.textDim}}>{cl.domain}</div>
                    </div>
                    <select value={cl.role||'viewer'} onChange={e=>handleChangeClientRole(cl.id, e.target.value)}
                      style={{padding:'4px 7px',borderRadius:7,border:`1px solid ${T.borderMid}`,fontSize:11,fontWeight:600,outline:'none',background:T.surface,color:T.ink,cursor:'pointer'}}>
                      <option value='viewer'>{t('Görüntüleyici')}</option>
                      <option value='editor'>{t('Editör')}</option>
                      <option value='admin'>{t('Müşteri Yöneticisi')}</option>
                    </select>
                    <button onClick={()=>handleRemoveClientFromUser(cl.id)} style={{background:'none',border:`1px solid ${alpha(T.red,30)}`,borderRadius:7,padding:'2px 9px',fontSize:11,color:T.redText,cursor:'pointer'}}>{t('Kaldır')}</button>
                  </div>
                ))}
                {allClients.filter((cl:any)=>!editClients.find((ec:any)=>ec.id===cl.id)).length>0 && (
                  <select onChange={e=>{if(e.target.value){handleAddClientToUser(Number(e.target.value));e.target.value='';}}}
                    style={{width:'100%',padding:'8px 10px',borderRadius:9,border:`1px solid ${alpha(T.amber,35)}`,fontSize:12,outline:'none',background:'var(--py-amber-tint)',color:T.amberDeepText,marginTop:4,cursor:'pointer'}}>
                    <option value=''>{t('Müşteri ekle...')}</option>
                    {allClients.filter((cl:any)=>!editClients.find((ec:any)=>ec.id===cl.id)).map((cl:any)=>(
                      <option key={cl.id} value={cl.id}>{cl.name}</option>
                    ))}
                  </select>
                )}
              </div>
            </div>
            <div style={{padding:'14px 24px',borderTop:'1px solid var(--py-table-divider)',display:'flex',justifyContent:'flex-end',gap:8,flexShrink:0}}>
              <button onClick={()=>setEditingUser(null)} style={{padding:'8px 20px',borderRadius:9,border:`1px solid ${T.borderMid}`,background:T.surface,fontSize:13,fontWeight:600,color:'var(--py-text-mid-alt)',cursor:'pointer'}}>{t('İptal')}</button>
              <button onClick={handleSaveEditUser} disabled={editSaving} style={{padding:'9px 16px',borderRadius:11,border:'none',background:T.accent,fontSize:13,fontWeight:700,color:'#fff',cursor:editSaving?'wait':'pointer',opacity:editSaving?0.7:1}}>{editSaving?t('Kaydediliyor...'):t('Kaydet')}</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}


const PLAN_DISPLAY_NAMES: Record<string,string> = { starter:'Başlangıç', professional:'Profesyonel', enterprise:'Kurumsal', admin:'Özel Plan (Admin)' };
function SettingsTab({ config, onSave, activeClientId, myClients }:{ config:any; onSave:(c:any)=>void; activeClientId?:number; myClients?:any[] }) {
  const { t, lang } = useLang();
  const T = SidebarT;
  const isMobile = useIsMobile();
  const [cfg, setCfg]   = useState(config);
  const [profilePlanName, setProfilePlanName] = useState('');
  useEffect(()=>{
    axios.get(`${API}/auth/me`)
      .then(me=>{
        const params = me.data?.role==='admin' ? {} : (activeClientId ? { client_id: activeClientId } : {});
        return axios.get(`${API}/subscription/status`, { params });
      })
      .then(r=>setProfilePlanName(PLAN_DISPLAY_NAMES[r.data?.plan] || r.data?.plan || ''))
      .catch(()=>{});
  },[activeClientId]);
  const [prefs, setPrefs] = useState<any>({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved]   = useState(false);
  const [freq, setFreq]     = useState<'immediate'|'daily'|'weekly'|'never'>('immediate');
  const [ga4Properties, setGa4Properties] = useState<any[]>([]);
  const [ga4Filter, setGa4Filter] = useState('');
  const [ga4OauthClientId, setGa4OauthClientId] = useState<number|null>(null);
  const [showPropModal, setShowPropModal] = useState(false);
  const [metaAccounts, setMetaAccounts] = useState<any[]>([]);
  const [showMetaModal, setShowMetaModal] = useState(false);
  const [gadsAccounts, setGadsAccounts] = useState<any[]>([]);
  const [gadsOauthClientId, setGadsOauthClientId] = useState<number|null>(null);
  const [showGadsModal, setShowGadsModal] = useState(false);
  const [gadsLoading, setGadsLoading] = useState(false);
  const [gscSites, setGscSites] = useState<any[]>([]);
  const [gscOauthClientId, setGscOauthClientId] = useState<number|null>(null);
  const [showGscModal, setShowGscModal] = useState(false);
  const [cgptKeyInput, setCgptKeyInput] = useState('');
  const [cgptConnecting, setCgptConnecting] = useState(false);
  const [cgptError, setCgptError] = useState('');
  const [xAdsConnecting, setXAdsConnecting] = useState(false);
  const [xAdsError, setXAdsError] = useState('');
  const [tiktokConnecting, setTiktokConnecting] = useState(false);
  const [tiktokError, setTiktokError] = useState('');
  const [adjustTokenInput, setAdjustTokenInput] = useState('');
  const [adjustApps, setAdjustApps] = useState<any[]|null>(null);
  const [adjustAppTokenSel, setAdjustAppTokenSel] = useState('');
  const [adjustVerifying, setAdjustVerifying] = useState(false);
  const [adjustConnecting, setAdjustConnecting] = useState(false);
  const [adjustError, setAdjustError] = useState('');
  const [pixaHostInput, setPixaHostInput] = useState('');
  const [pixaEmailInput, setPixaEmailInput] = useState('');
  const [pixaTokenInput, setPixaTokenInput] = useState('');
  const [pixaVerified, setPixaVerified] = useState<any|null>(null);
  const [pixaVerifying, setPixaVerifying] = useState(false);
  const [pixaConnecting, setPixaConnecting] = useState(false);
  const [pixaError, setPixaError] = useState('');
  const [shopifyShopInput, setShopifyShopInput] = useState('');
  const [shopifyConnecting, setShopifyConnecting] = useState(false);
  const [shopifyError, setShopifyError] = useState('');
  const [apiTokens, setApiTokens] = useState<any[]>([]);
  const [newTokenName, setNewTokenName] = useState('');
  const [newTokenCreating, setNewTokenCreating] = useState(false);
  const [newTokenResult, setNewTokenResult] = useState<any>(null);
  const [tokenCopied, setTokenCopied] = useState(false);

  const loadApiTokens = () => {
    const tok = localStorage.getItem('poyais_token')||'';
    axios.get(`${API}/auth/api-tokens`, { headers:{ Authorization:`Bearer ${tok}` } })
      .then(r=>setApiTokens(r.data||[])).catch(()=>{});
  };
  useEffect(()=>{ loadApiTokens(); },[]);

  const createApiToken = async () => {
    setNewTokenCreating(true);
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.post(`${API}/auth/api-tokens`, { name: newTokenName.trim() || 'Adsız anahtar' }, { headers:{ Authorization:`Bearer ${tok}` } });
      setNewTokenResult(res.data);
      setNewTokenName('');
      setTokenCopied(false);
      loadApiTokens();
    } catch(e) { alert(t('Anahtar oluşturulamadı.')); }
    setNewTokenCreating(false);
  };

  const revokeApiToken = async (id:number) => {
    if(!window.confirm(t('Bu anahtarı iptal etmek istediğinize emin misiniz? Bu anahtarı kullanan bağlantılar hemen kesilir.'))) return;
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.delete(`${API}/auth/api-tokens/${id}`, { headers:{ Authorization:`Bearer ${tok}` } });
      loadApiTokens();
    } catch(e) { alert(t('Anahtar iptal edilemedi.')); }
  };

  const [criteoIdInput, setCriteoIdInput] = useState('');
  const [criteoSecretInput, setCriteoSecretInput] = useState('');
  const [criteoAdvertisers, setCriteoAdvertisers] = useState<any[]|null>(null);
  const [criteoAdvertiserSel, setCriteoAdvertiserSel] = useState('');
  const [criteoVerifying, setCriteoVerifying] = useState(false);
  const [criteoConnecting, setCriteoConnecting] = useState(false);
  const [criteoError, setCriteoError] = useState('');
  const [criteoDatasetInput, setCriteoDatasetInput] = useState('');
  const [criteoDatasetSaving, setCriteoDatasetSaving] = useState(false);
  const [activeTab, setActiveTab] = useState<'integrations'|'profile'|'notifications'|'memory'|'developer'>('integrations');
  const ent = useIntegrationEntitlement(activeClientId);
  const [ikasOn, setIkasOn] = useState(false);
  const [jiraOn, setJiraOn] = useState(false);
  const [profileForm, setProfileForm] = useState({ name: config?.profile?.name||'', surname: config?.profile?.surname||'', title: config?.profile?.title||'', photo: config?.profile?.photo||'' });
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [profileSaving, setProfileSaving] = useState(false);
  const [profileSaved, setProfileSaved] = useState(false);
  const [profileError, setProfileError] = useState('');
  const [passwordSaving, setPasswordSaving] = useState(false);
  const [passwordSaved, setPasswordSaved] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const myUserRole = JSON.parse(localStorage.getItem('poyais_user')||'{}')?.role || '';
  const myCompany = (myClients && myClients.length > 0) ? myClients[0] : null;
  const [companyNameDraft, setCompanyNameDraft] = useState(myCompany?.name || '');
  const [companySaving, setCompanySaving] = useState(false);
  const [companySaved, setCompanySaved] = useState(false);
  const [companyError, setCompanyError] = useState('');
  useEffect(() => { setCompanyNameDraft(myCompany?.name || ''); }, [myCompany?.id, myCompany?.name]);
  const [rtbValidating, setRtbValidating] = useState(false);
  const [rtbValidateResult, setRtbValidateResult] = useState<{valid:boolean; message?:string; advertisers?:number}|null>(null);
  const handleRtbValidate = async () => {
    const rtb = (cfg?.platforms as any)?.rtbhouse;
    const token = rtb?.token || (rtb?.email && rtb?.password ? `${rtb.email}:${rtb.password}` : '');
    if(!token) { setRtbValidateResult({ valid:false, message:t('E-posta ve şifre girin.') }); return; }
    setRtbValidating(true); setRtbValidateResult(null);
    try {
      const res = await axios.get(`${API}/rtbhouse/validate`, { params:{ token } });
      setRtbValidateResult(res.data);
    } catch(e) {
      setRtbValidateResult({ valid:false, message:t('Doğrulama sırasında hata oluştu.') });
    }
    setRtbValidating(false);
  };
  const [rtbBusy, setRtbBusy] = useState(false);
  const handleRtbConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    const rtb = (cfg?.platforms as any)?.rtbhouse;
    const email = (rtb?.email||'').trim(), password = rtb?.password||'';
    if(!email || !password) { setRtbValidateResult({ valid:false, message:t('E-posta ve şifre girin.') }); return; }
    setRtbBusy(true);
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/rtbhouse/connect`, { client_id: activeClientId, email, password }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, rtbhouse:{...c.platforms?.rtbhouse, email, password, token:`${email}:${password}`, enabled:true}}}));
      setRtbValidateResult(null);
      setSaved(true); setTimeout(()=>setSaved(false), 2500);
    } catch(e:any) { alert(e?.response?.data?.detail || t('Bağlanamadı.')); }
    finally { setRtbBusy(false); }
  };
  const handleRtbDisconnect = async () => {
    if(!window.confirm(t('RTB House bağlantısını kesmek istediğinize emin misiniz?'))) return;
    setRtbBusy(true);
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/rtbhouse/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, rtbhouse:{...c.platforms?.rtbhouse, email:'', password:'', token:'', enabled:false}}}));
      setRtbValidateResult(null);
    } catch(e) { alert(t('Bağlantı kesilemedi.')); }
    finally { setRtbBusy(false); }
  };

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if(!file) return;
    if(file.size > 500 * 1024) { alert(t('Fotoğraf en fazla 500KB olabilir.')); return; }
    const reader = new FileReader();
    reader.onload = async (ev: ProgressEvent<FileReader>) => {
      const base64 = ev.target?.result as string;
      setProfileForm(f=>({...f, photo: base64}));
      try {
        const res = await axios.put(`${API}/auth/me`, { photo: base64 });
        const u = res.data?.user || {};
        setCfg((c:any)=>({...c, profile:{...c.profile, photo: u.photo||base64}}));
      } catch(e) {}
    };
    reader.readAsDataURL(file);
  };

  // Profil bilgilerini kaydetmek şifre alanlarına bağımlı değildir — ayrı bir işlemdir.
  const handleProfileSave = async () => {
    setProfileError(''); setProfileSaving(true);
    try {
      const payload: any = { name: profileForm.name, surname: profileForm.surname, title: profileForm.title };
      const res = await axios.put(`${API}/auth/me`, payload);
      const u = res.data?.user || {};
      setCfg((c:any)=>({...c, profile:{...c.profile, name:u.name||profileForm.name, surname:u.surname||profileForm.surname, title:u.title??profileForm.title}}));
      setProfileSaved(true);
      setTimeout(()=>setProfileSaved(false), 2500);
    } catch(e:any) {
      setProfileError(e.response?.data?.detail || t('Kayıt başarısız.'));
    }
    setProfileSaving(false);
  };

  const handlePasswordChange = async () => {
    if(!newPassword) { setPasswordError(t('Yeni şifre girin.')); return; }
    if(newPassword !== confirmPassword) { setPasswordError(t('Şifreler eşleşmiyor.')); return; }
    if(newPassword.length < 10 || !/[A-Za-zÇĞİÖŞÜçğıöşü]/.test(newPassword) || !/[0-9]/.test(newPassword)) { setPasswordError(t('Şifre en az 10 karakter olmalı ve en az bir harf ile bir rakam içermelidir.')); return; }
    setPasswordError(''); setPasswordSaving(true);
    try {
      await axios.put(`${API}/auth/me`, { password: newPassword });
      setNewPassword(''); setConfirmPassword('');
      setPasswordSaved(true);
      setTimeout(()=>setPasswordSaved(false), 2500);
    } catch(e:any) {
      setPasswordError(e.response?.data?.detail || t('Şifre güncellenemedi.'));
    }
    setPasswordSaving(false);
  };

  const handleCompanyNameSave = async () => {
    if(!myCompany?.id) return;
    const name = companyNameDraft.trim();
    if(!name) { setCompanyError(t('Şirket adı boş olamaz.')); return; }
    setCompanyError(''); setCompanySaving(true);
    try {
      await axios.put(`${API}/clients/${myCompany.id}/company-name`, { name });
      setCompanySaved(true);
      setTimeout(()=>setCompanySaved(false), 2500);
    } catch(e:any) {
      setCompanyError(e.response?.data?.detail || t('Kayıt başarısız.'));
    }
    setCompanySaving(false);
  };


  // OAuth callback sonrası property seçimi
  useEffect(()=>{
    const params = new URLSearchParams(window.location.search);
    if(params.get('ga4_oauth') === 'success') {
      const oauthClientId = params.get('ga4_client_id');
      setGa4OauthClientId(oauthClientId ? parseInt(oauthClientId) : null);
      window.history.replaceState({}, '', '/settings');
      const propsKey = params.get('ga4_props_key');
      if(propsKey) {
        // Liste artık URL'de değil, sunucuda (yüzlerce mülk sığmaz); anahtarla çekilir
        axios.get(`${API}/auth/google/properties`, { params:{ key: propsKey } })
          .then(r=>{ setGa4Properties(r.data?.properties||[]); setShowPropModal(true); })
          .catch(()=>{ setGa4Properties([]); setShowPropModal(true); });
      } else {
        try { setGa4Properties(JSON.parse(decodeURIComponent(params.get('ga4_properties')||'[]'))); } catch(e) { setGa4Properties([]); }
        setShowPropModal(true);
      }
    }
    if(params.get('meta_oauth') === 'success') {
      try {
        const accounts = JSON.parse(decodeURIComponent(params.get('meta_accounts')||'[]'));
        setMetaAccounts(accounts);
        setShowMetaModal(true);
        window.history.replaceState({}, '', '/settings');
      } catch(e) {}
    }
    if(params.get('gads_oauth') === 'success') {
      try {
        const accounts = JSON.parse(decodeURIComponent(params.get('gads_accounts')||'[]'));
        setGadsAccounts(accounts);
        const oauthClientId = params.get('gads_client_id');
        setGadsOauthClientId(oauthClientId ? parseInt(oauthClientId) : null);
        setShowGadsModal(true);
        window.history.replaceState({}, '', '/settings');
      } catch(e) {}
    }
    if(params.get('gsc_oauth') === 'success') {
      try {
        const sites = JSON.parse(decodeURIComponent(params.get('gsc_sites')||'[]'));
        setGscSites(sites);
        const oauthClientId = params.get('gsc_client_id');
        setGscOauthClientId(oauthClientId ? parseInt(oauthClientId) : null);
        setShowGscModal(true);
        window.history.replaceState({}, '', '/settings');
      } catch(e) {}
    }
    if(params.get('shopify_oauth') === 'success') {
      setSaved(true); setTimeout(()=>setSaved(false), 2500);
      window.history.replaceState({}, '', '/settings');
    }
    if(params.get('shopify_install') === 'success' && params.get('shop')) {
      const shopDomain = params.get('shop') || '';
      window.history.replaceState({}, '', '/settings');
      if(window.confirm(shopDomain + ' ' + t('mağazası Poyais One hesabınıza bağlansın mı?'))) {
        const cid = parseInt(localStorage.getItem('poyais_active_client') || '0');
        axios.post(`${API}/shopify/claim`, { client_id: cid, shop: shopDomain })
          .then(() => { setSaved(true); setTimeout(()=>setSaved(false), 2500); })
          .catch((e:any) => alert(t('Shopify bağlantısı başarısız oldu:') + ' ' + (e?.response?.data?.detail || '')));
      }
    }
    if(params.get('shopify_error')) {
      alert(t('Shopify bağlantısı başarısız oldu:') + ' ' + params.get('shopify_error'));
      window.history.replaceState({}, '', '/settings');
    }
    if(params.get('ga4_error')) {
      const detail = params.get('ga4_error_detail');
      alert(t('GA4 hesapları alınamadı:') + ' ' + (detail ? decodeURIComponent(detail) : params.get('ga4_error')));
      window.history.replaceState({}, '', '/settings');
    }
    if(params.get('x_ads_oauth') === 'success') {
      setSaved(true); setTimeout(()=>setSaved(false), 2500);
      window.history.replaceState({}, '', '/settings');
    }
    if(params.get('x_ads_error')) {
      alert(t('X Ads bağlantısı başarısız oldu:') + ' ' + params.get('x_ads_error'));
      window.history.replaceState({}, '', '/settings');
    }
    if(params.get('tiktok_oauth') === 'success') {
      setSaved(true); setTimeout(()=>setSaved(false), 2500);
      window.history.replaceState({}, '', '/settings');
    }
    if(params.get('tiktok_error')) {
      const reasons:Record<string,string> = { invalid_state:t('Bağlantı isteğinin süresi doldu, tekrar deneyin.'), denied:t('TikTok yetkisi verilmedi.'), token_failed:t('TikTok erişim anahtarı alınamadı.'), no_account:t('Bu TikTok hesabında yetki verilen reklam hesabı yok.') };
      alert(t('TikTok Ads bağlantısı başarısız oldu:') + ' ' + (reasons[params.get('tiktok_error')||''] || params.get('tiktok_error')));
      window.history.replaceState({}, '', '/settings');
    }
  },[]);

  const handleGadsConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    setGadsLoading(true);
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.get(`${API}/auth/google-ads/connect`, { params:{ client_id: activeClientId }, headers:{ Authorization:`Bearer ${tok}` } });
      window.location.href = res.data.auth_url;
    } catch(e) { alert(t('OAuth başlatılamadı.')); setGadsLoading(false); }
  };

  const selectGadsAccount = async (customerId: string) => {
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      // OAuth akışının başlatıldığı müşteri esastır — sayfa yenilendikten sonra
      // arayüzde farklı bir müşteri seçili olabilir, yanlış müşteriye yazmayı önler.
      const targetClientId = gadsOauthClientId || activeClientId;
      await axios.post(`${API}/auth/google-ads/select-account`, { client_id: targetClientId, customer_id: customerId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, gads:{...c.platforms?.gads, customerId, enabled:true}}}));
      setShowGadsModal(false);
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e) { alert(t('Hesap kaydedilemedi.')); }
  };

  const handleGscConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.get(`${API}/auth/search-console/connect`, { params:{ client_id: activeClientId }, headers:{ Authorization:`Bearer ${tok}` } });
      window.location.href = res.data.auth_url;
    } catch(e) { alert(t('OAuth başlatılamadı.')); }
  };

  const selectGscSite = async (siteUrl: string) => {
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const targetClientId = gscOauthClientId || activeClientId;
      await axios.post(`${API}/auth/search-console/select-site`, { client_id: targetClientId, site_url: siteUrl }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, search_console:{...c.platforms?.search_console, siteUrl, enabled:true}}}));
      setShowGscModal(false);
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e) { alert(t('Site kaydedilemedi.')); }
  };

  const handleCgptConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    if(!cgptKeyInput.trim()) return;
    setCgptConnecting(true); setCgptError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.post(`${API}/chatgpt-ads/connect`, { client_id: activeClientId, api_key: cgptKeyInput.trim() }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, chatgpt_ads:{...c.platforms?.chatgpt_ads, apiKey:'••••••••', accountName: res.data.account_name || '', enabled:true}}}));
      setCgptKeyInput('');
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e:any) { setCgptError(e?.response?.data?.detail || t('Bağlanamadı.')); }
    finally { setCgptConnecting(false); }
  };

  const handleCgptDisconnect = async () => {
    if(!window.confirm(t('ChatGPT Ads bağlantısını kesmek istediğinize emin misiniz?'))) return;
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/chatgpt-ads/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, chatgpt_ads:{...c.platforms?.chatgpt_ads, apiKey:'', accountName:'', enabled:false}}}));
    } catch(e) { alert(t('Bağlantı kesilemedi.')); }
  };

  const handleXAdsConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    setXAdsConnecting(true); setXAdsError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.get(`${API}/x-ads/connect`, { params:{ client_id: activeClientId }, headers:{ Authorization:`Bearer ${tok}` } });
      window.location.href = res.data.auth_url;
    } catch(e:any) { setXAdsError(e?.response?.data?.detail || t('Bağlanamadı.')); setXAdsConnecting(false); }
  };

  const handleXAdsDisconnect = async () => {
    if(!window.confirm(t('X Ads bağlantısını kesmek istediğinize emin misiniz?'))) return;
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/x-ads/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, x_ads:{...c.platforms?.x_ads, accountName:'', enabled:false}}}));
    } catch(e) { alert(t('Bağlantı kesilemedi.')); }
  };

  const handleTiktokConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    setTiktokConnecting(true); setTiktokError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.get(`${API}/tiktok/connect`, { params:{ client_id: activeClientId }, headers:{ Authorization:`Bearer ${tok}` } });
      window.location.href = res.data.auth_url;
    } catch(e:any) { setTiktokError(e?.response?.data?.detail || t('Bağlanamadı.')); setTiktokConnecting(false); }
  };

  const handleTiktokDisconnect = async () => {
    if(!window.confirm(t('TikTok Ads bağlantısını kesmek istediğinize emin misiniz?'))) return;
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/tiktok/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, tiktok:{...c.platforms?.tiktok, advertiserId:'', advertiserName:'', options:[], enabled:false}}}));
    } catch(e) { alert(t('Bağlantı kesilemedi.')); }
  };

  const handleTiktokSelect = async (advertiserId:string) => {
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.post(`${API}/tiktok/select-advertiser`, { client_id: activeClientId, advertiser_id: advertiserId }, { headers:{ Authorization:`Bearer ${tok}` } });
      const opt = ((cfg?.platforms as any)?.tiktok?.options||[]).find((o:any)=>o.id===advertiserId);
      setCfg((c:any)=>({...c, platforms:{...c.platforms, tiktok:{...c.platforms?.tiktok, advertiserId, advertiserName:res.data.advertiser_name, currency:opt?.currency||''}}}));
    } catch(e:any) { alert(e?.response?.data?.detail || t('Hesap değiştirilemedi.')); }
  };

  const handlePixaVerify = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    if(!pixaHostInput.trim() || !pixaEmailInput.trim() || !pixaTokenInput.trim()) return;
    setPixaVerifying(true); setPixaError(''); setPixaVerified(null);
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.post(`${API}/pixa/verify`, { client_id: activeClientId, host: pixaHostInput.trim(), email: pixaEmailInput.trim(), api_token: pixaTokenInput.trim() }, { headers:{ Authorization:`Bearer ${tok}` } });
      setPixaVerified(res.data);
    } catch(e:any) { setPixaError(e?.response?.data?.detail || t('Pixa bilgileri doğrulanamadı.')); }
    finally { setPixaVerifying(false); }
  };

  const handlePixaConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    setPixaConnecting(true); setPixaError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.post(`${API}/pixa/connect`, { client_id: activeClientId, host: pixaHostInput.trim(), email: pixaEmailInput.trim(), api_token: pixaTokenInput.trim() }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, pixa:{...c.platforms?.pixa, host: res.data.host||'', email: pixaEmailInput.trim(), apiToken:'••••••••', userName: res.data.user_name||'', currency: res.data.currency||'', enabled:true}}}));
      setPixaHostInput(''); setPixaEmailInput(''); setPixaTokenInput(''); setPixaVerified(null);
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e:any) { setPixaError(e?.response?.data?.detail || t('Bağlanamadı.')); }
    finally { setPixaConnecting(false); }
  };

  const handlePixaDisconnect = async () => {
    if(!window.confirm(t('Pixa bağlantısını kesmek istediğinize emin misiniz?'))) return;
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/pixa/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, pixa:{...c.platforms?.pixa, host:'', email:'', apiToken:'', userName:'', currency:'', enabled:false}}}));
    } catch(e:any) { alert(e?.response?.data?.detail || t('Bağlantı kesilemedi.')); }
  };

  const handleAdjustVerify = async () => {
    if(!adjustTokenInput.trim()) return;
    setAdjustVerifying(true); setAdjustError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.post(`${API}/adjust/verify-token`, { api_token: adjustTokenInput.trim() }, { headers:{ Authorization:`Bearer ${tok}` } });
      const apps = res.data.apps || [];
      setAdjustApps(apps);
      if(apps.length > 0) setAdjustAppTokenSel(apps[0].app_token);
    } catch(e:any) { setAdjustError(e?.response?.data?.detail || t('Token doğrulanamadı.')); }
    finally { setAdjustVerifying(false); }
  };

  const handleAdjustConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    if(!adjustTokenInput.trim() || !adjustAppTokenSel) return;
    setAdjustConnecting(true); setAdjustError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const appName = adjustApps?.find((a:any)=>a.app_token===adjustAppTokenSel)?.name || '';
      const res = await axios.post(`${API}/adjust/connect`, { client_id: activeClientId, api_token: adjustTokenInput.trim(), app_token: adjustAppTokenSel, app_name: appName }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, adjust:{...c.platforms?.adjust, apiToken:'••••••••', appToken: res.data.app_token || '', appName: res.data.app_name || '', enabled:true}}}));
      setAdjustTokenInput(''); setAdjustApps(null); setAdjustAppTokenSel('');
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e:any) { setAdjustError(e?.response?.data?.detail || t('Bağlanamadı.')); }
    finally { setAdjustConnecting(false); }
  };

  const handleAdjustDisconnect = async () => {
    if(!window.confirm(t('Adjust bağlantısını kesmek istediğinize emin misiniz?'))) return;
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/adjust/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, adjust:{...c.platforms?.adjust, apiToken:'', appToken:'', appName:'', enabled:false}}}));
    } catch(e) { alert(t('Bağlantı kesilemedi.')); }
  };

  const handleShopifyConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    if(!shopifyShopInput.trim()) return;
    setShopifyConnecting(true); setShopifyError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.get(`${API}/shopify/connect`, { params:{ client_id: activeClientId, shop: shopifyShopInput.trim(), return_to:'settings' }, headers:{ Authorization:`Bearer ${tok}` } });
      window.location.href = res.data.auth_url;
    } catch(e:any) { setShopifyError(e?.response?.data?.detail || t('Bağlantı başlatılamadı.')); setShopifyConnecting(false); }
  };

  const handleShopifyDisconnect = async () => {
    if(!window.confirm(t('Shopify bağlantısını kesmek istediğinize emin misiniz?'))) return;
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/shopify/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, shopify:{...c.platforms?.shopify, shopDomain:'', shopName:'', enabled:false}}}));
    } catch(e) { alert(t('Bağlantı kesilemedi.')); }
  };

  const handleCriteoVerify = async () => {
    if(!criteoIdInput.trim() || !criteoSecretInput.trim()) return;
    setCriteoVerifying(true); setCriteoError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const res = await axios.post(`${API}/criteo/verify-token`, { client_id: criteoIdInput.trim(), client_secret: criteoSecretInput.trim() }, { headers:{ Authorization:`Bearer ${tok}` } });
      const advertisers = res.data.advertisers || [];
      setCriteoAdvertisers(advertisers);
      if(advertisers.length > 0) setCriteoAdvertiserSel(advertisers[0].id);
    } catch(e:any) { setCriteoError(e?.response?.data?.detail || t('Kimlik doğrulanamadı.')); }
    finally { setCriteoVerifying(false); }
  };

  const handleCriteoConnect = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    if(!criteoIdInput.trim() || !criteoSecretInput.trim() || !criteoAdvertiserSel) return;
    setCriteoConnecting(true); setCriteoError('');
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const advertiserName = criteoAdvertisers?.find((a:any)=>a.id===criteoAdvertiserSel)?.name || '';
      const res = await axios.post(`${API}/criteo/connect`, { client_id: activeClientId, criteo_client_id: criteoIdInput.trim(), criteo_client_secret: criteoSecretInput.trim(), advertiser_id: criteoAdvertiserSel, advertiser_name: advertiserName }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, criteo:{...c.platforms?.criteo, clientId: criteoIdInput.trim(), advertiserId: res.data.advertiser_id || '', advertiserName: res.data.advertiser_name || '', enabled:true}}}));
      setCriteoIdInput(''); setCriteoSecretInput(''); setCriteoAdvertisers(null); setCriteoAdvertiserSel('');
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e:any) { setCriteoError(e?.response?.data?.detail || t('Bağlanamadı.')); }
    finally { setCriteoConnecting(false); }
  };

  const handleCriteoDisconnect = async () => {
    if(!window.confirm(t('Criteo bağlantısını kesmek istediğinize emin misiniz?'))) return;
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/criteo/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, criteo:{...c.platforms?.criteo, clientId:'', advertiserId:'', advertiserName:'', enabled:false}}}));
    } catch(e) { alert(t('Bağlantı kesilemedi.')); }
  };

  const handleCriteoDatasetSave = async () => {
    if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
    setCriteoDatasetSaving(true);
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/criteo/dataset`, { client_id: activeClientId, dataset_id: criteoDatasetInput.trim() }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, criteo:{...c.platforms?.criteo, datasetId: criteoDatasetInput.trim()}}}));
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e) { alert(t('Dataset ID kaydedilemedi.')); }
    finally { setCriteoDatasetSaving(false); }
  };

  const selectMetaAccount = async (accountId: string, accessToken: string) => {
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post(`${API}/auth/meta/select-account`, { account_id: accountId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, meta:{...c.platforms?.meta, accountId, accessToken, enabled:true}}}));
      setShowMetaModal(false);
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e) { alert(t('Hesap kaydedilemedi.')); }
  };

  const selectProperty = async (propertyId: string) => {
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      const targetClientId = ga4OauthClientId || activeClientId;
      await axios.post(`${API}/auth/google/select-property`, { client_id: targetClientId, property_id: propertyId }, { headers:{ Authorization:`Bearer ${tok}` } });
      setCfg((c:any)=>({...c, platforms:{...c.platforms, ga4:{...c.platforms?.ga4, propertyId, enabled:true}}}));
      setShowPropModal(false);
      setSaved(true);
      setTimeout(()=>setSaved(false), 2500);
    } catch(e) { alert(t('Property kaydedilemedi.')); }
  };

  useEffect(()=>{
    axios.get(`${API}/auth/preferences`).then(r=>{
      const p = r.data||{};
      setPrefs(p);
      setFreq(p.mail_frequency||'immediate');
    }).catch(()=>{});
  },[]);

  const handleSave = () => {
    setSaving(true);
    const updatedPrefs = { ...prefs, mail_frequency: freq };
    Promise.all([
      onSave(cfg),
      axios.put(`${API}/auth/preferences`, updatedPrefs),
    ]).then(()=>{ setSaved(true); setTimeout(()=>setSaved(false),2500); })
    .catch(()=>{})
    .finally(()=>setSaving(false));
  };

  const Toggle = ({ value, onChange }: { value:boolean; onChange:(v:boolean)=>void }) => (
    <div onClick={()=>onChange(!value)}
      style={{ width:44,height:24,borderRadius:999,background:value?T.accent:T.borderSoft,cursor:'pointer',position:'relative' as const,transition:'background .2s',flexShrink:0 }}>
      <div style={{ width:18,height:18,borderRadius:'50%',background:T.surface,position:'absolute' as const,top:3,left:value?23:3,transition:'left .2s',boxShadow:'0 1px 4px rgba(0,0,0,.2)' }}/>
    </div>
  );

  const metaConnected = !!cfg?.platforms?.meta?.accountId;
  const metaEnabled   = metaConnected && cfg?.platforms?.meta?.enabled !== false;
  const platforms = [
    { key:'ga4',  label:'Google Analytics 4', sub:t('PROPERTY ID'), field:'propertyId', icon:'ga4_img', color:'#f97316', connected: !!cfg?.platforms?.ga4?.propertyId,  enabled: cfg?.platforms?.ga4?.enabled  !== false },
    { key:'gads', label:'Google Ads',          sub:t('CUSTOMER ID'), field:'customerId', icon:'gads_img', color:'#4285f4', connected: !!cfg?.platforms?.gads?.customerId, enabled: cfg?.platforms?.gads?.enabled !== false },
    { key:'meta', label:'Meta Ads',            sub:'', field:'', icon:'meta_img', color:'#1877f2', connected: metaConnected, enabled: metaEnabled },
    { key:'search_console', label:'Search Console', sub:t('SİTE'), field:'siteUrl', icon:'gsc_img', color:'#4285f4', connected: !!(cfg?.platforms as any)?.search_console?.siteUrl, enabled: (cfg?.platforms as any)?.search_console?.enabled !== false },
  ];

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:'100%' }}>

      {/* Meta Ad Account Seçim Modalı */}
      {showMetaModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
          <div style={{ background:T.surface, borderRadius:16, padding:'32px 28px', width:'100%', maxWidth:480, boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ fontSize:18, fontWeight:800, color:T.text, marginBottom:8 }}>{t('Meta Ad Account Seç')}</div>
            <div style={{ fontSize:13, color:T.textMidAlt, marginBottom:20 }}>{t('Facebook hesabınızda bulunan reklam hesaplarından birini seçin.')}</div>
            {metaAccounts.length === 0 ? (
              <div style={{ fontSize:13, color:T.redText, marginBottom:16 }}>{t('Aktif reklam hesabı bulunamadı.')}</div>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:20 }}>
                {metaAccounts.map((a:any)=>(
                  <button key={a.id} onClick={()=>selectMetaAccount(a.id, '')}
                    style={{ padding:'12px 16px', borderRadius:10, border:`1px solid ${T.borderMid}`, background:T.subtleBg, cursor:'pointer', textAlign:'left', transition:'border-color 0.15s' }}
                    onMouseEnter={e=>(e.currentTarget.style.borderColor='#1877f2')}
                    onMouseLeave={e=>(e.currentTarget.style.borderColor=T.borderMid)}>
                    <div style={{ fontSize:13, fontWeight:700, color:T.text }}>{a.name}</div>
                    <div style={{ fontSize:11, color:T.textMidAlt, marginTop:2 }}>{t('Account ID')}: <span style={{ fontFamily:MONO }}>{a.id}</span></div>
                  </button>
                ))}
              </div>
            )}
            <button onClick={()=>setShowMetaModal(false)} style={{ width:'100%', padding:'10px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, color:T.textMidAlt, fontSize:13, fontWeight:600, cursor:'pointer' }}>
              {t('Kapat')}
            </button>
          </div>
        </div>
      )}

      {/* GA4 Property Seçim Modalı */}
      {showPropModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
          <div style={{ background:T.surface, borderRadius:16, padding:'32px 28px', width:'100%', maxWidth:480, boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ fontSize:18, fontWeight:800, color:T.text, marginBottom:8 }}>{t('GA4 Property Seç')}</div>
            <div style={{ fontSize:13, color:T.textMidAlt, marginBottom:20 }}>{t("Google hesabınızda bulunan GA4 property'lerinden birini seçin.")}</div>
            {ga4Properties.length === 0 ? (
              <div style={{ fontSize:13, color:T.redText, marginBottom:16 }}>{t('Hiç property bulunamadı. GA4 hesabınızı kontrol edin.')}</div>
            ) : (
              <>
              {ga4Properties.length > 8 && <input value={ga4Filter} onChange={e=>setGa4Filter(e.target.value)} placeholder={t('Ara: ad, hesap ya da ID')} style={{ width:'100%', padding:'10px 12px', borderRadius:9, border:`1px solid ${T.borderMid}`, fontSize:13, marginBottom:12, boxSizing:'border-box' as const, background:T.subtleBg, color:T.text }}/>}
              <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:20, maxHeight:'50vh', overflowY:'auto' as const }}>
                {ga4Properties.filter((p:any)=>!ga4Filter.trim() || `${p.name} ${p.account} ${p.id}`.toLowerCase().includes(ga4Filter.trim().toLowerCase())).map((p:any)=>(
                  <button key={p.id} onClick={()=>selectProperty(p.id)}
                    style={{ padding:'12px 16px', borderRadius:10, border:`1px solid ${T.borderMid}`, background:T.subtleBg, cursor:'pointer', textAlign:'left', transition:'border-color 0.15s' }}
                    onMouseEnter={e=>(e.currentTarget.style.borderColor=T.accent)}
                    onMouseLeave={e=>(e.currentTarget.style.borderColor=T.borderMid)}>
                    <div style={{ fontSize:13, fontWeight:700, color:T.text }}>{p.name}</div>
                    <div style={{ fontSize:11, color:T.textMidAlt, marginTop:2 }}>{t('Property ID')}: <span style={{ fontFamily:MONO }}>{p.id}</span> · {p.account}</div>
                  </button>
                ))}
              </div>
              </>
            )}
            <button onClick={()=>setShowPropModal(false)} style={{ width:'100%', padding:'10px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, color:T.textMidAlt, fontSize:13, fontWeight:600, cursor:'pointer' }}>
              {t('Kapat')}
            </button>
          </div>
        </div>
      )}

      {/* Google Ads Hesap Seçim Modalı */}
      {showGadsModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
          <div style={{ background:T.surface, borderRadius:16, padding:'32px 28px', width:'100%', maxWidth:480, boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ fontSize:18, fontWeight:800, color:T.text, marginBottom:8 }}>{t('Google Ads Hesabı Seç')}</div>
            <div style={{ fontSize:13, color:T.textMidAlt, marginBottom:20 }}>{t('Google hesabınızda bulunan reklam hesaplarından birini seçin.')}</div>
            {gadsAccounts.length === 0 ? (
              <div style={{ fontSize:13, color:T.redText, marginBottom:16 }}>{t('Erişilebilir Google Ads hesabı bulunamadı.')}</div>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:20 }}>
                {gadsAccounts.map((a:any)=>(
                  <button key={a.id} onClick={()=>selectGadsAccount(a.id)}
                    style={{ padding:'12px 16px', borderRadius:10, border:`1px solid ${T.borderMid}`, background:T.subtleBg, cursor:'pointer', textAlign:'left', transition:'border-color 0.15s' }}
                    onMouseEnter={e=>(e.currentTarget.style.borderColor='#4285f4')}
                    onMouseLeave={e=>(e.currentTarget.style.borderColor=T.borderMid)}>
                    <div style={{ fontSize:13, fontWeight:700, color:T.text }}>{a.name}</div>
                    <div style={{ fontSize:11, color:T.textMidAlt, marginTop:2 }}>{t('Müşteri ID')}: <span style={{ fontFamily:MONO }}>{a.id}</span></div>
                  </button>
                ))}
              </div>
            )}
            <button onClick={()=>setShowGadsModal(false)} style={{ width:'100%', padding:'10px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, color:T.textMidAlt, fontSize:13, fontWeight:600, cursor:'pointer' }}>
              {t('Kapat')}
            </button>
          </div>
        </div>
      )}

      {/* Search Console Site Seçim Modalı */}
      {showGscModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
          <div style={{ background:T.surface, borderRadius:16, padding:'32px 28px', width:'100%', maxWidth:480, boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ fontSize:18, fontWeight:800, color:T.text, marginBottom:8 }}>{t('Search Console Sitesi Seç')}</div>
            <div style={{ fontSize:13, color:T.textMidAlt, marginBottom:20 }}>{t('Google hesabınızda doğrulanmış sitelerden birini seçin.')}</div>
            {gscSites.length === 0 ? (
              <div style={{ fontSize:13, color:T.redText, marginBottom:16 }}>{t('Doğrulanmış Search Console sitesi bulunamadı.')}</div>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:20 }}>
                {gscSites.map((s:any)=>(
                  <button key={s.url} onClick={()=>selectGscSite(s.url)}
                    style={{ padding:'12px 16px', borderRadius:10, border:`1px solid ${T.borderMid}`, background:T.subtleBg, cursor:'pointer', textAlign:'left', transition:'border-color 0.15s' }}
                    onMouseEnter={e=>(e.currentTarget.style.borderColor='#4285f4')}
                    onMouseLeave={e=>(e.currentTarget.style.borderColor=T.borderMid)}>
                    <div style={{ fontSize:13, fontWeight:700, color:T.text }}>{s.url}</div>
                    <div style={{ fontSize:11, color:T.textMidAlt, marginTop:2 }}>{t('İzin')}: <span style={{ fontFamily:MONO }}>{s.permission}</span></div>
                  </button>
                ))}
              </div>
            )}
            <button onClick={()=>setShowGscModal(false)} style={{ width:'100%', padding:'10px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, color:T.textMidAlt, fontSize:13, fontWeight:600, cursor:'pointer' }}>
              {t('Kapat')}
            </button>
          </div>
        </div>
      )}

      {/* Sekmeler */}
      <div style={{ display:'flex', gap:4, background:T.trackBg, borderRadius:11, padding:4, width:'fit-content', overflowX:'auto' as const, maxWidth:'100%' }}>
        {[{k:'integrations',l:t('Entegrasyonlar')},{k:'profile',l:t('Profil')},{k:'notifications',l:t('Bildirimler')},{k:'memory',l:t('Hafıza')},{k:'developer',l:t('Geliştirici')}].map(tb=>(
          <button key={tb.k} onClick={()=>setActiveTab(tb.k as any)} style={{ padding:'8px 20px', borderRadius:8, fontSize:12.5, fontWeight:activeTab===tb.k?700:500, cursor:'pointer', whiteSpace:'nowrap' as const, background:activeTab===tb.k?T.surface:'transparent', color:activeTab===tb.k?T.text:T.textMidAlt, border:'none', boxShadow:activeTab===tb.k?'0 1px 2px rgba(20,22,43,.1)':'none', transition:'all .15s' }}>
            {tb.l}
          </button>
        ))}
      </div>

      {/* Platform Baglantilari */}
{activeTab==='integrations' && (()=>{
        const rtb=(cfg?.platforms as any)?.rtbhouse||{};
        const rtbConnected=!!(rtb.email && rtb.password && rtb.enabled!==false);
        const cp=(cfg?.platforms as any)||{};
        const P=(k:string)=>platforms.find(p=>p.key===k)!;
        const activeToggle=(k:string)=>(
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
            <span style={{ fontSize:12.5, fontWeight:600, color:T.text }}>{t('Aktif')}</span>
            <Toggle value={P(k).enabled} onChange={v=>setCfg((c:any)=>({...c,platforms:{...c.platforms,[k]:{...c.platforms?.[k],enabled:v}}}))}/>
          </div>
        );
        const connectGa4=async()=>{
          if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
          try {
            const tok = localStorage.getItem('poyais_token')||'';
            const res = await axios.get(`${API}/auth/google/connect`, { params:{ client_id: activeClientId }, headers:{ Authorization:`Bearer ${tok}` } });
            window.location.href = res.data.auth_url;
          } catch(e) { alert('OAuth başlatılamadı.'); }
        };
        const connectMeta=async()=>{
          try {
            const tok = localStorage.getItem('poyais_token')||'';
            const res = await axios.get(`${API}/auth/meta/connect`, { headers:{ Authorization:`Bearer ${tok}` } });
            window.location.href = res.data.auth_url;
          } catch(e) { alert('OAuth başlatılamadı.'); }
        };
        const needClient=(fn:()=>void)=>()=>{ if(!activeClientId) { alert(t('Önce üstten bir müşteri seçin.')); return; } fn(); };
        const img=(src:string,w=26,extra:React.CSSProperties={})=><img src={src} width={w} height={w} style={{objectFit:'contain',...extra}} alt=''/>;
        const items:IntegrationItem[]=[
          { key:'gads', name:'Google Ads', desc:t('Google ağında kampanyaları ve harcamayı izleyin, performansı analiz edin.'), icon:img('/google-ads-icon.png'),
            connected:P('gads').connected, enabled:P('gads').enabled, onConnect:needClient(handleGadsConnect),
            body:<>{activeToggle('gads')}
                  <div>
                    <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>Müşteri ID: <span style={{ fontFamily:MONO }}>{cfg?.platforms?.gads?.customerId}</span></div>
                    <button onClick={async()=>{
                      if(!window.confirm(t('Google Ads bağlantısını kesmek istediğinize emin misiniz?'))) return;
                      try {
                        const tok = localStorage.getItem('poyais_token')||'';
                        await axios.post(`${API}/auth/google-ads/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
                        setCfg((c:any)=>({...c,platforms:{...c.platforms,gads:{...c.platforms?.gads,customerId:'',enabled:false}}}));
                      } catch(e) { alert('Bağlantı kesilemedi.'); }
                    }} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                      {t('Bağlantıyı Kes')}
                    </button>
                  </div></> },
          { key:'meta', name:'Meta Ads', desc:t('Facebook ve Instagram reklamları, kitleler ve sayfalar.'), icon:img('/meta-icon.png'),
            connected:P('meta').connected, enabled:P('meta').enabled, onConnect:connectMeta,
            body:<>{activeToggle('meta')}
                  <div>
                    <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>Account ID: <span style={{ fontFamily:MONO }}>{cfg?.platforms?.meta?.accountId}</span></div>
                    <button onClick={async()=>{
                      if(!window.confirm(t('Meta bağlantısını kesmek istediğinize emin misiniz?'))) return;
                      try {
                        const tok = localStorage.getItem('poyais_token')||'';
                        await axios.post(`${API}/auth/meta/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
                        setCfg((c:any)=>({...c,platforms:{...c.platforms,meta:{...c.platforms?.meta,accountId:'',accessToken:'',enabled:false}}}));
                      } catch(e) { alert('Bağlantı kesilemedi.'); }
                    }} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                      {t('Bağlantıyı Kes')}
                    </button>
                  </div></> },
          { key:'ga4', name:'Google Analytics 4', desc:t('Web sitesi trafiği, kullanıcı davranışı, dönüşümler ve gelir (GA4).'), icon:img('/google-analytics-icon.png'),
            connected:P('ga4').connected, enabled:P('ga4').enabled, onConnect:connectGa4,
            body:<>{activeToggle('ga4')}
                  <div>
                    <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>Property ID: <span style={{ fontFamily:MONO }}>{cfg?.platforms?.ga4?.propertyId}</span></div>
                    <button onClick={async()=>{
                      if(!activeClientId) { alert(t('Önce bir müşteri seçin.')); return; }
                      if(!window.confirm(t('GA4 bağlantısını kesmek istediğinize emin misiniz?'))) return;
                      try {
                        const tok = localStorage.getItem('poyais_token')||'';
                        await axios.post(`${API}/auth/google/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
                        setCfg((c:any)=>({...c,platforms:{...c.platforms,ga4:{...c.platforms?.ga4,propertyId:'',enabled:false}}}));
                      } catch(e) { alert('Bağlantı kesilemedi.'); }
                    }} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                      {t('Bağlantıyı Kes')}
                    </button>
                  </div></> },
          { key:'search_console', name:'Search Console', desc:t('Organik arama tıklamaları, gösterimler, CTR ve sıralamalar.'), icon:img('/search-console-icon.png'),
            connected:P('search_console').connected, enabled:P('search_console').enabled, onConnect:needClient(handleGscConnect),
            body:<>{activeToggle('search_console')}
                  <div>
                    <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8, wordBreak:'break-all' as const }}>Site: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.search_console?.siteUrl}</span></div>
                    <button onClick={async()=>{
                      if(!window.confirm(t('Search Console bağlantısını kesmek istediğinize emin misiniz?'))) return;
                      try {
                        const tok = localStorage.getItem('poyais_token')||'';
                        await axios.post(`${API}/auth/search-console/disconnect`, { client_id: activeClientId }, { headers:{ Authorization:`Bearer ${tok}` } });
                        setCfg((c:any)=>({...c,platforms:{...c.platforms,search_console:{...c.platforms?.search_console,siteUrl:'',enabled:false}}}));
                      } catch(e) { alert('Bağlantı kesilemedi.'); }
                    }} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                      {t('Bağlantıyı Kes')}
                    </button>
                  </div></> },
          { key:'chatgpt_ads', name:'ChatGPT Ads', desc:t('OpenAI Ads API ile ChatGPT reklam kampanyalarını izleyin.'), icon:<div style={{width:44,height:44,borderRadius:12,background:'#fff',border:`1px solid ${T.border}`,display:'flex',alignItems:'center',justifyContent:'center'}}><img src='/chatgpt-icon.png' width={24} height={24} style={{objectFit:'contain'}} alt='ChatGPT'/></div>,
            connected:!!cp.chatgpt_ads?.accountName, enabled:cp.chatgpt_ads?.enabled!==false,
            body:<>            {(cfg?.platforms as any)?.chatgpt_ads?.accountName ? (
              <div>
                <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>{t('Hesap')}: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.chatgpt_ads?.accountName}</span></div>
                <button onClick={handleCgptDisconnect} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                  {t('Bağlantıyı Kes')}
                </button>
              </div>
            ) : (
              <>
              <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('API KEY')}</div>
              <input value={cgptKeyInput} onChange={e=>setCgptKeyInput(e.target.value)} placeholder='OpenAI Ads Manager → Settings → API Keys' type='password'
                style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}/>
              <button onClick={handleCgptConnect} disabled={!activeClientId||cgptConnecting||!cgptKeyInput.trim()} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:(activeClientId&&cgptKeyInput.trim())?'pointer':'not-allowed', opacity:(activeClientId&&cgptKeyInput.trim())?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                {cgptConnecting?t('Doğrulanıyor…'):t('Bağlan')}
              </button>
              {cgptError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{cgptError}</div>}
              <div style={{ fontSize:10, color:T.textMidAlt, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{t("Müşterinin kendi OpenAI Ads Manager hesabından ürettiği API key'i girin.")}</div>
              </>
            )}</> },
          { key:'x_ads', name:'X Ads', desc:t('X (Twitter) reklam kampanyalarını ve performansı izleyin.'), icon:<NavIcon id='x_icon' size={22}/>, proOnly:true,
            connected:!!cp.x_ads?.accountName, enabled:cp.x_ads?.enabled!==false,
            body:<>            {(cfg?.platforms as any)?.x_ads?.accountName ? (
              <div>
                <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>{t('Hesap')}: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.x_ads?.accountName}</span></div>
                <button onClick={handleXAdsDisconnect} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                  {t('Bağlantıyı Kes')}
                </button>
              </div>
            ) : (
              <>
              <button onClick={handleXAdsConnect} disabled={!activeClientId||xAdsConnecting} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:activeClientId?'pointer':'not-allowed', opacity:activeClientId?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                {xAdsConnecting?t('Yönlendiriliyor…'):t('Bağlan')}
              </button>
              {xAdsError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{xAdsError}</div>}
              <div style={{ fontSize:10, color:T.textMidAlt, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{t('X (Twitter) Ads hesabınızı yetkilendirmek için yönlendirileceksiniz.')}</div>
              </>
            )}</> },
          { key:'tiktok', name:'TikTok Ads', desc:t('TikTok reklam kampanyalarını, reklam gruplarını ve performansı izleyin.'), icon:img('/tiktok-logo.png',26), proOnly:true,
            connected:!!cp.tiktok?.advertiserId, enabled:cp.tiktok?.enabled!==false,
            body:<>            {(cfg?.platforms as any)?.tiktok?.advertiserId ? (
              <div>
                {((cfg?.platforms as any)?.tiktok?.options||[]).length > 1 ? (
                  <>
                  <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('REKLAM HESABI')}</div>
                  <select value={(cfg?.platforms as any)?.tiktok?.advertiserId} onChange={e=>handleTiktokSelect(e.target.value)}
                    style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}>
                    {((cfg?.platforms as any)?.tiktok?.options||[]).map((o:any)=>(<option key={o.id} value={o.id}>{o.name}{o.currency?` (${o.currency})`:''}</option>))}
                  </select>
                  </>
                ) : (
                  <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>{t('Hesap')}: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.tiktok?.advertiserName}</span></div>
                )}
                <button onClick={handleTiktokDisconnect} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                  {t('Bağlantıyı Kes')}
                </button>
              </div>
            ) : (
              <>
              <button onClick={handleTiktokConnect} disabled={!activeClientId||tiktokConnecting} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:activeClientId?'pointer':'not-allowed', opacity:activeClientId?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                {tiktokConnecting?t('Yönlendiriliyor…'):t('Bağlan')}
              </button>
              {tiktokError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{tiktokError}</div>}
              <div style={{ fontSize:10, color:T.textMidAlt, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{t('TikTok for Business hesabınızla reklam hesaplarınızı yetkilendirmek için yönlendirileceksiniz.')}</div>
              </>
            )}</> },
          { key:'rtbhouse', name:'RTB House', desc:t('RTB House retargeting kampanyaları, kreatifler ve performans.'), icon:img('/rtbhouse-logo.png',28), proOnly:true,
            connected:rtbConnected, enabled:true,
            body:<>            {rtbConnected ? (
              <>
                <div style={{ fontSize:12, color:T.textMidAlt, fontFamily:'Manrope, sans-serif', marginBottom:12 }}>{rtb.email}</div>
                <button onClick={handleRtbDisconnect} disabled={rtbBusy} style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:`1px solid ${alpha(T.red,25)}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:rtbBusy?'default':'pointer', fontFamily:'Manrope, sans-serif' }}>
                  {rtbBusy?t('İşleniyor…'):t('Bağlantıyı Kes')}
                </button>
              </>
            ) : (
              <>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                  <div>
                    <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('E-POSTA')}</div>
                    <input value={rtb.email||''} onChange={e=>{const em=e.target.value;const pw=rtb.password||'';setCfg((cc:any)=>({...cc,platforms:{...cc.platforms,rtbhouse:{...cc.platforms?.rtbhouse,email:em,password:pw,token:em+':'+pw}}}));}} placeholder='panel@domain.com' type='email' style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const }}/>
                  </div>
                  <div>
                    <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('ŞİFRE')}</div>
                    <input value={rtb.password||''} onChange={e=>{const pw=e.target.value;const em=rtb.email||'';setCfg((cc:any)=>({...cc,platforms:{...cc.platforms,rtbhouse:{...cc.platforms?.rtbhouse,email:em,password:pw,token:em+':'+pw}}}));}} placeholder='••••••••' type='password' style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const }}/>
                  </div>
                </div>
                <div style={{ display:'flex', gap:8, marginTop:12 }}>
                  <button onClick={handleRtbValidate} disabled={rtbValidating} style={{ flex:1, padding:'8px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.textMidAlt, fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>
                    {rtbValidating?t('Doğrulanıyor…'):t('Bağlantıyı Doğrula')}
                  </button>
                  <button onClick={handleRtbConnect} disabled={rtbBusy} style={{ flex:1, padding:'9px 16px', borderRadius:11, border:'none', background:T.accent, color:'#fff', fontSize:13, fontWeight:700, cursor:rtbBusy?'default':'pointer', fontFamily:'Manrope, sans-serif' }}>
                    {rtbBusy?t('Bağlanıyor…'):t('Bağlan')}
                  </button>
                </div>
                {rtbValidateResult && (
                  <div style={{ marginTop:8, fontSize:11, fontFamily:'Manrope, sans-serif', color: rtbValidateResult.valid?T.greenText:T.redText }}>
                    {rtbValidateResult.valid
                      ? (lang==='en' ? `Connection verified — ${rtbValidateResult.advertisers ?? 0} advertiser(s) found.` : `Bağlantı doğrulandı — ${rtbValidateResult.advertisers ?? 0} reklamveren bulundu.`)
                      : `${rtbValidateResult.message || t('Kimlik bilgileri geçersiz.')}`}
                  </div>
                )}
                <div style={{ fontSize:10, color:T.textMidAlt, marginTop:6, fontFamily:'Manrope, sans-serif' }}>{t('RTB House panel giriş bilgilerinizi girin.')}</div>
              </>
            )}</> },
          { key:'criteo', name:'Criteo', desc:t('Criteo kampanyaları ve ürün bazlı performans.'), icon:<NavIcon id='criteo_icon' size={22}/>, proOnly:true,
            connected:!!cp.criteo?.advertiserName, enabled:cp.criteo?.enabled!==false,
            body:<>            {(cfg?.platforms as any)?.criteo?.advertiserName ? (
              <div>
                <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>Advertiser: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.criteo?.advertiserName}</span></div>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('DATASET ID')} <span style={{ fontWeight:400, textTransform:'none' as const, letterSpacing:'normal', color:T.textDim }}>{t('(kampanya yayınlamak için gerekli)')}</span></div>
                <input defaultValue={(cfg?.platforms as any)?.criteo?.datasetId||''} onChange={e=>setCriteoDatasetInput(e.target.value)} placeholder={t('Criteo panelinizdeki Dataset ID')}
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:8 }}/>
                <button onClick={handleCriteoDatasetSave} disabled={criteoDatasetSaving} style={{ width:'100%', padding:'8px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:'pointer', marginBottom:10 }}>
                  {criteoDatasetSaving?t('Kaydediliyor…'):t('Dataset ID Kaydet')}
                </button>
                <button onClick={handleCriteoDisconnect} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                  {t('Bağlantıyı Kes')}
                </button>
              </div>
            ) : (
              <>
              {!criteoAdvertisers ? (
                <>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>CLIENT ID</div>
                <input value={criteoIdInput} onChange={e=>setCriteoIdInput(e.target.value)} placeholder={t('Criteo Developer Portal → Client ID')}
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}/>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>CLIENT SECRET</div>
                <input value={criteoSecretInput} onChange={e=>setCriteoSecretInput(e.target.value)} placeholder={t('Client Secret')} type='password'
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}/>
                <button onClick={handleCriteoVerify} disabled={criteoVerifying||!criteoIdInput.trim()||!criteoSecretInput.trim()} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:(criteoIdInput.trim()&&criteoSecretInput.trim())?'pointer':'not-allowed', opacity:(criteoIdInput.trim()&&criteoSecretInput.trim())?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                  {criteoVerifying?t('Doğrulanıyor…'):t('Doğrula')}
                </button>
                {criteoError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{criteoError}</div>}
                <div style={{ fontSize:10, color:T.textMidAlt, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{t("Müşterinin kendi Criteo hesabından ürettiği Client ID / Client Secret'ı girin.")}</div>
                </>
              ) : (
                <>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('ADVERTISER SEÇ')}</div>
                <select value={criteoAdvertiserSel} onChange={e=>setCriteoAdvertiserSel(e.target.value)}
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}>
                  {criteoAdvertisers.map((a:any)=>(<option key={a.id} value={a.id}>{a.name || a.id}</option>))}
                </select>
                <button onClick={handleCriteoConnect} disabled={!activeClientId||criteoConnecting||!criteoAdvertiserSel} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:(activeClientId&&criteoAdvertiserSel)?'pointer':'not-allowed', opacity:(activeClientId&&criteoAdvertiserSel)?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                  {criteoConnecting?t('Bağlanıyor…'):t('Bağlan')}
                </button>
                {criteoError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{criteoError}</div>}
                <button onClick={()=>{setCriteoAdvertisers(null); setCriteoError('');}} style={{ width:'100%', padding:'7px 12px', marginTop:6, borderRadius:8, border:'none', background:'transparent', color:T.textMidAlt, fontSize:11, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>
                  ← {t('Kimlik bilgilerini değiştir')}
                </button>
                </>
              )}
              </>
            )}</> },
          { key:'adjust', name:'Adjust', desc:t('Mobil uygulama atıfı ve kampanya performansı.'), icon:<NavIcon id='adjust_icon' size={22}/>, proOnly:true,
            connected:!!cp.adjust?.appName, enabled:cp.adjust?.enabled!==false,
            body:<>            {(cfg?.platforms as any)?.adjust?.appName ? (
              <div>
                <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>{t('Uygulama')}: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.adjust?.appName}</span></div>
                <button onClick={handleAdjustDisconnect} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                  {t('Bağlantıyı Kes')}
                </button>
              </div>
            ) : (
              <>
              {!adjustApps ? (
                <>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('API TOKEN')}</div>
                <input value={adjustTokenInput} onChange={e=>setAdjustTokenInput(e.target.value)} placeholder='Adjust → Ayarlar → API Token' type='password'
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}/>
                <button onClick={handleAdjustVerify} disabled={adjustVerifying||!adjustTokenInput.trim()} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:adjustTokenInput.trim()?'pointer':'not-allowed', opacity:adjustTokenInput.trim()?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                  {adjustVerifying?t('Doğrulanıyor…'):t('Doğrula')}
                </button>
                {adjustError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{adjustError}</div>}
                <div style={{ fontSize:10, color:T.textMidAlt, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{t("Müşterinin kendi Adjust hesabından ürettiği API token'ı girin.")}</div>
                </>
              ) : (
                <>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('UYGULAMA SEÇ')}</div>
                <select value={adjustAppTokenSel} onChange={e=>setAdjustAppTokenSel(e.target.value)}
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}>
                  {adjustApps.map((a:any)=>(<option key={a.app_token} value={a.app_token}>{a.name || a.app_token}</option>))}
                </select>
                <button onClick={handleAdjustConnect} disabled={!activeClientId||adjustConnecting||!adjustAppTokenSel} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:(activeClientId&&adjustAppTokenSel)?'pointer':'not-allowed', opacity:(activeClientId&&adjustAppTokenSel)?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                  {adjustConnecting?t('Bağlanıyor…'):t('Bağlan')}
                </button>
                {adjustError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{adjustError}</div>}
                <button onClick={()=>{setAdjustApps(null); setAdjustError('');}} style={{ width:'100%', padding:'7px 12px', marginTop:6, borderRadius:8, border:'none', background:'transparent', color:T.textMidAlt, fontSize:11, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>
                  ← {t("Token'ı değiştir")}
                </button>
                </>
              )}
              </>
            )}</> },
          { key:'shopify', name:'Shopify', desc:t('Shopify mağazanızın siparişleri ve ürünleri.'), icon:<NavIcon id='shopify_icon' size={22}/>, proOnly:true,
            connected:!!cp.shopify?.shopDomain, enabled:cp.shopify?.enabled!==false,
            body:<>            {(cfg?.platforms as any)?.shopify?.shopDomain ? (
              <div>
                <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:8 }}>{t('Mağaza')}: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.shopify?.shopDomain}</span></div>
                <button onClick={handleShopifyDisconnect} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                  {t('Bağlantıyı Kes')}
                </button>
              </div>
            ) : (
              <>
              <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('MAĞAZA ADRESİ')}</div>
              <input value={shopifyShopInput} onChange={e=>setShopifyShopInput(e.target.value)} placeholder='magazam.myshopify.com'
                style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}/>
              <button onClick={handleShopifyConnect} disabled={!activeClientId||shopifyConnecting||!shopifyShopInput.trim()} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:(activeClientId&&shopifyShopInput.trim())?'pointer':'not-allowed', opacity:(activeClientId&&shopifyShopInput.trim())?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                {shopifyConnecting?t('Yönlendiriliyor…'):t('Bağlan')}
              </button>
              {shopifyError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{shopifyError}</div>}
              <div style={{ fontSize:10, color:T.textMidAlt, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{t("Mağazanızın Shopify adresini girin, Shopify'ın kendi onay ekranına yönlendirileceksiniz.")}</div>
              </>
            )}</> },
          { key:'pixa', name:'Pixa', desc:t('Pazaryeri siparişleri, stok, iade ve kargo verileri (Pixa).'), icon:<NavIcon id='pixa_icon' size={22}/>, proOnly:true,
            connected:!!cp.pixa?.host, enabled:cp.pixa?.enabled!==false,
            body:<>            {(cfg?.platforms as any)?.pixa?.host ? (
              <div>
                <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:4 }}>{t('Sunucu')}: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.pixa?.host}</span></div>
                {(cfg?.platforms as any)?.pixa?.userName && <div style={{ fontSize:11, color:T.textMidAlt, marginBottom:8 }}>{t('Hesap')}: <span style={{ fontFamily:MONO }}>{(cfg?.platforms as any)?.pixa?.userName}</span></div>}
                <button onClick={handlePixaDisconnect} style={{ width:'100%', padding:'9px 12px', borderRadius:9, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                  {t('Bağlantıyı Kes')}
                </button>
              </div>
            ) : (
              <>
              {!pixaVerified ? (
                <>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('API ADRESİ')}</div>
                <input value={pixaHostInput} onChange={e=>setPixaHostInput(e.target.value)} placeholder='p3605.pixasoftwebservices.com'
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:8 }}/>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('E-POSTA')}</div>
                <input value={pixaEmailInput} onChange={e=>setPixaEmailInput(e.target.value)} placeholder='kullanici@firma.com' type='email'
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:8 }}/>
                <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('API TOKEN')}</div>
                <input value={pixaTokenInput} onChange={e=>setPixaTokenInput(e.target.value)} placeholder='Pixa → Hesabım → API Token' type='password'
                  style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const, marginBottom:10 }}/>
                <button onClick={handlePixaVerify} disabled={pixaVerifying||!pixaHostInput.trim()||!pixaEmailInput.trim()||!pixaTokenInput.trim()} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:(pixaHostInput.trim()&&pixaEmailInput.trim()&&pixaTokenInput.trim())?'pointer':'not-allowed', opacity:(pixaHostInput.trim()&&pixaEmailInput.trim()&&pixaTokenInput.trim())?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                  {pixaVerifying?t('Doğrulanıyor…'):t('Doğrula')}
                </button>
                {pixaError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{pixaError}</div>}
                <div style={{ fontSize:10, color:T.textMidAlt, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{t("Müşterinin Pixa panelindeki Hesabım sayfasından alınan API adresi ve token'ı girin.")}</div>
                </>
              ) : (
                <>
                <div style={{ fontSize:11, color:T.greenText, fontWeight:600, marginBottom:4 }}>{t('Doğrulandı')}: <span style={{ fontFamily:MONO }}>{pixaVerified.user_name}</span></div>
                <div style={{ fontSize:10, color:T.textMidAlt, marginBottom:10, fontFamily:MONO }}>{pixaVerified.host}</div>
                <button onClick={handlePixaConnect} disabled={!activeClientId||pixaConnecting} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:700, cursor:activeClientId?'pointer':'not-allowed', opacity:activeClientId?1:0.5, fontFamily:'Manrope, sans-serif' }}>
                  {pixaConnecting?t('Bağlanıyor…'):t('Bağlan')}
                </button>
                {pixaError && <div style={{ fontSize:11, color:T.redText, marginTop:8, fontFamily:'Manrope, sans-serif' }}>{pixaError}</div>}
                <button onClick={()=>{setPixaVerified(null); setPixaError('');}} style={{ width:'100%', padding:'7px 12px', marginTop:6, borderRadius:8, border:'none', background:'transparent', color:T.textMidAlt, fontSize:11, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>
                  ← {t('Bilgileri değiştir')}
                </button>
                </>
              )}
              </>
            )}</> },
          { key:'ikas', name:'ikas', desc:t('ikas mağazanızın ürünleri ve siparişleri.'), icon:img('/ikas-icon.png',22,{borderRadius:5}), proOnly:true,
            connected:ikasOn, enabled:true,
            body:<IkasIntegrationCard clientId={activeClientId || 1} embedded onStatus={setIkasOn} /> },
          { key:'jira', name:'Jira', desc:t('Asistan, Jira görevlerini salt okunur okuyup yorumlayabilir.'), icon:img('/jira-icon.svg',22), proOnly:true,
            connected:jiraOn, enabled:true,
            body:<JiraIntegrationCard clientId={activeClientId || 1} embedded onStatus={setJiraOn} /> },
        ];
        return <IntegrationsList items={items} ent={ent}/>;
      })()}

      {/* Profil */}
      {activeTab==='profile' && (
      <div style={{ display:'flex', flexDirection:'column' as const, gap:16 }}>
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px 24px', position:'relative' as const }}>
          {profilePlanName && (
            <div style={{ position:'absolute' as const, top:20, right:22, padding:'5px 12px', borderRadius:999, background:T.amberTint, border:`1px solid ${alpha(T.amber,35)}`, color:T.amberDeepText, fontSize:10.5, fontWeight:700, fontFamily:'Manrope, sans-serif' }}>
              {profilePlanName}
            </div>
          )}
          <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.15em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:4 }}>{t('Hesap')}</div>
          <div style={{ fontSize:20, fontWeight:700, color:T.text, fontFamily:'Manrope, sans-serif', marginBottom:24 }}>{t('Profil Bilgileri')}</div>

          <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:24 }}>
            <div style={{ width:64, height:64, borderRadius:'50%', border:`2px solid ${T.borderMid}`, overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', background:T.subtleBg, flexShrink:0 }}>
              {profileForm.photo
                ? <img src={profileForm.photo} alt="profil" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                : <span style={{ fontSize:22, color:T.accent, fontWeight:700, fontFamily:'Manrope, sans-serif' }}>{`${profileForm.name?.[0]||''}${profileForm.surname?.[0]||''}`.toUpperCase()||'PD'}</span>
              }
            </div>
            <div>
              <label style={{ display:'inline-block', padding:'8px 16px', borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.subtleBg, color:T.text, fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>
                {t('Fotoğraf Yükle')}
                <input type="file" accept="image/*" onChange={handlePhotoUpload} style={{ display:'none' }}/>
              </label>
              <div style={{ fontSize:10, color:T.textMidAlt, marginTop:6, fontFamily:'Manrope, sans-serif' }}>{t('PNG/JPG, maks. 500KB')}</div>
            </div>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:16, marginBottom:16 }}>
            <div>
              <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('Ad')}</div>
              <input value={profileForm.name} onChange={e=>setProfileForm(f=>({...f,name:e.target.value}))} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const }}/>
            </div>
            <div>
              <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('Soyad')}</div>
              <input value={profileForm.surname} onChange={e=>setProfileForm(f=>({...f,surname:e.target.value}))} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const }}/>
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:16, marginBottom:16 }}>
            <div>
              <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('Ünvan')}</div>
              <input value={profileForm.title} onChange={e=>setProfileForm(f=>({...f,title:e.target.value}))} placeholder={t('Örn. Pazarlama Müdürü')} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const }}/>
            </div>
            <div>
              <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('E-posta')}</div>
              <input value={config?.profile?.email||''} disabled style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.trackBg, outline:'none', color:T.textMidAlt, boxSizing:'border-box' as const }}/>
            </div>
          </div>

          {profileError && <div style={{ fontSize:12, color:T.redText, padding:'10px 14px', background:T.redTint, borderRadius:8, border:`1px solid ${T.redTint}`, fontFamily:'Manrope, sans-serif', marginBottom:16 }}>{profileError}</div>}

          <div style={{ display:'flex', justifyContent:'flex-end' }}>
            <button onClick={handleProfileSave} disabled={profileSaving}
              style={{ padding:'12px 28px', borderRadius:10, border:'none', background: profileSaved?T.greenText:T.accent, color: profileSaved?'#fff':T.accentInk, fontSize:12, fontWeight:800, cursor:'pointer', textTransform:'uppercase' as const, letterSpacing:'0.08em', minWidth:180, transition:'background .2s' }}>
              {profileSaving?t('Kaydediliyor...'):profileSaved?t('Kaydedildi'):t('Profili Kaydet')}
            </button>
          </div>
        </div>

        {myCompany && (
        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px 24px' }}>
          <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.15em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:4 }}>{t('Şirket')}</div>
          <div style={{ fontSize:20, fontWeight:700, color:T.text, fontFamily:'Manrope, sans-serif', marginBottom:24 }}>{t('Şirket Bilgileri')}</div>
          <div style={{ marginBottom: myUserRole==='client' ? 16 : 0 }}>
            <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('Şirket Adı')}</div>
            <input value={companyNameDraft} disabled={myUserRole!=='client'} onChange={e=>setCompanyNameDraft(e.target.value)}
              style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background: myUserRole==='client'?T.subtleBg:T.trackBg, outline:'none', color: myUserRole==='client'?T.text:T.textMidAlt, boxSizing:'border-box' as const }}/>
            {myUserRole!=='client' && <div style={{ fontSize:10, color:T.textMidAlt, marginTop:6, fontFamily:'Manrope, sans-serif' }}>{t('Şirket adını yalnızca şirket sahibi (Client) değiştirebilir.')}</div>}
          </div>

          {myUserRole==='client' && <>
            {companyError && <div style={{ fontSize:12, color:T.redText, padding:'10px 14px', background:T.redTint, borderRadius:8, border:`1px solid ${T.redTint}`, fontFamily:'Manrope, sans-serif', marginBottom:16 }}>{companyError}</div>}
            <div style={{ display:'flex', justifyContent:'flex-end' }}>
              <button onClick={handleCompanyNameSave} disabled={companySaving}
                style={{ padding:'12px 28px', borderRadius:10, border:'none', background: companySaved?T.greenText:T.accent, color: companySaved?'#fff':T.accentInk, fontSize:12, fontWeight:800, cursor:'pointer', textTransform:'uppercase' as const, letterSpacing:'0.08em', minWidth:180, transition:'background .2s' }}>
                {companySaving?t('Kaydediliyor...'):companySaved?t('Kaydedildi'):t('Şirketi Kaydet')}
              </button>
            </div>
          </>}
        </div>
        )}

        <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px 24px' }}>
          <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.15em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:4 }}>{t('Güvenlik')}</div>
          <div style={{ fontSize:20, fontWeight:700, color:T.text, fontFamily:'Manrope, sans-serif', marginBottom:24 }}>{t('Şifre Değiştir')}</div>
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:16, marginBottom:16 }}>
            <div>
              <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('Yeni Şifre')}</div>
              <input type="password" autoComplete="new-password" value={newPassword} onChange={e=>setNewPassword(e.target.value)} placeholder={t('En az 10 karakter')} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const }}/>
            </div>
            <div>
              <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:6 }}>{t('Şifre Tekrar')}</div>
              <input type="password" autoComplete="new-password" value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)} placeholder={t('Şifreni tekrar gir')} style={{ width:'100%', padding:'9px 12px', borderRadius:8, border:`1px solid ${T.borderMid}`, fontSize:12, fontFamily:'Manrope, sans-serif', background:T.subtleBg, outline:'none', color:T.text, boxSizing:'border-box' as const }}/>
            </div>
          </div>

          {passwordError && <div style={{ fontSize:12, color:T.redText, padding:'10px 14px', background:T.redTint, borderRadius:8, border:`1px solid ${T.redTint}`, fontFamily:'Manrope, sans-serif', marginBottom:16 }}>{passwordError}</div>}

          <div style={{ display:'flex', justifyContent:'flex-end' }}>
            <button onClick={handlePasswordChange} disabled={passwordSaving}
              style={{ padding:'12px 28px', borderRadius:10, border:'none', background: passwordSaved?T.greenText:T.accent, color: passwordSaved?'#fff':T.accentInk, fontSize:12, fontWeight:800, cursor:'pointer', textTransform:'uppercase' as const, letterSpacing:'0.08em', minWidth:180, transition:'background .2s' }}>
              {passwordSaving?t('Güncelleniyor...'):passwordSaved?t('Güncellendi'):t('Şifreyi Güncelle')}
            </button>
          </div>
        </div>
        <TwoFactorCard/>
        <DangerZoneCard workspace={(()=>{ const w=(myClients||[]).find((c:any)=>c.id===activeClientId)||myCompany; return w?{id:w.id,name:w.name}:null; })()}/>
      </div>
      )}

      {/* Bildirim Ayarlari */}
      {activeTab==='notifications' && (
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px 24px' }}>
        <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.15em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:4 }}>{t('Tercihler')}</div>
        <div style={{ fontSize:20, fontWeight:700, color:T.text, fontFamily:'Manrope, sans-serif', marginBottom:24 }}>{t('Bildirim Ayarları')}</div>

        <div style={{ display:'flex', flexDirection:'column' as const, gap:0 }}>
          {[
            { key:'pending_approvals', label:t('Bekleyen Onaylar'),         sub:t('Onay bekleyen kampanya değişiklikleri ve otomasyon şablonları için e-posta bildirimi al.'), default:true },
            { key:'daily_reports',     label:t('Günlük Raporlar'),           sub:t('Performans özetlerini içeren günlük analiz raporlarını al.'),       default:true },
            { key:'auto_rules',        label:t('Otomatik Uygulama Kuralları'),sub:t('Yapay zeka tarafından uygulanan kural bildirimlerini al.'),        default:false },
          ].map((item,i)=>(
            <div key={item.key} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'18px 0', borderBottom: i<2?`1px solid ${T.border}`:'none' }}>
              <div>
                <div style={{ fontSize:14, fontWeight:600, color:T.text, fontFamily:'Manrope, sans-serif', marginBottom:4 }}>{item.label}</div>
                <div style={{ fontSize:12, color:T.textMidAlt, fontFamily:'Manrope, sans-serif' }}>{item.sub}</div>
              </div>
              <Toggle
                value={prefs[item.key]??item.default}
                onChange={v=>setPrefs((p:any)=>({...p,[item.key]:v}))}/>
            </div>
          ))}
        </div>


      </div>
      )}

      {/* Geliştirici / MCP API Anahtarları */}
      {activeTab==='memory' && <BrandMemoryPanel clientId={activeClientId || 1} />}

      {activeTab==='developer' && (
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'22px 24px' }}>
        <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.15em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif', marginBottom:4 }}>{t('Geliştirici')}</div>
        <div style={{ fontSize:20, fontWeight:700, color:T.text, fontFamily:'Manrope, sans-serif', marginBottom:8 }}>{t('API Anahtarları (MCP)')}</div>
        <div style={{ fontSize:12.5, color:T.textMidAlt, fontFamily:'Manrope, sans-serif', lineHeight:1.6, marginBottom:20, maxWidth:640 }}>
          {t("Bu anahtarlarla Claude Desktop, Claude Code veya claude.ai gibi bir MCP istemcisini Poyais One'a bağlayabilirsiniz. Bağlantı salt-okunurdur, sadece erişiminiz olan müşterilerin raporlama verilerini okuyabilir; kampanya yayınlama, görev/not oluşturma gibi hiçbir yazma işlemi yapılamaz.")}
        </div>

        {newTokenResult && (
          <div style={{ border:`1px solid ${T.accent}`, background:alpha(T.accent,8), borderRadius:12, padding:'16px 18px', marginBottom:20 }}>
            <div style={{ fontSize:12.5, fontWeight:700, color:T.amberDeepText, marginBottom:8 }}>
              {lang==='en'
                ? `The "${newTokenResult.name}" key has been created. You won't be able to see it again, copy it now.`
                : `"${newTokenResult.name}" anahtarı oluşturuldu. Bu anahtarı bir daha göremeyeceksiniz, şimdi kopyalayın.`}
            </div>
            <div style={{ display:'flex', gap:8, alignItems:'center' }}>
              <div style={{ flex:1, fontFamily:MONO, fontSize:12, background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, padding:'9px 12px', overflowX:'auto' as const, whiteSpace:'nowrap' as const }}>
                {newTokenResult.token}
              </div>
              <button onClick={()=>{ navigator.clipboard.writeText(newTokenResult.token); setTokenCopied(true); setTimeout(()=>setTokenCopied(false),2000); }}
                style={{ padding:'9px 16px', borderRadius:11, border:'none', background:T.accent, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', whiteSpace:'nowrap' as const }}>
                {tokenCopied?t('Kopyalandı'):t('Kopyala')}
              </button>
            </div>
            <div style={{ fontSize:11.5, color:T.textMidAlt, marginTop:12, lineHeight:1.6 }}>
              {t('Bağlantı adresi')}: <span style={{ fontFamily:MONO }}>https://app.poyaisone.com/mcp/</span><br/>
              {t('Claude Desktop için')} <span style={{ fontFamily:MONO }}>claude_desktop_config.json</span> {t('içine')}:
              <pre style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, padding:'10px 12px', marginTop:6, fontSize:11, overflowX:'auto' as const }}>{`{
  "mcpServers": {
    "poyais-one": {
      "url": "https://app.poyaisone.com/mcp/",
      "headers": { "Authorization": "Bearer ${newTokenResult.token}" }
    }
  }
}`}</pre>
              {t('claude.ai\'da "custom connector" eklerken de aynı adresi ve Authorization başlığını kullanabilirsiniz.')}
            </div>
            <button onClick={()=>setNewTokenResult(null)} style={{ marginTop:10, padding:'6px 12px', borderRadius:7, border:`1px solid ${T.border}`, background:T.surface, color:T.textMidAlt, fontSize:11.5, fontWeight:600, cursor:'pointer' }}>
              {t('Kapat')}
            </button>
          </div>
        )}

        <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' as const }}>
          <input value={newTokenName} onChange={e=>setNewTokenName(e.target.value)} placeholder={t('Anahtar adı (ör. Claude Desktop)')}
            style={{ flex:'1 1 200px', minWidth:0, padding:'10px 12px', borderRadius:9, border:`1px solid ${T.borderMid}`, fontSize:13, fontFamily:'Manrope, sans-serif', outline:'none' }}/>
          <button onClick={createApiToken} disabled={newTokenCreating}
            style={{ padding:'10px 18px', borderRadius:9, border:'none', background:T.ink, color:'#fff', fontSize:12.5, fontWeight:700, cursor:'pointer', whiteSpace:'nowrap' as const }}>
            {newTokenCreating?t('Oluşturuluyor...'):t('Yeni Anahtar Oluştur')}
          </button>
        </div>

        {apiTokens.length===0 ? (
          <div style={{ fontSize:12.5, color:T.textDimAlt, fontFamily:'Manrope, sans-serif' }}>{t('Henüz bir API anahtarınız yok.')}</div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column' as const, gap:0 }}>
            {apiTokens.map((tok:any, i:number)=>(
              <div key={tok.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 0', borderBottom: i<apiTokens.length-1?`1px solid ${T.border}`:'none' }}>
                <div>
                  <div style={{ fontSize:13.5, fontWeight:600, color:T.text, fontFamily:'Manrope, sans-serif', marginBottom:3 }}>
                    {tok.name} {tok.revoked_at && <span style={{ fontSize:10, fontWeight:700, color:T.redText, marginLeft:6 }}>{t('İPTAL EDİLDİ')}</span>}
                  </div>
                  <div style={{ fontSize:11.5, color:T.textDimAlt, fontFamily:MONO }}>
                    {tok.token_prefix}… · {t('oluşturuldu')} {tok.created_at} {tok.last_used_at && `· ${t('son kullanım')} ${tok.last_used_at}`}
                  </div>
                </div>
                {!tok.revoked_at && (
                  <button onClick={()=>revokeApiToken(tok.id)}
                    style={{ padding:'7px 14px', borderRadius:8, border:`1px solid ${T.redTint}`, background:T.redTint, color:T.redText, fontSize:11.5, fontWeight:700, cursor:'pointer', whiteSpace:'nowrap' as const, flexShrink:0 }}>
                    {t('İptal Et')}
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      )}

      {/* Footer */}
      {activeTab!=='profile' && activeTab!=='developer' && (
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', paddingTop:8 }}>
        <div style={{ fontSize:11, color:T.textMidAlt, fontFamily:'Manrope, sans-serif' }}>{t('Bazı ayarların geçerli olması için tarayıcınızı yenilemeniz gerekebilir.')}</div>
        <button onClick={handleSave} disabled={saving}
          style={{ padding:'12px 28px', borderRadius:10, border:'none', background: saved?T.greenText:T.accent, color: saved?'#fff':T.accentInk, fontSize:12, fontWeight:800, cursor:'pointer', textTransform:'uppercase' as const, letterSpacing:'0.08em', minWidth:180, transition:'background .2s' }}>
          {saving?t('Kaydediliyor...'):saved?t('Kaydedildi'):t('Ayarları Kaydet')}
        </button>
      </div>
      )}

    </div>
  );
}
function SettingsMenu({ active, go, collapsed }: { active: string; go: (id: string) => void; collapsed?: boolean }) {
  const { t } = useLang();
  const T = SidebarT;
  const [open, setOpen] = React.useState(
    active === 'settings' || active === 'destek'
  );
  const GOLD = T.accent;
  const items = [
    { id: 'settings',    label: 'Genel Ayarlar', icon: 'tune' },
    { id: 'destek',      label: 'Destek',         icon: 'help_outline' },
  ];
  const isAnyActive = items.some(i => i.id === active);
  if (collapsed) {
    return (
      <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
        {items.map(item => (
          <button key={item.id} onClick={() => go(item.id)}
            style={{ display:'flex', alignItems:'center', justifyContent:'center', width:'calc(100% - 0px)', padding:'8px', borderRadius:8, cursor:'pointer', background: active===item.id ? alpha(GOLD,9) : 'transparent', border:'none', color: active===item.id ? GOLD : T.textDim, transition:'all .15s' }}>
            <span style={{ display:'flex' }}><NavIcon id={item.icon} size={17}/></span>
          </button>
        ))}
      </div>
    );
  }
  return (
    <div>
      <button
        onClick={() => { setOpen(v => !v); if (!open) go('settings'); }}
        style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '8px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily:'Manrope, sans-serif', color: isAnyActive ? GOLD : T.textMid, background: isAnyActive ? alpha(GOLD,9) : 'transparent', border: 'none', textAlign: 'left' as const, transition: 'all .15s' }}>
        <span style={{ color: isAnyActive ? GOLD : T.textDim, display:'flex' }}><NavIcon id="settings" size={17}/></span>
        <span style={{ flex: 1 }}>{t('Ayarlar')}</span>
        <span style={{ fontSize: 10, color: T.textDim, display: 'inline-block', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>▾</span>
      </button>
      {open && (
        <div style={{ paddingLeft: 14, marginTop: 2 }}>
          {items.map(item => (
            <button key={item.id} onClick={() => go(item.id)}
              style={{ display: 'flex', alignItems: 'center', gap: 8, width: 'calc(100% - 4px)', padding: '7px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: active===item.id ? 600 : 400, fontFamily:'Manrope, sans-serif', marginBottom: 1, color: active === item.id ? GOLD : T.textMid, background: active === item.id ? alpha(GOLD,8) : 'transparent', border: 'none', textAlign: 'left' as const, transition: 'all .15s' }}>
              <span style={{ color: active === item.id ? GOLD : T.textDim, display:'flex' }}><NavIcon id={item.icon} size={15}/></span>
              {t(item.label)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function NavIcon({ id, size=17 }:{ id:string; size?:number }) {
  const icons:Record<string,string> = {
    dashboard:    'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',
    insights:     'M3 3v18h18M7 16l4-4 4 4 5-5',
    ads_click:    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z',
    campaign:     'M3 11l19-9-9 19-2-8-8-2z',
    compare_arrows: 'M3 8h14M13 4l4 4-4 4M21 16H7M11 12l-4 4 4 4',
    storefront:   'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2zM9 22V12h6v10',
    auto_awesome: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
    palette:      'M12 3a9 9 0 000 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3-4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z',
    image_search: 'M4 11a9 9 0 019 9M4 4a16 16 0 0116 16M5 19a1 1 0 110-2 1 1 0 010 2z',
    calculate:    'M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zM9 17H7v-2h2v2zm0-4H7v-2h2v2zm0-4H7V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2zm4 8h-2v-6h2v6zm0-8h-2V7h2v2z',
    summarize:    'M4 6h16M4 10h16M4 14h10M4 18h7',
    settings:     'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z',
    admin_panel_settings: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
    tune:         'M4 6h16M4 12h10M4 18h4M15 12a3 3 0 106 0 3 3 0 00-6 0M7 18a3 3 0 106 0 3 3 0 00-6 0',
    toll:         'M17 12a5 5 0 100-10 5 5 0 000 10zM1 12h10M1 6h4M1 18h4',
    help_outline: 'M12 22a10 10 0 100-20 10 10 0 000 20zM9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01',
    people:       'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75',
    business:     'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2zM9 22V12h6v10',
    chat:         'M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z',
    layout_grid:  'M3 3h8v8H3zM13 3h8v6h-8zM13 11h8v10h-8zM3 13h8v8H3z',
    checklist:    'M9 6h11M9 12h11M9 18h11M4 6l1.2 1.2L7.5 5M4 12l1.2 1.2 2.3-2.2M4 18l1.2 1.2 2.3-2.2',
    notes:        'M6 3h9l5 5v13H6zM14 3v6h6M9 13h6M9 17h6',
    payments:     'M3 6a2 2 0 012-2h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2zM3 10h18M7 15h4',
    bell:         'M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0',
    geo_visibility: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17a5 5 0 110-10 5 5 0 010 10zm0-8a3 3 0 100 6 3 3 0 000-6z',
    bolt: 'M13 2 3 14h9l-1 8 10-12h-9l1-8z',
    trending_up: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z',
  };
  // Google Ads için özel SVG
  if (id === 'rtbhouse_icon') return (
    <img src='/rtbhouse-logo.png' width={size} height={size} style={{objectFit:'contain'}} alt='RTB House'/>
  );
  if (id === 'ads_click') return (
    <img src="/google-ads-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="Google Ads"/>
  );
  if (id === 'campaign') return (
    <img src="/meta-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="Meta"/>
  );
  if (id === 'tiktok_icon') return (
    <img src="/tiktok-logo.png" width={size} height={size} style={{objectFit:'contain'}} alt="TikTok"/>
  );
  if (id === 'chatgpt_icon') return (
    <img src="/chatgpt-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="ChatGPT"/>
  );
  if (id === 'adjust_icon') return (
    <img src="/adjust-icon.png" width={size} height={size} style={{objectFit:'contain', borderRadius:'50%'}} alt="Adjust"/>
  );
  if (id === 'criteo_icon') return (
    <img src="/criteo-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="Criteo"/>
  );
  if (id === 'shopify_icon') return (
    <img src="/shopify-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="Shopify"/>
  );
  if (id === 'ikas_icon') return (
    <img src="/ikas-icon.png" width={size} height={size} style={{objectFit:'contain', borderRadius:Math.round(size*0.22)}} alt="ikas"/>
  );
  if (id === 'pixa_icon') return (
    <img src="/pixa-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="Pixa"/>
  );
  if (id === 'search') return (
    <img src="/search-console-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="Search Console"/>
  );
  if (id === 'x_icon') return (
    <img src="/x-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="X"/>
  );
  if (id === 'insights') return (
    <img src="/google-analytics-icon.png" width={size} height={size} style={{objectFit:'contain'}} alt="Analytics"/>
  );
  const d = icons[id] || icons.dashboard;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d={d}/>
    </svg>
  );
}

function ProductTour({ onClose }: { onClose: () => void }) {
  const { t } = useLang();
  const T = SidebarT;
  const steps = [
    { key:'tour-dashboard',  title:t('Ana Sayfa'), desc:t('Tüm platformlarının performans özetini, kampanya sonuçlarını ve bekleyen görevlerini burada tek bakışta görürsün.') },
    { key:'tour-asistan',    title:t('AI Asistan'), desc:t('Verilerin hakkında soru sor, haftalık özet iste, önerileri sohbet ederek al.') },
    { key:'tour-panolar',    title:t('Panolar, Görevler & Notlar'), desc:t('Ekibinle panolar oluştur, görevleri sürükle-bırak Kanban ile yönet, notlarını paylaş.') },
    { key:'tour-uyari',      title:t('Uyarılar'), desc:t('İstediğin metrik için (harcama, ROAS, CTR vb.) kendi eşiğini belirle — aşıldığında burada anında görürsün.') },
    { key:'tour-ga4',        title:t('Analytics & Reklamlar'), desc:t('GA4, Google Ads ve Meta Ads verilerini buradan incele.') },
    { key:'tour-poyaisone',  title:t('Poyais One'), desc:t('Optimizasyon önerileri, otomasyon şablonları, akış oluşturucu ve kampanya oluşturucu burada.') },
  ];
  const [step, setStep] = React.useState(0);
  const [rect, setRect] = React.useState<any>(null);

  React.useEffect(() => {
    const update = () => {
      const el = document.querySelector(`[data-tour="${steps[step].key}"]`);
      if (el) setRect(el.getBoundingClientRect());
    };
    update();
    window.addEventListener('resize', update);
    const iv = setInterval(update, 250);
    return () => { window.removeEventListener('resize', update); clearInterval(iv); };
  }, [step]);

  const finish = () => { localStorage.setItem('poyais_seen_tour','1'); onClose(); };

  if (!rect) return null;
  const s = steps[step];
  const tooltipLeft = rect.right + 16;
  const maxTop = typeof window!=='undefined' ? window.innerHeight - 170 : 400;
  const tooltipTop = Math.min(Math.max(16, rect.top - 8), maxTop);

  return (
    <div style={{ position:'fixed', inset:0, zIndex:10000, pointerEvents:'none' }}>
      <div style={{
        position:'fixed', top:rect.top-6, left:rect.left-6, width:rect.width+12, height:rect.height+12,
        borderRadius:12, boxShadow:'0 0 0 9999px rgba(0,0,0,0.55)', border:`2px solid ${T.accent}`,
        transition:'all 0.25s ease', pointerEvents:'none',
      }}/>
      <div style={{
        position:'fixed', top:tooltipTop, left:tooltipLeft, maxWidth:260,
        background:T.ink, borderRadius:12, padding:'16px 18px', boxShadow:'0 12px 32px rgba(0,0,0,.3)',
        color:'#fff', fontFamily:'Manrope, sans-serif', pointerEvents:'auto',
      }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 }}>
          <div style={{ fontSize:9, fontWeight:700, color:T.accent, letterSpacing:'0.1em' }}>{step+1}/{steps.length}</div>
          <button onClick={finish} style={{ background:'none', border:'none', cursor:'pointer', color:T.textDimAlt, fontSize:14, lineHeight:1, padding:0 }}>✕</button>
        </div>
        <div style={{ fontSize:14, fontWeight:700, marginBottom:6 }}>{s.title}</div>
        <div style={{ fontSize:12, color:'rgba(255,255,255,.7)', lineHeight:1.6, marginBottom:14 }}>{s.desc}</div>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <button onClick={finish} style={{ background:'none', border:'none', color:T.textDimAlt, fontSize:11, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>{t('Atla')}</button>
          <button onClick={()=> step < steps.length-1 ? setStep(step+1) : finish()} style={{ background:T.accent, color:'#fff', border:'none', borderRadius:11, padding:'9px 16px', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>
            {step < steps.length-1 ? t('İleri →') : t('Anladım')}
          </button>
        </div>
      </div>
    </div>
  );
}

function Sidebar({ active, setActive, collapsed: collapsedProp, userInitials, userName, config, onSave, clients, activeClient, onClientChange }:{ active:string; setActive:(v:string)=>void; collapsed?:boolean; userInitials?:string; userName?:string; config?:any; onSave?:(c:any)=>void; clients?:any[]; activeClient?:any; onClientChange?:(c:any)=>void }) {
  const { t } = useLang();
  const [workspaceOpen, setWorkspaceOpen] = React.useState(false);
  const [adminExp, setAdminExp] = React.useState(active.startsWith('admin'));
  // "Ekibini davet et" kartı çarpıyla kapatılınca 7 gün gösterilmez (tarayıcı başına).
  const INVITE_HIDE_KEY = 'poyais_invite_card_hidden_until';
  const [inviteHidden, setInviteHidden] = React.useState(() => {
    try { return Date.now() < Number(localStorage.getItem(INVITE_HIDE_KEY) || 0); } catch { return false; }
  });
  const hideInvite = () => {
    try { localStorage.setItem(INVITE_HIDE_KEY, String(Date.now() + 7 * 24 * 60 * 60 * 1000)); } catch { /* depolama kapalıysa yalnızca bu oturumda gizlenir */ }
    setInviteHidden(true);
  };
  const { theme: sbTheme } = useTheme();
  const [exp, setExp] = React.useState<Record<string,boolean>>({
    ga4:   active.startsWith('ga4'),
    gads:  active.startsWith('gads'),
    meta:  active.startsWith('meta'),
    pixa:  active.startsWith('pixa'),
    poyaisone: active.startsWith('poyaisone'),
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const collapsed = collapsedProp !== undefined ? collapsedProp : false;

  const navScrollRef = React.useRef<HTMLDivElement>(null);
  const savedScrollTop = React.useRef(0);
  React.useLayoutEffect(() => {
    if (navScrollRef.current) navScrollRef.current.scrollTop = savedScrollTop.current;
  }, [collapsed]);

  const NAV = [
    { id:'dashboard',      label:'Ana Sayfa',  icon:'dashboard' },
    { id:'asistan',        label:'Asistan',    icon:'chat' },
    { id:'panolar',        label:'Panolar',    icon:'layout_grid' },
    { id:'gorevler',       label:'Görevler',   icon:'checklist' },
    { id:'uyari',          label:'Uyarılar',   icon:'bell' },

    { id:'gads', label:'Google Ads', icon:'ads_click', section:'Reklam Yönetimi', children:[
      { id:'gads-overview',    label:'Genel Bakış'      },
      { id:'gads-campaigns',   label:'Kampanyalar'      },
      { id:'gads-searchterms', label:'Arama Terimleri'  },
      { id:'gads-adtexts',     label:'Reklam Metinleri' },
      { id:'gads-audience',    label:'Kitle'            },
      { id:'gads-placements',  label:'Yerleşimler'      },
      { id:'gads-dayparting',  label:'Gün / Saat'       },
      { id:'gads-health',      label:'Hesap Sağlığı'    },
    ]},
    { id:'meta', label:'Meta Ads', icon:'campaign', children:[
      { id:'meta-overview',   label:'Genel Bakış'        },
      { id:'meta-campaigns',  label:'Kampanyalar'        },
      { id:'meta-adsets',     label:'Reklam Setleri'     },
      { id:'meta-creatives',  label:'Kreatifler'         },
      { id:'meta-audience',   label:'Kitle'              },
      { id:'meta-placements', label:'Yerleşimler'        },
      { id:'meta-hourly',     label:'Gün / Saat'         },
      { id:'meta-health',     label:'Hesap Sağlığı'      },
    ]},
    { id:'ads-compare', label:'Platform Karşılaştırma', icon:'compare_arrows' },
    { id:'chatgpt-ads', label:'ChatGPT Ads', icon:'chatgpt_icon', gated:true, children:[
      { id:'chatgpt-ads-overview',  label:'Genel Bakış'  },
      { id:'chatgpt-ads-campaigns', label:'Kampanyalar'  },
    ]},
    { id:'x-ads', label:'X Ads', icon:'x_icon', gated:true, children:[
      { id:'x-ads-overview',  label:'Genel Bakış' },
      { id:'x-ads-campaigns', label:'Kampanyalar' },
    ]},
    { id:'tiktok', label:'TikTok Ads', icon:'tiktok_icon', gated:true, children:[
      { id:'tiktok-overview',  label:'Genel Bakış'     },
      { id:'tiktok-campaigns', label:'Kampanyalar'     },
      { id:'tiktok-adgroups',  label:'Reklam Grupları' },
    ]},
    { id:'criteo', label:'Criteo', icon:'criteo_icon', gated:true, children:[
      { id:'criteo-overview',  label:'Genel Bakış' },
      { id:'criteo-campaigns', label:'Kampanyalar' },
    ]},
    { id:'rtbhouse', label:'RTB House', icon:'rtbhouse_icon', gated:true, children:[
      { id:'rtbhouse-overview',  label:'Genel Bakış' },
      { id:'rtbhouse-campaigns', label:'Kampanyalar' },
      { id:'rtbhouse-creatives', label:'Bannerlar'   },
    ]},

    { id:'ga4', label:'Analytics', icon:'insights', section:'Veri & Analitik', children:[
      { id:'ga4-overview',  label:'Genel Bakış'    },
      { id:'ga4-audience',  label:'Audience'       },
      { id:'ga4-funnel',    label:'Funnel'         },
      { id:'ga4-pages',     label:'Sayfa Performansı' },
      { id:'ga4-products',  label:'Ürün Analizi'   },
      { id:'ga4-traffic',   label:'Trafik Kaynağı' },
    ]},
    { id:'adjust', label:'Adjust', icon:'adjust_icon', section:'Veri & Analitik', gated:true, children:[
      { id:'adjust-overview',  label:'Genel Bakış' },
      { id:'adjust-campaigns', label:'Kampanyalar'  },
    ]},
    { id:'shopify', label:'Shopify', icon:'shopify_icon', section:'Veri & Analitik', gated:true, children:[
      { id:'shopify-overview', label:'Genel Bakış' },
      { id:'shopify-sales',    label:'Satışlar' },
      { id:'shopify-orders',   label:'Siparişler'   },
      { id:'shopify-products', label:'Ürünler'      },
      { id:'shopify-returns',  label:'İadeler ve İptaller' },
      { id:'shopify-sources',  label:'Trafik Kaynakları' },
      { id:'shopify-ads',      label:'Reklam Performansı' },
    ]},
    { id:'ikas', label:'İkas', icon:'ikas_icon', section:'Veri & Analitik', gated:true, children:[
      { id:'ikas-overview', label:'Genel Bakış' },
      { id:'ikas-products', label:'Ürünler'     },
      { id:'ikas-orders',   label:'Siparişler'  },
    ]},
    // 17 sayfa düz listede okunmaz; sidebar'ın grup içi başlık desteğiyle
    // (disabled:true çocuk = büyük harf ayraç, go() bunları atlıyor) beş bölüme ayrıldı.
    { id:'pixa', label:'Pixa', icon:'pixa_icon', section:'Veri & Analitik', gated:true, children:[
      { id:'pixa-sec-ozet',   label:'— ÖZET', disabled:true },
      { id:'pixa-overview',   label:'Genel Bakış' },
      { id:'pixa-asistan',    label:'Asistan'     },
      { id:'pixa-sec-satis',  label:'— SATIŞ', disabled:true },
      { id:'pixa-orders',     label:'Siparişler'  },
      { id:'pixa-returns',    label:'İadeler'     },
      { id:'pixa-shipments',  label:'Kargo'       },
      { id:'pixa-customers',  label:'Müşteriler'  },
      { id:'pixa-sec-katalog', label:'— KATALOG', disabled:true },
      { id:'pixa-products',   label:'Katalog'     },
      { id:'pixa-listings',   label:'Pazaryeri Listeleri' },
      { id:'pixa-inventory',  label:'Stok'        },
      { id:'pixa-pricing',    label:'Değişiklik Geçmişi' },
      { id:'pixa-sec-sistem', label:'— SİSTEM', disabled:true },
      { id:'pixa-integrations', label:'Entegrasyonlar' },
      { id:'pixa-reports',    label:'Raporlar'    },
    ]},
    { id:'gsc', label:'Search Console', icon:'search', section:'Veri & Analitik', children:[
      { id:'gsc-overview', label:'Genel Bakış' },
      { id:'gsc-queries',  label:'Sorgular'     },
      { id:'gsc-pages',    label:'Sayfalar'     },
    ]},

    { id:'poyaisone', label:'Poyais One', icon:'auto_awesome', section:'Araçlar', children:[
      { id:'poyaisone-recommendations', label:'Optimizasyon'       },
      { id:'poyaisone-automation',      label:'Otomasyon Şablonları' },
      { id:'poyaisone-audiences',       label:'Akıllı Kitleler' },
      { id:'poyaisone-flow',            label:'Akış Oluşturucu'   },
      { id:'poyaisone-campaign-builder', label:'Kampanya Oluşturucu' },
    ]},
    { id:'growth', label:'Büyüme', icon:'trending_up', section:'Araçlar', children:[
      { id:'growth-products', label:'Ürün Analizi' },
      { id:'growth-forecast', label:'Tahminleme' },
      { id:'growth-price-elasticity', label:'Fiyat & Talep' },
    ]},
    { id:'feed-wizard', label:'Feed Wizard', icon:'image_search', section:'Araçlar', noLink:true, children:[
      { id:'feed-wizard', label:'Feed Wizard' },
      { id:'dynamic-feed', label:'Dynamic Feed' },
    ]},
    // NOT: "Kreatif Stüdyo" (kreativ-studyo), "Raporlama" (raporlama-menu) ve "AI Radar"
    // (geo) grupları sidebar'dan kaldırıldı — rotaları/render case'leri/backend
    // endpoint'leri App.tsx'te ve backend'de aynen duruyor, sayfalar bozulmadı, sadece
    // menüden çıkarıldı. AI Radar 2026-09-21'de kaldırıldı: kapsamın dışına çıkıyordu ve
    // 4 LLM sağlayıcısına (ChatGPT/Gemini/Claude/Perplexity) giden çağrılar maliyetliydi —
    // ileride tekrar aktif edilmek istenirse bu blok geri eklenir:
    // { id:'geo', label:'AI Radar', icon:'geo_visibility', section:'Araçlar', children:[
    //   { id:'geo-overview',     label:'Genel Bakış' },
    //   { id:'geo-prompts',      label:"Prompt'lar" },
    //   { id:'geo-competitors',  label:'Rakipler' },
    //   { id:'geo-perception',   label:'Marka Algısı' },
    // ]},
  ];
  // "gated:true" gruplar (Reklam Yönetimi'ndeki temel 4 platform — Google Ads/Meta/Analytics/
  // Search Console — dışındaki her şey: ChatGPT Ads/X Ads/Criteo/RTB House/Adjust/Shopify)
  // yalnızca müşteri o platformu Ayarlar > Entegrasyonlar'dan bağlamışsa sidebar'da görünür —
  // aksi halde menü, sayısı artan platform entegrasyonlarıyla anlamsızca kalabalıklaşır.
  const visibleNAV = NAV.filter((item:any) => {
    if (!item.gated) return true;
    const platformKey = item.id.replace(/-/g, '_');
    return !!(config?.platforms as any)?.[platformKey]?.enabled;
  });
  const user = JSON.parse(localStorage.getItem('poyais_user')||'{}');
  const isAdmin = user?.role === 'admin';
  const isClient = user?.role === 'client';
  const CLIENT_HIDDEN = new Set(['admin','admin-clients','admin-reports']);

  const go = (id:string) => {
    const item = visibleNAV.find((n:any) => n.id === id);
    if(item?.children && item.children.length > 0) {
      const firstChild = item.children.find((c:any) => !c.disabled);
      if(firstChild) { setActive(firstChild.id); setMobileOpen(false); return; }
    }
    setActive(id); setMobileOpen(false);
  };

  // ── v2 Design Tokens (poyais-ui/theme) ──────────────────
  const T = SidebarT;
  const accent = T.accent;
  const sidebarW = collapsed ? 56 : 264;

  const sidebarContent = (
    <div style={{ display:'flex', flexDirection:'column', height:'100vh', background:T.surface, width:sidebarW, transition:'width 0.22s cubic-bezier(.4,0,.2,1)', overflow:'hidden', position:'relative' as const }}>
      {/* Marka */}
      <div style={{ padding: collapsed ? '18px 0 12px' : '16px 20px 12px', display:'flex', alignItems:'center', justifyContent: collapsed ? 'center' : 'flex-start', gap:9, flexShrink:0 }}>
        {collapsed
          ? <img src="/poyais-halka.png" alt="Poyais One" width={28} height={28} draggable={false} style={{ display:'block', flexShrink:0 }}/>
          : <img src={sbTheme==='dark' ? '/poyaisone-logo-dark-crop.png' : '/poyaisone-logo-light-crop.png'} alt="Poyais One" height={34} draggable={false} style={{ display:'block', height:34, width:'auto', maxWidth:'100%' }}/>}
      </div>

      {/* Çalışma alanı seçici */}
      {!collapsed && (
        <div style={{ margin:'0 14px 12px', position:'relative' as const, flexShrink:0 }}>
          <button onClick={()=> (clients && clients.length>1) && setWorkspaceOpen(v=>!v)}
            style={{ display:'flex', alignItems:'center', gap:9, width:'100%', border:`1px solid ${T.borderMid}`, borderRadius:12, padding:'9px 11px', background:'var(--py-surface)', cursor:(clients&&clients.length>1)?'pointer':'default', textAlign:'left' as const, fontFamily:'inherit' }}>
            <span style={{ width:24, height:24, borderRadius:7, background:tint(T.accent,16), color:'var(--py-amber-deep-text)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:800, flexShrink:0 }}>
              {(activeClient?.name||'P')[0].toUpperCase()}
            </span>
            <span style={{ flex:1, minWidth:0, fontSize:13.5, fontWeight:700, color:T.text, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>
              {activeClient?.name || t('Çalışma Alanım')}
            </span>
            {clients && clients.length>1 && <span style={{ fontSize:10, color:T.textDim, flexShrink:0 }}>▾</span>}
          </button>
          {workspaceOpen && clients && clients.length>1 && (
            <>
              <div onClick={()=>setWorkspaceOpen(false)} style={{ position:'fixed' as const, inset:0, zIndex:998 }}/>
              <div style={{ position:'absolute' as const, top:'calc(100% + 6px)', left:0, right:0, background:'var(--py-surface)', borderRadius:12, border:`1px solid ${T.border}`, boxShadow:'0 8px 24px rgba(0,0,0,.1)', zIndex:999, padding:'6px 0', maxHeight:280, overflowY:'auto' as const }}>
                {clients.map((c:any)=>(
                  <button key={c.id} onClick={()=>{ onClientChange?.(c); setWorkspaceOpen(false); }}
                    style={{ display:'flex', alignItems:'center', gap:9, width:'100%', padding:'9px 14px', background: activeClient?.id===c.id ? tint(T.accent,10) : 'transparent', border:'none', cursor:'pointer', textAlign:'left' as const, fontFamily:'inherit' }}>
                    <span style={{ width:7, height:7, borderRadius:'50%', background: c.is_active?T.greenText:T.border, flexShrink:0 }}/>
                    <span style={{ fontSize:13, fontWeight:600, color:T.text, flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{c.name}</span>
                    {activeClient?.id===c.id && <span style={{ color:T.accent, fontSize:13 }}>✓</span>}
                  </button>
                ))}
                {isAdmin && (
                  <div style={{ borderTop:`1px solid ${T.border}`, padding:'6px 8px 2px' }}>
                    <button onClick={()=>{ setWorkspaceOpen(false); go('admin-clients'); }}
                      style={{ width:'100%', padding:'8px 10px', borderRadius:8, border:`1px solid ${T.border}`, background:T.card, cursor:'pointer', fontSize:12, color:T.textMid, fontWeight:600, fontFamily:'inherit' }}>
                      {t('Yeni Müşteri Ekle')}
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}

      {/* Nav */}
      <div ref={navScrollRef} onScroll={(e)=>{ savedScrollTop.current = e.currentTarget.scrollTop; }} style={{ flex:1, overflowY:'auto' as const, overflowX:'hidden' as const, padding:'8px 0', minHeight:0 }}>
        {visibleNAV.filter((item:any) => !isClient || !CLIENT_HIDDEN.has(item.id)).map((item:any, idx:number, arr:any[]) => {
          const isItemActive = !item.noLink && active.startsWith(item.id);
          const isExpanded = exp[item.id];
          return (
            <div key={item.id}>
              {!collapsed && item.section && (idx===0 || arr[idx-1]?.section !== item.section) && (
                <div style={{ fontSize:9, fontWeight:700, color:T.textDim, letterSpacing:'0.12em', textTransform:'uppercase' as const, padding:'12px 14px 4px', whiteSpace:'nowrap' as const, fontFamily:'Manrope, sans-serif' }}>{t(item.section)}</div>
              )}
              {collapsed && item.section && (idx===0 || arr[idx-1]?.section !== item.section) && (
                <div style={{ height:8 }}/>
              )}
              {item.children ? (
                <div>
                  <button
                    data-tour={item.id==='ga4'?'tour-ga4':item.id==='poyaisone'?'tour-poyaisone':undefined}
                    onClick={()=>{ if(collapsed){ return; } const willExpand=!exp[item.id]; setExp(e=>({...e,[item.id]:!e[item.id]})); if(willExpand && !item.noLink && window.innerWidth > 768){ if(item.id==='poyaisone') go('poyaisone-recommendations'); else if(item.id==='reports') go('reports-general'); else { const first=(item.children||[]).find((c:any)=>!c.disabled); /* '— ÖZET' gibi başlık satırları atlanır */ if(first) go(first.id); else go(item.id+'-overview'); } } }}
                    style={{ display:'flex', alignItems:'center', justifyContent: collapsed ? 'center' : 'space-between', width: collapsed ? 'calc(100% - 16px)' : 'calc(100% - 12px)', padding: collapsed ? '8px' : '8px 14px', margin: collapsed ? '1px 8px' : '1px 6px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'Manrope, sans-serif', marginBottom:2, color: isItemActive ? accent : T.textMid, background: isItemActive ? alpha(accent, 9) : 'transparent', border:'none', textAlign:'left' as const, transition:'all .15s' }}>
                    <span style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <span style={{ color: isItemActive ? accent : T.textDim, flexShrink:0, display:'flex' }}><NavIcon id={item.icon} size={17}/></span>
                      {!collapsed && t(item.label)}
                    </span>
                    {!collapsed && <span style={{ fontSize:10, color:T.textDim, display:'inline-block', transform: isExpanded ? 'rotate(180deg)' : 'none', transition:'transform .2s' }}>▾</span>}
                  </button>
                  {!collapsed && isExpanded && (
                    <div style={{ paddingLeft:14, marginBottom:4 }}>
                      {item.children.map((child:any) => (
                        child.disabled ? (
                          <div key={child.id} style={{ padding:'6px 12px', fontSize:9, fontWeight:700, color:T.textDim, letterSpacing:'0.08em', textTransform:'uppercase' as const, fontFamily:'Manrope, sans-serif' }}>
                            {t(child.label.replace('— ',''))}
                          </div>
                        ) : (
                          <button key={child.id} onClick={()=>go(child.id)}
                            style={{ display:'flex', alignItems:'center', gap:8, width:'calc(100% - 4px)', padding:'7px 12px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight: active===child.id ? 600 : 400, fontFamily:'Manrope, sans-serif', marginBottom:1, color: active===child.id ? accent : T.textMid, background: active===child.id ? alpha(accent, 8) : 'transparent', border:'none', textAlign:'left' as const, transition:'all .15s' }}>
                            <span style={{ width:4, height:4, borderRadius:'50%', background: active===child.id ? accent : T.border, flexShrink:0 }}/>
                            {t(child.label)}
                          </button>
                        )
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <button onClick={()=>go(item.id)}
                  data-tour={item.id==='dashboard'?'tour-dashboard':item.id==='asistan'?'tour-asistan':item.id==='panolar'?'tour-panolar':item.id==='uyari'?'tour-uyari':undefined}
                  style={{ display:'flex', alignItems:'center', gap:10, width: collapsed ? 'calc(100% - 16px)' : 'calc(100% - 12px)', padding: collapsed ? '8px' : '8px 14px', margin: collapsed ? '1px 8px' : '1px 6px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'Manrope, sans-serif', marginBottom:2, color: active===item.id ? accent : T.textMid, background: active===item.id ? alpha(accent, 9) : 'transparent', border:'none', textAlign:'left' as const, transition:'all .15s', justifyContent: collapsed ? 'center' : 'flex-start' }}>
                  <span style={{ color: active===item.id ? accent : T.textDim, flexShrink:0, display:'flex' }}><NavIcon id={item.icon} size={17}/></span>
                  {!collapsed && t(item.label)}
                  {!collapsed && active===item.id && <div style={{ width:4, height:4, borderRadius:'50%', background:accent, marginLeft:'auto', flexShrink:0 }}/>}
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* Ekibini davet et */}
      {!collapsed && !inviteHidden && (
        <div style={{ padding:'0 8px 8px', flexShrink:0, position:'relative' as const }}>
          <button type="button" onClick={hideInvite} aria-label={t('Kapat')} title={t('Kapat')}
            style={{ position:'absolute' as const, top:6, right:14, width:28, height:28, border:'none', borderRadius:8, background:'transparent', color:T.textDim, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1 }}>
            <span className="material-symbols-outlined" style={{ fontSize:18 }}>close</span>
          </button>
          <button onClick={()=>go('takim')} style={{ display:'block', width:'100%', textAlign:'left' as const, border:`1px solid ${T.border}`, borderRadius:14, padding:'15px 16px', background:'var(--py-bg)', cursor:'pointer', fontFamily:'inherit' }}>
            <span style={{ width:32, height:32, borderRadius:10, background:tint(T.accent,14), color:'var(--py-amber-deep-text)', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:9 }}>
              <NavIcon id="people" size={16}/>
            </span>
            <div style={{ fontSize:13, fontWeight:800, color:T.text, marginBottom:3 }}>{t('Ekibini davet et')}</div>
            <div style={{ fontSize:12, color:T.textMid, lineHeight:1.5 }}>{t('Ekip arkadaşlarını ekle, raporları ve panoları birlikte yönetin.')}</div>
          </button>
        </div>
      )}

      {/* Bottom */}
      <div style={{ padding:'8px', borderTop:`1px solid ${T.border}`, flexShrink:0 }}>
        {isAdmin && !collapsed && (
          <div>
            <button onClick={()=>setAdminExp(v=>!v)}
              style={{ display:'flex', alignItems:'center', gap:10, width:'100%', padding:'8px 12px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'Manrope, sans-serif', color:T.textMid, background:'transparent', border:'none', textAlign:'left' as const, transition:'all .15s' }}>
              <span style={{ color:T.textDim, display:'flex' }}><NavIcon id="admin_panel_settings" size={17}/></span>
              <span style={{ flex:1 }}>{t('Admin')}</span>
              <span style={{ fontSize:10, color:T.textDim }}>{adminExp ? '▲' : '▼'}</span>
            </button>
            {adminExp && (
              <div style={{ paddingLeft:8, marginTop:2 }}>
                <button onClick={()=>go('admin')}
                  style={{ display:'flex', alignItems:'center', gap:8, width:'100%', padding:'7px 12px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:500, fontFamily:'Manrope, sans-serif', color: active==='admin' ? T.red : T.textMid, background: active==='admin' ? `${alpha(T.red, 8)}` : 'transparent', border:'none', textAlign:'left' as const, transition:'all .15s', marginBottom:2 }}>
                  <span style={{ color: active==='admin' ? T.red : T.textDim, display:'flex' }}><NavIcon id="people" size={15}/></span>{t('Kullanıcılar')}
                </button>
                <button onClick={()=>go('admin-clients')}
                  style={{ display:'flex', alignItems:'center', gap:8, width:'100%', padding:'7px 12px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:500, fontFamily:'Manrope, sans-serif', color: active==='admin-clients' ? T.red : T.textMid, background: active==='admin-clients' ? `${alpha(T.red, 8)}` : 'transparent', border:'none', textAlign:'left' as const, transition:'all .15s', marginBottom:2 }}>
                  <span style={{ color: active==='admin-clients' ? T.red : T.textDim, display:'flex' }}><NavIcon id="business" size={15}/></span>{t('Müşteriler')}
                </button>
                <button onClick={()=>go('admin-reports')}
                  style={{ display:'flex', alignItems:'center', gap:8, width:'100%', padding:'7px 12px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:500, fontFamily:'Manrope, sans-serif', color: active==='admin-reports' ? T.red : T.textMid, background: active==='admin-reports' ? `${alpha(T.red, 8)}` : 'transparent', border:'none', textAlign:'left' as const, transition:'all .15s', marginBottom:2 }}>
                  <span style={{ color: active==='admin-reports' ? T.red : T.textDim, display:'flex' }}><NavIcon id="summarize" size={15}/></span>{t('Raporlar')}
                </button>
              </div>
            )}
          </div>
        )}
        <SettingsMenu active={active} go={go} collapsed={collapsed}/>
      </div>
      {/* Profil — sabit alt */}
      <div style={{ borderTop:`1px solid ${T.border}`, paddingTop:6, paddingBottom:4, flexShrink:0, background:T.surface }}>
        {config && onSave
          ? <ProfileDropdown config={config} onSave={onSave} collapsed={collapsed}/>
          : (
            <div style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 10px', borderRadius:8, cursor:'pointer' }}>
              <div style={{ width:28, height:28, borderRadius:'50%', background:alpha(T.accent,20), display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:T.accent, flexShrink:0 }}>
                {userInitials||'BK'}
              </div>
              {!collapsed && (
                <div style={{ minWidth:0 }}>
                  <div style={{ fontSize:12, fontWeight:600, color:T.text, whiteSpace:'nowrap' as const, overflow:'hidden', textOverflow:'ellipsis' }}>{userName||t('Kullanıcı')}</div>
                  <div style={{ fontSize:10, color:T.textDim }}>Admin</div>
                </div>
              )}
            </div>
          )
        }
      </div>
    </div>
  );
  return <>{sidebarContent}</>;
}


// ── App ────────────────────────────────────────────────────────────────────

function DisabledMsg({ label, onSettings }: { label: string, onSettings?: () => void }) {
  const { t } = useLang();
  const T = SidebarT;
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:320, gap:16 }}>
      <span style={{ fontSize:40 }}>🔌</span>
      <div style={{ fontSize:16, fontWeight:700, color:T.text, fontFamily:'Manrope, sans-serif' }}>{t(label)} {t('Devre Dışı')}</div>
      <div style={{ fontSize:13, color:T.textDim, fontFamily:'Manrope, sans-serif' }}>{t('Ayarlar sayfasından platformu aktif edebilirsiniz.')}</div>
      {onSettings && <button onClick={onSettings} style={{ padding:'9px 16px', borderRadius:11, border:'none', background:T.accent, color:'#fff', fontWeight:700, fontSize:13, cursor:'pointer', fontFamily:'Manrope, sans-serif' }}>{t('Ayarlara Git')}</button>}
    </div>
  );
}

export default function App() {
  const { t } = useLang();
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem('poyais_token'));

  const urlParams = new URLSearchParams(window.location.search);
  const inviteToken = urlParams.get('invite');
  const resetToken  = urlParams.get('token');
  const isVerify    = window.location.pathname === '/verify-email';
  const isReset       = window.location.pathname === '/reset-password';
  const isSetPassword = window.location.pathname === '/set-password';
  const isRegister  = window.location.pathname === '/register' || !!inviteToken;

  const clearUrl = () => window.history.replaceState({}, '', '/');
  const location = useLocation();
  const navigate  = useNavigate();

  // URL'den başlangıç nav'ı belirle
  const initNav = URL_TO_NAV[location.pathname] || 'dashboard';
  const [nav,setNavState] = useState(initNav);
  const [globalCredits, setGlobalCredits] = React.useState<number>(0);
  const [emailVerified, setEmailVerified] = React.useState<boolean>(true);
  const [resendingVerify, setResendingVerify] = React.useState(false);
  const [resendSent, setResendSent] = React.useState(false);
  const handleResendVerification = async () => {
    setResendingVerify(true);
    try {
      const tok = localStorage.getItem('poyais_token')||'';
      await axios.post('/api/v1/auth/resend-verification', {}, { headers:{ Authorization:`Bearer ${tok}` } });
      setResendSent(true);
    } catch(e) {}
    setResendingVerify(false);
  };
  const loadCredits = React.useCallback(()=>{
    const tok=localStorage.getItem('poyais_token')||'';
    if(!tok) return;
    fetch('/api/v1/credits/balance',{headers:{'Authorization':'Bearer '+tok}})
      .then(r=>r.ok?r.json():null)
      .then(d=>{ if(d&&d.balance!=null) setGlobalCredits(Number(d.balance)); })
      .catch(()=>{});
  },[]);
  React.useEffect(()=>{ loadCredits(); },[]);


  const setNav = (v:string) => {
    setNavState(v);
    const url = NAV_TO_URL[v] || '/dashboard';
    navigate(url, { replace: false });
  };

  // Tarayıcı geri/ileri tuşu
  useEffect(() => {
    const n = URL_TO_NAV[location.pathname];
    if(n && n !== nav) setNavState(n);
  // Global bridge
  (window as any).__poyaisGoNav = setNav;
  }, [location.pathname]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sidebarHover, setSidebarHover] = useState(false);
  const sidebarDraggingRef = React.useRef(false);
  React.useEffect(() => {
    const handleUp = (e: MouseEvent) => {
      if (!sidebarDraggingRef.current) return;
      sidebarDraggingRef.current = false;
      const el = document.getElementById('poyais-sidebar');
      if (!el) return;
      const r = el.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      setSidebarHover(inside);
    };
    window.addEventListener('mouseup', handleUp);
    return () => window.removeEventListener('mouseup', handleUp);
  }, []);
  const [clients, setClients] = useState<any[]>([]);
  const [activeClient, setActiveClient] = useState<any>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  const [showTour, setShowTour] = React.useState(false);
  const tourStartedRef = React.useRef(false);
  React.useEffect(()=>{
    const tok=localStorage.getItem('poyais_token')||'';
    if(!tourStartedRef.current && nav==='dashboard' && !isMobile && tok && !localStorage.getItem('poyais_seen_tour')){
      const t=setTimeout(()=>{ tourStartedRef.current=true; setShowTour(true); }, 900);
      return ()=>clearTimeout(t);
    }
  },[nav, isMobile]);

  const handleLogout = () => {
    logout();
    localStorage.removeItem('poyais_config');
    localStorage.removeItem('poyais_active_client');
    localStorage.removeItem('poyais_token');
    localStorage.removeItem('poyais_user');
    setLoggedIn(false);
    setConfig(defaultConfig);
  };

  useEffect(() => {
    const handler = (e: any) => setNav(e.detail);
    window.addEventListener('poyais-nav', handler);
    return () => window.removeEventListener('poyais-nav', handler);
  }, []);

  useEffect(() => {
    if(!loggedIn) return;
    // Login sonrası backend'den profil + platform yükle
    const freshConfig = {
      profile: { name:'', surname:'', title:'', email:'', photo:'' },
      platforms: {
        ga4:      { enabled:false, label:'Google Analytics 4', propertyId:'' },
        gads:     { enabled:false, label:'Google Ads',          customerId:'' },
        meta:     { enabled:true,  label:'Meta Ads',            accountId:'', accessToken:'' },
        rtbhouse: { enabled:false, label:'RTB House', token:'', email:'', password:'' },
        search_console: { enabled:false, label:'Search Console', siteUrl:'' },
        chatgpt_ads: { enabled:false, label:'ChatGPT Ads', apiKey:'', accountName:'' },
        adjust: { enabled:false, label:'Adjust', apiToken:'', appToken:'', appName:'' },
    shopify: { enabled:false, label:'Shopify', shopDomain:'', shopName:'' },
    ikas: { enabled:false, label:'İkas', store:'' },
    pixa: { enabled:false, label:'Pixa', host:'', email:'', apiToken:'', userName:'', currency:'' },
    criteo: { enabled:false, label:'Criteo', clientId:'', advertiserId:'', advertiserName:'', datasetId:'' },
      },
      notifications: { email_on_apply:true, email_on_auto:true, auto_apply:false, auto_apply_threshold:'low' },
    };

    Promise.all([
      axios.get('/api/v1/auth/me'),
      axios.get('/api/v1/auth/platforms'),
      axios.get('/api/v1/clients/'),
      axios.get('/api/v1/auth/preferences').catch(()=>({data:{}})),
    ]).then(([meRes, platRes, clientRes, prefRes]) => {
      const clientList = clientRes.data;
      setClients(clientList);
      if(clientList.length > 0) {
        const saved = localStorage.getItem('poyais_active_client');
        const found = saved ? clientList.find((c:any) => c.id === parseInt(saved)) : null;
        setActiveClient(found || pickDefaultClient(clientList));
      }
      const me = meRes.data;
      setEmailVerified(me.is_verified !== 0 && me.is_verified !== false);
      localStorage.setItem('poyais_user', JSON.stringify({ role: me.role || 'user', email: me.email || '' }));
      const platforms = platRes.data;
      const merged = { ...freshConfig };
      merged.profile = { name: me.name||'', surname: me.surname||'', title: me.title||'', email: me.email||'', photo: me.photo||'' };
      if(prefRes?.data && Object.keys(prefRes.data).length > 0) {
        merged.notifications = { ...merged.notifications, ...prefRes.data };
      }
      // Platform credentials'ı merged'e ekle
      for(const [key, val] of Object.entries(platforms) as any) {
        if(merged.platforms[key as keyof typeof merged.platforms]) {
          (merged.platforms[key as keyof typeof merged.platforms] as any) = {
            ...(merged.platforms[key as keyof typeof merged.platforms] as any),
            enabled: val.enabled,
            ...val.credentials,
          };
        }
      }
      // activeClient varsa platform ID'lerini hemen uygula (client yoksa boş bırak)
      const savedClient = localStorage.getItem('poyais_active_client');
      const activeC = clientList.length > 0 ? (savedClient ? clientList.find((c:any) => c.id === parseInt(savedClient)) : pickDefaultClient(clientList)) : null;
      (merged as any).client_id = activeC?.id || null;
      if(activeC) {
        merged.platforms.ga4      = { ...merged.platforms.ga4,      propertyId:  activeC.ga4_property_id  || '', enabled: !!(activeC.ga4_property_id) };
        merged.platforms.gads     = { ...merged.platforms.gads,     customerId:  activeC.gads_customer_id || '', enabled: !!(activeC.gads_customer_id) };
        // Meta'nın gads'takine benzer bir per-client OAuth akışı yok — meta_oauth_router.py
        // sadece `platforms` tablosuna (kullanıcı bazında, tüm müşteriler için ortak) yazıyor,
        // clients.meta_account_id hiçbir zaman doldurulmuyor. Burada koşulsuz üzerine yazmak
        // az önce /auth/platforms'tan doğru şekilde yüklenen bağlantıyı her sayfa
        // yüklemesinde/müşteri değişiminde sıfırlıyordu — "bağlanıp kaydediyorum ama
        // bağlantı kopuyor" şikayetinin kök nedeni buydu. Gerçekten o müşteriye özel bir
        // meta_account_id varsa uygula, yoksa kullanıcı-seviyesindeki bağlantıya dokunma.
        if(activeC.meta_account_id) {
          merged.platforms.meta = { ...merged.platforms.meta, accountId: activeC.meta_account_id, accessToken: activeC.meta_access_token || '', enabled: true };
        }
        const _re=activeC.rtbhouse_email||'',_rp=activeC.rtbhouse_password||'';
        (merged.platforms as any).rtbhouse = { enabled:!!(_re&&_rp), label:'RTB House', email:_re, password:_rp, token:_re&&_rp?_re+':'+_rp:'' };
        (merged.platforms as any).search_console = { enabled:!!(activeC.search_console_site_url), label:'Search Console', siteUrl: activeC.search_console_site_url || '' };
        (merged.platforms as any).chatgpt_ads = { enabled:!!(activeC.chatgpt_ads_account_name), label:'ChatGPT Ads', apiKey: activeC.chatgpt_ads_api_key ? '••••••••' : '', accountName: activeC.chatgpt_ads_account_name || '', currency: activeC.chatgpt_ads_currency || '' };
        (merged.platforms as any).x_ads = { enabled:!!(activeC.x_ads_account_name), label:'X Ads', accountName: activeC.x_ads_account_name || '', currency: activeC.x_ads_currency || '' };
        { let _tto:any[] = []; try { _tto = JSON.parse(activeC.tiktok_advertiser_options || '[]'); } catch {}
          (merged.platforms as any).tiktok = { enabled:!!(activeC.tiktok_advertiser_id), label:'TikTok Ads', advertiserId: activeC.tiktok_advertiser_id || '', advertiserName: activeC.tiktok_advertiser_name || '', currency: activeC.tiktok_currency || '', options: _tto }; }
        (merged.platforms as any).adjust = { enabled:!!(activeC.adjust_app_name), label:'Adjust', apiToken: activeC.adjust_api_token ? '••••••••' : '', appToken: activeC.adjust_app_token || '', appName: activeC.adjust_app_name || '' };
        (merged.platforms as any).ikas = { enabled:!!(activeC.ikas_store), label:'İkas', store: activeC.ikas_store || '' };
        (merged.platforms as any).shopify = { enabled:!!(activeC.shopify_shop_domain), label:'Shopify', shopDomain: activeC.shopify_shop_domain || '', shopName: activeC.shopify_shop_name || '' };
        (merged.platforms as any).pixa = { enabled:!!(activeC.pixa_host), label:'Pixa', host: activeC.pixa_host || '', email: activeC.pixa_email || '', apiToken: activeC.pixa_api_token ? '••••••••' : '', userName: activeC.pixa_user_name || '', currency: activeC.pixa_currency || '' };
        (merged.platforms as any).criteo = { enabled:!!(activeC.criteo_advertiser_name), label:'Criteo', clientId: activeC.criteo_client_id || '', advertiserId: activeC.criteo_advertiser_id || '', advertiserName: activeC.criteo_advertiser_name || '', datasetId: activeC.criteo_dataset_id || '' };
      } else {
        // Client yoksa gads'ı devre dışı bırak (per-client OAuth'a bağlı, client'sız anlamsız).
        // GA4/Meta OAuth ile bağlıysa (platforms tablosundan geldi) dokunma — Meta'nın
        // gads gibi per-client bağlantısı yok, kullanıcı-seviyesinde kalıyor.
        merged.platforms.gads  = { ...merged.platforms.gads,  customerId: '',  enabled: false };
      }
      localStorage.setItem('poyais_config', JSON.stringify(merged));
      setConfig(merged as any);
      saveConfig(merged);
      setConfigLoaded(true);  // En son — her şey hazır olunca
    }).catch(() => { setConfig(freshConfig); setConfigLoaded(true); });

  }, [loggedIn]);

  // activeClient değişince platform ID'lerini güncelle
  useEffect(() => {
    if(!activeClient) return;
    localStorage.setItem('poyais_active_client', activeClient.id);
    try {
      const saved = JSON.parse(localStorage.getItem('poyais_config')||'{}');
      // Meta'nın per-client kaydı yok (clients.meta_account_id hep boş) — sadece
      // gerçekten doluysa uygula, yoksa kullanıcı-seviyesindeki bağlantıyı ezme.
      if(saved?.platforms && activeClient.meta_account_id) {
        saved.platforms.meta = { ...saved.platforms.meta, accessToken: activeClient.meta_access_token||'' };
        localStorage.setItem('poyais_config', JSON.stringify(saved));
      }
    } catch(e) {}
    const _re2=activeClient.rtbhouse_email||'',_rp2=activeClient.rtbhouse_password||'';
    setConfig((prev:any) => ({
      ...prev,
      client_id: activeClient.id,
      platforms: {
        ...prev.platforms,
        ga4:  { ...prev.platforms.ga4,  propertyId:  activeClient.ga4_property_id  || '', enabled: !!activeClient.ga4_property_id },
        gads: { ...prev.platforms.gads, customerId:  activeClient.gads_customer_id || '', enabled: !!activeClient.gads_customer_id },
        // Meta'nın gads gibi per-client bağlantısı yok — clients.meta_account_id hep boş
        // (meta_oauth_router.py sadece platforms tablosuna, kullanıcı bazında yazıyor).
        // Koşulsuz üzerine yazmak, login sonrası doğru yüklenen bağlantıyı bu efekt
        // activeClient set edilince (aynı ilk yüklemede) anında sıfırlıyordu — "sayfayı
        // yenileyince bağlantı kopuyor" şikayetinin asıl kaynağı, önceki oturumdaki
        // fix bu ikinci efekti atlamıştı. Gerçekten doluysa uygula, yoksa dokunma.
        meta: activeClient.meta_account_id
          ? { ...prev.platforms.meta, accountId: activeClient.meta_account_id, accessToken: activeClient.meta_access_token || '', enabled: true }
          : prev.platforms.meta,
        rtbhouse: { enabled:!!(_re2&&_rp2), label:'RTB House', email:_re2, password:_rp2, token:_re2&&_rp2?_re2+':'+_rp2:'' },
        search_console: { enabled:!!activeClient.search_console_site_url, label:'Search Console', siteUrl: activeClient.search_console_site_url || '' },
        chatgpt_ads: { enabled:!!activeClient.chatgpt_ads_account_name, label:'ChatGPT Ads', apiKey: activeClient.chatgpt_ads_api_key ? '••••••••' : '', accountName: activeClient.chatgpt_ads_account_name || '', currency: activeClient.chatgpt_ads_currency || '' },
        adjust: { enabled:!!activeClient.adjust_app_name, label:'Adjust', apiToken: activeClient.adjust_api_token ? '••••••••' : '', appToken: activeClient.adjust_app_token || '', appName: activeClient.adjust_app_name || '' },
        ikas: { enabled:!!activeClient.ikas_store, label:'İkas', store: activeClient.ikas_store || '' },
        shopify: { enabled:!!activeClient.shopify_shop_domain, label:'Shopify', shopDomain: activeClient.shopify_shop_domain || '', shopName: activeClient.shopify_shop_name || '' },
        pixa: { enabled:!!activeClient.pixa_host, label:'Pixa', host: activeClient.pixa_host || '', email: activeClient.pixa_email || '', apiToken: activeClient.pixa_api_token ? '••••••••' : '', userName: activeClient.pixa_user_name || '', currency: activeClient.pixa_currency || '' },
        criteo: { enabled:!!activeClient.criteo_advertiser_name, label:'Criteo', clientId: activeClient.criteo_client_id || '', advertiserId: activeClient.criteo_advertiser_id || '', advertiserName: activeClient.criteo_advertiser_name || '', datasetId: activeClient.criteo_dataset_id || '' },
      }
    }));
  }, [activeClient]);

  const [start,setStart] = useState(monthStart());
  const [end,setEnd]     = useState(todayStr());
  const [config,setConfig] = useState(defaultConfig);
  const [configLoaded,setConfigLoaded] = useState(false);
  const { theme } = useTheme();
  const { lang: uiLang } = useLang();
  const darkMode = theme === 'dark';
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [notifTr, setNotifTr] = useState<Record<string,string>>({});   // İngilizce arayüzde dinamik bildirim metinleri çevirisi
  const [notifLoaded, setNotifLoaded] = useState(false);

  // Scrollbar dark mode rengi
  useEffect(()=>{
    const style = document.getElementById('poyais-scroll-style') || document.createElement('style');
    style.id = 'poyais-scroll-style';
    style.textContent = darkMode ? `
      ::-webkit-scrollbar { width: 13px; height: 13px; }
      ::-webkit-scrollbar-track { background: #1e2028; }
      ::-webkit-scrollbar-thumb { background: #F5A623; border-radius: 8px; border: 2px solid #1e2028; }
      ::-webkit-scrollbar-thumb:hover { background: #ffb648; }
    ` : `
      ::-webkit-scrollbar { width: 13px; height: 13px; }
      ::-webkit-scrollbar-track { background: transparent; }
      ::-webkit-scrollbar-thumb { background: #F5A623; border-radius: 8px; border: 2px solid #FCFCFD; }
      ::-webkit-scrollbar-thumb:hover { background: #D6890F; }
    `;
    document.head.appendChild(style);
  }, [darkMode]);

  // Bildirimler — aktif müşterinin son 30 gündeki otomasyon kayıtları (uygulanan + bekleyen onaylar).
  // "Okundu" tek bir zaman damgasıyla tutulur: paneli açmak hepsini okundu sayar, rozet yalnızca
  // o andan sonra oluşan yeni kayıtlar için tekrar görünür (eski bir liste kalıcı rozete yol açmasın).
  const NOTIF_SEEN_KEY = 'poyais_notif_seen_ts';
  const [notifSeenTs, setNotifSeenTs] = useState<number>(() => {
    try { return parseInt(localStorage.getItem(NOTIF_SEEN_KEY) || '0', 10) || 0; } catch { return 0; }
  });
  const notifTime = (n:any):number => {
    const raw = String(n?.triggered_at || n?.created_at || n?.resolved_at || '').trim();
    if(!raw) return 0;
    const iso = raw.includes('T') ? raw : raw.replace(' ', 'T');
    const t = Date.parse(/[Z+]/.test(iso) ? iso : iso + 'Z');
    return isNaN(t) ? 0 : t;
  };
  const loadNotifications = () => {
    const langNow = uiLang;
    const clientId = (config as any)?.client_id
      || parseInt(localStorage.getItem('poyais_active_client') || '0', 10)
      || 1;
    // İki kaynak: otomasyon logları + Pixa uyarı motorunun bulguları. Pixa tarafı
    // automation_logs ŞEKLİNDE satır döndürüyor (backend'de dönüştürülüyor), böylece
    // aşağıdaki filtre/sırala/kes zinciri ve localStorage okundu mantığı değişmiyor.
    // Pixa'sı bağlı olmayan müşteride 424 NORMAL durum — hata değil, boş dizi.
    Promise.all([
      axios.get(`/api/v1/automation/logs?client_id=${clientId}&limit=50&status=applied,approved,pending`)
        .then(r=> Array.isArray(r.data) ? r.data : r.data?.logs || []).catch(()=>[]),
      axios.get(`/api/v1/pixa/${clientId}/anomalies/notifications`)
        .then(r=> Array.isArray(r.data) ? r.data : []).catch(()=>[]),
      axios.get(`/api/v1/uyarilar/notifications?client_id=${clientId}`)
        .then(r=> Array.isArray(r.data) ? r.data : []).catch(()=>[]),
    ]).then(([logs, pixaItems, alertItems]:any[])=>{
      const cutoff = Date.now() - 30 * 86400000;
      const recent = [...logs, ...pixaItems, ...alertItems]
        .filter((l:any)=> notifTime(l) >= cutoff)
        .sort((a:any,b:any)=> notifTime(b) - notifTime(a))
        .slice(0, 20);
      setNotifications(recent);
      setNotifLoaded(true);
      // Bildirim metinleri (otomasyon, Pixa, uyarılar) Türkçe üretilir; İngilizce arayüzde tek istekle çevrilir
      if(langNow==='en' && recent.length){
        const texts:string[] = [];
        recent.forEach((n:any)=>{
          let at:any = n.action_taken; try { at = typeof at==='string' ? JSON.parse(at||'{}') : (at||{}); } catch { at = {}; }
          [at.title, at.message, n.rule_name, n.status_label].forEach((x:any)=>{ if(typeof x==='string' && x.trim()) texts.push(x); });
        });
        axios.post('/api/v1/optimize/translate', { texts: Array.from(new Set(texts)), lang:'en' }).then(r=> setNotifTr(r.data||{})).catch(()=>{});
      }
    }).catch(()=>setNotifLoaded(true));
  };
  useEffect(()=>{ if(loggedIn) loadNotifications(); },[loggedIn, (config as any)?.client_id, uiLang]); // eslint-disable-line react-hooks/exhaustive-deps
  const nt = (x:any):string => (uiLang==='en' && typeof x==='string' && notifTr[x]) ? notifTr[x] : x;

  const unreadCount = notifications.filter((n:any)=> notifTime(n) > notifSeenTs).length;
  const markAllNotifsRead = () => {
    const newest = notifications.reduce((m:number,n:any)=> Math.max(m, notifTime(n)), 0);
    const ts = Math.max(newest, notifSeenTs, Date.now() - 30 * 86400000);
    setNotifSeenTs(ts);
    try { localStorage.setItem(NOTIF_SEEN_KEY, String(ts)); } catch {}
  };
  // Paneli aç/kapat — kapanışta hepsini "görüldü" say (rozet temizlenir, açıkken "yeni" vurgusu kalır)
  const toggleNotifPanel = () => {
    if(notifOpen) { closeNotifPanel(); return; }
    if(!notifLoaded) loadNotifications();
    setNotifOpen(true);
  };
  const closeNotifPanel = () => { setNotifOpen(false); markAllNotifsRead(); };

  const handleConfigSave = async (newConfig:any) => {
    setConfig(newConfig);
    saveConfig(newConfig);
    try {
      for(const [platform, data] of Object.entries(newConfig.platforms) as any) {
        // meta'da accessToken eksikti — `platforms` tablosundaki `credentials` kolonu
        // tam üzerine yazılıyor (merge değil, bkz. save_user_platform), yani her ayar
        // kaydında meta'nın accessToken'ı buradan sessizce siliniyordu. `_tok()` ayrı
        // `oauth_access_token` kolonuna düşerek çalışmaya devam ediyordu ama credentials
        // JSON'u yanlış/eksik kalıyordu — accountId gibi eklenen her yeni platform aynı
        // hataya düşmesin diye burada da açıkça taşınıyor.
        await axios.post('/api/v1/auth/platforms', {
          platform,
          credentials: data.credentials || { propertyId: data.propertyId, customerId: data.customerId, accountId: data.accountId, accessToken: data.accessToken },
          enabled: data.enabled
        });
      }
      // RTB House bağlantısı artık Entegrasyonlar'daki Bağlan/Bağlantıyı Kes butonlarıyla
      // /rtbhouse/connect|disconnect üzerinden yönetiliyor — buradan clients tablosuna yazmıyoruz.
      await axios.put('/api/v1/auth/me', {
        name: newConfig.profile.name,
        surname: newConfig.profile.surname,
        photo: newConfig.profile.photo,
      });
      // Notification preferences SettingsTab'dan ayrıca kaydediliyor, burada ezme
    } catch(e) { console.warn('Backend sync failed', e); }
  };

  // URL'den token geliyorsa direkt login yap (reset/set-password sayfalarında çalışmasın)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('token');
    const path = window.location.pathname;
    const isAuthPage = path === '/reset-password' || path === '/set-password' || path === '/verify-email';
    if (urlToken && !loggedIn && !isAuthPage) {
      localStorage.setItem('poyais_token', urlToken);
      window.history.replaceState({}, '', '/');
      setLoggedIn(true);
    }
  }, []);

  if(isVerify) return <VerifyEmailPage />;
  if(isReset) return <ResetPasswordPage />;
  if(isSetPassword) return <SetPasswordPage />;
  if(!loggedIn) return <LoginScreen onSuccess={()=>{
    setLoggedIn(true);
    window.history.replaceState({}, '', '/dashboard');
  }}/>;

  const labels:Record<string,string> = {
    dashboard:'Ana Sayfa', asistan:'Asistan', panolar:'Panolar', gorevler:'Görevler', notlar:'Notlar', uyari:'Uyarılar',
    faturalandirma:'Faturalama',
    'ga4-overview':'Analytics — Genel Bakış', 'ga4-audience':'Analytics — Audience', 'ga4-funnel':'Analytics — Funnel', 'ga4-pages':'Analytics — Sayfa Performansı','ga4-products':'Analytics — Ürün Analizi', 'ga4-traffic':'Analytics — Trafik Kaynağı',
    'gsc-overview':'Search Console — Genel Bakış', 'gsc-queries':'Search Console — Sorgular', 'gsc-pages':'Search Console — Sayfalar',
    'chatgpt-ads-overview':'ChatGPT Ads — Genel Bakış', 'chatgpt-ads-campaigns':'ChatGPT Ads — Kampanyalar',
    'adjust-overview':'Adjust — Genel Bakış', 'adjust-campaigns':'Adjust — Kampanyalar',
    'geo-overview':'AI Radar — Genel Bakış', 'geo-prompts':"AI Radar — Prompt'lar", 'geo-competitors':'AI Radar — Rakipler', 'geo-perception':'AI Radar — Marka Algısı',
    'criteo-overview':'Criteo — Genel Bakış', 'criteo-campaigns':'Criteo — Kampanyalar',
    'pixa-overview':'Pixa — Genel Bakış', 'pixa-asistan':'Pixa — Asistan', 'pixa-orders':'Pixa — Siparişler', 'pixa-returns':'Pixa — İadeler', 'pixa-shipments':'Pixa — Kargo', 'pixa-customers':'Pixa — Müşteriler', 'pixa-products':'Pixa — Katalog', 'pixa-listings':'Pixa — Pazaryeri Listeleri', 'pixa-pricing':'Pixa — Değişiklik Geçmişi', 'pixa-inventory':'Pixa — Stok', 'pixa-integrations':'Pixa — Entegrasyonlar', 'pixa-reports':'Pixa — Raporlar',
    'x-ads-overview':'X Ads — Genel Bakış', 'x-ads-campaigns':'X Ads — Kampanyalar',
    'tiktok-overview':'TikTok Ads — Genel Bakış', 'tiktok-campaigns':'TikTok Ads — Kampanyalar', 'tiktok-adgroups':'TikTok Ads — Reklam Grupları',
    'gads-overview':'Google Ads — Genel Bakış', 'gads-campaigns':'Google Ads — Kampanyalar', 'gads-placements':'Google Ads — Yerleşimler', 'gads-audience':'Google Ads — Kitle', 'gads-health':'Google Ads — Hesap Sağlığı', 'gads-searchterms':'Google Ads — Arama Terimleri', 'gads-adtexts':'Google Ads — Reklam Metinleri', 'gads-dayparting':'Google Ads — Gün/Saat', 'ads-compare':'Reklam — Platform Karşılaştırma',
    'meta-overview':'Meta Ads — Genel Bakış', 'meta-campaigns':'Meta Ads — Kampanyalar', 'meta-hourly':'Meta Ads — Gün / Saat', 'meta-health':'Meta Ads — Hesap Sağlığı', 'meta-audience':'Meta Ads — Kitle', 'meta-creatives':'Meta Ads — Kreatifler', 'meta-adsets':'Meta Ads — Reklam Setleri', 'meta-placements':'Meta Ads — Yerleşimler',
    poyaisone:'Poyais One',
    'rtbhouse-overview':'RTB House — Genel Bakış',
    'rtbhouse-campaigns':'RTB House — Kampanyalar',
    'rtbhouse-creatives':'RTB House — Bannerlar',
    'poyaisone-automation':'Poyais One — Otomasyon',
    'poyaisone-flow':'Poyais One — Akış Oluşturucu','poyaisone-recommendations':'Poyais One — Optimizasyon',
    'poyaisone-logs':'Poyais One — Aksiyon Logları',
    'poyaisone-audiences':'Poyais One — Akıllı Kitleler',
    settings:'Ayarlar', admin:'Admin Paneli', 'admin-clients':'Müşteri Yönetimi', 'admin-reports':'Raporlar',
  };
  const showDate = !['poyaisone','settings','asistan','panolar','gorevler','notlar','uyari','faturalandirma','admin','admin-clients','admin-reports','feed-wizard','dynamic-feed','geo-overview','geo-prompts','geo-competitors','geo-perception','poyaisone-automation','poyaisone-campaign-builder','poyaisone-audiences','growth-products','growth-forecast','growth-price-elasticity','pixa-products','pixa-inventory','pixa-shipments','pixa-asistan','pixa-listings','pixa-integrations','ikas-products','destek'].includes(nav);
  const activeLabel = labels[nav] || nav;

  return (
    <div className="poyais-app-shell-fix" style={{ display:'flex', background:SidebarT.bg, color:SidebarT.text, fontFamily:'Manrope, sans-serif' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=block');
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');
        *{margin:0;padding:0;box-sizing:border-box}
        body{background:var(--py-bg)}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
        ::-webkit-scrollbar{width:4px;height:4px}
        ::-webkit-scrollbar-thumb{background:rgba(201,168,76,.2);border-radius:2px}
        button{font-family:inherit;-webkit-tap-highlight-color:transparent;touch-action:manipulation}
        input[type="date"]::-webkit-calendar-picker-indicator{filter:invert(0.3)}
        .topbar-pill{display:flex;align-items:center;gap:6px;height:32px;padding:0 13px;border-radius:20px;border:1px solid var(--py-divider);background:var(--py-card);color:var(--py-text-mid);font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;flex-shrink:0;transition:border-color .15s,color .15s,background .2s,box-shadow .2s;font-family:'Manrope',sans-serif}
        .topbar-pill:hover{border-color:var(--py-accent);color:var(--py-text)}
        .topbar-pill.active{background:linear-gradient(135deg,var(--py-accent),var(--py-accent-deep));color:var(--py-accent-ink);border-color:transparent;box-shadow:0 2px 10px rgba(201,168,76,.35)}
        .topbar-pill.active:hover{color:var(--py-accent-ink)}
        .material-symbols-outlined{font-family:'Material Symbols Outlined';font-size:20px;font-style:normal;font-weight:normal;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased}
        .content-padding.flow-builder-active{padding:56px 0 0 0!important;overflow:hidden!important;height:calc(var(--vh,1vh)*100)!important;box-sizing:border-box;display:flex;flex-direction:column}
        @media(max-width:768px){
          .kpi-grid{grid-template-columns:1fr 1fr!important}
          .kpi-grid-4{grid-template-columns:1fr 1fr!important}
          .two-col{grid-template-columns:1fr!important}
          .topbar-title{font-size:12px!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:180px}
          .hide-mobile{display:none!important}
          .topbar-pill{padding:0 9px}
          .topbar-pill .pill-label{display:none}
          .mobile-hamburger{display:flex!important}
          .mobile-client-bar{display:flex!important}
          .mobile-client-hide{display:none!important}
          .mobile-client-bar{display:none}
          .content-padding{padding:16px 14px!important;padding-top:75px!important}
          .content-padding.flow-builder-active{padding:56px 0 0 0!important;overflow:hidden!important}
          table{font-size:11px!important}
          td,th{padding:8px 8px!important}
        }
        @media(max-width:480px){
          .kpi-grid{grid-template-columns:1fr!important}
          .kpi-grid-4{grid-template-columns:1fr!important}
        }
      `}</style>

      {/* Mobile overlay menu */}
      {isMobile && mobileMenuOpen && (
        <div style={{ position:'fixed', inset:0, zIndex:99999, display:'flex' }}>
          <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,.35)' }} onClick={()=>setMobileMenuOpen(false)}/>
          <div style={{ position:'relative', width:264, background:'var(--py-surface)', height:'100%', overflowY:'auto', zIndex:1, boxShadow:'4px 0 16px rgba(0,0,0,.08)', display:'flex', flexDirection:'column' }}>
            <Sidebar active={nav} setActive={(v)=>{ setNav(v); setMobileMenuOpen(false); }} userInitials={`${config?.profile?.name?.[0]||''}${config?.profile?.surname?.[0]||''}`.toUpperCase()||'BK'} userName={`${config?.profile?.name||''} ${config?.profile?.surname||''}`.trim()||'Kullanıcı'} config={config} onSave={handleConfigSave} clients={clients} activeClient={activeClient} onClientChange={setActiveClient}/>
          </div>
        </div>
      )}
      {/* Desktop sidebar */}
      {!isMobile && (
        <nav
          id="poyais-sidebar"
          onMouseEnter={()=>setSidebarHover(true)}
          onMouseLeave={()=>{ if (!sidebarDraggingRef.current) setSidebarHover(false); }}
          onMouseDown={()=>{ sidebarDraggingRef.current = true; }}
          style={{ position:'fixed', left:0, top:0, bottom:0, background:'var(--py-surface)', borderRight:`1px solid ${SidebarT.divider}`, display:'flex', flexDirection:'column', zIndex:100, transition:'width 0.22s cubic-bezier(.4,0,.2,1)', overflow:'hidden', width: sidebarHover ? 264 : 56 }}>
          <Sidebar active={nav} setActive={setNav} collapsed={!sidebarHover} userInitials={`${config?.profile?.name?.[0]||''}${config?.profile?.surname?.[0]||''}`.toUpperCase()||'BK'} userName={`${config?.profile?.name||''} ${config?.profile?.surname||''}`.trim()||'Kullanıcı'} config={config} onSave={handleConfigSave} clients={clients} activeClient={activeClient} onClientChange={setActiveClient}/>
        </nav>
      )}

      <div id="poyais-main-content" className="poyais-main-content-fix" style={{ marginLeft: isMobile ? 0 : (sidebarHover ? 264 : 56), flex:1, display:'flex', flexDirection:'column', minWidth:0, transition:'margin-left 0.22s cubic-bezier(.4,0,.2,1)' }}>

        {/* Topbar */}
        <div id="poyais-topbar" style={{ height: isMobile?48:60, borderBottom:`1px solid ${SidebarT.divider}`, display:'flex', alignItems:'center', justifyContent:'space-between', padding: isMobile?'0 12px':'0 clamp(16px,2.4vw,28px)', background:'var(--py-surface)', position:'fixed', top:0, left: isMobile?0:(sidebarHover?264:56), right:0, zIndex:50, boxShadow:'none', flexShrink:0, fontFamily:'Manrope, sans-serif', transition:'left 0.22s cubic-bezier(.4,0,.2,1)', transform:'translateZ(0)', WebkitTransform:'translateZ(0)', WebkitBackfaceVisibility:'hidden', backfaceVisibility:'hidden' }}>
          {/* Sol: panel-toggle + ayraç + sayfa başlığı (design v2) */}
          <div style={{ display:'flex', alignItems:'center', gap:14, minWidth:0, flex:1 }}>
            {isMobile && (
              <button onClick={()=>setMobileMenuOpen((v:boolean)=>!v)} style={{ display:'flex', alignItems:'center', justifyContent:'center', width:36, height:36, border:`1px solid ${SidebarT.borderMid}`, borderRadius:9, background:'var(--py-surface)', cursor:'pointer', flexShrink:0 }}>
                <span style={{ fontSize:18 }}>☰</span>
              </button>
            )}
            <span style={{ display:'flex', alignItems:'center', color:SidebarT.textDim, flexShrink:0 }}><NavIcon id={topbarIcon(nav)} size={16}/></span>
            {!isMobile && <span style={{ width:1, height:20, background:SidebarT.divider, flexShrink:0 }}/>}
            <div className="topbar-title" style={{ fontSize:14, fontWeight:700, color:SidebarT.text, whiteSpace:'nowrap' as const, overflow:'hidden', textOverflow:'ellipsis' }}>
              {t(topbarTitle(nav))}
            </div>

          </div>

          {/* Sağ: Bell + Client */}
          <div style={{ display:'flex', alignItems:'center', gap: isMobile?6:8, flexShrink:0 }}>

            {/* Hızlı erişim: Optimizasyonlar + Otomasyonlar — mobilde gizli (ikon-only
                halleri bile topbar'daki sayfa başlığını kısaltıp kesiyordu) */}
            <button className={`topbar-pill hide-mobile${nav==='poyaisone-recommendations'?' active':''}`} onClick={()=>setNav('poyaisone-recommendations')}>
              <NavIcon id="tune" size={14}/>
              <span className="pill-label">{t('Optimizasyonlar')}</span>
            </button>
            <button className={`topbar-pill hide-mobile${nav==='poyaisone-automation'?' active':''}`} onClick={()=>setNav('poyaisone-automation')}>
              <NavIcon id="bolt" size={14}/>
              <span className="pill-label">{t('Otomasyonlar')}</span>
            </button>

            {/* Bell + Notification Panel */}
            {(
              <div style={{ position:'relative' }}>
                <button onClick={toggleNotifPanel}
                  style={{ width:32, height:32, borderRadius:8, border:'1px solid var(--py-divider)', background:'var(--py-card)', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', color:'var(--py-text-mid)', position:'relative' as const }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0"/></svg>
                  {unreadCount>0&&(
                    <span style={{ position:'absolute' as const, top:-4, right:-4, minWidth:16, height:16, borderRadius:8, background:'var(--py-red)', border:'2px solid var(--py-surface)', fontSize:9, fontWeight:700, color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', padding:'0 3px' }}>
                      {unreadCount>9?'9+':unreadCount}
                    </span>
                  )}
                </button>

                {/* Notification Dropdown — portal'a alınır ki topbar'ın transform/stacking bağlamına takılmasın */}
                {notifOpen && createPortal(
                  <>
                  <div onClick={closeNotifPanel} style={{ position:'fixed', inset:0, zIndex:100000, background:'transparent' }}/>
                  <div style={ isMobile
                    ? { position:'fixed', top:56, left:8, right:8, width:'auto', maxHeight:'min(560px, calc(100dvh - 110px))', background:'var(--py-surface)', borderRadius:14, border:'1px solid var(--py-divider)', boxShadow:'0 8px 32px rgba(0,0,0,0.28)', zIndex:100001, overflow:'hidden', display:'flex', flexDirection:'column' }
                    : { position:'fixed', top:60, right:16, width:340, maxHeight:'calc(100vh - 90px)', background:'var(--py-surface)', borderRadius:14, border:'1px solid var(--py-divider)', boxShadow:'0 8px 32px rgba(0,0,0,0.28)', zIndex:100001, overflow:'hidden', display:'flex', flexDirection:'column' } }>
                    {/* Header */}
                    <div style={{ padding:'14px 16px', borderBottom:'1px solid var(--py-divider)', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
                      <div style={{ fontSize:13, fontWeight:700, color:'var(--py-text)' }}>{t('Bildirimler')}</div>
                      {unreadCount>0&&<span style={{ fontSize:10, padding:'2px 8px', borderRadius:20, background:'rgba(255,92,122,0.1)', color:'var(--py-red)', fontWeight:700 }}>{unreadCount} {t('yeni')}</span>}
                    </div>
                    {/* List */}
                    <div style={{ flex:1, minHeight:0, overflowY:'auto' as const }}>
                      {!notifLoaded?(
                        <PoyaisSpinner size={36} pad={24}/>
                      ):notifications.length===0?(
                        <div style={{ padding:'24px', textAlign:'center', color:'var(--py-text-dim)', fontSize:13 }}>{t('Bildirim yok')}</div>
                      ):notifications.map((n:any,i:number)=>{
                        const isUnread = notifTime(n) > notifSeenTs;
                        const isPending = n.status==='pending';
                        let msg = '', actTitle = '';
                        try {
                          const at = typeof n.action_taken==='string' ? JSON.parse(n.action_taken||'{}') : n.action_taken||{};
                          msg = at.message || ''; actTitle = at.title || '';
                        } catch { msg = ''; }
                        return(
                          <div key={n.id||i} onClick={()=>{ closeNotifPanel(); setNav(n.nav || 'reports-logs'); }}
                            style={{ padding:'12px 16px', borderBottom:'1px solid var(--py-card)', cursor:'pointer', background:isUnread?'rgba(201,168,76,0.08)':'transparent',
                              transition:'background 0.15s' }}
                            onMouseEnter={e=>(e.currentTarget as HTMLDivElement).style.background='var(--py-card)'}
                            onMouseLeave={e=>(e.currentTarget as HTMLDivElement).style.background=isUnread?'rgba(201,168,76,0.08)':'transparent'}>
                            <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
                              <span style={{ width:7, height:7, borderRadius:'50%', background: isUnread?'var(--py-accent)':'transparent', flexShrink:0, marginTop:6 }}/>
                              <div style={{ flex:1, minWidth:0 }}>
                                <div style={{ fontSize:12, fontWeight:600, color:'var(--py-text)', marginBottom:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>
                                  {nt(actTitle)||nt(n.rule_name)||n.template_slug||t('Otomasyon')}
                                </div>
                                <div style={{ fontSize:11, color:'var(--py-text-mid)', lineHeight:1.4, marginBottom:3 }}>
                                  {nt(msg) || (isPending ? t('Onayınız bekleniyor.') : t('Aksiyon uygulandı.'))}
                                </div>
                                <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                                  {/* Pixa bulguları status_label + severity taşıyor; otomasyon
                                      logları eski pending/applied ikilisini kullanmaya devam ediyor. */}
                                  <span style={{ fontSize:9, fontWeight:700, padding:'1px 6px', borderRadius:10,
                                    background: n.status_label
                                      ? (n.severity==='high'?'rgba(229,72,77,0.12)':n.severity==='medium'?'rgba(245,166,35,0.12)':'rgba(91,124,250,0.12)')
                                      : isPending?'rgba(245,166,35,0.12)':'rgba(20,195,154,0.1)',
                                    color: n.status_label
                                      ? (n.severity==='high'?'var(--py-red-text)':n.severity==='medium'?'var(--py-amber-text)':'var(--py-blue-text)')
                                      : isPending?'var(--py-amber-text)':'var(--py-green-text)' }}>
                                    {n.status_label ? (notifTr[n.status_label] && uiLang==='en' ? notifTr[n.status_label] : t(n.status_label)) : isPending ? t('Onay Bekliyor') : t('Uygulandı')}
                                  </span>
                                  <span style={{ fontSize:9, color:'var(--py-text-dim)' }}>
                                    {String(n.triggered_at||'').slice(0,16).replace('T',' ')}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {/* Footer */}
                    <div style={{ padding:'10px 16px', borderTop:'1px solid var(--py-divider)', display:'flex', alignItems:'center', justifyContent:'center', gap:14, flexShrink:0 }}>
                      <button onClick={markAllNotifsRead} disabled={unreadCount===0}
                        style={{ fontSize:12, fontWeight:600, color: unreadCount===0?'var(--py-text-dim)':'var(--py-accent)', background:'none', border:'none', cursor: unreadCount===0?'default':'pointer' }}>
                        {t('Tümü Okundu')}
                      </button>
                      <span style={{ width:1, height:12, background:'var(--py-divider)' }}/>
                      <button onClick={()=>{ closeNotifPanel(); setNav('reports-logs'); }}
                        style={{ fontSize:12, fontWeight:600, color:'var(--py-text-mid)', background:'none', border:'none', cursor:'pointer' }}>
                        {t('Tüm Bildirimleri Gör')}
                      </button>
                    </div>
                  </div>
                  </>,
                  document.body
                )}
              </div>
            )}

            <ThemeToggle/>
            <LangSwitcher/>

          </div>
        </div>

        {/* Content */}
        <div className="content-padding" style={{ padding: isMobile ? '10px 8px' : '16px 20px', paddingTop: isMobile ? '75px' : '76px', boxSizing:'border-box' as const, width:'100%', background:'var(--py-page-bg)', minHeight:'100vh' }}>
          {!emailVerified && (
            <div style={{ display:'flex', flexWrap:'wrap' as const, alignItems:'center', justifyContent:'space-between', gap:10, background:'rgba(245,166,35,.1)', border:'1px solid rgba(245,166,35,.35)', borderRadius:10, padding:'10px 16px', marginBottom:16, fontFamily:'Manrope, sans-serif' }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:12.5, color:'#8a5a00' }}>
                <span style={{ fontSize:16 }}>⚠️</span>
                <span>E-posta adresiniz henüz doğrulanmadı. Gelen kutunuzu kontrol edin{resendSent ? ' — yeni bağlantı gönderildi.' : '.'}</span>
              </div>
              <button onClick={handleResendVerification} disabled={resendingVerify||resendSent} style={{ padding:'5px 14px', borderRadius:7, border:'1px solid #f5a623', background: resendSent?'transparent':'#f5a623', color: resendSent?'#8a5a00':'#1A1A2E', fontSize:11, fontWeight:700, cursor: resendSent?'default':'pointer', whiteSpace:'nowrap' as const }}>
                {resendSent?'Gönderildi ✓':resendingVerify?'Gönderiliyor…':'Tekrar Gönder'}
              </button>
            </div>
          )}
          {showTour && <ProductTour onClose={()=>setShowTour(false)}/>}
          <PageHeader nav={nav} start={start} end={end} showDate={showDate} onDateChange={(s,e)=>{setStart(s);setEnd(e);}}/>
          {nav==='dashboard'        && configLoaded && <DashboardTabNew start={start} end={end} config={config} configLoaded={configLoaded} onNavigate={setNav} prevStart={prevMonthStart(start)} prevEnd={prevMonthEnd(end)} clientId={activeClient?.id||1} onDateChange={(s,e)=>{setStart(s);setEnd(e);}} sidebarOpen={!isMobile && sidebarHover}/>}
          {nav==='asistan'          && <Asistan config={config}/>}
          {nav==='panolar'          && <Panolar clientId={activeClient?.id||1}/>}
          {nav==='gorevler'         && <Gorevler clientId={activeClient?.id||1} userInitials={`${config?.profile?.name?.[0]||''}${config?.profile?.surname?.[0]||''}`.toUpperCase()||'BK'}/>}
          {nav==='notlar'           && <Notlar clientId={activeClient?.id||1} userInitials={`${config?.profile?.name?.[0]||''}${config?.profile?.surname?.[0]||''}`.toUpperCase()||'BK'}/>}
          {nav==='uyari'            && <Uyarilar clientId={activeClient?.id||1} config={config}/>}
          {(()=>{
            const ga4On   = configLoaded && config?.platforms?.ga4?.enabled !== false && !!config?.platforms?.ga4?.propertyId;
            const gadsOn  = configLoaded && config?.platforms?.gads?.enabled !== false && !!config?.platforms?.gads?.customerId;
            const metaOn  = configLoaded && config?.platforms?.meta?.enabled !== false && !!config?.platforms?.meta?.accountId;
            const rtbOn   = configLoaded && (config?.platforms as any)?.rtbhouse?.enabled !== false && !!(config?.platforms as any)?.rtbhouse?.token;
            const gscOn   = configLoaded && (config?.platforms as any)?.search_console?.enabled !== false && !!(config?.platforms as any)?.search_console?.siteUrl;
            const cgptOn  = configLoaded && (config?.platforms as any)?.chatgpt_ads?.enabled !== false && !!(config?.platforms as any)?.chatgpt_ads?.accountName;
            const xAdsOn  = configLoaded && (config?.platforms as any)?.x_ads?.enabled !== false && !!(config?.platforms as any)?.x_ads?.accountName;
            const tiktokOn = configLoaded && (config?.platforms as any)?.tiktok?.enabled !== false && !!(config?.platforms as any)?.tiktok?.advertiserId;
            const adjustOn = configLoaded && (config?.platforms as any)?.adjust?.enabled !== false && !!(config?.platforms as any)?.adjust?.appName;
            const ikasOn = configLoaded && !!(config?.platforms as any)?.ikas?.enabled;
            const shopifyOn = configLoaded && (config?.platforms as any)?.shopify?.enabled !== false && !!(config?.platforms as any)?.shopify?.shopDomain;
            const pixaOn = configLoaded && (config?.platforms as any)?.pixa?.enabled !== false && !!(config?.platforms as any)?.pixa?.host;
            const criteoOn = configLoaded && (config?.platforms as any)?.criteo?.enabled !== false && !!(config?.platforms as any)?.criteo?.advertiserName;
            const DisabledMsgInline = ({label}:{label:string}) => (
              <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',height:320,gap:16}}>
                <div style={{fontSize:16,fontWeight:700,color:SidebarT.text,fontFamily:'Manrope, sans-serif'}}>{t(label)} {t('Devre Dışı')}</div>
                <div style={{fontSize:13,color:SidebarT.textDim,fontFamily:'Manrope, sans-serif'}}>{t('Ayarlar sayfasından platformu aktif edebilirsiniz.')}</div>
                <button onClick={()=>setNav('settings')} style={{padding:'9px 16px',borderRadius:11,border:'none',background:SidebarT.accent,color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer',fontFamily:'Manrope, sans-serif'}}>{t('Ayarlara Git')}</button>
              </div>
            );
            if (nav==='ga4-overview')      return ga4On  ? <GA4Tab               start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Analytics 4"/>;
            if (nav==='ga4-audience')      return ga4On  ? <GA4AudienceTab        start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Analytics 4"/>;
            if (nav==='ga4-funnel')        return ga4On  ? <GA4FunnelTab          start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Analytics 4"/>;
            if (nav==='ga4-products')      return ga4On  ? <GA4ProductsTab        start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Analytics 4"/>;
            if (nav==='ga4-pages')         return ga4On  ? <GA4PagePerformanceTab start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Analytics 4"/>;
            if (nav==='ga4-traffic')       return ga4On  ? <GA4TrafficSourcesTab  start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Analytics 4"/>;
            if (nav==='ads-compare')       return <PlatformCompareTab start={start} end={end} config={config}/>;
            if (nav==='gads-overview')     return gadsOn ? <GoogleTab             start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Ads"/>;
            if (nav==='gads-campaigns' || nav==='gads-types') return gadsOn ? <KampanyalarPage platform="google" start={start} end={end} config={config} clientId={activeClient?.id||1}/> : <DisabledMsgInline label="Google Ads"/>;
            if (nav==='gads-health')       return gadsOn ? <GoogleHealth customerId={config?.platforms?.gads?.customerId} start={start} end={end}/> : <DisabledMsgInline label="Google Ads"/>;
            if (nav==='gads-placements')   return gadsOn ? <GooglePlacements customerId={config?.platforms?.gads?.customerId} start={start} end={end}/> : <DisabledMsgInline label="Google Ads"/>;
            if (nav==='gads-audience')     return gadsOn ? <GoogleAudiences customerId={config?.platforms?.gads?.customerId} start={start} end={end}/> : <DisabledMsgInline label="Google Ads"/>;
            if (nav==='meta-campaigns')    return metaOn ? <KampanyalarPage platform="meta" start={start} end={end} config={config} clientId={activeClient?.id||1}/> : <DisabledMsgInline label="Meta Ads"/>;
            if (nav==='meta-hourly')       return metaOn ? <MetaHourlyPage clientId={activeClient?.id||1} start={start} end={end}/> : <DisabledMsgInline label="Meta Ads"/>;
            if (nav==='meta-health')       return metaOn ? <MetaHealth clientId={activeClient?.id||1} start={start} end={end} accountId={config?.platforms?.meta?.accountId}/> : <DisabledMsgInline label="Meta Ads"/>;
            if (nav==='gads-searchterms')  return gadsOn ? <GAdsSearchTermsTab    start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Ads"/>;
            if (nav==='gads-adtexts')      return gadsOn ? <GAdsAdTextsTab        start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Ads"/>;
            if (nav==='gads-dayparting')   return gadsOn ? <GAdsHeatmapTab        start={start} end={end} config={config}/> : <DisabledMsgInline label="Google Ads"/>;
            if (nav==='gsc-overview')      return gscOn ? <SearchConsoleTab tab='overview' start={start} end={end} config={config}/> : <DisabledMsgInline label="Search Console"/>;
            if (nav==='gsc-queries')       return gscOn ? <SearchConsoleTab tab='queries'  start={start} end={end} config={config}/> : <DisabledMsgInline label="Search Console"/>;
            if (nav==='gsc-pages')         return gscOn ? <SearchConsoleTab tab='pages'    start={start} end={end} config={config}/> : <DisabledMsgInline label="Search Console"/>;
            if (nav==='adjust-overview')   return adjustOn ? <AdjustTab tab='overview'  start={start} end={end} config={config}/> : <DisabledMsgInline label="Adjust"/>;
            if (nav==='adjust-campaigns')  return adjustOn ? <AdjustTab tab='campaigns' start={start} end={end} config={config}/> : <DisabledMsgInline label="Adjust"/>;
            if (nav==='shopify-overview')  return shopifyOn ? <ShopifyTab tab='overview' start={start} end={end} config={config}/> : <DisabledMsgInline label="Shopify"/>;
            if (nav==='shopify-products')  return shopifyOn ? <ShopifyTab tab='products' start={start} end={end} config={config}/> : <DisabledMsgInline label="Shopify"/>;
            if (nav==='shopify-sales')  return shopifyOn ? <ShopifyTab tab='sales' start={start} end={end} config={config}/> : <DisabledMsgInline label="Shopify"/>;
            if (nav==='shopify-orders')  return shopifyOn ? <ShopifyTab tab='orders' start={start} end={end} config={config}/> : <DisabledMsgInline label="Shopify"/>;
            if (nav==='shopify-returns')  return shopifyOn ? <ShopifyTab tab='returns' start={start} end={end} config={config}/> : <DisabledMsgInline label="Shopify"/>;
            if (nav==='shopify-sources')  return shopifyOn ? <ShopifyTab tab='sources' start={start} end={end} config={config}/> : <DisabledMsgInline label="Shopify"/>;
            if (nav==='shopify-ads')  return shopifyOn ? <ShopifyTab tab='ads' start={start} end={end} config={config}/> : <DisabledMsgInline label="Shopify"/>;
            if (nav==='ikas-overview' || nav==='ikas-products' || nav==='ikas-orders') return ikasOn ? <IkasTab tab={nav==='ikas-overview'?'overview':nav==='ikas-products'?'products':'orders'} clientId={activeClient?.id||1} start={start} end={end}/> : <DisabledMsgInline label="İkas"/>;
            if (nav.startsWith('pixa-'))   return pixaOn ? <PixaTab tab={nav.slice(5)} start={start} end={end} config={config}/> : <DisabledMsgInline label="Pixa"/>;
            if (nav==='criteo-overview')   return criteoOn ? <CriteoTab tab='overview'  start={start} end={end} config={config}/> : <DisabledMsgInline label="Criteo"/>;
            if (nav==='criteo-campaigns')  return criteoOn ? <CriteoTab tab='campaigns' start={start} end={end} config={config}/> : <DisabledMsgInline label="Criteo"/>;
            if (nav==='rtbhouse-overview')  return rtbOn ? <RTBHouseTab config={config} start={start} end={end}/> : <DisabledMsgInline label="RTB House"/>;
            if (nav==='rtbhouse-campaigns') return rtbOn ? <RTBHouseTab config={config} tab='campaigns' start={start} end={end}/> : <DisabledMsgInline label="RTB House"/>;
            if (nav==='rtbhouse-creatives') return rtbOn ? <RTBHouseTab config={config} tab='creatives' start={start} end={end}/> : <DisabledMsgInline label="RTB House"/>;
            if (nav==='chatgpt-ads-overview')  return cgptOn ? <ChatGPTAdsTab tab='overview'  start={start} end={end} config={config}/> : <DisabledMsgInline label="ChatGPT Ads"/>;
            if (nav==='chatgpt-ads-campaigns') return cgptOn ? <ChatGPTAdsTab tab='campaigns' start={start} end={end} config={config}/> : <DisabledMsgInline label="ChatGPT Ads"/>;
            if (nav==='x-ads-overview')  return xAdsOn ? <XAdsTab tab='overview'  start={start} end={end} config={config}/> : <DisabledMsgInline label="X Ads"/>;
            if (nav==='x-ads-campaigns') return xAdsOn ? <XAdsTab tab='campaigns' start={start} end={end} config={config}/> : <DisabledMsgInline label="X Ads"/>;
            if (nav==='tiktok-overview')  return tiktokOn ? <TikTokAdsTab tab='overview'  start={start} end={end} config={config}/> : <DisabledMsgInline label="TikTok Ads"/>;
            if (nav==='tiktok-campaigns') return tiktokOn ? <TikTokAdsTab tab='campaigns' start={start} end={end} config={config}/> : <DisabledMsgInline label="TikTok Ads"/>;
            if (nav==='tiktok-adgroups')  return tiktokOn ? <TikTokAdsTab tab='adgroups'  start={start} end={end} config={config}/> : <DisabledMsgInline label="TikTok Ads"/>;
            if (nav==='meta-overview')     return metaOn ? <MetaTab               start={start} end={end} config={config}/> : <DisabledMsgInline label="Meta Ads"/>;
            if (nav==='meta-audience')     return metaOn ? <MetaAudienceTab       start={start} end={end} config={config}/> : <DisabledMsgInline label="Meta Ads"/>;
            if (nav==='meta-creatives')    return metaOn ? <MetaCreativesTab      start={start} end={end} config={config}/> : <DisabledMsgInline label="Meta Ads"/>;
            if (nav==='meta-adsets')       return metaOn ? <MetaAdSetsTab         start={start} end={end} config={config}/> : <DisabledMsgInline label="Meta Ads"/>;
            if (nav==='meta-placements')   return metaOn ? <MetaPlacementsTab     start={start} end={end} config={config}/> : <DisabledMsgInline label="Meta Ads"/>;
            if (nav==='geo-overview')      return <GeoVisibilityTab tab='overview'    config={config}/>;
            if (nav==='geo-prompts')       return <GeoVisibilityTab tab='prompts'     config={config}/>;
            if (nav==='geo-competitors')   return <GeoVisibilityTab tab='competitors' config={config}/>;
            if (nav==='geo-perception')    return <GeoVisibilityTab tab='perception'  config={config}/>;
            return null;
          })()}
          {nav==='poyaisone-automation' && (clients.length > 0 ? <PoyaisOneTab config={config}/> : <DisabledMsg label="Otomasyon" onSettings={()=>setNav('settings')}/>)}
          {nav==='poyaisone-creative'   && <AIGorselTab          config={config} creditBalance={globalCredits} onSpend={loadCredits}/>}
            {nav==='kreativ-metin'        && <AIMetinTab           config={config} creditBalance={globalCredits} onSpend={loadCredits}/>}
            {nav==='kreativ-video'         && <AIVideoTab           config={config} creditBalance={globalCredits} onSpend={loadCredits}/>}
            {nav==='kreativ-ses'           && <AISesTab             config={config} creditBalance={globalCredits} onSpend={loadCredits}/>}
            {nav==='growth-products' && <GrowthProductAnalysis clientId={activeClient?.id||1}/>}
            {nav==='growth-forecast' && <GrowthForecast clientId={activeClient?.id||1}/>}
            {nav==='growth-price-elasticity' && <GrowthPriceElasticity clientId={activeClient?.id||1}/>}
            {nav==='feed-wizard' && <FeedWizardTab clientId={activeClient?.id||1}/>}
            {nav==='dynamic-feed' && <DynamicFeedTab clientId={activeClient?.id||1}/>}
          {nav==='poyaisone-flow'        && <FlowBuilderTab       config={config}/>}
          {nav==='poyaisone-campaign-builder' && <CampaignBuilderTab config={config} clientId={activeClient?.id||1}/>}
          {nav==='poyaisone-audiences' && <SmartAudiences clientId={activeClient?.id||1}/>}
          {nav==='poyaisone-recommendations' && (clients.length > 0 ? <RecommendationsTabNew config={config} start={start} end={end}/> : <DisabledMsg label="Optimizasyon Önerileri" onSettings={()=>setNav('settings')}/>)}
          {nav==='ab-test'              && <ABTestTab            start={start} end={end} config={config}/>}
          {nav==='reports-general'     && <ReportsTab config={config} start={start} end={end}/>}
          {nav==='reports-logs'        && <AutomationLogsTab config={config}/>}
          {nav==='reports-custom'      && <CustomDashboardTab config={config} start={start} end={end}/>}
          {nav==='admin'            && <AdminTab              config={config}/> }
          {nav==='admin-clients'   && <AdminClientsTab      config={config} onClientChange={(c:any)=>{ setActiveClient(c); }}/>}
          {nav==='settings'          && (configLoaded ? <SettingsTab config={config} onSave={handleConfigSave} activeClientId={activeClient?.id} myClients={clients}/> : <Loader/>)}
          {nav==='kredi-yukle'       && <KrediYuklePage config={config}/>}
          {nav==='faturalandirma'   && <FaturalamaPage config={config} activeClientId={activeClient?.id}/>}
          {nav==='takim'            && <TakimPage config={config}/>}
          {nav==='admin-reports'   && <ClientReportAdmin activeClientId={activeClient?.id}/>}
          {nav==='destek'            && <DestekPage config={config} clientId={activeClient?.id}/>}
          {nav==='reports'           && <ReportsTab config={config} start={start} end={end}/>}
        </div>
      </div>
    </div>
  );
}



// -- GA4 Products Tab -------------------------------------------------------
function GA4ProductsTab({ start, end, config }:{ start:string; end:string; config:any }) {
  const { t } = useLang();
  const T = SidebarT;
  const { propertyId } = config.platforms.ga4;
  const isMobile = useIsMobile();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [orderBy, setOrderBy] = useState('itemRevenue');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [trendExpanded, setTrendExpanded] = useState(false);
  const PAGE_SIZE = 10;

  useEffect(() => {
    if (!propertyId) return;
    setLoading(true);
    axios.get(`${API}/ga4/${propertyId}/products?start_date=${start}&end_date=${end}&limit=50&order_by=${orderBy}`)
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [start, end, orderBy]);

  if(loading) return <Loader/>;
  if(!data) return <div style={{color:T.textMid,padding:24}}>{t('Veri bulunamadı.')}</div>;

  const filtered = (data.products||[]).filter((p:any) =>
    p.name?.toLowerCase().includes(search.toLowerCase()) ||
    p.category?.toLowerCase().includes(search.toLowerCase())
  );
  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged = filtered.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);
  const catMax = data.category_breakdown?.length ? Math.max(...data.category_breakdown.map((c:any)=>c.revenue||0)) : 1;
  const topProduct = (data.products||[]).slice().sort((a:any,b:any)=>(b.sold||0)-(a.sold||0))[0];
  

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>

      {/* KPI Grid */}
      <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4,1fr)', gap:isMobile?8:14, overflowX:'hidden' as const }}>
        {[
          { label:t('Toplam Gelir'),  value:fmt.k(data.total_revenue),   delta:'+12.5%', up:true  },
          { label:t('Satılan Ürün'),  value:fmt.n(data.total_sold),             delta:'+8.2%',  up:true  },
          { label:t('Sepete Ekleme'), value:fmt.n(data.total_atc),              delta:'-2.1%',  up:false },
          { label:t('ATC → Satış'),   value:`%${data.atc_to_sale_rate||0}`,    delta:'+0.8%',  up:true  },
        ].map(kpi => (
          <div key={kpi.label} style={{ background:T.surface, borderRadius:14, border:`1px solid ${T.border}`, padding:isMobile?'12px 14px':'18px 19px' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:10 }}>
              <span style={{ fontSize:12.5, fontWeight:600, color:'var(--py-text-mid-alt)' }}>{kpi.label}</span>
              <span style={{ fontSize:11, fontWeight:700, color:kpi.up?T.greenText:T.redText, fontFamily:MONO }}>{kpi.up?'↑':'↓'} {kpi.delta}</span>
            </div>
            <div style={{ fontSize:20, fontWeight:800, fontFamily:MONO }}>{kpi.value}</div>
          </div>
        ))}
      </div>

      {/* Kategori Bazlı Gelir + Trend Analizi */}
      {data.category_breakdown?.length > 0 && (
        <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr auto', gap:14 }}>
          {/* Kategori bars */}
          <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, padding:'20px 22px' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18 }}>
              <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Kategori Bazlı Gelir')}</span>
              <span style={{ fontSize:11, fontWeight:600, color:T.textDim, display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ width:8, height:8, borderRadius:'50%', background:T.accent, display:'inline-block' }}/> {t('Mevcut Dönem')}
              </span>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:14, maxWidth:'100%' }}>
              {data.category_breakdown.slice(0,6).map((cat:any, i:number) => {
                const pct = catMax>0 ? (cat.revenue/catMax)*100 : 0;
                return (
                  <div key={i}>
                    <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, fontWeight:600, marginBottom:6 }}>
                      <span style={{ color:'var(--py-text-mid-alt)' }}>{cat.category}</span>
                      <span style={{ fontFamily:MONO }}>{fmt.k(cat.revenue)}</span>
                    </div>
                    <div style={{ height:7, background:'var(--py-track-bg)', borderRadius:999, overflow:'hidden' }}>
                      <div style={{ height:'100%', width:`${pct}%`, background:T.accent, borderRadius:999, transition:'width .6s ease' }}/>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Trend Analizi card */}
          <div style={{ background:T.accent, borderRadius:16, padding:'26px 22px', minWidth:240, display:'flex', flexDirection:'column', justifyContent:'space-between' }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
                <div style={{ fontSize:10, fontWeight:800, letterSpacing:'.1em', color:'rgba(255,255,255,.8)', textTransform:'uppercase' as const }}>{t('Trend Analizi')}</div>
                <span style={{ fontSize:9, fontWeight:700, background:'rgba(255,255,255,.25)', color:'#fff', padding:'2px 9px', borderRadius:999, letterSpacing:'.06em' }}>{t('Çok Satan')}</span>
              </div>
              <div style={{ fontSize:17, fontWeight:800, color:'#fff', lineHeight:1.3, marginBottom:12 }}>
                {topProduct?.name || t('Ürün')}
              </div>
              <p style={{ fontSize:12, color:'rgba(255,255,255,.85)', lineHeight:1.65, margin:0 }}>
                {topProduct
                  ? `${topProduct.category || ''} ${t('kategorisinde bu dönem en yüksek geliri elde etti.')}`
                  : t('Bu dönem en çok satan ürün analizi hazırlanıyor.')}
              </p>
              {trendExpanded && topProduct && (
                <div style={{ marginTop:14, display:'flex', flexDirection:'column', gap:8, padding:'14px', background:'rgba(255,255,255,.16)', borderRadius:11 }}>
                  {[
                    { label:t('Gelir'),         val: fmt.k(topProduct.revenue) },
                    { label:t('Satış'),         val: fmt.n(topProduct.sold) + ' ' + t('adet') },
                    { label:t('Sepete Ekle'),   val: fmt.n(topProduct.atc) },
                    { label:t('ATC → Satış'),   val: `%${topProduct.cr?.toFixed(1)}` },
                    { label:t('Kategori'),      val: topProduct.category },
                  ].map((s:any) => (
                    <div key={s.label} style={{ display:'flex', justifyContent:'space-between', fontSize:11.5 }}>
                      <span style={{ color:'rgba(255,255,255,.75)' }}>{s.label}</span>
                      <span style={{ color:'#fff', fontWeight:700, fontFamily:MONO }}>{s.val}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button onClick={()=>setTrendExpanded((e:boolean)=>!e)} style={{ marginTop:20, padding:'10px 16px', borderRadius:10, background:'#fff', color:T.accentDeep, border:'none', fontSize:12, fontWeight:800, cursor:'pointer' }}>
              {trendExpanded ? t('Kapat ↑') : t('Detayları Gör →')}
            </button>
          </div>
        </div>
      )}

      {/* Ürün Performansı Tablosu */}
      <div style={{ background:T.surface, borderRadius:16, border:`1px solid ${T.border}`, overflow:'hidden' }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap' as const, gap:10 }}>
          <span style={{ fontSize:13.5, fontWeight:800 }}>{t('Ürün Performansı')}</span>
          <div style={{ display:'flex', gap:8, alignItems:'center' }}>
            <div style={{ display:'inline-flex', gap:4, background:'var(--py-track-bg)', padding:4, borderRadius:11 }}>
              {[['itemRevenue','Gelir'],['itemsPurchased','Satış'],['itemsAddedToCart','Sepet']].map(([val,label])=>(
                <button key={val} onClick={()=>{setOrderBy(val);setPage(0);}} style={{
                  padding:'6px 13px', borderRadius:8, border:'none',
                  background:orderBy===val?T.surface:'transparent', boxShadow:orderBy===val?'0 1px 2px rgba(20,22,43,.1)':'none',
                  color:orderBy===val?T.text:'var(--py-text-mid-alt)',
                  fontSize:12, fontWeight:orderBy===val?700:500, cursor:'pointer',
                }}>{t(label)}</button>
              ))}
            </div>
            <input value={search} onChange={e=>{setSearch(e.target.value);setPage(0);}} placeholder={t('Ürün ara...')}
              style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:'var(--py-subtle-bg)', fontSize:12, outline:'none', width:160 }}/>
            <button onClick={()=>exportCsv(`ga4-urun-performansi-${start}-${end}.csv`, filtered, [
              { key:'name', label:t('Ürün') }, { key:'category', label:t('Kategori') },
              { key:'revenue', label:t('Gelir') }, { key:'sold', label:t('Satış') },
              { key:'atc', label:t('Sepet') }, { key:'cr', label:'CR%' },
            ])} disabled={filtered.length===0} style={{ padding:'7px 13px', borderRadius:9, border:`1px solid ${T.borderMid}`, background:T.surface, fontSize:12, fontWeight:700, color:'var(--py-text-mid-alt)', cursor:filtered.length?'pointer':'not-allowed', opacity:filtered.length?1:.5 }}>
              {t('Dışa Aktar')}
            </button>
          </div>
        </div>

      <div style={{ overflowX:'auto' as const, WebkitOverflowScrolling:'touch' as any }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
          <thead>
            <tr style={{ background:'var(--py-subtle-bg)' }}>
              {['Ürün','Kategori','Gelir','Satış','Sepet','CR%'].map((h,i) => (
                <th key={h} style={{ padding:'10px 18px', fontSize:10.5, fontWeight:800, color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, letterSpacing:'.06em', textAlign:i<=1?'left':'right', borderBottom:'1px solid var(--py-table-divider)', whiteSpace:'nowrap' as const }}>{t(h)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paged.map((p:any, i:number) => (
              <tr key={i} style={{ borderBottom:'1px solid var(--py-table-divider)', cursor:'pointer' }}
                onMouseEnter={e=>(e.currentTarget.style.background='var(--py-subtle-bg)')}
                onMouseLeave={e=>(e.currentTarget.style.background='transparent')}>
                <td style={{ padding:'12px 18px' }}>
                  <div style={{ fontSize:12.5, fontWeight:600, maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' as const }}>{p.name}</div>
                  {p.sku && <div style={{ fontSize:10.5, color:T.textDim }}>SKU: {p.sku}</div>}
                </td>
                <td style={{ padding:'12px 18px' }}>
                  <span style={{ fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:999, background:'var(--py-track-bg)', color:'var(--py-text-mid-alt)' }}>{p.category||'—'}</span>
                </td>
                <td style={{ padding:'12px 18px', textAlign:'right', fontSize:13, fontWeight:700, fontFamily:MONO }}>{fmt.k(p.revenue)}</td>
                <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(p.sold)}</td>
                <td style={{ padding:'12px 18px', textAlign:'right', fontSize:12.5, color:T.textMid, fontFamily:MONO }}>{fmt.n(p.atc)}</td>
                <td style={{ padding:'12px 18px', textAlign:'right' }}>
                  <span style={{ fontSize:12, fontWeight:800, color:p.cr>15?T.greenText:p.cr>5?T.amberText:T.redText, fontFamily:MONO }}>%{p.cr}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

        {/* Pagination */}
        <div style={{ padding:'13px 20px', borderTop:'1px solid var(--py-table-divider)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:11.5, color:T.textDim }}>
            {t('Toplam')} {filtered.length} {t('ürün gösteriliyor')}
          </span>
          <div style={{ display:'flex', gap:4 }}>
            <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page===0?'not-allowed':'pointer', opacity:page===0?0.4:1, fontSize:14 }}>‹</button>
            {Array.from({length:Math.min(3,totalPages)},(_,i)=>i).map(n=>(
              <button key={n} onClick={()=>setPage(n)}
                style={{ width:28, height:28, borderRadius:8, border:`1px solid ${page===n?T.accent:T.borderMid}`, background:page===n?T.accent:T.surface, color:page===n?'var(--py-accent-ink)':'var(--py-text-mid-alt)', cursor:'pointer', fontSize:11, fontWeight:700 }}>{n+1}</button>
            ))}
            <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page>=totalPages-1}
              style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.borderMid}`, background:T.surface, cursor:page>=totalPages-1?'not-allowed':'pointer', opacity:page>=totalPages-1?.4:1, fontSize:14 }}>›</button>
          </div>
        </div>
      </div>

    </div>
  );
}
function PlatformEditor({ userId, onSaved }:{ userId:number; onSaved:()=>void }) {
  const T = SidebarT;
  const [platform, setPlatform] = useState('ga4');
  const [creds, setCreds] = useState<Record<string,string>>({});
  const [saving, setSaving] = useState(false);

  const FIELDS:Record<string,{label:string;key:string;secret?:boolean}[]> = {
    ga4:  [{ label:'Property ID', key:'propertyId' }],
    gads: [{ label:'Customer ID', key:'customerId' }],
    meta: [{ label:'Account ID', key:'accountId' }, { label:'Access Token', key:'accessToken', secret:true }],
  };

  const fields = FIELDS[platform] || [];

  const save = async () => {
    setSaving(true);
    try {
      await axios.post(`/api/v1/admin/users/${userId}/platforms`, {
        platform,
        credentials: creds,
        enabled: true,
      });
      setCreds({});
      onSaved();
    } catch(e) { console.error(e); }
    setSaving(false);
  };

  return (
    <div style={{ marginTop:14, background:T.card, borderRadius:8, padding:'14px 16px', border:'1px solid rgba(201,168,76,.15)' }}>
      <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.accent, letterSpacing:0, marginBottom:12 }}>PLATFORM EKLE / GÜNCELLE</div>
      <div style={{ display:'flex', gap:8, marginBottom:12, flexWrap:'wrap' as const }}>
        {['ga4','gads','meta'].map(p => (
          <button key={p} onClick={()=>{ setPlatform(p); setCreds({}); }}
            style={{ fontFamily:'Manrope, sans-serif', fontSize:10, padding:'5px 12px', borderRadius:6, border:`1px solid ${platform===p?T.accent:T.borderAlt}`, background:platform===p?'rgba(201,168,76,.15)':T.surface, color:platform===p?T.accent:T.textDim, cursor:'pointer' }}>
            {p==='ga4'?'GA4':p==='gads'?'Google Ads':'Meta Ads'}
          </button>
        ))}
      </div>
      <div style={{ display:'flex', flexDirection:'column' as const, gap:8, marginBottom:12 }}>
        {fields.map(f => (
          <div key={f.key}>
            <div style={{ fontFamily:'Manrope, sans-serif', fontSize:9, color:T.textDim, marginBottom:4 }}>{f.label}</div>
            <input
              type={f.secret?'password':'text'}
              value={creds[f.key]||''}
              onChange={e=>setCreds(c=>({...c,[f.key]:e.target.value}))}
              placeholder={f.label}
              style={{ width:'100%', background:T.surface, border:`1px solid ${T.borderAlt}`, borderRadius:6, padding:'7px 10px', fontFamily:'Manrope, sans-serif', fontSize:12, color:T.ink, outline:'none', boxSizing:'border-box' as const }}/>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving || fields.some(f=>!creds[f.key])}
        style={{ fontFamily:'Manrope, sans-serif', fontSize:10, padding:'7px 16px', borderRadius:6, border:`1px solid ${T.accent}`, background:'rgba(201,168,76,0.12)', color:T.accent, cursor:'pointer' }}>
        {saving?'Kaydediliyor...':'Kaydet'}
      </button>
    </div>
  );
}
